// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 1000 1000%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noiseFilter%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.65%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noiseFilter%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 100 100%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noiseFilter%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.65%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noiseFilter%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --demmi-50: #eff2ed;
  --demmi-100: #d4ddd0;
  --demmi-200: #b7c4b0;
  --demmi-300: #99ae8f;
  --demmi-400: #849b78;
  --demmi-500: #6f8a60;
  --demmi-600: #607854;
  --demmi-700: #506345;
  --demmi-800: #40493c;
  --demmi-900: #2d312b;
  --palette-50-s: 35%;
  --palette-50-l: 93%;
  --palette-100-s: 40%;
  --palette-100-l: 84%;
  --palette-200-s: 45%;
  --palette-200-l: 73%;
  --palette-300-s: 50%;
  --palette-300-l: 63%;
  --palette-400-s: 55%;
  --palette-400-l: 55%;
  --palette-500-s: 60%;
  --palette-500-l: 47%;
  --palette-600-s: 65%;
  --palette-600-l: 42%;
  --palette-700-s: 70%;
  --palette-700-l: 36%;
  --palette-800-s: 75%;
  --palette-800-l: 30%;
  --palette-900-s: 80%;
  --palette-900-l: 23%;
  --palette-50: hsl(
      var(--theme-bg-hue),
      var(--palette-50-s),
      var(--palette-50-l)
  );
  --palette-100: hsl(
      var(--theme-bg-hue),
      var(--palette-100-s),
      var(--palette-100-l)
  );
  --palette-200: hsl(
      var(--theme-bg-hue),
      var(--palette-200-s),
      var(--palette-200-l)
  );
  --palette-300: hsl(
      var(--theme-bg-hue),
      var(--palette-300-s),
      var(--palette-300-l)
  );
  --palette-400: hsl(
      var(--theme-bg-hue),
      var(--palette-400-s),
      var(--palette-400-l)
  );
  --palette-500: hsl(
      var(--theme-bg-hue),
      var(--palette-500-s),
      var(--palette-500-l)
  );
  --palette-600: hsl(
      var(--theme-bg-hue),
      var(--palette-600-s),
      var(--palette-600-l)
  );
  --palette-700: hsl(
      var(--theme-bg-hue),
      var(--palette-700-s),
      var(--palette-700-l)
  );
  --palette-800: hsl(
      var(--theme-bg-hue),
      var(--palette-800-s),
      var(--palette-800-l)
  );
  --palette-900: hsl(
      var(--theme-bg-hue),
      var(--palette-900-s),
      var(--palette-900-l)
  );
}

body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar {
  width: 1.6rem;
  height: 1.6rem;
  background-color: transparent;
}
body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb {
  border: 0.5rem solid transparent;
  border-radius: 0.8rem;
  background-clip: padding-box;
  outline: none;
  background-color: rgba(255, 255, 255, 0.7);
}
body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb:hover {
  border-width: 0.4rem;
  background-color: rgba(255, 255, 255, 0.9);
}
body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb:active {
  border-width: 0.4rem;
  background-color: rgba(255, 255, 255, 0.9);
}

body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 1rem;
}

body:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-corner {
  background-color: transparent;
}

body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar {
  background-color: transparent;
}
body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb {
  border: 0.5rem solid transparent;
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.6);
}
body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-thumb:active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-track {
  background: transparent;
}

body.theme-dark:not(.isCapacitor):not(.isMobile) * ::-webkit-scrollbar-corner {
  background-color: transparent;
}

:root {
  --sidebar-width: 34rem;
  --sidebar-width-offset: 7rem;
  --sidebar-transition-time: 0.3s;
  --colour-light: hsl(99, 30%, 74%);
  --colour-dark: hsl(99, 22%, 57%);
}
@media (max-width: 480px) {
  :root {
    --sidebar-width: 100%;
  }
}

:root {
  --theme-bg-hue: 200;
  --theme-bg-01: 120;
  --theme-bg-02: 160;
  --theme-bg-pos: 20;
  --theme-bg-intensity: 0.6;
  --theme-bg-grain: 0.4;
  --theme-bg-svg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --theme-config-svg: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

body {
  background-color: black;
}

#demmi-dash {
  height: 100%;
  width: 100vw;
  box-sizing: border-box;
  overflow: hidden;
  justify-items: start;
  position: relative;
  color: rgba(0, 0, 0, 0.6);
  z-index: 0;
}
#demmi-dash {
  background-color: var(--palette-100);
}
body.theme-dark #demmi-dash {
  background-color: rgb(0, 0, 0);
}

body .emdee-logo img.emdee-logo__image--light {
  display: none;
}
body .emdee-logo img.emdee-logo__image--dark {
  display: block;
}
body.theme-dark .emdee-logo img.emdee-logo__image--light {
  display: block;
}
body.theme-dark .emdee-logo img.emdee-logo__image--dark {
  display: none;
}

/* Define main content transition */
.vendor-wrapper__content {
  view-transition-name: vendor-content;
}

.vendor-wrapper__error {
  view-transition-name: vendor-error;
}

/* Define transition animations */
@keyframes fade-in {
  from {
    opacity: 0;
  }
}
@keyframes fade-out {
  to {
    opacity: 0;
  }
}
@keyframes inAnimation {
  from {
    transform: translate3d(0, 4rem, 0);
    opacity: 0;
  }
  35% {
    transform: translate3d(0, 4rem, 0);
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes outAnimation {
  from {
    opacity: 1;
  }
  35% {
    transform: translate3d(0, 4rem, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 4rem, 0);
    opacity: 0;
  }
}
@view-transition {
  navigation: auto;
}
/* Apply animations to view transitions */
::view-transition-old(vendor-content) {
  z-index: 1;
  animation: outAnimation 600ms ease-out;
}

::view-transition-new(vendor-content) {
  z-index: 1;
  animation: inAnimation 600ms ease-in;
}

::view-transition-old(vendor-error) {
  animation: 400ms fade-out ease-in-out;
}

::view-transition-new(vendor-error) {
  animation: 400ms fade-in ease-in-out;
}

/* For all other content */
/* Optional: Add this to your ::view-transition-group */
::view-transition-group(vendor-content) {
  z-index: 5;
}

/* Add this if your loading overlay is also using view transitions */
::view-transition-group(root) {
  z-index: auto; /* Let normal document flow handle stacking */
}

.not-found-404__wrapper {
  padding: 2rem;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
  z-index: 1;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  overflow: hidden;
  height: 100%;
  box-sizing: border-box;
}
.not-found-404__wrapper .not-found-404__content {
  max-width: 50rem;
  width: 100%;
}
.not-found-404__wrapper .not-found-404__content .not-found-404__title {
  width: 100%;
  text-align: center;
  font-weight: 100;
  white-space: nowrap;
  line-height: min(6rem, 10vw);
  font-size: min(6.4rem, 11vw);
  letter-spacing: min(0.5rem, 1vw);
  margin-bottom: min(2rem, 4vw);
}
.not-found-404__wrapper .not-found-404__content .not-found-404__title {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.8);
}
body.theme-dark .not-found-404__wrapper .not-found-404__content .not-found-404__title {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}

.not-found-404__wrapper .not-found-404__content .not-found-404__title span {
  font-weight: 200;
}
.not-found-404__wrapper .not-found-404__content .not-found-404__title span {
  color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .not-found-404__wrapper .not-found-404__content .not-found-404__title span {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}

.not-found-404__wrapper .not-found-404__content .not-found-404__subtitle {
  text-align: center;
  font-weight: 400;
  margin-bottom: 5rem;
  white-space: nowrap;
  letter-spacing: 0.1rem;
  line-height: min(2.2rem, 4vw);
  font-size: min(2.2rem, 3.8vw);
}
.not-found-404__wrapper .not-found-404__content .not-found-404__subtitle {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .not-found-404__wrapper .not-found-404__content .not-found-404__subtitle {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}

.not-found-404__wrapper .not-found-404__content .not-found-404__description {
  max-width: 100%;
  text-align: center;
  font-weight: 500;
  letter-spacing: 0.1rem;
  margin-top: 3rem;
  line-height: max(min(2.4rem, 5vw), 2.2rem);
  font-size: max(min(1.5rem, 3vw), 1.3rem);
}
.not-found-404__wrapper .not-found-404__content .not-found-404__description {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .not-found-404__wrapper .not-found-404__content .not-found-404__description {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.analytics {
  width: 100%;
  height: 100%;
  display: grid;
  gap: 1.6rem;
  padding: 0.6rem;
  box-sizing: border-box;
  overflow: auto;
}

.coupons-sidebar-button {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 1.2rem 1.6rem;
  box-sizing: border-box;
}
.coupons-sidebar-button .coupons-sidebar-button__type {
  letter-spacing: 0.1rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.8rem;
  text-align: center;
  text-transform: uppercase;
}
.coupons-sidebar-button .coupons-sidebar-button__type {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .coupons-sidebar-button .coupons-sidebar-button__type {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.coupons-sidebar-button .coupons-sidebar-button__code {
  letter-spacing: 0.2rem;
  font-weight: 600;
  font-size: 1.2rem;
}
.coupons-sidebar-button .coupons-sidebar-button__expiration {
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 400;
}

.coupons {
  position: relative;
  z-index: 100;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.coupon-detail {
  grid-area: details;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.coupon-detail .coupon-detail__buttons {
  display: flex;
  justify-content: end;
  gap: 1rem;
  margin-top: 2rem;
  width: 42rem;
}
.coupon-detail .coupon-detail__wrapper {
  position: relative;
}
.coupon-detail .coupon-detail__wrapper {
  filter: drop-shadow(0 0.4rem 1.2rem hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.2));
}
body.theme-dark .coupon-detail .coupon-detail__wrapper {
  filter: drop-shadow(0 0.4rem 1.2rem hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0));
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__wrapper-background {
  position: relative;
  height: 23rem;
  width: 42rem;
  border-radius: 1.2rem;
  -webkit-mask-image: radial-gradient(circle at 1rem 5rem, transparent 1rem, red 1rem), radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
  -webkit-mask-size: 100%, 1.2rem 0.4rem;
  -webkit-mask-repeat: repeat, repeat-x;
  -webkit-mask-position: -1rem, 50% 4.8rem;
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__wrapper-background {
  background: radial-gradient(circle at 30% 40%, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.4));
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__wrapper-background {
  background: radial-gradient(circle at 30% 40%, hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.5), hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2));
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__wrapper-background::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5rem;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__wrapper-background::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.15);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__wrapper-background::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content {
  position: absolute;
  inset: 0;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__code {
  line-height: 5rem;
  text-align: center;
  font-weight: 700;
  font-size: 1.3rem;
  letter-spacing: 0.4rem;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__code {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__code {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.9);
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details {
  position: relative;
  box-sizing: border-box;
  padding: 0.8rem 1.6rem;
  padding-bottom: 4rem;
  height: calc(100% - 5rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__type {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 1.3rem;
  letter-spacing: 0.1rem;
  line-height: 4rem;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__type {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.4);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__type {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.8);
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__detail-split {
  display: flex;
  justify-content: space-between;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__detail-split .coupon-detail__detail:first-child {
  text-align: start !important;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__detail-split .coupon-detail__detail:last-child {
  text-align: end;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__detail {
  line-height: 1.6rem;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__detail {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.7);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__detail {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__detail .coupon-detail__detail-key {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1rem;
  letter-spacing: 0.2rem;
  opacity: 0.7;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__detail .coupon-detail__detail-value {
  font-weight: 500;
  font-size: 1.3rem;
  letter-spacing: 0.1rem;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status {
  position: absolute;
  bottom: 0.8rem;
  right: 0.8rem;
  height: 2.2rem;
  line-height: 2.2rem;
  padding: 0rem 1.2rem;
  box-sizing: border-box;
  border-radius: 0.6rem;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
}
.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.9);
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--disabled {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--disabled {
  border-color: transparent;
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--disabled {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--disabled {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--disabled {
  color: white;
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--disabled {
  color: white;
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--expired {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--expired {
  border-color: transparent;
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--expired {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--expired {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--expired {
  color: white;
}
body.theme-dark .coupon-detail .coupon-detail__wrapper .coupon-detail__content .coupon-detail__content-details .coupon-detail__status.coupon-detail__status--expired {
  color: white;
}

@media (max-width: 480px) {
  .coupon-detail .coupon-detail__buttons {
    width: 38rem;
  }
  .coupon-detail .coupon-detail__wrapper .coupon-detail__wrapper-background {
    width: 38rem;
  }
}

.inventory-sidebar-button {
  padding: 1.2rem 1.2rem;
  gap: 2rem;
  border-radius: 1.2rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.inventory-sidebar-button.inventory-sidebar-button--archived .inventory-sidebar-button__image {
  border: 0.3rem solid;
}
.inventory-sidebar-button.inventory-sidebar-button--archived .inventory-sidebar-button__image {
  border-color: hsl(0, 70%, 70%);
}
body.theme-dark .inventory-sidebar-button.inventory-sidebar-button--archived .inventory-sidebar-button__image {
  border-color: hsl(0, 40%, 50%);
}

.inventory-sidebar-button .inventory-sidebar-button__image {
  position: relative;
  flex: 0 0 6.8rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 0.8rem;
  width: 6.8rem;
  height: 5rem;
}
.inventory-sidebar-button .inventory-sidebar-button__image img {
  width: 6.8rem;
  height: 5rem;
  object-fit: cover;
}
.inventory-sidebar-button .inventory-sidebar-button__image .inventory-sidebar-button__status {
  position: absolute;
  height: 2rem;
  bottom: -0.3rem;
  left: -0.3rem;
  right: -0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
}
.inventory-sidebar-button .inventory-sidebar-button__image .inventory-sidebar-button__status {
  color: white;
}
body.theme-dark .inventory-sidebar-button .inventory-sidebar-button__image .inventory-sidebar-button__status {
  color: white;
}

.inventory-sidebar-button .inventory-sidebar-button__image .inventory-sidebar-button__status {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .inventory-sidebar-button .inventory-sidebar-button__image .inventory-sidebar-button__status {
  background-color: hsl(0, 40%, 50%);
}

.inventory-sidebar-button .inventory-sidebar-button__text {
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 0.4rem;
  letter-spacing: 0.1rem;
}
.inventory-sidebar-button .inventory-sidebar-button__text .inventory-sidebar-button__description {
  font-size: 1.2rem;
  line-height: 1.4rem;
}

.product-details {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  padding: 2rem;
  box-sizing: border-box;
  overflow: auto;
}
@media (max-width: 1400px) {
  .product-details {
    padding: 2rem 1rem;
  }
}
.product-details .product-details__status {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1.2rem;
  box-sizing: border-box;
  border-radius: 1rem;
  border: 0.2rem solid;
  margin-bottom: -1rem;
}
.product-details .product-details__status {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .product-details .product-details__status {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.product-details .product-details__status {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .product-details .product-details__status {
  background-color: transparent;
}

.product-details .product-details__status {
  color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .product-details .product-details__status {
  color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.product-details .product-details__status .product-details__status-text {
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 2rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
}
.product-details .product-details__status.product-details__status--published {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .product-details .product-details__status.product-details__status--published {
  border-color: transparent;
}

.product-details .product-details__status.product-details__status--published {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .product-details .product-details__status.product-details__status--published {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.product-details .product-details__status.product-details__status--published {
  color: white;
}
body.theme-dark .product-details .product-details__status.product-details__status--published {
  color: white;
}

.product-details .product-details__status.product-details__status--archived {
  border-color: transparent;
}
body.theme-dark .product-details .product-details__status.product-details__status--archived {
  border-color: transparent;
}

.product-details .product-details__status.product-details__status--archived {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .product-details .product-details__status.product-details__status--archived {
  background-color: hsl(0, 40%, 50%);
}

.product-details .product-details__status.product-details__status--archived {
  color: white;
}
body.theme-dark .product-details .product-details__status.product-details__status--archived {
  color: white;
}

.product-details .product-details__details {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
.product-details .product-details__details .product-details__details-description {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.product-details .product-details__buttons-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  align-items: stretch;
}
.product-details .product-details__buttons-row .demmi-ui-button {
  flex: 1 1 calc(50% - 1rem);
  height: auto;
}

.product-category {
  display: flex;
  flex-wrap: wrap;
}
.product-category {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .product-category {
  color: rgba(255, 255, 255, 0.8);
}

.product-category .product-category__list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem;
}
.product-category .product-category__list .product-category__tag {
  display: flex;
  gap: 1rem;
}

.product-images .product-images__no-images {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 2rem;
  text-align: center;
  letter-spacing: 0.08rem;
  margin: 1rem auto;
}
.product-images .product-images__no-images {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .product-images .product-images__no-images {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.product-tags .product-tags__list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 0 1rem 1rem;
}
.product-tags .product-tags__list .product-tags__tag {
  display: flex;
  gap: 1rem;
}

.product-variants {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  border-radius: 1.2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  padding: 2rem;
  box-sizing: border-box;
  overflow: auto;
}
@media (max-width: 1400px) {
  .product-variants {
    padding: 2rem 1rem;
  }
}
.product-variants .product-variants__title {
  font-size: 1.6rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 2rem;
  text-align: center;
}
.product-variants .product-variants__title {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .product-variants .product-variants__title {
  color: rgba(255, 255, 255, 0.8);
}

.product-variant {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem 1rem;
  margin: 0 auto;
  align-items: center;
}
.product-variant {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .product-variant {
  color: white;
}

.product-variant .product-variant__buttons-row {
  margin-top: 2rem;
  align-items: center;
  display: flex;
  gap: 1rem;
}

.product-variant-inputs {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}
.product-variant-inputs .product-variant-inputs__details-row {
  width: 100%;
  display: flex;
  gap: 1rem;
  align-items: center;
}
.product-variant-inputs .product-variant-inputs__details-row .product-variant-inputs__details-item {
  width: 100%;
}
.product-variant-inputs .product-variant-inputs__details-row .product-variant-inputs__details-item .product-variant-inputs__details-title {
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 1.4rem;
  margin: 0.5rem 1rem 1rem;
}
.product-variant-inputs .product-variant-inputs__details-row .product-variant-inputs__details-item .demmi-ui-button {
  width: 100%;
}

.inventory {
  position: relative;
  z-index: 100;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.inventory .inventory__details {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.inventory .inventory__details .inventory__live-preview {
  display: none;
}
.inventory .inventory__details .inventory__swiper {
  height: 100%;
  margin: 0 auto;
}
.inventory .inventory__details .inventory__swiper .inventory__pane.inventory__pane--preview {
  display: flex;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
}
@media (max-width: 1600px) {
  .inventory .inventory__details .inventory__swiper .inventory__pane.inventory__pane--preview .fake-phone {
    max-height: 76rem;
  }
}
.inventory .inventory__details .swiper-pagination-bullets {
  --swiper-pagination-bottom: 0;
  overflow: visible;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 0.5rem 0;
}
.inventory .inventory__details .swiper-pagination-bullets {
  background-color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .inventory .inventory__details .swiper-pagination-bullets {
  background-color: hsla(var(--theme-bg-hue), 16%, 24%, 0.6);
}

.inventory .inventory__details .swiper-pagination-bullet {
  position: relative;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1.4rem;
  border-radius: 0.6rem;
  padding: 1rem 2.2rem;
  box-sizing: border-box;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  opacity: 1;
  text-transform: uppercase;
  margin: 0 0.1rem;
  transition: transform 0.1s ease-in-out, border-radius 0.1s ease-in-out;
  z-index: 1;
  background-color: transparent;
}
.inventory .inventory__details .swiper-pagination-bullet {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.7);
}
body.theme-dark .inventory .inventory__details .swiper-pagination-bullet {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.inventory .inventory__details .swiper-pagination-bullet-active {
  z-index: 2;
}
.inventory .inventory__details .swiper-pagination-bullet-active {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.9);
}
body.theme-dark .inventory .inventory__details .swiper-pagination-bullet-active {
  color: white;
}

.inventory .inventory__details .swiper-pagination-bullet-active {
  background-color: white;
}
body.theme-dark .inventory .inventory__details .swiper-pagination-bullet-active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

@media (max-width: 800px) {
  .inventory .inventory__details .product-details {
    padding-bottom: 6rem;
  }
  .inventory .inventory__details .product-variants {
    padding-bottom: 6rem;
  }
}
.inventory.inventory--live-preview .inventory__details {
  grid-template: "preview details variants" 1fr/42rem 3fr 2fr;
}
.inventory.inventory--live-preview .inventory__details .inventory__live-preview {
  grid-area: preview;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  overflow: hidden auto;
}
.inventory.inventory--live-preview .inventory__details .inventory__live-preview .fake-phone {
  margin: 0.5rem auto;
}
@media (max-height: 930px) {
  .inventory.inventory--live-preview .inventory__details .inventory__live-preview .fake-phone {
    align-self: auto;
  }
}
.inventory.inventory--live-preview .inventory__details .product-details {
  padding: 2rem 0.5rem;
}
.inventory.inventory--live-preview .inventory__details .product-variants {
  padding: 2rem 0.5rem;
}
@media (max-width: 1500px) {
  .inventory.inventory--live-preview .inventory__details .product-details {
    padding-bottom: 6rem;
  }
  .inventory.inventory--live-preview .inventory__details .product-variants {
    padding-bottom: 6rem;
  }
}

.reviews-sidebar-button {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 1rem 1.6rem;
  border-radius: 1.2rem;
  box-sizing: border-box;
}
.reviews-sidebar-button {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .reviews-sidebar-button {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.reviews-sidebar-button .reviews-sidebar-button__top {
  width: 100%;
  height: 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.reviews-sidebar-button .reviews-sidebar-button__top .reviews-sidebar-button__customer-name {
  line-height: 2rem;
  letter-spacing: 0.1rem;
  font-weight: 400;
  font-size: 1.4rem;
  text-align: start;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.reviews-sidebar-button .reviews-sidebar-button__top .reviews-sidebar-button__rating {
  display: flex;
  gap: 0.4rem;
}
.reviews-sidebar-button .reviews-sidebar-button__top .reviews-sidebar-button__rating svg {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .reviews-sidebar-button .reviews-sidebar-button__top .reviews-sidebar-button__rating svg {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.reviews-sidebar-button .reviews-sidebar-button__content {
  width: calc(100% + 1rem);
  box-sizing: border-box;
  padding: 0.8rem 1.2rem;
  border-radius: 0.8rem;
  margin: 0 -0.5rem;
}
.reviews-sidebar-button .reviews-sidebar-button__content {
  background-color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.08);
}
body.theme-dark .reviews-sidebar-button .reviews-sidebar-button__content {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.reviews-sidebar-button .reviews-sidebar-button__content .reviews-sidebar-button__title {
  line-height: 2rem;
  letter-spacing: 0.05rem;
  font-weight: 600;
  font-size: 1.3rem;
  text-align: start;
  margin-bottom: 0.5rem;
}
.reviews-sidebar-button .reviews-sidebar-button__content .reviews-sidebar-button__body {
  line-height: 1.8rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  font-size: 1.2rem;
  text-align: start;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.reviews-sidebar-button .reviews-sidebar-button__date {
  width: 100%;
  line-height: 2rem;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  opacity: 0.8;
  text-align: end;
}

.reviews {
  position: relative;
  z-index: 100;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
}

.review-item__wrapper {
  grid-area: details;
  margin: 0 auto;
  width: 100%;
  max-width: 90rem;
  padding: 2rem 1rem;
  box-sizing: border-box;
}

.review-item {
  display: grid;
  grid-template: "header customer" 1fr "body body" "response response"/1fr 30rem;
  gap: 0rem;
  position: relative;
  align-items: start;
  padding: 2rem !important;
}
.review-item {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .review-item {
  color: white;
}

.review-item .review-item__header {
  grid-area: header;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 4rem;
}
.review-item .review-item__header .review-item__rating {
  display: flex;
  gap: 0.4rem;
}
.review-item .review-item__header .review-item__rating svg {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .review-item .review-item__header .review-item__rating svg {
  color: white;
}

.review-item .review-item__header .review-item__timestamp {
  font-size: 1.4rem;
  font-weight: 500;
}
.review-item .review-item__header .review-item__timestamp span {
  text-transform: uppercase;
  font-size: 1.3rem;
  font-weight: 700;
  margin-left: 1rem;
}
.review-item .review-item__review {
  grid-area: body;
  margin-bottom: 2rem;
}
.review-item .review-item__review .review-item__review-title {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
}
.review-item .review-item__review .review-item__review-description {
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.review-item .review-item__review .review-item__review-description .review-item__review-description-paragraph {
  margin: 1rem 0;
}
.review-item .review-item__customer {
  grid-area: customer;
  padding: 1.2rem 1.6rem;
  margin-top: -1rem;
  margin-right: -1rem;
  border-radius: 1.2rem;
}
.review-item .review-item__customer {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .review-item .review-item__customer {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.review-item .review-item__customer .review-item__not-found {
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  letter-spacing: 0.1rem;
  line-height: 2rem;
}
.review-item .review-item__customer .review-item__not-found {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .review-item .review-item__customer .review-item__not-found {
  color: white;
}

.review-item .review-item__customer .review-item__title {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  line-height: 2rem;
}
.review-item .review-item__customer .review-item__title {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .review-item .review-item__customer .review-item__title {
  color: white;
}

.review-item .review-item__customer .review-item__customer-name {
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  line-height: 2rem;
}
.review-item .review-item__customer .review-item__customer-number {
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  line-height: 2rem;
}
.review-item .review-item__review-response {
  grid-area: response;
  padding: 0.8rem 1.6rem 0.2rem;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
  border-radius: 1.2rem;
}
.review-item .review-item__review-response {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .review-item .review-item__review-response {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.review-item .review-item__review-response .review-item__review-response-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
  margin-right: -0.8rem;
}
.review-item .review-item__review-response .review-item__review-response-title .review-item__review-response-title-buttons {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.review-item .review-item__review-response .review-item__review-description-paragraph {
  margin: 1.2rem 0;
}
.review-item .review-item__review-response .review-item__review-no-response {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1.6rem;
  font-size: 1.4rem;
  font-weight: 400;
  padding: 1.6rem 0;
}
@media (max-width: 640px) {
  .review-item {
    grid-template: "customer customer" auto "header header" auto "body body" auto "response response"/auto 30rem;
  }
  .review-item .review-item__customer {
    margin: -0.8rem;
    margin-bottom: 2rem;
  }
  .review-item .review-item__review-response {
    margin: -0.8rem;
    margin-top: 0;
  }
}

.widget-order-item {
  line-height: 1.8rem;
}
.widget-order-item .widget-order-item__collection-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 1rem;
  text-align: center;
  margin-bottom: 0.8rem;
  padding: 0.4rem 1rem;
}
.widget-order-item .widget-order-item__collection-info {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .widget-order-item .widget-order-item__collection-info {
  color: white;
}

.widget-order-item .widget-order-item__collection-info .widget-order-item__collection-item {
  flex: 0 0 1fr;
}
.widget-order-item .widget-order-item__collection-info .widget-order-item__collection-item:first-child {
  text-align: start;
}
.widget-order-item .widget-order-item__collection-info .widget-order-item__collection-item:first-child .widget-order-item__collection-item-value {
  letter-spacing: 0.3rem;
}
.widget-order-item .widget-order-item__collection-info .widget-order-item__collection-item:last-child {
  text-align: end;
}
.widget-order-item .widget-order-item__collection-info .widget-order-item__collection-item .widget-order-item__collection-item-heading {
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
  line-height: 1.4rem;
  text-transform: uppercase;
}
.widget-order-item .widget-order-item__collection-info .widget-order-item__collection-item .widget-order-item__collection-item-value {
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.15rem;
  line-height: 2.2rem;
}
.widget-order-item .widget-order-item__products-list {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  border-radius: 1rem;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product {
  display: flex;
  gap: 1.6rem;
  align-items: center;
  box-sizing: border-box;
  border-radius: 0.4rem;
  padding: 0.4rem;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .widget-order-item .widget-order-item__products-list .widget-order-item__product {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.6);
}

.widget-order-item .widget-order-item__products-list .widget-order-item__product {
  color: rgba(0, 0, 0, 0.7);
}
body.theme-dark .widget-order-item .widget-order-item__products-list .widget-order-item__product {
  color: white;
}

.widget-order-item .widget-order-item__products-list .widget-order-item__product:first-child {
  border-top-left-radius: 1.2rem;
  border-top-right-radius: 1.2rem;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product:first-child .widget-order-item__product-image {
  border-top-left-radius: 1rem;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product:last-child {
  border-bottom-left-radius: 1.2rem;
  border-bottom-right-radius: 1.2rem;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product:last-child .widget-order-item__product-image {
  border-bottom-left-radius: 1rem;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product .widget-order-item__product-image {
  width: 6rem;
  height: 5rem;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.3rem;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product .widget-order-item__product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product .widget-order-item__product-name {
  font-size: 1.3rem;
  font-weight: 600;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product .widget-order-item__product-variant {
  margin-top: 0.4rem;
  font-size: 1.2rem;
  line-height: 1.4rem;
  font-weight: 400;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product .widget-order-item__product-quantity {
  margin-left: auto;
  margin-right: 1rem;
  font-size: 1.8rem;
  font-weight: 400;
}
.widget-order-item .widget-order-item__products-list .widget-order-item__product .widget-order-item__product-quantity .widget-order-item__product-quantity-unit {
  font-size: 1.1rem;
  font-weight: 700;
  margin-left: 0.4rem;
  text-transform: uppercase;
  opacity: 0.6;
}

.widget-orders {
  grid-area: orders;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 50rem;
  overflow: auto;
}
.widget-orders .widget-orders__list {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 1.5rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  padding: 1rem 0;
}
.widget-orders .widget-orders__list {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .widget-orders .widget-orders__list {
  color: white;
}

.widget-review-item .widget-review-item__header {
  grid-area: header;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  padding: 0.6rem 0.8rem 0.4rem;
}
.widget-review-item .widget-review-item__header .widget-review-item__rating {
  display: flex;
  gap: 0.4rem;
  font-size: 1.3rem;
}
.widget-review-item .widget-review-item__header .widget-review-item__rating svg {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .widget-review-item .widget-review-item__header .widget-review-item__rating svg {
  color: white;
}

.widget-review-item .widget-review-item__header .widget-review-item__timestamp {
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.4rem;
}
.widget-review-item .widget-review-item__header .widget-review-item__timestamp span {
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 700;
  margin-left: 1rem;
}
.widget-review-item .widget-review-item__review {
  grid-area: body;
  padding: 1.2rem;
  border-radius: 1rem;
}
.widget-review-item .widget-review-item__review {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .widget-review-item .widget-review-item__review {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.5);
}

.widget-review-item .widget-review-item__review .widget-review-item__review-title {
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 500;
}
.widget-review-item .widget-review-item__review .widget-review-item__review-description {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.7rem;
  letter-spacing: 0.02rem;
  text-align: justify;
}
.widget-review-item .widget-review-item__review .widget-review-item__review-description .widget-review-item__review-description-paragraph {
  margin: 1rem 0 0;
}

.widget-reviews {
  grid-area: reviews;
  display: flex;
  flex-direction: column;
  min-width: 42rem;
}
.widget-reviews .widget-reviews__list {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  padding: 1rem 0;
}
.widget-reviews .widget-reviews__list {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .widget-reviews .widget-reviews__list {
  color: white;
}

.widget-analytics {
  grid-area: analytics;
  display: flex;
  min-width: 40rem;
}
.widget-analytics .widget-analytics__coming-soon {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  letter-spacing: 0.2rem;
  font-weight: 600;
  line-height: 3.8rem;
  text-transform: uppercase;
}
.widget-analytics .widget-analytics__coming-soon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .widget-analytics .widget-analytics__coming-soon {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.widget-incoming-schedule {
  grid-area: incoming-schedule;
  height: 100%;
  padding: 0;
  position: relative;
  overflow: hidden;
}
.widget-incoming-schedule .widget-incoming-schedule__list {
  position: relative;
  height: 100%;
  overflow: auto;
  padding: 1rem 0;
  box-sizing: border-box;
}
.widget-incoming-schedule .widget-incoming-schedule__list .widget-incoming-schedule__time-indicator {
  position: absolute;
  margin-top: 2.9rem;
  top: 0;
  left: 6.4rem;
  right: 0;
  height: 0.4rem;
  border-radius: 0.2rem;
}
.widget-incoming-schedule .widget-incoming-schedule__list .widget-incoming-schedule__time-indicator {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}
body.theme-dark .widget-incoming-schedule .widget-incoming-schedule__list .widget-incoming-schedule__time-indicator {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}

.widget-incoming-schedule .widget-incoming-schedule__list .widget-incoming-schedule__time-indicator::before {
  content: "";
  position: absolute;
  top: -0.4rem;
  right: 0rem;
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
}
.widget-incoming-schedule .widget-incoming-schedule__list .widget-incoming-schedule__time-indicator::before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}
body.theme-dark .widget-incoming-schedule .widget-incoming-schedule__list .widget-incoming-schedule__time-indicator::before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}

.widget-incoming-schedule .widget-incoming-schedule__message {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.widget-incoming-schedule .widget-incoming-schedule__message .widget-incoming-schedule__message-text {
  border-radius: 1.2rem;
  padding: 1.2rem 2rem;
  box-sizing: border-box;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 2rem;
  backdrop-filter: blur(4px);
  white-space: pre-line;
  text-align: center;
}
.widget-incoming-schedule .widget-incoming-schedule__message .widget-incoming-schedule__message-text {
  background-color: rgba(255, 255, 255, 0.7);
}
body.theme-dark .widget-incoming-schedule .widget-incoming-schedule__message .widget-incoming-schedule__message-text {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.widget-incoming-schedule .widget-incoming-schedule__message .widget-incoming-schedule__message-text {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .widget-incoming-schedule .widget-incoming-schedule__message .widget-incoming-schedule__message-text {
  color: rgb(255, 255, 255);
}

.widget-incoming-schedule-slot {
  margin: 0.4rem 0;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: flex-start;
  min-height: 7rem;
  max-height: 7rem;
  padding: 1rem 1.2rem;
  box-sizing: border-box;
  border-radius: 0.8rem;
  transition: background-color 0.1s ease-in-out;
  opacity: 0.4;
}
.widget-incoming-schedule-slot:not(.widget-incoming-schedule-slot.widget-incoming-schedule-slot--has-passed).widget-incoming-schedule-slot--is-open:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .widget-incoming-schedule-slot:not(.widget-incoming-schedule-slot.widget-incoming-schedule-slot--has-passed).widget-incoming-schedule-slot--is-open:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.28);
}

.widget-incoming-schedule-slot.widget-incoming-schedule-slot--is-open {
  opacity: 1;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__time {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 1.2rem;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__time .widget-incoming-schedule-slot__time-text {
  width: 5rem;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.4rem;
  letter-spacing: 0.2rem;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__time .widget-incoming-schedule-slot__time-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .widget-incoming-schedule-slot .widget-incoming-schedule-slot__time .widget-incoming-schedule-slot__time-text {
  color: white;
}

.widget-incoming-schedule-slot .widget-incoming-schedule-slot__time .widget-incoming-schedule-slot__time-line {
  height: 0.1rem;
  width: 100%;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__time .widget-incoming-schedule-slot__time-line {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .widget-incoming-schedule-slot .widget-incoming-schedule-slot__time .widget-incoming-schedule-slot__time-line {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 0rem 0;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order {
  cursor: pointer;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 0.6rem 0.8rem;
  border-radius: 0.8rem;
  border: 0.3rem solid transparent;
  transition: box-shadow 0.1s ease-in-out;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order {
  background-color: white;
}
body.theme-dark .widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.5);
}

.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-status {
  width: 100%;
  font-weight: 700;
  font-size: 1.1rem;
  line-height: 2.2rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  text-align: center;
  border-radius: 0.4rem;
  margin-bottom: 0.8rem;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-status {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-status {
  color: white;
}

.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-status {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-status {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-id {
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.6rem;
  letter-spacing: 0.1rem;
  margin-bottom: 0.2rem;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-id {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-id {
  color: white;
}

.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-customer {
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.8rem;
  letter-spacing: 0.02rem;
}
.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-customer {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order .widget-incoming-schedule-slot__order-customer {
  color: white;
}

.widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order:hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .widget-incoming-schedule-slot .widget-incoming-schedule-slot__orders-list .widget-incoming-schedule-slot__order:hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 8%, 16%,0.56);
}

.dashboard-badges {
  grid-area: badges;
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
}
.dashboard-badges .dashboard-badge {
  pointer-events: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 6rem;
  width: 26rem;
  border-radius: 1.6rem;
  padding: 1.2rem 2rem;
  box-sizing: border-box;
}
.dashboard-badges .dashboard-badge {
  background-color: rgba(255, 255, 255, 0.7);
}
body.theme-dark .dashboard-badges .dashboard-badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.dashboard-badges .dashboard-badge .dashboard-badge__text .dashboard-badge__title {
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 2.2rem;
}
.dashboard-badges .dashboard-badge .dashboard-badge__text .dashboard-badge__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .dashboard-badges .dashboard-badge .dashboard-badge__text .dashboard-badge__title {
  color: rgb(255, 255, 255);
}

.dashboard-badges .dashboard-badge .dashboard-badge__text .dashboard-badge__subtitle {
  font-size: 1rem;
  line-height: 1.4rem;
  font-weight: 700;
  text-transform: uppercase;
}
.dashboard-badges .dashboard-badge .dashboard-badge__text .dashboard-badge__subtitle {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .dashboard-badges .dashboard-badge .dashboard-badge__text .dashboard-badge__subtitle {
  color: rgba(255, 255, 255, 0.6);
}

.dashboard-badges .dashboard-badge .dashboard-badge__value {
  font-size: 2.4rem;
  font-weight: 300;
  line-height: 2rem;
  letter-spacing: 0.2rem;
}
.dashboard-badges .dashboard-badge .dashboard-badge__value {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .dashboard-badges .dashboard-badge .dashboard-badge__value {
  color: rgb(255, 255, 255);
}

.home {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: "badges badges badges" 6rem "incoming-schedule analytics analytics" 30rem "incoming-schedule orders reviews"/26rem 1fr 1fr;
  gap: 1.6rem;
  padding: 0.6rem;
  box-sizing: border-box;
  overflow: auto hidden;
}

.dashboard-section {
  position: relative;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;
  border-radius: 2rem;
}
.dashboard-section {
  background-color: rgba(255, 255, 255, 0.5);
}
body.theme-dark .dashboard-section {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.dashboard-section.dashboard-section--loading .dashboard-section__content {
  opacity: 0.4;
}
.dashboard-section .dashboard-section__content {
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem 0 1rem;
  overflow: hidden;
}
.dashboard-section .dashboard-section__title {
  position: relative;
  flex: 0 0 0.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.6rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 3.8rem;
  padding: 0 0 1rem 1.5rem;
}
.dashboard-section .dashboard-section__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .dashboard-section .dashboard-section__title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.dashboard-section .dashboard-section__title::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: -1rem;
  right: -1rem;
  height: 0.1rem;
}
.dashboard-section .dashboard-section__title::before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.2);
}
body.theme-dark .dashboard-section .dashboard-section__title::before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.6);
}

.shop-management-details {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
}
.shop-management-details {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .shop-management-details {
  color: rgba(255, 255, 255, 0.8);
}

.shop-management-details .shop-management-details__description {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  box-sizing: border-box;
}

.shop-management-images {
  border-radius: 1rem;
  padding: 1rem;
  box-sizing: border-box;
  overflow: auto;
}
.shop-management-images .shop-management-images__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  overflow: auto;
  gap: 1rem;
}
.shop-management-images .shop-management-images__grid .shop-management-images__image-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 1.5rem;
  padding: 0.5rem;
}
.shop-management-images .shop-management-images__grid .shop-management-images__image-item {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.5);
}
body.theme-dark .shop-management-images .shop-management-images__grid .shop-management-images__image-item {
  background-color: rgba(0, 0, 0, 0.2);
}

.shop-management-images .shop-management-images__grid .shop-management-images__image-item .shop-management-images__image-wrapper {
  width: 100%;
  box-sizing: border-box;
  height: 30rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.shop-management-images .shop-management-images__grid .shop-management-images__image-item .shop-management-images__image-wrapper img {
  max-height: 100%;
  max-width: 100%;
  border-radius: 0.5rem;
}
.shop-management-images .shop-management-images__grid .shop-management-images__image-item .shop-management-images__image-details {
  display: flex;
  gap: 0.5rem;
}

.shop-management-location {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  max-width: 80rem !important;
}
.shop-management-location {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .shop-management-location {
  color: white;
}

.shop-management-location .shop-management-location__button-not-found {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  align-items: center;
}
.shop-management-location .shop-management-location__button-not-found .shop-management-location__button-not-found-text {
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 1.4rem;
  text-align: center;
}
.shop-management-location .shop-management-location__buttons {
  align-self: center;
  display: flex;
  gap: 1rem;
}
.shop-management-location .shop-management-location__address {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.shop-management-location .shop-management-location__address .shop-management-location__inputs-area {
  align-items: center;
  border-radius: 1.5rem;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -1rem;
}
.shop-management-location .shop-management-location__address .shop-management-location__inputs-area .shop-management-location__details-item {
  flex: 0 1 50%;
  box-sizing: border-box;
  padding: 1rem;
}
.shop-management-location .shop-management-location__address .shop-management-location__inputs-area .shop-management-location__details-item .shop-management-location__details-title {
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 1.4rem;
  margin: 0.5rem 1rem 1rem;
}
.shop-management-location .shop-management-location__address .shop-management-location__inputs-area .shop-management-location__details-item .demmi-ui-button {
  width: 100%;
}
.shop-management-location .shop-management-location__geo {
  width: 100%;
  height: 40rem;
  box-sizing: border-box;
}
.shop-management-location .shop-management-location__geo #gmaps-view {
  border-radius: 1rem;
}
.shop-management-location .shop-management-location__geo #gmaps-view .shop-management-location__geo-input-search {
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 1rem 1.6rem !important;
  font-size: 1.3rem;
  letter-spacing: 0.08rem;
  line-height: 2rem;
  width: 30rem !important;
  height: auto !important;
  box-sizing: border-box;
  outline: none;
  border-radius: 0.8rem !important;
  border: 0.2rem solid transparent;
  transition: background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
@media (max-width: 580px) {
  .shop-management-location {
    gap: 2rem;
  }
  .shop-management-location .shop-management-location__address .shop-management-location__inputs-area .shop-management-location__details-item {
    flex: 0 1 100%;
  }
}

.gmap-autocomplete {
  width: 30rem;
  box-sizing: border-box;
  margin-top: 0.8rem;
  margin-left: 0.8rem;
}
.gmap-autocomplete .demmi-ui-input {
  opacity: 0.9;
  box-sizing: border-box;
}
.gmap-autocomplete .demmi-ui-input {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .gmap-autocomplete .demmi-ui-input {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.8);
}

.gmap-autocomplete .demmi-ui-input:hover {
  opacity: 1;
}
.gmap-autocomplete .demmi-ui-input:hover {
  box-shadow: 0 0.9rem 1.2rem hsl(var(--theme-bg-hue), 100%, 20%,0.18);
}
body.theme-dark .gmap-autocomplete .demmi-ui-input:hover {
  box-shadow: 0 0.9rem 1.2rem hsl(var(--theme-bg-hue), 8%, 16%,0.48);
}

.gmap-autocomplete .demmi-ui-input:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .gmap-autocomplete .demmi-ui-input:hover {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.8);
}

.gmap-autocomplete .demmi-ui-input:focus {
  opacity: 1;
}
.gmap-autocomplete .demmi-ui-input:focus {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .gmap-autocomplete .demmi-ui-input:focus {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.8);
}

.gmap-autocomplete .demmi-ui-menu {
  margin-top: 0.8rem;
  box-sizing: border-box;
}
.gmap-autocomplete .demmi-ui-menu .demmi-ui-menu-item {
  text-align: start;
}
.gmap-autocomplete .gmap-autocomplete__predictions {
  box-sizing: border-box;
  background: white;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden auto;
  max-height: 40rem;
  border-radius: 2rem;
  box-shadow: 0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12), 0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);
}

.shop-management-delivery-days {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 30rem;
  overflow: hidden;
}

.shop-management-theme-item {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  border-radius: 1rem;
  padding: 0.5rem;
  box-sizing: border-box;
  cursor: pointer;
}
.shop-management-theme-item {
  background-color: rgba(255, 255, 255, 0.4);
}
body.theme-dark .shop-management-theme-item {
  background-color: rgba(0, 0, 0, 0.4);
}

.shop-management-theme-item .shop-management-theme-item__block {
  height: 100%;
  width: 100%;
  border-radius: 0.5rem;
}
.shop-management-theme-item:hover {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .shop-management-theme-item:hover {
  background-color: black;
}

.shop-management-theme {
  padding: 2rem;
  box-sizing: border-box;
  margin: 0 auto;
  max-height: 100%;
  width: 100%;
  max-width: 100rem;
  align-self: center;
  gap: 2rem 3rem;
  display: grid;
  grid-template: "phone appswitcher" 5rem "phone themes" 75rem "buttons buttons" 6rem/auto 1fr;
}
.shop-management-theme {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .shop-management-theme {
  color: rgba(255, 255, 255, 0.8);
}

.shop-management-theme .shop-management-theme__items {
  grid-area: themes;
  overflow: auto;
  border-radius: 1rem;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.shop-management-theme .fake-phone {
  grid-area: phone;
}
.shop-management-theme .shop-management-theme__buttons {
  grid-area: buttons;
  display: flex;
  gap: 1rem;
  margin: 1rem auto 0;
}
@media (max-width: 1350px) {
  .shop-management-theme {
    gap: 1.6rem;
    padding: 1.6rem;
    grid-template: "phone appswitcher" 5rem "phone themes" 68rem "buttons buttons" 6rem/36rem auto;
  }
}
@media (max-width: 1100px) {
  .shop-management-theme {
    padding: 2rem;
    gap: 2rem 3rem;
    grid-template: "phone appswitcher" 5rem "phone themes" 75rem "buttons buttons" 6rem/auto 1fr;
  }
}
@media (max-width: 900px) {
  .shop-management-theme {
    gap: 1.6rem;
    padding: 1.6rem;
    grid-template: "phone appswitcher" 5rem "phone themes" 68rem "buttons buttons" 6rem/36rem auto;
  }
}
@media (max-width: 800px) {
  .shop-management-theme {
    gap: 0.8rem;
    padding: 2rem 1.2rem;
    grid-template: "phone appswitcher" 5rem "phone themes" 62rem "buttons buttons" 6rem/32rem auto;
  }
}
@media (max-width: 700px) {
  .shop-management-theme {
    max-width: 46rem;
    gap: 2rem;
    grid-template: "appswitcher" 5rem "phone" 72rem "themes" 70rem "buttons" auto/1fr;
  }
  .shop-management-theme .shop-management-theme__buttons {
    margin-top: 0;
    padding-bottom: 2rem;
  }
}
@media (max-width: 440px) {
  .shop-management-theme .fake-phone {
    width: 36rem;
  }
}
@media (max-width: 400px) {
  .shop-management-theme .fake-phone {
    width: 34rem;
  }
}

.shop-management-opening-hours .shop-management-opening-hours__slots-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  border-radius: 1.6rem;
  margin-bottom: 1.2rem;
}
.shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slots-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 1.4rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 1.8rem;
  padding: 0 0.8rem 0 1.6rem;
  margin-top: 2.4rem;
  text-align: start;
  box-sizing: border-box;
}
.shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slots-title {
  color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slots-title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  gap: 2rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  border-radius: 2.4rem;
  padding: 1.2rem 1.2rem;
}
.shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.5);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row {
  background-color: rgba(0, 0, 0, 0.2);
}

.shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item {
  flex: 1 1 auto;
}
.shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item .shop-management-opening-hours__slot-title {
  font-size: 1.1rem;
  letter-spacing: 0.05rem;
  font-weight: 600;
  line-height: 1.2rem;
  text-transform: uppercase;
  margin: 0rem 0 0.8rem 1rem;
}
.shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item .shop-management-opening-hours__slot-title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item .shop-management-opening-hours__slot-title {
  color: white;
}

@media (max-width: 580px) {
  .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item .demmi-ui-input-time {
    width: 17rem;
  }
}
@media (max-width: 520px) {
  .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item .demmi-ui-input-time {
    width: 15rem;
  }
}
@media (max-width: 480px) {
  .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row {
    width: 100%;
    display: grid;
    grid-template: "slotStart button" "slotEnd button" auto/1fr auto;
  }
  .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item:nth-child(1) {
    grid-area: slotStart;
  }
  .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item:nth-child(2) {
    grid-area: slotEnd;
  }
  .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .shop-management-opening-hours__slot-item .demmi-ui-input-time {
    width: 18rem;
  }
  .shop-management-opening-hours .shop-management-opening-hours__slots-container .shop-management-opening-hours__slot-row .demmi-ui-icon-button {
    margin-right: 0.8rem;
    grid-area: button;
  }
}

.shop-management-opening-hours .shop-management-opening-hours__preview {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  margin-top: 1.2rem;
  border-radius: 0.8rem;
}
.shop-management-opening-hours .shop-management-opening-hours__preview {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.4);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__preview {
  background-color: rgba(0, 0, 0, 0.2);
}

.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-text {
  text-align: center;
  padding: 1.2rem 0 1.6rem;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.8rem;
}
.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-text {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-text span {
  display: block;
  margin-top: 0.4rem;
}
.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  padding: 0;
}
.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__open-slot {
  position: absolute;
  top: 3.2rem;
  bottom: 0;
  border-radius: 0.8rem;
  margin-left: 1rem;
  padding-right: 0.6rem;
}
.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__open-slot {
  background-color: white;
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__open-slot {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__time-slot {
  flex: 0 0 6rem;
  height: 6rem;
  text-align: center;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: flex-start;
  padding: 1rem 1.2rem 0.4rem;
  box-sizing: border-box;
  border-radius: 0.8rem;
  transition: background-color 0.1s ease-in-out;
}
.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__time-slot .shop-management-opening-hours__time {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1.2rem;
}
.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__time-slot .shop-management-opening-hours__time .shop-management-opening-hours__time-text {
  flex: 0 0 auto;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.4rem;
  letter-spacing: 0.08rem;
}
.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__time-slot .shop-management-opening-hours__time .shop-management-opening-hours__time-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__time-slot .shop-management-opening-hours__time .shop-management-opening-hours__time-text {
  color: white;
}

.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__time-slot .shop-management-opening-hours__time .shop-management-opening-hours__time-line {
  width: 0.2rem;
  height: 100%;
}
.shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__time-slot .shop-management-opening-hours__time .shop-management-opening-hours__time-line {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__preview .shop-management-opening-hours__preview-timeline .shop-management-opening-hours__time-slot .shop-management-opening-hours__time .shop-management-opening-hours__time-line {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.shop-management-opening-hours .shop-management-opening-hours__preview.shop-management-opening-hours__preview--closed .shop-management-opening-hours__preview-timeline {
  opacity: 0.4;
  overflow: hidden;
}

.shop-management-opening-hours {
  max-width: 64rem !important;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.shop-management-opening-hours {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .shop-management-opening-hours {
  color: rgba(255, 255, 255, 0.8);
}

.shop-management-opening-hours .shop-management-opening-hours__days {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 1.5rem;
  box-sizing: border-box;
  gap: 2rem;
  padding: 0;
}
.shop-management-opening-hours .shop-management-opening-hours__days .shop-management-opening-hours__day {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 1.2rem;
  box-sizing: border-box;
  border-radius: 1.6rem;
}
.shop-management-opening-hours .shop-management-opening-hours__days .shop-management-opening-hours__day {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__days .shop-management-opening-hours__day {
  color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.shop-management-opening-hours .shop-management-opening-hours__days .shop-management-opening-hours__day .shop-management-opening-hours__day-toggle {
  flex: 0 0 14rem;
}
.shop-management-opening-hours .shop-management-opening-hours__days .shop-management-opening-hours__day .shop-management-opening-hours__day-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 1.4rem;
  padding: 0 0 0 2.4rem;
  box-sizing: border-box;
}
.shop-management-opening-hours .shop-management-opening-hours__days .shop-management-opening-hours__day .shop-management-opening-hours__day-title {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .shop-management-opening-hours .shop-management-opening-hours__days .shop-management-opening-hours__day .shop-management-opening-hours__day-title {
  color: white;
}

.shop-management-opening-hours .shop-management-opening-hours__days .shop-management-opening-hours__day .shop-management-opening-hours__buttons {
  margin-top: 2rem;
}

.sm-collection-schedule-edit {
  width: 100%;
  max-width: 72rem !important;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.sm-collection-schedule-edit .sm-collection-schedule-edit__title {
  width: 100%;
  margin-top: 1.6rem;
  text-align: center;
  font-size: 1.8rem;
  letter-spacing: 0.04rem;
  font-weight: 400;
  line-height: 2.4rem;
  box-sizing: border-box;
}
.sm-collection-schedule-edit .sm-collection-schedule-edit__title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-edit .sm-collection-schedule-edit__title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-edit .sm-collection-schedule-edit__no-edit {
  letter-spacing: 0.1rem;
  font-weight: 600;
  font-size: 1.2rem;
  padding: 0.8rem 1.6rem;
  border-radius: 0.8rem;
  text-align: center;
  margin: 0.8rem 0;
}
.sm-collection-schedule-edit .sm-collection-schedule-edit__no-edit {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .sm-collection-schedule-edit .sm-collection-schedule-edit__no-edit {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.sm-collection-schedule-edit .sm-collection-schedule-edit__no-edit {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-edit .sm-collection-schedule-edit__no-edit {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-edit .sm-collection-schedule-edit__delete {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.2rem;
}
.sm-collection-schedule-edit .sm-collection-schedule-edit__delete .sm-collection-schedule-edit__warning {
  font-size: 1.2rem;
  letter-spacing: 0.04rem;
  font-weight: 500;
  line-height: 1.4rem;
  box-sizing: border-box;
}
.sm-collection-schedule-edit .sm-collection-schedule-edit__delete .sm-collection-schedule-edit__warning {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-edit .sm-collection-schedule-edit__delete .sm-collection-schedule-edit__warning {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-preview {
  width: 100%;
  max-width: 64rem !important;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.sm-collection-schedule-preview .sm-collection-schedule-preview__title {
  width: 100%;
  margin-top: 1.6rem;
  text-align: center;
  font-size: 1.8rem;
  letter-spacing: 0.04rem;
  font-weight: 400;
  line-height: 2.4rem;
  box-sizing: border-box;
}
.sm-collection-schedule-preview .sm-collection-schedule-preview__title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-preview .sm-collection-schedule-preview__title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-create {
  width: 100%;
  max-width: 68rem !important;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.sm-collection-schedule-create .sm-collection-schedule-create__title {
  width: 100%;
  margin-top: 1.6rem;
  text-align: center;
  font-size: 1.8rem;
  letter-spacing: 0.04rem;
  font-weight: 400;
  line-height: 2.4rem;
  box-sizing: border-box;
}
.sm-collection-schedule-create .sm-collection-schedule-create__title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-create .sm-collection-schedule-create__title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-create .sm-collection-schedule-create__date .sm-collection-schedule-create__date-text {
  width: 100%;
  margin-top: 2.4rem;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.04rem;
  font-weight: 400;
  line-height: 1.8rem;
  box-sizing: border-box;
}
.sm-collection-schedule-create .sm-collection-schedule-create__date .sm-collection-schedule-create__date-text {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-create .sm-collection-schedule-create__date .sm-collection-schedule-create__date-text {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-create .sm-collection-schedule-create__date .sm-collection-schedule-create__date-text span {
  font-weight: 500;
  margin: 0 1.6rem;
}
.sm-collection-schedule-create .sm-collection-schedule-create__days {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 1.5rem;
  box-sizing: border-box;
  gap: 2rem;
  padding: 0;
}

.sm-collection-schedule-date-picker {
  margin: 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}
.sm-collection-schedule-date-picker .sm-collection-schedule-date-picker-title {
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.04rem;
  font-weight: 500;
  line-height: 1.8rem;
  box-sizing: border-box;
}
.sm-collection-schedule-date-picker .sm-collection-schedule-date-picker-title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-date-picker .sm-collection-schedule-date-picker-title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-create__days {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 1.5rem;
  box-sizing: border-box;
  gap: 2rem;
  padding: 0;
}

.sm-collection-schedule-day-edit {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 1.2rem;
  box-sizing: border-box;
  border-radius: 1.6rem;
}
.sm-collection-schedule-day-edit {
  color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 1);
}
body.theme-dark .sm-collection-schedule-day-edit {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.sm-collection-schedule-day-edit .sm-collection-schedule-day-edit__toggle {
  flex: 0 0 17rem;
}
.sm-collection-schedule-day-edit .sm-collection-schedule-day-edit__title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 1.4rem;
  padding: 0 0 0 2.4rem;
  box-sizing: border-box;
}
.sm-collection-schedule-day-edit .sm-collection-schedule-day-edit__title {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .sm-collection-schedule-day-edit .sm-collection-schedule-day-edit__title {
  color: white;
}

.sm-collection-schedule-day-edit .sm-collection-schedule-day-edit__buttons {
  margin-top: 2rem;
}

.sm-collection-schedule-day-preview-timeline {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  margin-top: 1.2rem;
  border-radius: 0.8rem;
}
.sm-collection-schedule-day-preview-timeline {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.4);
}
body.theme-dark .sm-collection-schedule-day-preview-timeline {
  background-color: rgba(0, 0, 0, 0.2);
}

.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-text {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-text span {
  border-radius: 1.2rem;
  padding: 1.2rem 2rem;
  box-sizing: border-box;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 2rem;
  backdrop-filter: blur(4px);
  white-space: pre-line;
  text-align: center;
}
.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-text span {
  background-color: rgba(255, 255, 255, 0.7);
}
body.theme-dark .sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-text span {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-text span {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-text span {
  color: rgb(255, 255, 255);
}

.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  padding: 0;
}
.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__available-slot {
  position: absolute;
  top: 3.2rem;
  bottom: 0;
  border-radius: 0.8rem;
  margin-left: 1rem;
  padding-right: 0.6rem;
  scroll-margin: 1.6rem;
}
.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__available-slot {
  background-color: white;
}
body.theme-dark .sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__available-slot {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__time-slot {
  flex: 0 0 6rem;
  height: 6rem;
  text-align: center;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: flex-start;
  padding: 1rem 1.2rem 0.4rem;
  box-sizing: border-box;
  border-radius: 0.8rem;
  transition: background-color 0.1s ease-in-out;
}
.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__time-slot .sm-collection-schedule-day-preview-timeline__time {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 1.2rem;
}
.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__time-slot .sm-collection-schedule-day-preview-timeline__time .sm-collection-schedule-day-preview-timeline__time-text {
  flex: 0 0 auto;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.4rem;
  letter-spacing: 0.08rem;
}
.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__time-slot .sm-collection-schedule-day-preview-timeline__time .sm-collection-schedule-day-preview-timeline__time-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__time-slot .sm-collection-schedule-day-preview-timeline__time .sm-collection-schedule-day-preview-timeline__time-text {
  color: white;
}

.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__time-slot .sm-collection-schedule-day-preview-timeline__time .sm-collection-schedule-day-preview-timeline__time-line {
  width: 0.2rem;
  height: 100%;
}
.sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__time-slot .sm-collection-schedule-day-preview-timeline__time .sm-collection-schedule-day-preview-timeline__time-line {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .sm-collection-schedule-day-preview-timeline .sm-collection-schedule-day-preview-timeline__preview-timeline .sm-collection-schedule-day-preview-timeline__time-slot .sm-collection-schedule-day-preview-timeline__time .sm-collection-schedule-day-preview-timeline__time-line {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.sm-collection-schedule-day-preview-timeline.sm-collection-schedule-day-preview-timeline__preview--closed .sm-collection-schedule-day-preview-timeline__preview-timeline {
  opacity: 0.4;
  overflow: hidden;
}

.sm-collection-schedule-editing-view__day {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}
.sm-collection-schedule-editing-view__day {
  color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view__day {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__toggle {
  flex: 0 0 17rem;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 1.6rem;
  padding: 0 0 0 1.6rem;
  box-sizing: border-box;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__title {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__title {
  color: white;
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__badge {
  letter-spacing: 0.1rem;
  font-weight: 600;
  font-size: 1.2rem;
  padding: 0.8rem 1.6rem;
  border-radius: 0.8rem;
  text-align: center;
  margin: 0.8rem 0.8rem;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__badge {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__badge {
  color: white;
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__error {
  letter-spacing: 0.1rem;
  font-weight: 600;
  font-size: 1.2rem;
  padding: 0.8rem 1.6rem;
  border-radius: 0.8rem;
  text-align: center;
  margin: 0.8rem 0;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__error {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__error {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__error {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__error {
  color: white;
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  border-radius: 1.6rem;
  margin-top: 1.2rem;
  padding: 0 1rem 1rem;
  box-sizing: border-box;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  box-sizing: border-box;
  align-items: start;
  border-radius: 1.6rem;
  padding: 0.8rem 0;
  flex-wrap: wrap;
  gap: 1.2rem;
  justify-content: space-between;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day .sm-collection-schedule-editing-view__day__day-time {
  position: relative;
  width: 100%;
  flex: 1 1 auto;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  gap: 0.8rem;
  justify-content: space-between;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day .sm-collection-schedule-editing-view__day__day-section {
  flex: 0 0 calc(50% - 3rem);
  flex-direction: row;
  position: relative;
  display: flex;
  gap: 1.2rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day .sm-collection-schedule-editing-view__day__day-section .sm-collection-schedule-editing-view__day__day-section-title {
  width: 100%;
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 1.8rem;
  margin-left: 0.8rem;
  text-align: start;
  box-sizing: border-box;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day .sm-collection-schedule-editing-view__day__day-section .sm-collection-schedule-editing-view__day__day-section-title {
  color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day .sm-collection-schedule-editing-view__day__day-section .sm-collection-schedule-editing-view__day__day-section-title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

@media (max-width: 600px) {
  .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day .sm-collection-schedule-editing-view__day__day-section {
    flex: 0 0 calc(50% - 1.2rem);
  }
}
@media (max-width: 500px) {
  .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day {
    width: 100%;
    flex-direction: column;
    gap: 0.8rem;
  }
  .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day .sm-collection-schedule-editing-view__day__day-time {
    width: 100%;
    flex-direction: column;
    gap: 0.8rem;
  }
  .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__day .sm-collection-schedule-editing-view__day__day-section {
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
  }
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  align-items: center;
  margin-top: 0.8rem;
  padding: 2.4rem 1.6rem 1.6rem;
  border-radius: 1.6rem;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.5);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container {
  background-color: rgba(0, 0, 0, 0.2);
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__breaks-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 1.4rem;
  box-sizing: border-box;
  margin-bottom: 1.6rem;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__breaks-title {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__breaks-title {
  color: white;
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row {
  width: 100%;
  position: relative;
  flex: 1 1 auto;
  display: flex;
  gap: 2rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 1.2rem 1.2rem;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row::after {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.1rem;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row::after {
  background-color: white;
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.5);
}

.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row .sm-collection-schedule-editing-view__day__break-item {
  flex: 1 1 auto;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  gap: 0.8rem;
  justify-content: space-between;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row .sm-collection-schedule-editing-view__day__break-item .sm-collection-schedule-editing-view__day__break-title {
  width: 100%;
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 1.8rem;
  text-align: start;
  box-sizing: border-box;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row .sm-collection-schedule-editing-view__day__break-item .sm-collection-schedule-editing-view__day__break-title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row .sm-collection-schedule-editing-view__day__break-item .sm-collection-schedule-editing-view__day__break-title {
  color: white;
}

@media (max-width: 620px) {
  .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row {
    flex-direction: column;
    gap: 0.8rem;
  }
  .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row .sm-collection-schedule-editing-view__day__day-time {
    width: 100%;
    flex-direction: column;
    gap: 0.8rem;
  }
  .sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .sm-collection-schedule-editing-view__day__break-row .sm-collection-schedule-editing-view__day__break-item {
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
  }
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__days-container .sm-collection-schedule-editing-view__day__breaks-container .demmi-ui-button {
  margin-top: 1.6rem;
}
.sm-collection-schedule-editing-view__day .sm-collection-schedule-editing-view__day__buttons {
  margin-top: 2rem;
}

.sm-collection-schedule-editing-view {
  width: 100%;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__date {
  max-width: 100%;
}
.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__date .sm-collection-schedule-editing-view__date-text {
  width: 100%;
  margin-top: 2.4rem;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.04rem;
  font-weight: 400;
  line-height: 1.8rem;
  box-sizing: border-box;
}
.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__date .sm-collection-schedule-editing-view__date-text {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__date .sm-collection-schedule-editing-view__date-text {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__date .sm-collection-schedule-editing-view__date-text span {
  font-weight: 500;
  margin: 0 1.6rem;
}
.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__days {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 1.5rem;
  box-sizing: border-box;
  gap: 2rem;
  padding: 0;
}
.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.2rem;
  letter-spacing: 0.08rem;
  font-weight: 500;
  font-size: 1.5rem;
  padding: 1.6rem 2rem;
  border-radius: 0.8rem;
  text-align: center;
}
.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__error {
  color: white;
}
body.theme-dark .sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__error {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}

.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__error {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__error {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.8);
}

.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__error span {
  display: flex;
  gap: 0.8rem;
  text-align: center;
  justify-content: center;
  align-items: center;
}
.sm-collection-schedule-editing-view .sm-collection-schedule-editing-view__error .sm-collection-schedule-editing-view__error-message {
  letter-spacing: 0.12rem;
  font-weight: 400;
  font-size: 1.2rem;
}

.sm-collection-schedule-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  margin: 0.8rem 0;
}
.sm-collection-schedule-list .sm-collection-schedule-list__title {
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.04rem;
  font-weight: 500;
  line-height: 1.8rem;
  margin: 2rem 0 1.2rem;
  box-sizing: border-box;
}
.sm-collection-schedule-list .sm-collection-schedule-list__title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-list .sm-collection-schedule-list__title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-list .sm-collection-schedule-list__item {
  position: relative;
  flex: 1 1 auto;
  width: 38rem;
  display: flex;
  gap: 1.2rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: flex-start;
  border-radius: 1.6rem;
  padding: 1.2rem;
}
.sm-collection-schedule-list .sm-collection-schedule-list__item {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.4);
}
body.theme-dark .sm-collection-schedule-list .sm-collection-schedule-list__item {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.sm-collection-schedule-list .sm-collection-schedule-list__item:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.8);
}
body.theme-dark .sm-collection-schedule-list .sm-collection-schedule-list__item:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.sm-collection-schedule-list .sm-collection-schedule-list__item.sm-collection-schedule-list__item--expired {
  pointer-events: none;
}
.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-dates {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2rem;
}
.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-dates .sm-collection-schedule-list__item-date-item {
  flex: 0 0 10rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 0.4rem;
}
.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-dates .sm-collection-schedule-list__item-date-item {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-dates .sm-collection-schedule-list__item-date-item {
  color: white;
}

.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-dates .sm-collection-schedule-list__item-date-item .sm-collection-schedule-list__item-date-title {
  font-size: 1.1rem;
  letter-spacing: 0.16rem;
  font-weight: 700;
  line-height: 1.8rem;
  box-sizing: border-box;
  opacity: 0.6;
  text-transform: uppercase;
}
.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-dates .sm-collection-schedule-list__item-date-item .sm-collection-schedule-list__item-date {
  font-size: 1.4rem;
  letter-spacing: 0.12rem;
  font-weight: 400;
  line-height: 1.8rem;
  box-sizing: border-box;
}
.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-controls {
  display: flex;
  margin-left: auto;
  gap: 0.8rem;
}
.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-badge {
  margin-left: auto;
  letter-spacing: 0.16rem;
  font-weight: 600;
  font-size: 1.1rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.8rem;
  text-align: center;
  text-transform: uppercase;
}
.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-badge {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-badge {
  color: white;
}

.sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .sm-collection-schedule-list .sm-collection-schedule-list__item .sm-collection-schedule-list__item-badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.sm-collection-schedule-preview-view__day {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0.4rem !important;
}
.sm-collection-schedule-preview-view__day {
  color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 1);
}
body.theme-dark .sm-collection-schedule-preview-view__day {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.5rem;
  letter-spacing: 0.08rem;
  font-weight: 400;
  line-height: 4.8rem;
  padding: 0 1.6rem;
  margin: 0.8rem 0;
  box-sizing: border-box;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__title {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__title {
  color: white;
}

.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__title .sm-collection-schedule-preview-view__day__title-badge {
  flex: 0 0 auto;
  position: relative;
  display: flex;
  gap: 4rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.8rem;
  padding: 0.8rem 1.2rem;
  font-size: 1.12rem;
  letter-spacing: 0.12rem;
  line-height: 1.4rem;
  font-weight: 600;
  text-transform: uppercase;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__title .sm-collection-schedule-preview-view__day__title-badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.5);
}
body.theme-dark .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__title .sm-collection-schedule-preview-view__day__title-badge {
  background-color: rgba(0, 0, 0, 0.2);
}

.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  border-radius: 1.6rem;
  margin-top: 1.2rem;
  box-sizing: border-box;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day {
  width: 100%;
  position: relative;
  flex: 1 1 auto;
  display: flex;
  box-sizing: border-box;
  align-items: start;
  border-radius: 1.6rem;
  padding: 0 1.2rem;
  margin-top: -0.8rem;
  flex-wrap: wrap;
  gap: 0.8rem;
  justify-content: space-between;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-time {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  gap: 0.8rem;
  justify-content: space-between;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-section {
  flex: 0 0 calc(50% - 2rem);
  justify-content: space-between;
  flex-direction: row;
  position: relative;
  display: flex;
  gap: 0.8rem;
  box-sizing: border-box;
  align-items: center;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-section {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-section {
  color: white;
}

.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-section .sm-collection-schedule-preview-view__day__day-section-title {
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 1.8rem;
  text-align: start;
  box-sizing: border-box;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-section .sm-collection-schedule-preview-view__day__day-section-title {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.6);
}
body.theme-dark .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-section .sm-collection-schedule-preview-view__day__day-section-title {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-section span {
  font-size: 1.2rem;
  display: inline-block;
}
@media (max-width: 400px) {
  .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day {
    flex-direction: column;
    gap: 0.8rem;
  }
  .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-time {
    width: 100%;
    flex-direction: column;
    gap: 0.8rem;
  }
  .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__day .sm-collection-schedule-preview-view__day__day-section {
    width: 100%;
    justify-content: space-between;
    flex-direction: row;
  }
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  box-sizing: border-box;
  align-items: flex-start;
  margin-top: 2rem;
  padding: 0 1.2rem;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__breaks-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 1.5rem;
  letter-spacing: 0.08rem;
  font-weight: 400;
  line-height: 1.4rem;
  margin: 0.8rem 0;
  padding-left: 0.4rem;
  box-sizing: border-box;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__breaks-title {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__breaks-title {
  color: white;
}

.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__break-row {
  position: relative;
  display: flex;
  gap: 4rem;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.8rem;
  padding: 1rem 1.2rem;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__break-row {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.5);
}
body.theme-dark .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__break-row {
  background-color: rgba(0, 0, 0, 0.2);
}

.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__break-row .sm-collection-schedule-preview-view__day__break-item {
  flex: 0 0 8rem;
  width: 8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.4rem;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__break-row .sm-collection-schedule-preview-view__day__break-item .sm-collection-schedule-preview-view__day__break-title {
  font-size: 1.1rem;
  letter-spacing: 0.05rem;
  font-weight: 600;
  text-transform: uppercase;
}
.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__break-row .sm-collection-schedule-preview-view__day__break-item .sm-collection-schedule-preview-view__day__break-title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__days-container .sm-collection-schedule-preview-view__day__breaks-container .sm-collection-schedule-preview-view__day__break-row .sm-collection-schedule-preview-view__day__break-item .sm-collection-schedule-preview-view__day__break-title {
  color: white;
}

.sm-collection-schedule-preview-view__day .sm-collection-schedule-preview-view__day__buttons {
  margin-top: 2rem;
}

.sm-collection-schedule-preview-view {
  width: 100%;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.sm-collection-schedule-preview-view .sm-collection-schedule-preview-view__days {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 1.5rem;
  box-sizing: border-box;
  gap: 2rem;
  padding: 0;
}
.sm-collection-schedule-preview-view .sm-collection-schedule-preview-view__date .sm-collection-schedule-preview-view__date-text {
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.04rem;
  font-weight: 400;
  line-height: 1.8rem;
  box-sizing: border-box;
}
.sm-collection-schedule-preview-view .sm-collection-schedule-preview-view__date .sm-collection-schedule-preview-view__date-text {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.8);
}
body.theme-dark .sm-collection-schedule-preview-view .sm-collection-schedule-preview-view__date .sm-collection-schedule-preview-view__date-text {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sm-collection-schedule-preview-view .sm-collection-schedule-preview-view__date .sm-collection-schedule-preview-view__date-text span {
  font-weight: 500;
  margin: 0 1.6rem;
}

.sm-collection-schedule {
  width: 100%;
  max-width: 68rem !important;
  border-radius: 2rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3rem;
  margin: 0 auto;
}
.sm-collection-schedule {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .sm-collection-schedule {
  color: rgba(255, 255, 255, 0.8);
}

.shop-management {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  overflow: auto;
}
.shop-management .shop-management__content-wrapper {
  padding: 2rem;
  max-width: 90rem;
  margin: 0 auto;
  box-sizing: border-box;
}
@media (max-width: 480px) {
  .shop-management .shop-management__content-wrapper {
    padding: 1.2rem;
  }
}

.demmi-support-sidebar-button {
  display: grid;
  grid-template: "title time" 2.4rem "order order" auto "message message" 1.8rem/auto auto;
  gap: 0.8rem 1.5rem;
  padding: 1.6rem 1.6rem;
  align-items: center;
}
.demmi-support-sidebar-button .demmi-support-sidebar-button__text {
  grid-area: title;
  font-size: 1.5rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.demmi-support-sidebar-button .demmi-support-sidebar-button__text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .demmi-support-sidebar-button .demmi-support-sidebar-button__text {
  color: white;
}

.demmi-support-sidebar-button .demmi-support-sidebar-button__order-info {
  grid-area: order;
  font-size: 1.1rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0.6rem 1.2rem;
  text-align: center;
  border-radius: 0.8rem;
}
.demmi-support-sidebar-button .demmi-support-sidebar-button__order-info {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-support-sidebar-button .demmi-support-sidebar-button__order-info {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.1);
}

.demmi-support-sidebar-button .demmi-support-sidebar-button__order-info {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .demmi-support-sidebar-button .demmi-support-sidebar-button__order-info {
  color: white;
}

.demmi-support-sidebar-button .demmi-support-sidebar-button__message {
  display: flex;
  align-items: center;
  gap: 1rem;
  grid-area: message;
  font-size: 1.2rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.demmi-support-sidebar-button .demmi-support-sidebar-button__message {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .demmi-support-sidebar-button .demmi-support-sidebar-button__message {
  color: white;
}

.demmi-support-sidebar-button .demmi-support-sidebar-button__time {
  grid-area: time;
  text-align: end;
  line-height: 2rem;
  font-size: 1.3rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
}
.demmi-support-sidebar-button .demmi-support-sidebar-button__time {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .demmi-support-sidebar-button .demmi-support-sidebar-button__time {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.8);
}

.demmi-support-chat {
  grid-area: chat;
  padding: 0;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  min-width: 34rem;
  max-width: 72rem;
  margin: 0 auto;
  flex-direction: column;
  overflow: hidden;
  gap: 0.8rem;
}
.demmi-support-chat.demmi-support-chat--is-loading > *:not(.element-loading-indicator) {
  opacity: 0.4;
}
body.theme-dark .demmi-support-chat--is-loading > :not(.element-loading-indicator) {
  opacity: 0.4;
}

.demmi-support-chat .demmi-support-chat__title {
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  line-height: 5rem;
  text-align: center;
  font-size: 1.4rem;
  letter-spacing: 0.05rem;
  font-weight: 600;
  border-radius: 2.4rem 2.4rem 1.2rem 1.2rem;
  box-sizing: border-box;
}
.demmi-support-chat .demmi-support-chat__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .demmi-support-chat .demmi-support-chat__title {
  color: white;
}

.demmi-support-chat .demmi-support-chat__title {
  background-color: rgba(255, 255, 255, 0.4);
}
body.theme-dark .demmi-support-chat .demmi-support-chat__title {
  background-color: rgba(0, 0, 0, 0.2);
}

.demmi-support-chat .demmi-support-chat__content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 1.2rem 1.2rem 2.4rem 2.4rem;
  box-sizing: border-box;
  overflow: auto;
}
.demmi-support-chat .demmi-support-chat__content {
  background-color: rgba(255, 255, 255, 0.4);
}
body.theme-dark .demmi-support-chat .demmi-support-chat__content {
  background-color: rgba(0, 0, 0, 0.2);
}

.demmi-support-chat .demmi-support-chat__content .demmi-support-chat__messages {
  flex: 1 1 auto;
  overflow: hidden auto;
  box-sizing: border-box;
  padding: 1rem 0;
  position: relative;
}
.demmi-support-chat .demmi-support-chat__content .demmi-support-chat__messages .demmi-support-chat__no-messages {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  font-weight: 300;
  line-height: 1.8rem;
  text-align: center;
}
.demmi-support-chat .demmi-support-chat__content .demmi-support-chat__messages .demmi-support-chat__no-messages {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .demmi-support-chat .demmi-support-chat__content .demmi-support-chat__messages .demmi-support-chat__no-messages {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.demmi-support-chat .demmi-support-chat__input-area {
  position: relative;
  flex: 0 0 auto;
  display: flex;
  gap: 1rem;
  margin: 0 1rem 1rem;
}
.demmi-support-chat .demmi-support-chat__input-area.demmi-support-chat .demmi-support-chat__input-area--is-loading > *:not(.element-loading-indicator) {
  opacity: 0.4;
}
body.theme-dark .demmi-support-chat .demmi-support-chat__input-area--is-loading > :not(.element-loading-indicator) {
  opacity: 0.4;
}

.demmi-support-chat .demmi-support-chat--snippet {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.6rem 2rem 2rem;
  margin: 0 1.2rem 1.2rem 1.2rem;
  border-radius: 1.2rem;
  text-align: start;
}
.demmi-support-chat .demmi-support-chat--snippet {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .demmi-support-chat .demmi-support-chat--snippet {
  color: white;
}

.demmi-support-chat .demmi-support-chat--snippet {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-support-chat .demmi-support-chat--snippet {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.2);
}

.demmi-support-chat .demmi-support-chat-snippet-order .demmi-support-chat-snippet-order__title {
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  font-size: 1.4rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
}
.demmi-support-chat .demmi-support-chat-snippet-order .demmi-support-chat__key-val {
  margin: 1rem 0 0;
}
.demmi-support-chat .demmi-support-chat-snippet-order .demmi-support-chat__key-val .demmi-support-chat__key {
  font-weight: 500;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  opacity: 0.7;
  line-height: 1.4rem;
}
.demmi-support-chat .demmi-support-chat-snippet-order .demmi-support-chat__key-val .demmi-support-chat__value {
  font-weight: 400;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  line-height: 1.8rem;
}

.demmi-support-chat-message {
  position: relative;
  padding: 1rem 1.5rem;
  margin: 0 1.5rem 1rem 6.5rem;
  border-radius: 1.6rem 0 1.6rem 1.6rem;
  opacity: 1;
}
.demmi-support-chat-message {
  background-color: hsla(var(--theme-bg-hue), 100%, 100%, 1);
}
body.theme-dark .demmi-support-chat-message {
  background-color: hsla(var(--theme-bg-hue), 15%, 38%, 1);
}

.demmi-support-chat-message.demmi-support-chat-message--demmi {
  opacity: 1;
  margin: 0 6.5rem 1rem 1.5rem;
  border-radius: 0 1.6rem 1.6rem 1.6rem;
}
.demmi-support-chat-message.demmi-support-chat-message--demmi:after {
  left: -1rem;
  right: auto;
}
.demmi-support-chat-message:after {
  content: " ";
  position: absolute;
  width: 0;
  height: 0;
  right: -1rem;
  left: auto;
  top: 0;
  bottom: auto;
  border: 1rem solid;
  box-sizing: border-box;
  border-color: transparent;
}
.demmi-support-chat-message:after {
  border-top-color: hsla(var(--theme-bg-hue), 100%, 100%, 1);
}
body.theme-dark .demmi-support-chat-message:after {
  border-top-color: hsla(var(--theme-bg-hue), 15%, 38%, 1);
}

.demmi-support-chat-message .demmi-support-chat-message__text {
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  font-weight: 400;
  line-height: 2rem;
}
.demmi-support-chat-message .demmi-support-chat-message__text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .demmi-support-chat-message .demmi-support-chat-message__text {
  color: white;
}

.demmi-support-chat-message .demmi-support-chat-message__timestamp {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  text-align: end;
  margin-top: 1rem;
  line-height: 2rem;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.15rem;
}
.demmi-support-chat-message .demmi-support-chat-message__timestamp {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .demmi-support-chat-message .demmi-support-chat-message__timestamp {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.8);
}

.demmi-support {
  position: relative;
  z-index: 100;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 2rem 1rem;
}

.async-image {
  content: "";
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.async-image.async-image--loaded img {
  animation: image-fade-in 0.2s forwards;
}
.async-image.async-image--loaded .async-image__loading-indicator-wrapper {
  animation: loader-fade-out 0.2s forwards;
}
.async-image img {
  pointer-events: none;
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.async-image .async-image__loading-indicator-wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  opacity: 0.6;
  animation: image-loader 1.2s linear infinite;
}
.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator {
  background: linear-gradient(hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1), hsla(99, 90%, 80%, 0), hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1));
}
body.theme-dark .async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator {
  background: linear-gradient(white, hsla(99, 90%, 80%, 0), white);
}

.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:before {
  content: "";
  inset: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  filter: blur(0.4rem);
}
.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:before {
  background: linear-gradient(hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1), hsla(99, 90%, 80%, 0), hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1));
}
body.theme-dark .async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:before {
  background: linear-gradient(white, hsla(99, 90%, 80%, 0), white);
}

.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:after {
  content: "";
  position: absolute;
  inset: 0.2rem;
  border-radius: 50%;
}
.async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:after {
  background-color: hsl(99, 0%, 98%);
}
body.theme-dark .async-image .async-image__loading-indicator-wrapper .async-image__loading-indicator:after {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.8);
}

@keyframes image-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes image-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes loader-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.coming-soon {
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
}
.coming-soon .coming-soon__title {
  line-height: 5rem;
  text-align: center;
  font-weight: 200;
  font-size: 3.2rem;
  letter-spacing: 0.5rem;
  margin-bottom: 2rem;
  white-space: nowrap;
}
.coming-soon .coming-soon__title {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .coming-soon .coming-soon__title {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}

.coming-soon .coming-soon__description {
  max-width: 34rem;
  line-height: 2.2rem;
  text-align: center;
  font-weight: 400;
  font-size: 1.3rem;
  letter-spacing: 0.15rem;
}
.coming-soon .coming-soon__description {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .coming-soon .coming-soon__description {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.gallery-editor {
  display: block;
}
.gallery-editor .gallery-editor__thumbnails {
  --gallery-thumbnail-height: 12rem;
  --gallery-thumbnail-gap: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--gallery-thumbnail-height), 1fr));
  align-content: space-evenly;
  gap: var(--gallery-thumbnail-gap);
}
.gallery-editor .gallery-editor__thumbnails .gallery-editor__thumbnail-wrapper {
  display: block;
  position: relative;
}
.gallery-editor .gallery-editor__thumbnails .gallery-editor__thumbnail-wrapper .gallery-editor__button-delete {
  position: absolute;
  bottom: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.gallery-editor__thumbnail {
  position: relative;
  cursor: grab;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  transform-origin: 0 0;
  user-select: none;
  border-radius: 0.8rem;
  border: 0.4rem solid;
  overflow: hidden;
}
.gallery-editor__thumbnail {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.5);
}
body.theme-dark .gallery-editor__thumbnail {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.6);
}

.gallery-editor__thumbnail.gallery-editor__thumbnail--overlay {
  cursor: grabbing;
}
.gallery-editor__thumbnail.gallery-editor__thumbnail--overlay {
  border-color: white;
}
body.theme-dark .gallery-editor__thumbnail.gallery-editor__thumbnail--overlay {
  border-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.8);
}

.gallery-editor__thumbnail .async-image {
  pointer-events: none;
}
.gallery-editor__thumbnail .async-image img {
  pointer-events: none;
}

.gallery-editor-modal-delete__thumbnail {
  margin: 1rem auto 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.5rem;
  padding: 1rem;
}
.gallery-editor-modal-delete__thumbnail {
  background-color: rgba(255, 255, 255, 0.05);
}
body.theme-dark .gallery-editor-modal-delete__thumbnail {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.2);
}

.gallery-editor-modal-delete__thumbnail img {
  max-height: 25rem;
  max-width: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
}

.theme-switcher {
  position: relative;
  display: flex;
  gap: 0.4rem;
  width: fit-content;
  box-sizing: border-box;
  padding: 0 0.4rem;
  transition: box-shadow 0.1s ease-in-out;
  border-radius: 2rem;
  z-index: 100;
  background-color: red;
  margin: 0.8rem auto;
}
.theme-switcher {
  background-color: rgba(255, 255, 255, 0.5);
}
body.theme-dark .theme-switcher {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.theme-switcher .theme-switcher__item {
  z-index: 1;
  cursor: pointer;
  flex: 0 0 auto;
  display: flex;
  height: 4rem;
  align-items: center;
  padding: 0 2rem;
  gap: 1.2rem;
  transition: color 0.1s ease;
}
.theme-switcher .theme-switcher__item .theme-switcher__item-icon {
  flex: 0 0 1.2rem;
  width: 1.2rem;
  font-size: 1.2rem;
  transition: transform 0.2s ease;
}
.theme-switcher .theme-switcher__item .theme-switcher__item-icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .theme-switcher .theme-switcher__item .theme-switcher__item-icon {
  color: white;
}

.theme-switcher .theme-switcher__item .theme-switcher__item-icon svg {
  display: block;
}
.theme-switcher .theme-switcher__item .theme-switcher__item-text {
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  width: 6rem;
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  text-align: center;
  overflow: hidden;
}
.theme-switcher .theme-switcher__item .theme-switcher__item-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .theme-switcher .theme-switcher__item .theme-switcher__item-text {
  color: white;
}

.theme-switcher .theme-switcher__item.theme-switcher--active .theme-switcher__item-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .theme-switcher .theme-switcher__item.theme-switcher--active .theme-switcher__item-text {
  color: black;
}

.theme-switcher .theme-switcher__item.theme-switcher--active .theme-switcher__item-icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .theme-switcher .theme-switcher__item.theme-switcher--active .theme-switcher__item-icon {
  color: black;
}

.theme-switcher .theme-switcher__item:not(.theme-switcher--active) .theme-switcher__item-icon {
  transform: translate3d(0.6rem, 0, 0);
}
.theme-switcher .theme-switcher__item:not(.theme-switcher--active) .theme-switcher__item-text {
  opacity: 0;
  width: 0;
}
.theme-switcher .theme-switcher__indicator {
  z-index: 0;
  pointer-events: none;
  width: 12.4rem;
  border-radius: 1rem;
  position: absolute;
  top: 0rem;
  bottom: 0rem;
  transition: transform 0.2s ease;
}
.theme-switcher .theme-switcher__indicator {
  background-color: white;
}
body.theme-dark .theme-switcher .theme-switcher__indicator {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.theme-switcher .theme-switcher__indicator {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .theme-switcher .theme-switcher__indicator {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.theme-switcher.theme-switcher--light .theme-switcher__indicator {
  transform: translate3d(6.8rem, 0, 0);
}
.theme-switcher.theme-switcher--dark .theme-switcher__indicator {
  transform: translate3d(13.6rem, 0, 0);
}
.theme-switcher.theme-switcher--system .theme-switcher__indicator {
  left: 0.4rem;
}

.modal-create-demmi-support-ticket {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 50rem;
  margin: 4rem auto;
}
@media (max-width: 480px) {
  .modal-create-demmi-support-ticket {
    width: calc(100% - 2rem);
    margin: 1rem auto 0;
  }
}
.modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__title {
  line-height: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  padding: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__title {
  color: white;
}

.modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__error {
  margin-top: 1rem;
  line-height: 1.4rem;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  padding: 1.6rem 1.6rem;
  width: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
  text-align: center;
}
.modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__error {
  color: white;
}
body.theme-dark .modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__error {
  color: white;
}

.modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__error {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__error {
  background-color: hsl(0, 40%, 50%);
}

.modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__content {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;
  margin: 0 auto;
  box-sizing: border-box;
}
.modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__content {
  padding: 0 1rem 1rem;
}
body.theme-dark .modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__content {
  padding: 0;
}

.modal-create-demmi-support-ticket .modal-create-demmi-support-ticket__content input {
  margin-bottom: 1rem;
}

.modal-create-product {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 60rem;
  margin: 4rem auto;
}
@media (max-width: 480px) {
  .modal-create-product {
    width: calc(100% - 2rem);
    margin: 1rem auto;
  }
}
.modal-create-product .modal-create-product__title {
  line-height: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  padding: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-create-product .modal-create-product__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-create-product .modal-create-product__title {
  color: white;
}

.modal-create-product .modal-create-product__content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 auto;
  box-sizing: border-box;
}
.modal-create-product .modal-create-product__content {
  padding: 0 1rem 1rem;
}
body.theme-dark .modal-create-product .modal-create-product__content {
  padding: 0;
}

.modal-create-product .modal-create-product__content input {
  margin-bottom: 1rem;
}

.modal-create-variant {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 54rem;
  margin: 4rem auto;
}
.modal-create-variant {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-create-variant {
  color: white;
}

@media (max-width: 480px) {
  .modal-create-variant {
    width: calc(100% - 2rem);
    margin: 1rem auto 0;
  }
}
.modal-create-variant .modal-create-variant__title {
  line-height: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  padding: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-create-variant .modal-create-variant__content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 auto;
  box-sizing: border-box;
}
.modal-create-variant .modal-create-variant__content {
  padding: 0 1rem 1rem;
}
body.theme-dark .modal-create-variant .modal-create-variant__content {
  padding: 0;
}

.modal-create-coupon {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 50rem;
  margin: 4rem auto;
}
@media (max-width: 480px) {
  .modal-create-coupon {
    width: calc(100% - 2rem);
    margin: 1rem auto 0;
  }
}
.modal-create-coupon .modal-create-coupon__title {
  line-height: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  padding: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-create-coupon .modal-create-coupon__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-create-coupon .modal-create-coupon__title {
  color: white;
}

.modal-create-coupon .modal-create-coupon__error {
  margin-top: 1rem;
  line-height: 1.4rem;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  padding: 1.6rem 1.6rem;
  width: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
  text-align: center;
}
.modal-create-coupon .modal-create-coupon__error {
  color: white;
}
body.theme-dark .modal-create-coupon .modal-create-coupon__error {
  color: white;
}

.modal-create-coupon .modal-create-coupon__error {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .modal-create-coupon .modal-create-coupon__error {
  background-color: hsl(0, 40%, 50%);
}

.modal-create-coupon .modal-create-coupon__content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 auto;
  box-sizing: border-box;
}
.modal-create-coupon .modal-create-coupon__content {
  padding: 0 1rem 1rem;
}
body.theme-dark .modal-create-coupon .modal-create-coupon__content {
  padding: 0;
}

.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__code-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-left: 1rem;
}
.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__code-row .modal-create-coupon__code-prefix {
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
}
.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__code-row .modal-create-coupon__code-prefix {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .modal-create-coupon .modal-create-coupon__content .modal-create-coupon__code-row .modal-create-coupon__code-prefix {
  color: rgba(255, 255, 255, 0.8);
}

.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__details-item {
  margin: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__details-item {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .modal-create-coupon .modal-create-coupon__content .modal-create-coupon__details-item {
  color: rgba(255, 255, 255, 0.8);
}

.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__details-item .modal-create-coupon__details-title {
  font-size: 1.3rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 1.4rem;
  margin: 0.5rem 1rem;
}
.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__details-item .modal-create-coupon__details-input {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: 600;
  font-size: 1.4rem;
}
.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__details-item .modal-create-coupon__details-input .modal-create-coupon__details-text {
  width: 1.4rem;
  text-align: center;
}
.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__details-item .modal-create-coupon__details-input input {
  width: 14rem;
}
.modal-create-coupon .modal-create-coupon__content .modal-create-coupon__toggle-item input {
  margin-top: 1rem;
}

.modal-edit-coupon {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 50rem;
  margin: 4rem auto;
}
@media (max-width: 480px) {
  .modal-edit-coupon {
    width: calc(100% - 2rem);
    margin: 1rem auto 0;
  }
}
.modal-edit-coupon .modal-edit-coupon__title {
  line-height: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  padding: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-edit-coupon .modal-edit-coupon__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-edit-coupon .modal-edit-coupon__title {
  color: white;
}

.modal-edit-coupon .modal-edit-coupon__error {
  margin-top: 1rem;
  line-height: 1.4rem;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  padding: 1.2rem 1.6rem;
  width: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
  text-align: center;
}
.modal-edit-coupon .modal-edit-coupon__error {
  color: white;
}
body.theme-dark .modal-edit-coupon .modal-edit-coupon__error {
  color: white;
}

.modal-edit-coupon .modal-edit-coupon__error {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .modal-edit-coupon .modal-edit-coupon__error {
  background-color: hsl(0, 40%, 50%);
}

.modal-edit-coupon .modal-edit-coupon__content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0 auto;
  box-sizing: border-box;
}
.modal-edit-coupon .modal-edit-coupon__content {
  padding: 0 1rem 1rem;
}
body.theme-dark .modal-edit-coupon .modal-edit-coupon__content {
  padding: 0;
}

.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__code {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  padding: 1rem 0;
}
.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__code {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__code {
  color: rgba(255, 255, 255, 0.8);
}

.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__details-item {
  margin: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__details-item {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__details-item {
  color: rgba(255, 255, 255, 0.8);
}

.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__details-item .modal-edit-coupon__details-title {
  font-size: 1.3rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  line-height: 1.4rem;
  margin: 0.5rem 1rem;
}
.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__details-item .modal-edit-coupon__details-input {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: 600;
  font-size: 1.4rem;
}
.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__details-item .modal-edit-coupon__details-input .modal-edit-coupon__details-text {
  width: 1.4rem;
  text-align: center;
}
.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__details-item .modal-edit-coupon__details-input input {
  width: 10rem;
}
.modal-edit-coupon .modal-edit-coupon__content .modal-edit-coupon__toggle-item input {
  margin-top: 1rem;
}

.modal-image {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 36rem;
  margin: 4rem auto;
}
@media (max-width: 480px) {
  .modal-image {
    width: calc(100% - 2rem);
    margin: 1rem auto 0;
  }
}
.modal-image .modal-image__upload-area {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 0 auto;
  padding: 2rem;
  box-sizing: border-box;
}
.modal-image .modal-image__upload-area input {
  display: none;
}
.modal-image .modal-image__selected {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  line-height: 1.8rem;
  font-weight: 400;
  letter-spacing: 0.15rem;
  box-sizing: border-box;
  border-radius: 1.5rem;
  margin: 0 auto;
  opacity: 1;
}
.modal-image .modal-image__selected {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .modal-image .modal-image__selected {
  color: white;
}

.modal-image .modal-image__selected.modal-image__selected--active {
  opacity: 1;
}
.modal-image .modal-image__buttons {
  position: absolute;
  bottom: -6rem;
  right: 0;
  width: 24rem;
  display: flex;
  gap: 2rem;
  justify-content: flex-end;
}
.modal-image .modal-image__image-wrapper {
  display: none;
  margin: 0 auto;
  max-width: 32rem;
  box-sizing: border-box;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  border-radius: 1.5rem;
  padding: 1rem;
}
.modal-image .modal-image__image-wrapper {
  background-color: rgba(255, 255, 255, 0.05);
}
body.theme-dark .modal-image .modal-image__image-wrapper {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.modal-image .modal-image__image-wrapper.modal-image__image-wrapper--active {
  display: flex;
}
.modal-image .modal-image__image-wrapper img {
  max-height: 25rem;
  max-width: 100%;
  border-radius: 1rem;
  box-sizing: border-box;
}

.modal-boolean {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 36rem;
  margin: 4rem auto;
}
@media (max-width: 480px) {
  .modal-boolean {
    width: calc(100% - 2rem);
    margin: 1rem auto 0;
  }
}
.modal-boolean .modal-boolean__text {
  line-height: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  padding: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-boolean .modal-boolean__text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-boolean .modal-boolean__text {
  color: white;
}

.modal-boolean .modal-boolean__name {
  line-height: 2rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.2rem;
  padding: 0 2rem;
  margin-bottom: 2.6rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-boolean .modal-boolean__name {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-boolean .modal-boolean__name {
  color: white;
}

.modal-boolean .modal-boolean__description {
  line-height: 1.4rem;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: 0.08rem;
  padding: 0 2rem 1.2rem 2rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-boolean .modal-boolean__description {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-boolean .modal-boolean__description {
  color: white;
}

.modal-boolean .modal-boolean__buttons {
  position: absolute;
  bottom: -6rem;
  right: 0;
  width: 24rem;
  display: flex;
  gap: 2rem;
  justify-content: flex-end;
}

.modal-publish {
  position: relative;
  width: calc(100% - 4rem);
  max-width: 36rem;
  margin: 4rem auto;
}
@media (max-width: 480px) {
  .modal-publish {
    width: calc(100% - 2rem);
    margin: 1rem auto 0;
  }
}
.modal-publish .modal-publish__text {
  line-height: 2.4rem;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.16rem;
  padding: 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-publish .modal-publish__text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-publish .modal-publish__text {
  color: white;
}

.modal-publish .modal-publish__description {
  line-height: 1.8rem;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: 0.08rem;
  padding: 0 4rem 2.4rem;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
}
.modal-publish .modal-publish__description {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .modal-publish .modal-publish__description {
  color: white;
}

.modal-publish .modal-publish__buttons {
  position: absolute;
  bottom: -6rem;
  right: 0;
  width: 24rem;
  display: flex;
  gap: 2rem;
  justify-content: flex-end;
}

.mobile-menu {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  overflow: auto;
}
.mobile-menu .mobile-menu__divider {
  flex: 0 0 0.1rem;
  height: 0.1rem;
  border-radius: 0.1rem;
  width: calc(100% - 3.2rem);
}
.mobile-menu .mobile-menu__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.6);
}
body.theme-dark .mobile-menu .mobile-menu__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.mobile-menu .mobile-menu__vendor {
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  padding: 0 2rem;
  box-sizing: border-box;
  margin-top: 3rem;
}
.mobile-menu .mobile-menu__vendor .mobile-menu__vendor-image {
  flex: 0 0 12rem;
  width: 16rem;
  height: 12rem;
  border-radius: 1.6rem;
  overflow: hidden;
}
.mobile-menu .mobile-menu__vendor .mobile-menu__vendor-image {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .mobile-menu .mobile-menu__vendor .mobile-menu__vendor-image {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.mobile-menu .mobile-menu__vendor .mobile-menu__vendor-image img {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mobile-menu .mobile-menu__vendor .mobile-menu__vendor-info-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  overflow: hidden;
}
.mobile-menu .mobile-menu__vendor .mobile-menu__vendor-info-stack .mobile-menu__vendor-name {
  font-weight: 500;
  font-size: 1.6rem;
  letter-spacing: 0.08rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mobile-menu .mobile-menu__vendor .mobile-menu__vendor-info-stack .mobile-menu__vendor-name {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .mobile-menu .mobile-menu__vendor .mobile-menu__vendor-info-stack .mobile-menu__vendor-name {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.mobile-menu .mobile-menu__vendor .mobile-menu__vendor-info-stack .mobile-menu__vendor-email {
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.04rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
}
.mobile-menu .mobile-menu__vendor .mobile-menu__vendor-info-stack .mobile-menu__vendor-email {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .mobile-menu .mobile-menu__vendor .mobile-menu__vendor-info-stack .mobile-menu__vendor-email {
  color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.mobile-menu .mobile-menu__section {
  width: 100%;
  padding: 0rem 0.4rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.mobile-menu .mobile-menu__section .mobile-menu__item {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 2rem;
  padding: 1.2rem 2rem;
  border-radius: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.mobile-menu .mobile-menu__section .mobile-menu__item {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .mobile-menu .mobile-menu__section .mobile-menu__item {
  color: white;
}

.mobile-menu .mobile-menu__section .mobile-menu__item.mobile-menu__item--active {
  background-color: white;
}
body.theme-dark .mobile-menu .mobile-menu__section .mobile-menu__item.mobile-menu__item--active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.mobile-menu .mobile-menu__section .mobile-menu__item.mobile-menu__item--active {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .mobile-menu .mobile-menu__section .mobile-menu__item.mobile-menu__item--active {
  color: black;
}

.mobile-menu .mobile-menu__section .mobile-menu__item.mobile-menu__item--active .mobile-menu__item-icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .mobile-menu .mobile-menu__section .mobile-menu__item.mobile-menu__item--active .mobile-menu__item-icon {
  color: black;
}

.mobile-menu .mobile-menu__section .mobile-menu__item .mobile-menu__item-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.6rem;
  height: 1.6rem;
  font-size: 1.6rem;
  line-height: 1.6rem;
}
.mobile-menu .mobile-menu__section .mobile-menu__item .mobile-menu__item-icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .mobile-menu .mobile-menu__section .mobile-menu__item .mobile-menu__item-icon {
  color: white;
}

.mobile-menu .mobile-menu__section .mobile-menu__item .mobile-menu__item-text {
  font-size: 1.3rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
}
.mobile-menu .mobile-menu__section .mobile-menu__item:not(.mobile-menu__item--active):not(:disabled):hover {
  background-color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .mobile-menu .mobile-menu__section .mobile-menu__item:not(.mobile-menu__item--active):not(:disabled):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.mobile-menu .mobile-menu__section .mobile-menu__item:not(.mobile-menu__item--active):not(:disabled):active {
  background-color: rgba(255, 255, 255, 0.8);
}
.mobile-menu .mobile-menu__section .mobile-menu__item:not(.mobile-menu__item--active):not(:disabled):active {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .mobile-menu .mobile-menu__section .mobile-menu__item:not(.mobile-menu__item--active):not(:disabled):active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.6);
}

.mobile-menu .mobile-menu__version {
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.8rem 2rem 1.6rem;
  box-sizing: border-box;
  line-height: 1.4rem;
  pointer-events: none;
  user-select: none;
  text-transform: uppercase;
}
.mobile-menu .mobile-menu__version .mobile-menu__version-build,
.mobile-menu .mobile-menu__version .mobile-menu__version-date {
  display: flex;
  justify-content: space-between;
}
.mobile-menu .mobile-menu__version .mobile-menu__version-key {
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
  text-align: start;
  letter-spacing: 0.1rem;
}
.mobile-menu .mobile-menu__version .mobile-menu__version-key {
  color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .mobile-menu .mobile-menu__version .mobile-menu__version-key {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.mobile-menu .mobile-menu__version .mobile-menu__version-val {
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 700;
  text-align: end;
  letter-spacing: 0.2rem;
}
.mobile-menu .mobile-menu__version .mobile-menu__version-val {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .mobile-menu .mobile-menu__version .mobile-menu__version-val {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}

.login-card {
  width: 34rem;
  color: rgba(255, 255, 255, 0.8);
}
.login-card .login-card__content {
  padding: 1.6rem;
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 2rem;
  overflow: hidden;
  box-shadow: 0 0.8rem 2rem hsla(99, 40%, 10%, 0.12), 0 4rem 8rem hsla(99, 40%, 10%, 0.08);
}
.login-card .login-card__content {
  background-color: var(--demmi-900);
}
body.theme-dark .login-card .login-card__content {
  background-color: var(--demmi-900);
}

.login-card .login-card__content .login-card__title {
  line-height: 2rem;
  font-weight: 600;
  font-size: 1.6rem;
  letter-spacing: 0.5rem;
  text-align: center;
  margin: 1.5rem auto;
  color: var(--colour-dark);
  text-transform: uppercase;
}
.login-card .login-card__content .login-card__title img {
  width: 12rem;
}
.login-card .login-card__content .login-card__title span {
  display: block;
  margin-right: -0.6rem;
  text-align: end;
}
.login-card .login-card__content .login-card__description {
  line-height: 1.6rem;
  font-weight: 400;
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  text-align: center;
  margin: 0 0 1rem;
}
.login-card .login-card__content .login-card__description {
  color: var(--demmi-300);
}
body.theme-dark .login-card .login-card__content .login-card__description {
  color: var(--demmi-300);
}

.login-card-error {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  opacity: 0;
  margin-top: -5rem;
  pointer-events: none;
  transition: opacity 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66), margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);
}
.login-card-error.login-card-error--visible {
  opacity: 1;
  margin-top: 0;
}
.login-card-error .login-card-error__error {
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(176, 51, 46, 0.5);
  line-height: 2rem;
  font-weight: 500;
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  text-align: center;
  color: white;
  border-radius: 2rem;
  box-shadow: 0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12), 0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);
}

.login__wrapper {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;
  z-index: 1;
  background-color: hsl(99, 10%, 5%);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.login__wrapper:before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  z-index: 0;
  background: radial-gradient(circle at calc(1% * var(--theme-bg-pos)) top, hsla(99, 30%, 74%, 0.25), transparent), radial-gradient(circle at calc(100% - 1% * var(--theme-bg-pos)) bottom, hsla(99, 22%, 57%, 0.4), transparent);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.login__wrapper:before::before {
  z-index: -1;
  content: "";
  inset: 0;
  position: absolute;
  background-color: rgb(252, 252, 252);
}
.login__wrapper:before::after {
  z-index: 0;
  content: "";
  inset: 0;
  position: absolute;
  background: var(--theme-bg-svg);
  mix-blend-mode: color-dodge;
  opacity: var(--theme-bg-grain);
}
.login__wrapper.login--hide {
  transform: translate3d(0, 4rem, 0);
  opacity: 0;
}
.login__wrapper.login--error .login__sign-in {
  margin-top: 0rem;
}
.login__wrapper.login--error .login__submit-button {
  margin-top: 0rem;
}
.login__wrapper.login--register-visible .login__sign-in {
  pointer-events: none;
  opacity: 0;
  transform: rotate3d(0, 1, 0, 180deg);
}
.login__wrapper.login--register-visible .login__register {
  pointer-events: unset;
  transform: rotate3d(0, 1, 0, 0deg);
  opacity: 1;
}
.login__wrapper.login--register-visible .login__submit-button {
  margin-top: 0rem;
}
.login__wrapper .login__submit-button {
  z-index: 1;
  margin-top: -3rem;
  transition: margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);
}
.login__wrapper .demmi-ui-button {
  box-shadow: 0 0.8rem 2rem hsla(99, 40%, 10%, 0.12), 0 4rem 8rem hsla(99, 40%, 10%, 0.08);
}
.login__wrapper .demmi-ui-button {
  background-color: var(--demmi-700);
}
body.theme-dark .login__wrapper .demmi-ui-button {
  background-color: var(--demmi-700);
}

.login__wrapper .demmi-ui-button {
  border-color: var(--demmi-500);
}
body.theme-dark .login__wrapper .demmi-ui-button {
  border-color: var(--demmi-500);
}

.login__wrapper .demmi-ui-button {
  color: var(--demmi-50);
}
body.theme-dark .login__wrapper .demmi-ui-button {
  color: var(--demmi-50);
}

.login__wrapper .demmi-ui-button:not(:disabled):hover {
  box-shadow: 0 0.8rem 2rem hsla(99, 40%, 10%, 0.12), 0 4rem 8rem hsla(99, 40%, 10%, 0.08);
}
.login__wrapper .demmi-ui-button:not(:disabled):hover {
  background-color: var(--demmi-700);
}
body.theme-dark .login__wrapper .demmi-ui-button:not(:disabled):hover {
  background-color: var(--demmi-700);
}

.login__wrapper .demmi-ui-button:not(:disabled):active {
  box-shadow: 0 0.8rem 2rem hsla(99, 40%, 10%, 0.12), 0 4rem 8rem hsla(99, 40%, 10%, 0.08);
}
.login__wrapper .demmi-ui-button:not(:disabled):active {
  background-color: var(--demmi-600);
}
body.theme-dark .login__wrapper .demmi-ui-button:not(:disabled):active {
  background-color: var(--demmi-600);
}

.login__wrapper .demmi-ui-input {
  box-shadow: none;
}
.login__wrapper .demmi-ui-input {
  background-color: var(--demmi-900);
}
body.theme-dark .login__wrapper .demmi-ui-input {
  background-color: var(--demmi-900);
}

.login__wrapper .demmi-ui-input {
  color: var(--demmi-100);
}
body.theme-dark .login__wrapper .demmi-ui-input {
  color: var(--demmi-100);
}

.login__wrapper .demmi-ui-input {
  border-color: var(--demmi-800);
}
body.theme-dark .login__wrapper .demmi-ui-input {
  border-color: var(--demmi-800);
}

.login__wrapper .demmi-ui-input::placeholder {
  color: var(--demmi-200);
}
body.theme-dark .login__wrapper .demmi-ui-input::placeholder {
  color: var(--demmi-200);
}

.login__wrapper .demmi-ui-input:hover {
  background-color: var(--demmi-800);
}
body.theme-dark .login__wrapper .demmi-ui-input:hover {
  background-color: var(--demmi-800);
}

.login__wrapper .demmi-ui-input:hover {
  border-color: var(--demmi-800);
}
body.theme-dark .login__wrapper .demmi-ui-input:hover {
  border-color: var(--demmi-800);
}

.login__wrapper .demmi-ui-input:focus {
  box-shadow: none;
}
.login__wrapper .demmi-ui-input:focus {
  background-color: var(--demmi-800);
}
body.theme-dark .login__wrapper .demmi-ui-input:focus {
  background-color: var(--demmi-800);
}

.login__wrapper .demmi-ui-input:focus {
  border-color: var(--demmi-700);
}
body.theme-dark .login__wrapper .demmi-ui-input:focus {
  border-color: var(--demmi-700);
}

.login__wrapper .login__content-position {
  position: relative;
  height: 34rem;
  width: 34rem;
  perspective: 400px;
}
.login__wrapper .login__sign-in {
  margin-top: 3rem;
  position: absolute;
  inset: 0;
  pointer-events: unset;
  transform: rotate3d(0, 1, 0, 0deg);
  opacity: 1;
  transition: opacity 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66), transform 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66), margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);
}
.login__wrapper .login__register {
  pointer-events: none;
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: rotate3d(0, 1, 0, -180deg);
  transition: opacity 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66), transform 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);
}

.loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 99999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  flex-direction: column;
  isolation: isolate;
  transition: opacity 0.5s ease-in-out;
}
.loading-overlay {
  background-color: hsla(99, 0%, 98%, 0.9);
}
body.theme-dark .loading-overlay {
  background-color: hsl(99, 22%, 8%);
}

.loading-overlay.loading-overlay--login-page .loading-overlay__loading-indicator {
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 0%, 0), hsl(99, 22%, 57%));
}
body.theme-dark .loading-overlay.loading-overlay--login-page .loading-overlay__loading-indicator {
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 80%, 0), hsl(99, 22%, 57%));
}

.loading-overlay.loading-overlay--login-page .loading-overlay__loading-indicator:before {
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 0%, 0), hsl(99, 22%, 57%));
}
body.theme-dark .loading-overlay.loading-overlay--login-page .loading-overlay__loading-indicator:before {
  background: linear-gradient(hsl(99, 30%, 74%), hsla(99, 90%, 80%, 0), hsl(99, 22%, 57%));
}

.loading-overlay.loading-overlay--animated .loading-overlay__title {
  animation: load-title 0.4s forwards;
  animation-delay: 0.4s;
  opacity: 0;
}
.loading-overlay.loading-overlay--animated .loading-overlay__subtitle {
  animation: load-subtitle 0.4s forwards;
  animation-delay: 0.7s;
  opacity: 0;
}
.loading-overlay .loading-overlay__logo {
  position: relative;
  width: 30rem;
  height: 30rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.loading-overlay .loading-overlay__title {
  position: relative;
}
.loading-overlay .loading-overlay__title img {
  width: 20rem;
}
.loading-overlay .loading-overlay__subtitle {
  position: relative;
  font-size: 1.6rem;
  line-height: 2rem;
  font-weight: 400;
  margin-top: 0.8rem;
  letter-spacing: 0.05rem;
  color: var(--colour-light);
  pointer-events: none;
  user-select: none;
}
.loading-overlay .loading-overlay__loading-indicator {
  position: absolute;
  inset: 0;
  width: 30rem;
  height: 30rem;
  border-radius: 50%;
  animation: animate-loader 1.2s linear infinite;
  transition: opacity 0.3s ease-in-out;
  background: linear-gradient(var(--colour-light), hsla(99, 90%, 80%, 0), var(--colour-dark));
  opacity: 0.6;
}
.loading-overlay .loading-overlay__loading-indicator:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  filter: blur(0.8rem);
  background: linear-gradient(var(--colour-light), hsla(99, 90%, 80%, 0), var(--colour-dark));
}
.loading-overlay .loading-overlay__loading-indicator:after {
  content: "";
  position: absolute;
  inset: 0.3rem;
  border-radius: 50%;
}
.loading-overlay .loading-overlay__loading-indicator:after {
  background-color: hsl(99, 0%, 98%);
}
body.theme-dark .loading-overlay .loading-overlay__loading-indicator:after {
  background-color: hsl(99, 22%, 8%);
}

.loading-overlay.loading-overlay--auth .loading-overlay__subtitle {
  opacity: 1;
  animation: none;
}

@keyframes globalLoadingIn {
  0% {
    z-index: 99999;
    opacity: 0;
  }
  100% {
    z-index: 99999;
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes globalLoadingOut {
  0% {
    transform: scale(1);
  }
  100% {
    opacity: 0;
  }
}
@keyframes animate-loader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes load-text-in {
  0% {
    transform: scale3d(0, 0, 0);
    opacity: 0;
  }
  50% {
    transform: scale3d(1, 1.2, 1);
    opacity: 0.7;
  }
  100% {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }
}
@keyframes load-title {
  0% {
    bottom: -3rem;
  }
  50% {
    bottom: 1.2rem;
    opacity: 1;
  }
  100% {
    bottom: 0;
    opacity: 1;
  }
}
@keyframes load-subtitle {
  0% {
    bottom: 1.6rem;
  }
  50% {
    bottom: -0.4rem;
    opacity: 1;
  }
  100% {
    bottom: 0;
    opacity: 1;
  }
}
.element-loading-indicator {
  position: absolute;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
}
.element-loading-indicator.element-loading-indicator--loading {
  display: flex;
}
.element-loading-indicator .element-loading-indicator__loading-indicator {
  position: relative;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  opacity: 0.6;
  animation: element-loading-indicator 1.2s linear infinite;
}
.element-loading-indicator .element-loading-indicator__loading-indicator {
  background: linear-gradient(hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1), hsla(99, 90%, 80%, 0), hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1));
}
body.theme-dark .element-loading-indicator .element-loading-indicator__loading-indicator {
  background: linear-gradient(white, hsla(99, 90%, 80%, 0), white);
}

.element-loading-indicator .element-loading-indicator__loading-indicator:before {
  content: "";
  inset: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  filter: blur(0.4rem);
}
.element-loading-indicator .element-loading-indicator__loading-indicator:before {
  background: linear-gradient(hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1), hsla(99, 90%, 80%, 0), hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1));
}
body.theme-dark .element-loading-indicator .element-loading-indicator__loading-indicator:before {
  background: linear-gradient(white, hsla(99, 90%, 80%, 0), white);
}

.element-loading-indicator .element-loading-indicator__loading-indicator:after {
  content: "";
  position: absolute;
  inset: 0.2rem;
  border-radius: 50%;
}
.element-loading-indicator .element-loading-indicator__loading-indicator:after {
  background-color: hsl(99, 0%, 98%);
}
body.theme-dark .element-loading-indicator .element-loading-indicator__loading-indicator:after {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.8);
}

@keyframes element-loading-indicator {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.toolbar__wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
}
.toolbar__wrapper .toolbar {
  display: flex;
  gap: 0.6rem;
  border-radius: 2.2rem;
  padding: 0 0.8rem;
}
.toolbar__wrapper .toolbar {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .toolbar__wrapper .toolbar {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.toolbar__wrapper .toolbar .toolbar__item {
  cursor: pointer;
  user-select: none;
  display: flex;
  gap: 1.4rem;
  padding: 1.4rem 2rem;
  border-radius: 0.8rem;
  color: rgba(0, 0, 0, 0.6);
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.toolbar__wrapper .toolbar .toolbar__item {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item {
  color: white;
}

.toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  background-color: white;
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  color: black;
}

.toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active .toolbar__item-icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item.toolbar__item--active .toolbar__item-icon {
  color: black;
}

.toolbar__wrapper .toolbar .toolbar__item .toolbar__item-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.6rem;
  height: 1.6rem;
  font-size: 1.4rem;
  line-height: 1.4rem;
}
.toolbar__wrapper .toolbar .toolbar__item .toolbar__item-icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item .toolbar__item-icon {
  color: white;
}

.toolbar__wrapper .toolbar .toolbar__item .toolbar__item-text {
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  line-height: 1.6rem;
}
.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):hover {
  background-color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):hover {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  background-color: rgba(255, 255, 255, 0.8);
}
.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.6);
}

.toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  box-shadow: 0 1.6rem 2.2rem hsl(var(--theme-bg-hue), 100%, 20%,0.14);
}
body.theme-dark .toolbar__wrapper .toolbar .toolbar__item:not(.toolbar__item--active):not(:disabled):active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-toast .demmi-toast__action {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  letter-spacing: 0.15rem;
  font-size: 1.2rem;
  line-height: 1.6rem;
  border-radius: 2rem;
  padding: 0.8rem 1.2rem;
  box-sizing: border-box;
  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;
}
.demmi-toast .demmi-toast__action {
  background-color: rgba(0, 0, 0, 0.04);
}
body.theme-dark .demmi-toast .demmi-toast__action {
  background-color: rgba(255, 255, 255, 0.08);
}

.demmi-toast .demmi-toast__action {
  color: hsla(0, 0%, 0%, 0.8);
}
body.theme-dark .demmi-toast .demmi-toast__action {
  color: hsla(0, 0%, 100%, 0.8);
}

.demmi-toast .demmi-toast__action:not(:disabled):hover {
  background-color: rgba(0, 0, 0, 0.12);
}
body.theme-dark .demmi-toast .demmi-toast__action:not(:disabled):hover {
  background-color: rgba(255, 255, 255, 0.16);
}

.demmi-toast .demmi-toast__action:not(:disabled):active, .demmi-toast .demmi-toast__action:not(:disabled):focus-visible {
  background-color: rgba(0, 0, 0, 0.08);
}
body.theme-dark .demmi-toast .demmi-toast__action:not(:disabled):active, .demmi-toast .demmi-toast__action:not(:disabled):focus-visible {
  background-color: rgba(255, 255, 255, 0.12);
}

.demmi-toast .demmi-toast__button-close {
  cursor: pointer;
  flex: 0 0 auto;
  width: 3.2rem;
  height: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.6rem;
  border-radius: 50%;
  box-sizing: border-box;
  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;
}
.demmi-toast .demmi-toast__button-close {
  background-color: rgba(0, 0, 0, 0);
}
body.theme-dark .demmi-toast .demmi-toast__button-close {
  background-color: rgba(255, 255, 255, 0);
}

.demmi-toast .demmi-toast__button-close:not(:disabled):hover {
  background-color: rgba(0, 0, 0, 0.12);
}
body.theme-dark .demmi-toast .demmi-toast__button-close:not(:disabled):hover {
  background-color: rgba(255, 255, 255, 0.12);
}

.demmi-toast .demmi-toast__button-close:not(:disabled):hover svg {
  color: rgba(0, 0, 0, 0.8);
}
body.theme-dark .demmi-toast .demmi-toast__button-close:not(:disabled):hover svg {
  color: rgba(255, 255, 255, 0.7);
}

.demmi-toast .demmi-toast__button-close:not(:disabled):active, .demmi-toast .demmi-toast__button-close:not(:disabled):focus-visible {
  background-color: rgba(0, 0, 0, 0.08);
}
body.theme-dark .demmi-toast .demmi-toast__button-close:not(:disabled):active, .demmi-toast .demmi-toast__button-close:not(:disabled):focus-visible {
  background-color: rgba(255, 255, 255, 0.08);
}

.demmi-toast .demmi-toast__button-close:not(:disabled):active svg, .demmi-toast .demmi-toast__button-close:not(:disabled):focus-visible svg {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .demmi-toast .demmi-toast__button-close:not(:disabled):active svg, .demmi-toast .demmi-toast__button-close:not(:disabled):focus-visible svg {
  color: rgba(255, 255, 255, 0.8);
}

.demmi-toast .demmi-toast__button-close svg {
  display: block;
  pointer-events: none;
  height: 1.8rem;
  width: 1.8rem;
}
.demmi-toast .demmi-toast__button-close svg {
  color: rgba(0, 0, 0, 0.32);
}
body.theme-dark .demmi-toast .demmi-toast__button-close svg {
  color: rgba(255, 255, 255, 0.5);
}

.demmi-toasts-viewport {
  --viewport-padding: 25px;
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 1.6rem;
  gap: 10px;
  width: 42rem;
  box-sizing: border-box;
  max-width: 100vw;
  margin: 0;
  list-style: none;
  z-index: 2147483647;
  outline: none;
}

.demmi-toast {
  border-radius: 2.4rem;
  box-shadow: hsla(206, 22%, 7%, 0.35) 0px 10px 38px -10px, hsla(206, 22%, 7%, 0.2) 0px 10px 20px -15px;
  padding: 0.8rem;
  display: grid;
  grid-template-areas: "icon title buttons" "icon description buttons";
  grid-template-columns: auto auto max-content;
  column-gap: 1.6rem;
  row-gap: 0.8rem;
  align-items: center;
}
.demmi-toast {
  background-color: hsl(143, 43%, 85%);
}
body.theme-dark .demmi-toast {
  background-color: hsl(143, 22%, 45%);
}

.demmi-toast.demmi-toast--type-success {
  background-color: hsl(143, 43%, 85%);
}
body.theme-dark .demmi-toast.demmi-toast--type-success {
  background-color: hsl(143, 22%, 45%);
}

.demmi-toast.demmi-toast--type-success .demmi-toast__icon svg {
  color: hsl(148, 33%, 70%);
}
body.theme-dark .demmi-toast.demmi-toast--type-success .demmi-toast__icon svg {
  color: hsl(148, 33%, 70%);
}

.demmi-toast.demmi-toast--type-error {
  background-color: hsl(352, 59%, 85%);
}
body.theme-dark .demmi-toast.demmi-toast--type-error {
  background-color: hsl(352, 20%, 50%);
}

.demmi-toast.demmi-toast--type-error .demmi-toast__icon svg {
  color: hsl(352, 43%, 70%);
}
body.theme-dark .demmi-toast.demmi-toast--type-error .demmi-toast__icon svg {
  color: hsl(352, 43%, 70%);
}

.demmi-toast.demmi-toast--type-warning {
  background-color: hsl(40, 72%, 79%);
}
body.theme-dark .demmi-toast.demmi-toast--type-warning {
  background-color: hsl(40, 38%, 55%);
}

.demmi-toast.demmi-toast--type-warning .demmi-toast__icon svg {
  color: hsl(40, 60%, 60%);
}
body.theme-dark .demmi-toast.demmi-toast--type-warning .demmi-toast__icon svg {
  color: hsl(40, 60%, 60%);
}

.demmi-toast.demmi-toast--type-info {
  background-color: hsl(55, 50%, 92%);
}
body.theme-dark .demmi-toast.demmi-toast--type-info {
  background-color: hsl(55, 10%, 32%);
}

.demmi-toast.demmi-toast--type-info .demmi-toast__icon svg {
  color: hsl(55, 70%, 75%);
}
body.theme-dark .demmi-toast.demmi-toast--type-info .demmi-toast__icon svg {
  color: hsl(55, 70%, 75%);
}

.demmi-toast .demmi-toast[data-state=open] {
  animation: slideIn 150ms cubic-bezier(0.16, 1, 0.3, 1);
}
.demmi-toast .demmi-toast[data-state=closed] {
  animation: hide 100ms ease-in;
}
.demmi-toast .demmi-toast[data-swipe=move] {
  transform: translateX(var(--radix-toast-swipe-move-x));
}
.demmi-toast .demmi-toast[data-swipe=cancel] {
  transform: translateX(0);
  transition: transform 200ms ease-out;
}
.demmi-toast .demmi-toast[data-swipe=end] {
  animation: swipeOut 100ms ease-out;
}
.demmi-toast .demmi-toast__buttons-area {
  grid-area: buttons;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  gap: 0.8rem;
}
.demmi-toast .demmi-toast__title {
  grid-area: title;
  margin-top: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.08rem;
  font-size: 1.3rem;
  line-height: 1.8rem;
}
.demmi-toast .demmi-toast__title {
  color: hsla(0, 0%, 0%, 0.6);
}
body.theme-dark .demmi-toast .demmi-toast__title {
  color: hsla(0, 0%, 100%, 0.9);
}

.demmi-toast .demmi-toast__description {
  grid-area: description;
  margin-bottom: 1rem;
  letter-spacing: 0.08rem;
  font-size: 1.2rem;
  line-height: 1.4rem;
}
.demmi-toast .demmi-toast__description {
  color: hsla(0, 0%, 0%, 0.9);
}
body.theme-dark .demmi-toast .demmi-toast__description {
  color: hsla(0, 0%, 100%, 0.9);
}

.demmi-toast .demmi-toast__icon {
  grid-area: icon;
  margin-left: 0.8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 4rem;
  width: 4rem;
}
.demmi-toast .demmi-toast__icon {
  background-color: white;
}
body.theme-dark .demmi-toast .demmi-toast__icon {
  background-color: black;
}

.demmi-toast .demmi-toast__icon svg {
  display: block;
  pointer-events: none;
  height: 2.4rem;
  width: 2.4rem;
}
.demmi-toast .demmi-toast__icon svg {
  color: hsl(143, 43%, 85%);
}
body.theme-dark .demmi-toast .demmi-toast__icon svg {
  color: hsl(143, 22%, 45%);
}

@keyframes hide {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes slideIn {
  from {
    transform: translateX(calc(100% + var(--viewport-padding)));
  }
  to {
    transform: translateX(0);
  }
}
@keyframes swipeOut {
  from {
    transform: translateX(var(--radix-toast-swipe-end-x));
  }
  to {
    transform: translateX(calc(100% + var(--viewport-padding)));
  }
}
.sidebar__section-title {
  display: flex;
  align-items: center;
  gap: 2rem;
  font-size: 1.5rem;
  line-height: 2rem;
  padding: 0 2.4rem;
  font-weight: 400;
  letter-spacing: 0.15rem;
  text-align: start;
  margin: 3.2rem 0 1.6rem;
}
.sidebar__section-title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .sidebar__section-title {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.sidebar__section-title:first-child {
  margin-top: 0;
}
.sidebar__section-title svg {
  display: block;
  pointer-events: none;
  height: 2rem;
  width: 2rem;
  line-height: 2rem;
}
.sidebar__section-title svg {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.7);
}
body.theme-dark .sidebar__section-title svg {
  color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.sidebar-button {
  cursor: pointer;
  width: 100%;
  align-items: center;
  gap: 2rem;
  font-size: 1.3rem;
  box-sizing: border-box;
  line-height: 1.6rem;
  font-weight: 500;
  letter-spacing: 0.15rem;
  text-align: start;
  background-color: transparent;
  transition: background-color 0.1s ease-in-out;
}
.sidebar-button {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.7);
}
body.theme-dark .sidebar-button {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.sidebar-button:disabled {
  opacity: 0.4;
}
.sidebar-button:not(:disabled):not(.sidebar-button--active):hover {
  background-color: rgba(255, 255, 255, 0.3);
}
body.theme-dark .sidebar-button:not(:disabled):not(.sidebar-button--active):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.sidebar-button:not(:disabled):not(.sidebar-button--active):active {
  background-color: rgba(255, 255, 255, 0.5);
}
body.theme-dark .sidebar-button:not(:disabled):not(.sidebar-button--active):active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.sidebar-button.sidebar-button--active {
  background-color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .sidebar-button.sidebar-button--active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.sidebar-button.sidebar-button-managed {
  display: flex;
  align-items: center;
  gap: 2rem;
  font-size: 1.3rem;
  line-height: 1.6rem;
  padding: 1.6rem 2.4rem;
  font-weight: 500;
  letter-spacing: 0.15rem;
  text-align: start;
}
.sidebar-button.sidebar-button-managed .sidebar-button__icon {
  height: 1.6rem;
  width: 1.6rem;
  line-height: 1.6rem;
}
.sidebar-button.sidebar-button-managed .sidebar-button__icon svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}
.sidebar-button.sidebar-button-managed .sidebar-button__text .sidebar-button__badge {
  letter-spacing: 0.1rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.8rem;
  text-align: center;
  text-transform: uppercase;
  margin-right: 0.8rem;
}
.sidebar-button.sidebar-button-managed .sidebar-button__text .sidebar-button__badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .sidebar-button.sidebar-button-managed .sidebar-button__text .sidebar-button__badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.sidebar-button-custom {
  display: block;
  padding: 0;
}

.sidebar-button-divider {
  flex: 0 0 0.1rem;
  height: 0.1rem;
  width: 100%;
}
.sidebar-button-divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .sidebar-button-divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.sidebar {
  position: relative;
  height: 100%;
  display: flex;
  width: var(--sidebar-width);
  flex-direction: column;
  max-height: 100%;
  box-sizing: border-box;
  overflow: hidden auto;
  transition: transform var(--sidebar-transition-time) ease-in-out;
}
.sidebar .sidebar__header {
  width: var(--sidebar-width);
  flex: 0 0 auto;
  transition: opacity var(--sidebar-transition-time) ease-in-out;
  padding: 1.6rem;
  box-sizing: border-box;
}
.sidebar .sidebar__header .sidebar__title {
  font-size: 1.8rem;
  letter-spacing: 0.15rem;
  font-weight: 400;
  line-height: 4rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-left: 0.8rem;
}
.sidebar .sidebar__header .sidebar__title {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.6);
}
body.theme-dark .sidebar .sidebar__header .sidebar__title {
  color: white;
}

.sidebar .sidebar__header .sidebar__title.sidebar__title--only-buttons {
  display: block;
  width: 100%;
  margin-left: 0;
}
.sidebar .sidebar__header .sidebar__title .sidebar__title-buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.sidebar .sidebar__header .sidebar__search {
  margin: 2rem 0 0;
}
.sidebar .sidebar__buttons {
  width: var(--sidebar-width);
  position: relative;
  min-height: 10rem;
  flex: 1 1 auto;
  padding: 1rem 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
  box-sizing: border-box;
  transition: opacity var(--sidebar-transition-time) ease-in-out;
}
.sidebar:hover {
  transform: translate3d(0, 0, 0);
}
.sidebar:hover .sidebar__header {
  opacity: 1;
}
.sidebar:hover .sidebar__buttons {
  opacity: 1;
}

.notifications-panel {
  position: absolute;
  inset: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.notifications-panel.notifications-panel--visible .notifications-panel__content {
  opacity: 1;
}
.notifications-panel.notifications-panel--visible .notifications-panel__backdrop {
  opacity: 1;
}
.notifications-panel.notifications-panel--visible .notifications-panel-content {
  transition: transform 0.4s ease-out;
  transform: translate3d(0, 1.2rem, 0);
}
@media (max-width: 480px) {
  .notifications-panel.notifications-panel--visible .notifications-panel-content {
    transform: translate3d(0, 0, 0);
  }
}
.notifications-panel .notifications-panel__backdrop {
  opacity: 0;
  position: absolute;
  inset: 0;
  transition: opacity 0.3s ease-in-out;
}
.notifications-panel .notifications-panel__backdrop {
  background-color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .notifications-panel .notifications-panel__backdrop {
  background-color: rgba(0, 0, 0, 0.7);
}

.notifications-panel-content {
  width: calc(100% - 4rem);
  max-width: 46rem;
  max-height: calc(100% - 2rem);
  box-sizing: border-box;
  border-radius: 2.4rem;
  overflow: auto;
  margin: 0;
  transform-origin: top;
  transform: translate3d(0, -100%, 0);
  transition: transform 0.3s ease-in;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.notifications-panel-content {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.16);
}
body.theme-dark .notifications-panel-content {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 8%, 16%,0.4);
}

.notifications-panel-content {
  color: rgba(0, 0, 0, 0.5);
}
body.theme-dark .notifications-panel-content {
  color: white;
}

.notifications-panel-content {
  background-color: white;
}
body.theme-dark .notifications-panel-content {
  background-color: hsla(var(--theme-bg-hue), 15%, 8%, 0.6);
}

.notifications-panel-content {
  box-shadow: 1.2rem 0rem 4rem hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.1);
}
body.theme-dark .notifications-panel-content {
  box-shadow: 1.2rem 0rem 4rem rgba(0, 0, 0, 0.3);
}

.notifications-panel-content::before {
  content: "";
  z-index: 0;
  inset: 0;
  position: absolute;
  pointer-events: none;
  background-repeat: no-repeat;
}
.notifications-panel-content::before {
  background-color: rgba(255, 255, 255, 0.2);
}
body.theme-dark .notifications-panel-content::before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.notifications-panel-content .notifications-panel-content__title {
  text-align: center;
  font-size: 1.6rem;
  letter-spacing: 0.05rem;
  font-weight: 500;
  line-height: 6rem;
}
.notifications-panel-content .notifications-panel-content__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .notifications-panel-content .notifications-panel-content__title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.notifications-panel-content .notifications-panel-content__close-button {
  display: none;
  position: absolute;
  top: 1rem;
  right: 1rem;
}
@media (max-width: 480px) {
  .notifications-panel-content {
    border-radius: 0;
    height: 100%;
    max-height: unset;
    width: 100%;
  }
  .notifications-panel-content .notifications-panel-content__close-button {
    display: block;
  }
}

.notification-item {
  position: relative;
  display: grid;
  grid-template: "badge action" 3.8rem "message message" auto "timestamp title" 2rem/auto auto;
  padding: 1.2rem 1rem;
  border-top: 0.1rem solid transparent;
  transition: background-color 0.1s ease-in-out;
}
.notification-item:not(:last-child) {
  border-bottom: none;
}
.notification-item {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.6);
}
body.theme-dark .notification-item {
  border-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.4);
}

.notification-item:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.08);
}
body.theme-dark .notification-item:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.2);
}

.notification-item.notification-item--new::before {
  content: "";
  position: absolute;
  width: 1rem;
  height: 1rem;
  right: 1.6rem;
  bottom: 1.6rem;
  border-radius: 0.5rem;
}
.notification-item.notification-item--new::before {
  background-color: hsl(101, 71%, 68%);
}
body.theme-dark .notification-item.notification-item--new::before {
  background-color: hsl(101, 71%, 68%);
}

.notification-item .notification-item__badge {
  grid-area: badge;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-start;
  text-align: center;
  border-radius: 0.8rem;
  font-size: 1.2rem;
  letter-spacing: 0.1rem;
  font-weight: 500;
  padding: 0 1.5rem;
  line-height: 1.6rem;
}
.notification-item .notification-item__badge {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .notification-item .notification-item__badge {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.notification-item .notification-item__badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .notification-item .notification-item__badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.notification-item .notification-item__badge svg {
  margin-right: 1rem;
  height: 1.4rem;
}
.notification-item .notification-item__timestamp {
  grid-area: timestamp;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  margin-left: 0.6rem;
}
.notification-item .notification-item__timestamp {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.9);
}
body.theme-dark .notification-item .notification-item__timestamp {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.notification-item .notification-item__buttons {
  justify-self: flex-end;
  grid-area: action;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
}
.notification-item .notification-item__buttons .demmi-ui-button {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 100%, 20%,0.24);
}
body.theme-dark .notification-item .notification-item__buttons .demmi-ui-button {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.notification-item .notification-item__message {
  grid-area: message;
  display: flex;
  flex-direction: column;
  margin-top: 1.6rem;
  margin-bottom: 0.4rem;
}
.notification-item .notification-item__message {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.7);
}
body.theme-dark .notification-item .notification-item__message {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.notification-item .notification-item__message .notification-item__text {
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  line-height: 2rem;
  padding: 0 0.6rem 0.4rem;
}
.notification-item .notification-item__message .notification-item__text strong {
  font-weight: 600;
}

.notifications__icon {
  position: relative;
}
.notifications__icon .notifications__icon-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -0.3rem;
  right: -0.3rem;
  width: 2rem;
  height: 2rem;
  border-radius: 1rem;
  font-weight: 700;
  font-size: 1.1rem;
  color: white;
}
.notifications__icon .notifications__icon-indicator {
  background-color: hsl(101, 50%, 60%);
}
body.theme-dark .notifications__icon .notifications__icon-indicator {
  background-color: hsl(101, 37%, 55%);
}

.order-item-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.order-item-header .order-item-header__id {
  line-height: 3rem;
  font-size: 1.8rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  padding-left: 1rem;
}
.order-item-header .order-item-header__id {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .order-item-header .order-item-header__id {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.order-item-header .order-item-header__status {
  display: flex;
  gap: 1rem;
}
.order-item-header .order-item-header__status .order-item-header__status-badge {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 1.6rem;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  line-height: 2.8rem;
  border-radius: 2rem;
}
.order-item-header .order-item-header__status .order-item-header__status-badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 0.6);
}
body.theme-dark .order-item-header .order-item-header__status .order-item-header__status-badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.order-item-header .order-item-header__status .order-item-header__status-badge {
  color: white;
}
body.theme-dark .order-item-header .order-item-header__status .order-item-header__status-badge {
  color: white;
}

@media (max-width: 480px) {
  .order-item-header {
    flex-direction: column-reverse;
  }
  .order-item-header .order-item-header__status {
    margin-left: auto;
  }
}

.order-item-collection {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  text-align: center;
  padding: 1rem;
}
.order-item-collection {
  background-color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .order-item-collection {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.order-item-collection {
  color: white;
}
body.theme-dark .order-item-collection {
  color: white;
}

.order-item-collection .order-item-collection__title {
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.18rem;
  line-height: 1.2rem;
  margin: 1rem 0;
}
.order-item-collection .order-item-collection__title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .order-item-collection .order-item-collection__title {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.order-item-collection .order-item-collection__code {
  gap: 1rem;
  display: flex;
  font-size: 3.6rem;
  font-weight: 200;
  line-height: 4rem;
  text-transform: uppercase;
}
.order-item-collection .order-item-collection__details {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.order-item-collection .order-item-collection__details .order-item-collection__key-val {
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding: 0rem 1rem;
  text-align: start;
}
.order-item-collection .order-item-collection__details .order-item-collection__key-val .order-item-collection__key {
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 2rem;
  letter-spacing: 0.1rem;
}
.order-item-collection .order-item-collection__details .order-item-collection__key-val .order-item-collection__key {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .order-item-collection .order-item-collection__details .order-item-collection__key-val .order-item-collection__key {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.order-item-collection .order-item-collection__details .order-item-collection__key-val .order-item-collection__value {
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  line-height: 2.4rem;
}
.order-item-collection .order-item-collection__details .order-item-collection__key-val:last-child {
  text-align: end;
}
@media (max-width: 540px) {
  .order-item-collection .order-item-collection__code {
    margin-bottom: 1rem;
  }
}
@media (max-width: 480px) {
  .order-item-collection .order-item-collection__code {
    margin-bottom: 2rem;
  }
  .order-item-collection .order-item-collection__details {
    flex-direction: column;
    gap: 1.2rem;
  }
  .order-item-collection .order-item-collection__details .order-item-collection__key-val {
    text-align: center;
  }
  .order-item-collection .order-item-collection__details .order-item-collection__key-val:last-child {
    text-align: center;
  }
}

.order-item-coupon {
  width: 100%;
  max-width: 38rem;
  margin: 0 auto 2rem auto;
  position: relative;
}
.order-item-coupon {
  filter: drop-shadow(0 0.4rem 0.6rem hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0));
}
body.theme-dark .order-item-coupon {
  filter: drop-shadow(0 0.4rem 0.6rem hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0));
}

.order-item-coupon .order-item-coupon__wrapper-background {
  position: relative;
  height: 18rem;
  width: 100%;
  max-width: 38rem;
  border-radius: 1.2rem;
  -webkit-mask-image: radial-gradient(circle at 1rem 5rem, transparent 1rem, red 1rem), radial-gradient(closest-side circle at 50%, red 99%, transparent 100%);
  -webkit-mask-size: 100%, 1.2rem 0.4rem;
  -webkit-mask-repeat: repeat, repeat-x;
  -webkit-mask-position: -1rem, 50% 4.8rem;
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
}
.order-item-coupon .order-item-coupon__wrapper-background {
  background: radial-gradient(circle at 30% 40%, hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.35), hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.15));
}
body.theme-dark .order-item-coupon .order-item-coupon__wrapper-background {
  background: radial-gradient(circle at 30% 40%, hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.5), hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2));
}

.order-item-coupon .order-item-coupon__wrapper-background::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5rem;
}
.order-item-coupon .order-item-coupon__wrapper-background::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.6);
}
body.theme-dark .order-item-coupon .order-item-coupon__wrapper-background::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.order-item-coupon .order-item-coupon__contents {
  position: absolute;
  inset: 0;
}
.order-item-coupon .order-item-coupon__contents .order-item-coupon__code {
  line-height: 5rem;
  text-align: center;
  font-weight: 700;
  font-size: 1.3rem;
  letter-spacing: 0.4rem;
}
.order-item-coupon .order-item-coupon__contents .order-item-coupon__code {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .order-item-coupon .order-item-coupon__contents .order-item-coupon__code {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.9);
}

.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details {
  position: relative;
  box-sizing: border-box;
  padding: 0.8rem 2rem;
  padding-bottom: 2rem;
  height: calc(100% - 5rem);
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 1rem;
}
.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__type {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
  font-weight: 600;
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  line-height: 5rem;
}
.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__type {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__type {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.8);
}

.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__detail-split {
  display: flex;
  justify-content: space-between;
}
.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__detail-split .order-item-coupon__detail:first-child {
  text-align: start !important;
}
.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__detail-split .order-item-coupon__detail:last-child {
  text-align: end;
}
.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__detail {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__detail {
  color: white;
}

.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__detail .order-item-coupon__key {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.1rem;
  letter-spacing: 0.15rem;
  opacity: 0.7;
  line-height: 2rem;
}
.order-item-coupon .order-item-coupon__contents .order-item-coupon__content-details .order-item-coupon__detail .order-item-coupon__value {
  font-weight: 400;
  font-size: 1.5rem;
  letter-spacing: 0.1rem;
  line-height: 2.4rem;
}

.order-item .order-item__timeline {
  display: flex;
  position: relative;
  gap: 2rem;
  flex-direction: column;
  padding: 1rem;
}
.order-item .order-item__timeline .order-item__title {
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  line-height: 2rem;
  text-align: center;
  margin: 1rem auto;
}
.order-item .order-item__timeline .order-item__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .order-item .order-item__timeline .order-item__title {
  color: white;
}

.order-item .order-item__timeline .order-item__title svg {
  margin-right: 2rem;
}
.order-item .order-item__timeline .order-item__title span {
  font-weight: 600;
}
.order-item .order-item__timeline .order-item__update {
  margin-top: 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
}
.order-item .order-item__timeline .order-item__update.order-item .order-item__timeline .order-item__update--is-loading > *:not(.element-loading-indicator) {
  opacity: 0.4;
}
body.theme-dark .order-item .order-item__timeline .order-item__update--is-loading > :not(.element-loading-indicator) {
  opacity: 0.4;
}

.order-item .order-item__timeline .order-item__update .order-item__update-title {
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  line-height: 2rem;
  text-align: start;
  margin: 1rem 0;
}
.order-item .order-item__timeline .order-item__update .order-item__update-title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .order-item .order-item__timeline .order-item__update .order-item__update-title {
  color: white;
}

.order-item .order-item__timeline .order-item__update textarea.demmi-ui-input {
  height: 10rem;
}
.order-item .order-item__timeline .order-item__update .order-item__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.order-item .order-item__timeline .order-item__update .order-item__buttons .demmi-ui-button {
  flex: 1 1 auto;
}

.order-item .order-item__products-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.order-item .order-item__review-none {
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  text-align: center;
  padding: 4rem 2rem;
  letter-spacing: 0.1rem;
}
.order-item .order-item__review-none {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .order-item .order-item__review-none {
  color: white;
}

.order-item .order-item__review {
  position: relative;
  padding: 1rem;
}
.order-item .order-item__review .order-item__review-rating {
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  gap: 0.4rem;
}
.order-item .order-item__review .order-item__review-rating svg {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .order-item .order-item__review .order-item__review-rating svg {
  color: white;
}

.order-item .order-item__review .order-item__review-timestamp {
  font-size: 1.3rem;
  font-weight: 500;
  margin-bottom: 2rem;
}
.order-item .order-item__review .order-item__review-timestamp span {
  text-transform: uppercase;
  font-size: 1.2rem;
  font-weight: 700;
  margin-left: 1rem;
}
.order-item .order-item__review .order-item__review-title {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
}
.order-item .order-item__review .order-item__review-description {
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.order-item .order-item__review .order-item__review-description .order-item__review-description-paragraph {
  margin: 1rem 0;
}
.order-item .order-item__review .order-item__review-response {
  margin-top: 2rem;
  padding: 0.8rem 1.6rem 0.2rem;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
}
.order-item .order-item__review .order-item__review-response {
  border-radius: 1rem;
}
body.theme-dark .order-item .order-item__review .order-item__review-response {
  border-radius: 1.2rem;
}

.order-item .order-item__review .order-item__review-response {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .order-item .order-item__review .order-item__review-response {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.order-item .order-item__review .order-item__review-response .order-item__review-response-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.5rem;
  font-weight: 500;
  margin-bottom: 1rem;
  margin-right: -0.8rem;
}
.order-item .order-item__review .order-item__review-response .order-item__review-response-title .order-item__review-response-title-buttons {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.order-item .order-item__review .order-item__review-response .order-item__review-description-paragraph {
  margin: 1.2rem 0;
}
.order-item .order-item__review .order-item__review-response .order-item__review-no-response {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  font-size: 1.4rem;
  font-weight: 400;
  padding: 1.6rem 0;
}

.order-refund-request__wrapper {
  padding: 2rem 1rem;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.order-refund-request__none {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.8rem;
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 400;
  text-align: center;
  padding: 2.8rem 2rem;
  letter-spacing: 0.1rem;
}
.order-refund-request__none {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .order-refund-request__none {
  color: white;
}

.order-refund-request {
  width: 100%;
  display: flex;
  gap: 3rem;
  flex-direction: column;
  padding: 1rem;
  box-sizing: border-box;
}
.order-refund-request {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .order-refund-request {
  color: white;
}

.order-refund-request.order-refund-request--is-loading > *:not(.element-loading-indicator) {
  opacity: 0.4;
}
body.theme-dark .order-refund-request--is-loading > :not(.element-loading-indicator) {
  opacity: 0.4;
}

.order-refund-request .order-refund-request__title {
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  line-height: 2rem;
  text-align: center;
  margin: 1rem auto 0;
}
.order-refund-request .order-refund-request__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .order-refund-request .order-refund-request__title {
  color: white;
}

.order-refund-request .order-refund-request__title svg {
  margin-right: 2rem;
}
.order-refund-request .order-refund-request__title span {
  font-weight: 600;
}
.order-refund-request .demmi-ui-timeline {
  margin: 2rem 1rem;
}
.order-refund-request .order-refund-request__update {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  box-sizing: border-box;
}
.order-refund-request .order-refund-request__update.order-refund-request .order-refund-request__update--is-loading > *:not(.element-loading-indicator) {
  opacity: 0.4;
}
body.theme-dark .order-refund-request .order-refund-request__update--is-loading > :not(.element-loading-indicator) {
  opacity: 0.4;
}

.order-refund-request .order-refund-request__update .order-refund-request__update-title {
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  line-height: 2rem;
  text-align: start;
  margin: 0 0 1rem 0;
}
.order-refund-request .order-refund-request__update .order-refund-request__update-title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .order-refund-request .order-refund-request__update .order-refund-request__update-title {
  color: white;
}

.order-refund-request .order-refund-request__update textarea.demmi-ui-input {
  height: 10rem;
}
.order-refund-request .order-refund-request__update .order-refund-request__buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.order-refund-request .order-refund-request__update .order-refund-request__buttons .demmi-ui-button {
  flex: 1 1 calc(50% - 1rem);
}
.order-refund-request .order-refund-request__details {
  padding: 2rem 2rem;
  border-radius: 1.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.order-refund-request .order-refund-request__details {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .order-refund-request .order-refund-request__details {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.order-refund-request .order-refund-request__details {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .order-refund-request .order-refund-request__details {
  color: white;
}

.order-refund-request .order-refund-request__details .order-refund-request__details-title {
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.1rem;
  line-height: 2rem;
  text-align: center;
  margin-bottom: 1rem;
}
.order-refund-request .order-refund-request__details .order-refund-request__products-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.5rem 1rem;
  box-sizing: border-box;
  border-radius: 1.2rem;
  max-width: 40rem;
  width: 100%;
}
.order-refund-request .order-refund-request__details .order-refund-request__products-list {
  background-color: white;
}
body.theme-dark .order-refund-request .order-refund-request__details .order-refund-request__products-list {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.2);
}

.order-refund-request .order-refund-request__details .order-refund-request__costing {
  display: flex;
  flex-direction: column;
  padding: 1rem 1rem;
  box-sizing: border-box;
  border-radius: 1.2rem;
  max-width: 40rem;
  width: 100%;
}
.order-refund-request .order-refund-request__details .order-refund-request__costing {
  background-color: white;
}
body.theme-dark .order-refund-request .order-refund-request__details .order-refund-request__costing {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.2);
}

.order-refund-request .order-refund-request__details .order-refund-request__costing .order-refund-request__key-val {
  display: flex;
  justify-content: space-between;
  line-height: 2rem;
  padding: 0rem 1rem;
  margin: 0.4rem 0;
}
.order-refund-request .order-refund-request__details .order-refund-request__costing .order-refund-request__key-val .order-refund-request__key {
  font-size: 1.3rem;
  font-weight: 600;
}
.order-refund-request .order-refund-request__details .order-refund-request__costing .order-refund-request__key-val .order-refund-request__value {
  font-size: 1.4rem;
  font-weight: 400;
}

.order-item .order-product-item {
  display: flex;
  gap: 2rem;
  box-sizing: border-box;
  border-radius: 1rem;
  padding: 0.5rem;
  line-height: 1.8rem;
  width: 100%;
}
.order-item .order-product-item {
  background-color: white;
}
body.theme-dark .order-item .order-product-item {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.order-item .order-product-item {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .order-item .order-product-item {
  color: white;
}

.order-item .order-product-item .order-product-item__image {
  width: 12rem;
  box-sizing: border-box;
  height: 10rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1rem;
}
.order-item .order-product-item .order-product-item__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.order-item .order-product-item .order-product-item__info {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 0;
}
.order-item .order-product-item .order-product-item__info .order-product-item__name {
  font-size: 1.5rem;
  font-weight: 600;
}
.order-item .order-product-item .order-product-item__info .order-product-item__variant {
  margin-top: 0.4rem;
  font-size: 1.3rem;
  font-weight: 400;
}
.order-item .order-product-item .order-product-item__info .order-product-item__quantity {
  margin-top: auto;
  font-size: 1.6rem;
  font-weight: 400;
}
.order-item .order-product-item .order-product-item__info .order-product-item__quantity span {
  font-weight: 600;
  font-size: 1.4rem;
}
.order-item .order-product-item .order-product-item__cost {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 1rem;
  font-size: 1.6rem;
  font-weight: 600;
}
.order-item .order-product-item--list-view {
  padding: 1rem 0.5rem;
  border-radius: 0;
}
.order-item .order-product-item--list-view {
  background-color: transparent;
}
body.theme-dark .order-item .order-product-item--list-view {
  background-color: transparent;
}

.order-item .order-product-item--list-view:not(:last-child) {
  border-bottom: 0.1rem solid transparent;
}
.order-item .order-product-item--list-view:not(:last-child) {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .order-item .order-product-item--list-view:not(:last-child) {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.order-item .order-product-item--S {
  gap: 1.5rem;
}
.order-item .order-product-item--S .order-product-item__image {
  width: 9rem;
  height: 7rem;
  border-radius: 0.8rem;
}
.order-item .order-product-item--S .order-product-item__info {
  padding: 0.2rem 0;
}
.order-item .order-product-item--S .order-product-item__info .order-product-item__name {
  font-size: 1.4rem;
}
.order-item .order-product-item--S .order-product-item__info .order-product-item__variant {
  margin-top: 0.2rem;
  font-size: 1.3rem;
}
.order-item .order-product-item--S .order-product-item__info .order-product-item__quantity {
  font-size: 1.5rem;
}
.order-item .order-product-item--S .order-product-item__cost {
  font-size: 1.5rem;
}
@media (max-width: 480px) {
  .order-item .order-product-item {
    display: grid;
    grid-template: "image image" "info cost"/1fr auto;
    gap: 1.2rem 1rem;
    padding: 1.2rem;
  }
  .order-item .order-product-item .order-product-item__image {
    grid-area: image;
    width: 18rem;
    height: 12rem;
    margin: 0 auto;
  }
  .order-item .order-product-item .order-product-item__info {
    grid-area: info;
    padding: 0;
    gap: 0.4rem;
  }
  .order-item .order-product-item .order-product-item__info .order-product-item__variant {
    margin-top: 0;
  }
  .order-item .order-product-item .order-product-item__info .order-product-item__variant {
    margin-top: 0;
  }
  .order-item .order-product-item .order-product-item__cost {
    grid-area: cost;
  }
}

.order-item__wrapper {
  grid-area: order;
  overflow: hidden;
  width: 100%;
  max-width: 80rem;
  justify-self: center;
  box-sizing: border-box;
}

.order-item {
  padding: 2rem 1rem;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  line-height: 1.8rem;
  display: flex;
  gap: 2rem;
  flex-direction: column;
  overflow: auto;
  height: 100%;
}
.order-item {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .order-item {
  color: white;
}

.order-item .order-item__key-val {
  display: flex;
  justify-content: space-between;
  line-height: 2rem;
  padding: 0rem 1rem;
  margin: 1rem 0;
}
.order-item .order-item__key-val .order-item__key {
  font-size: 1.3rem;
  font-weight: 600;
}
.order-item .order-item__key-val .order-item__value {
  font-size: 1.4rem;
  font-weight: 400;
}
.order-item .order-item__divider {
  margin: 2rem 1rem;
  height: 0.1rem;
  width: calc(100% - 2rem);
}
.order-item .order-item__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}
body.theme-dark .order-item .order-item__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.2);
}

@media (max-width: 480px) {
  .order-item {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }
  .order-item .order-item__key-val {
    flex-direction: column;
  }
}

.orders-sidebar-button {
  position: relative;
  cursor: pointer;
  line-height: 1.8rem;
  transition: box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out;
  padding: 1.6rem 1.2rem;
  box-sizing: border-box;
}
.orders-sidebar-button {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .orders-sidebar-button {
  color: white;
}

.orders-sidebar-button .orders-sidebar-button__status {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: 0.2rem;
  line-height: 2rem;
  border-radius: 2rem;
  text-align: center;
  margin-bottom: 1rem;
  padding: 0.5rem;
}
.orders-sidebar-button .orders-sidebar-button__status {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .orders-sidebar-button .orders-sidebar-button__status {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.5);
}

.orders-sidebar-button .orders-sidebar-button__key-val-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 1.6rem;
  margin-bottom: 0.4rem;
  box-sizing: border-box;
  padding: 0 0.6rem;
}
.orders-sidebar-button .orders-sidebar-button__key-val {
  display: flex;
  flex-direction: column;
  justify-content: start;
  text-align: start;
}
.orders-sidebar-button .orders-sidebar-button__key-val .orders-sidebar-button__key {
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.4rem;
  letter-spacing: 0.1rem;
}
.orders-sidebar-button .orders-sidebar-button__key-val .orders-sidebar-button__key {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .orders-sidebar-button .orders-sidebar-button__key-val .orders-sidebar-button__key {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.orders-sidebar-button .orders-sidebar-button__key-val .orders-sidebar-button__value {
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.08rem;
  line-height: 1.8rem;
}
.orders-sidebar-button .orders-sidebar-button__key-val:last-child {
  text-align: end;
}

.orders {
  position: relative;
  z-index: 100;
  margin: 0 auto;
  display: grid;
  grid-template: "orders order" 1fr/36rem 1fr;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: auto hidden;
}
.orders {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .orders {
  color: white;
}

.vendor-wrapper .vendor-wrapper__error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  justify-self: center;
  border-radius: 2rem;
  padding: 2.5rem 3.5rem;
  box-sizing: border-box;
  text-align: center;
}
.vendor-wrapper .vendor-wrapper__error {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.5);
}
body.theme-dark .vendor-wrapper .vendor-wrapper__error {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.vendor-wrapper .vendor-wrapper__error {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.5);
}
body.theme-dark .vendor-wrapper .vendor-wrapper__error {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.vendor-wrapper .vendor-wrapper__error {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .vendor-wrapper .vendor-wrapper__error {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.vendor-wrapper .vendor-wrapper__error .vendor-wrapper__error-title {
  text-align: center;
  line-height: 2.4rem;
  font-weight: 6500;
  font-size: 1.8rem;
  letter-spacing: 0.1rem;
}
.vendor-wrapper .vendor-wrapper__error .vendor-wrapper__error-subtitle {
  text-align: center;
  line-height: 2.4rem;
  font-weight: 400;
  font-size: 1.3rem;
  letter-spacing: 0.05rem;
  margin-top: 1rem;
}
.vendor-wrapper .vendor-wrapper__error .demmi-ui-button {
  margin-top: 2rem;
}

.vendor-wrapper .vendor-wrapper__content {
  border-radius: 2rem;
  margin: 1rem auto;
  overflow: auto hidden;
  max-width: 180rem;
  width: 100%;
  box-sizing: border-box;
  transition: opacity 0.3s ease-in-out;
}
.vendor-wrapper .vendor-wrapper__content {
  background-color: rgba(255, 255, 255, 0.3);
}
body.theme-dark .vendor-wrapper .vendor-wrapper__content {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.vendor-wrapper .vendor-wrapper__content.vendor-wrapper--home {
  border: none;
}
body.theme-dark .vendor-wrapper .vendor-wrapper__content.vendor-wrapper--home {
  border: none;
}

.vendor-wrapper .vendor-wrapper__content.vendor-wrapper--home {
  background-color: transparent;
}
body.theme-dark .vendor-wrapper .vendor-wrapper__content.vendor-wrapper--home {
  background-color: transparent;
}

.vendor-wrapper .vendor-wrapper__content.vendor-wrapper--home {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 100%, 20%,0.24);
}
body.theme-dark .vendor-wrapper .vendor-wrapper__content.vendor-wrapper--home {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.vendor-wrapper__mobile-menu {
  display: none;
  position: absolute;
  inset: 0;
}
.vendor-wrapper__mobile-menu.vendor-wrapper__mobile-menu--active .mobile-menu__content {
  opacity: 1;
}
.vendor-wrapper__mobile-menu {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .vendor-wrapper__mobile-menu {
  background-color: hsla(var(--theme-bg-hue), 15%, 23%, 1);
}

@media (max-width: 1100px) {
  .vendor-wrapper__mobile-menu {
    display: block;
  }
}
.vendor-wrapper__mobile-menu .mobile-menu__content {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  width: 30rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.vendor-wrapper {
  position: relative;
  z-index: 100;
  display: grid;
  grid-template: "header" 4rem "content" 1fr "toolbar" 5rem/1fr;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 1rem;
  transform-origin: left;
}
.vendor-wrapper {
  background-color: var(--palette-100);
}
body.theme-dark .vendor-wrapper {
  background-color: rgb(0, 0, 0);
}

.vendor-wrapper .vendor-wrapper__background {
  position: absolute;
  inset: 0;
  z-index: -100;
}
.vendor-wrapper .vendor-wrapper__background {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .vendor-wrapper .vendor-wrapper__background {
  background-color: hsla(var(--theme-bg-hue), 15%, 8%, 1);
}

.vendor-wrapper .vendor-wrapper__background::before {
  content: "";
  z-index: 0;
  inset: 0;
  position: absolute;
  opacity: 0.5;
  background: radial-gradient(circle at calc(1% * var(--theme-bg-pos)) top, white, transparent, transparent), radial-gradient(circle at calc(100% - 1% * var(--theme-bg-pos)) bottom, white, transparent, transparent);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.vendor-wrapper .vendor-wrapper__background::after {
  z-index: 0;
  content: "";
  inset: 0;
  position: absolute;
  background: var(--theme-bg-svg);
}
.vendor-wrapper .vendor-wrapper__background::after {
  mix-blend-mode: color-burn;
}
body.theme-dark .vendor-wrapper .vendor-wrapper__background::after {
  mix-blend-mode: color-dodge;
}

.vendor-wrapper .vendor-wrapper__background::after {
  opacity: 0.6;
}
body.theme-dark .vendor-wrapper .vendor-wrapper__background::after {
  opacity: 0.1;
}

body.theme-dark .vendor-wrapper .vendor-wrapper__background::before {
  opacity: 0.2;
  background: radial-gradient(circle at calc(1% * var(--theme-bg-pos)) top, var(--theme-bg-01), transparent, transparent), radial-gradient(circle at calc(100% - 1% * var(--theme-bg-pos)) bottom, var(--theme-bg-02), transparent, transparent);
}

.vendor-wrapper .vendor-wrapper__foreground {
  position: absolute;
  inset: 0;
  opacity: 0;
  z-index: 100;
  pointer-events: none;
  transition: opacity 0.24s ease-in-out;
}
.vendor-wrapper .vendor-wrapper__foreground {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .vendor-wrapper .vendor-wrapper__foreground {
  background-color: hsla(var(--theme-bg-hue), 15%, 8%, 1);
}

.vendor-wrapper .vendor-wrapper__foreground::before {
  content: "";
  z-index: 0;
  inset: 0;
  position: absolute;
  opacity: 0.25;
  background: radial-gradient(circle at calc(1% * var(--theme-bg-pos)) top, white, transparent, transparent), radial-gradient(circle at calc(100% - 1% * var(--theme-bg-pos)) bottom, white, transparent, transparent);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.vendor-wrapper .vendor-wrapper__foreground::after {
  z-index: 0;
  content: "";
  inset: 0;
  position: absolute;
  background: var(--theme-bg-svg);
}
.vendor-wrapper .vendor-wrapper__foreground::after {
  mix-blend-mode: color-burn;
}
body.theme-dark .vendor-wrapper .vendor-wrapper__foreground::after {
  mix-blend-mode: color-dodge;
}

.vendor-wrapper .vendor-wrapper__foreground::after {
  opacity: 0.6;
}
body.theme-dark .vendor-wrapper .vendor-wrapper__foreground::after {
  opacity: 0.1;
}

body.theme-dark .vendor-wrapper .vendor-wrapper__foreground::before {
  opacity: 0.1;
  background: radial-gradient(circle at calc(1% * var(--theme-bg-pos)) top, var(--theme-bg-01), transparent, transparent), radial-gradient(circle at calc(100% - 1% * var(--theme-bg-pos)) bottom, var(--theme-bg-02), transparent, transparent);
}

.vendor-wrapper .vendor-wrapper__foreground .vendor-wrapper__foreground-icon {
  position: absolute;
  left: 2rem;
  top: 0;
  bottom: 0;
  width: 2.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
.vendor-wrapper .vendor-wrapper__foreground .vendor-wrapper__foreground-icon svg {
  height: 2.4rem;
  width: 2.4rem;
}
.vendor-wrapper .vendor-wrapper__foreground .vendor-wrapper__foreground-icon svg {
  color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 1);
}
body.theme-dark .vendor-wrapper .vendor-wrapper__foreground .vendor-wrapper__foreground-icon svg {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.vendor-wrapper .vendor-wrapper__header {
  grid-area: header;
  z-index: 1;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}
.vendor-wrapper .vendor-wrapper__header .vendor-wrapper__action-buttons {
  display: flex;
  gap: 0.8rem;
  z-index: 1;
}
.vendor-wrapper .vendor-wrapper__header .vendor-wrapper__action-buttons .vendor-wrapper__action-button-menu {
  display: none;
}
.vendor-wrapper .vendor-wrapper__content {
  grid-area: content;
  z-index: 1;
}
.vendor-wrapper .vendor-wrapper__toolbar {
  grid-area: toolbar;
  z-index: 1;
}
@media (max-width: 1100px) {
  .vendor-wrapper {
    display: grid;
    grid-template: "header" 6rem "content" 1fr/1fr;
    padding: 0;
    transition: transform 0.24s ease-in-out, border-radius 0.24s ease-in-out, box-shadow 0.24s ease-in-out;
  }
  .vendor-wrapper.vendor-wrapper--mobile-menu-active {
    transform: translate3d(30rem, 0px, 0px) scale3d(0.95, 0.95, 0.95);
    border-radius: 2rem;
  }
  .vendor-wrapper.vendor-wrapper--mobile-menu-active .vendor-wrapper__content {
    pointer-events: none;
    opacity: 0.8;
  }
  .vendor-wrapper.vendor-wrapper--mobile-menu-active .vendor-wrapper__foreground {
    cursor: pointer;
    pointer-events: unset;
    z-index: 1;
    opacity: 1;
  }
  .vendor-wrapper .vendor-wrapper__header {
    display: flex;
    justify-content: flex-start;
    padding: 0.8rem;
  }
  .vendor-wrapper .vendor-wrapper__header .vendor-wrapper__theme-switcher {
    display: none;
  }
  .vendor-wrapper .vendor-wrapper__header .vendor-wrapper__action-buttons {
    width: 100%;
  }
  .vendor-wrapper .vendor-wrapper__header .vendor-wrapper__action-buttons .vendor-wrapper__action-button-menu {
    display: block;
    margin-right: auto;
  }
  .vendor-wrapper .vendor-wrapper__content {
    margin: 0;
  }
  .vendor-wrapper .vendor-wrapper__toolbar {
    display: none;
  }
}

.vendor-title {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  font-size: 1.6rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  line-height: 4rem;
  text-align: center;
  color: white;
}
.vendor-title {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.7);
}
body.theme-dark .vendor-title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

:root {
  --phone-preview-hue: 200;
}

body.theme-dark .display-shop__app {
  background: radial-gradient(ellipse at top left, hsl(var(--phone-preview-hue), var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l), 0.3), transparent), radial-gradient(ellipse at bottom right, hsl(var(--phone-preview-hue), var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l), 0.2), transparent), hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 0.2);
}
body.theme-dark .display-shop__app .display-shop__header {
  background-color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 0.6);
}
body.theme-dark .display-shop__app .display-shop__header .display-shop__title {
  color: white;
}
body.theme-dark .display-shop__app .display-shop__header .display-shop__title span {
  color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .display-shop__app .display-shop__header .display-shop__buttons-row .display-shop__buttons-row-button span {
  color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .display-shop__app .display-shop__header .display-shop__location {
  color: rgba(255, 255, 255, 0.9);
  background-color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l), 0.2);
  border-color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l), 0.2);
}
body.theme-dark .display-shop__app .display-shop__header .display-shop__location .display-shop__location-top span {
  color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .display-shop__app .display-shop__header .display-shop__search {
  color: white;
}
body.theme-dark .display-shop__app .display-shop__header .display-shop__search span {
  color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .display-shop__app .display-shop__section-title {
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-100-s), var(--phone-preview-palette-100-l));
}
body.theme-dark .display-shop__app .display-shop__categories .display-shop__category {
  color: rgba(255, 255, 255, 0.8);
  background-color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 0.3);
}
body.theme-dark .display-shop__app .display-shop__categories .display-shop__category span {
  color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .display-shop__app .display-shop__product-list .display-shop__product {
  box-shadow: none;
  background-color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 0.4);
}
body.theme-dark .display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-image {
  background-color: hsla(var(--phone-preview-hue), , 0.2);
}
body.theme-dark .display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-name {
  color: rgb(255, 255, 255);
}
body.theme-dark .display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-price {
  color: rgb(255, 255, 255);
}
body.theme-dark .display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-variant {
  color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .display-shop__app .display-shop__reviews-list .display-shop__review {
  box-shadow: none;
  background-color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 0.4);
}
body.theme-dark .display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-title {
  color: rgb(255, 255, 255);
}
body.theme-dark .display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-date {
  color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-rating .display-shop__review-rating-icon {
  color: #a5d6a7;
}
body.theme-dark .display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-description {
  color: rgb(255, 255, 255);
}

.display-shop__app {
  display: block;
  box-sizing: border-box;
  background: radial-gradient(ellipse at center, hsl(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l)), transparent), radial-gradient(hsl(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l)), hsl(var(--phone-preview-hue), var(--phone-preview-palette-100-s), var(--phone-preview-palette-100-l)));
  width: 100%;
  height: 100%;
  border-radius: 1.5rem;
  padding: 0 0 1rem 0;
  overflow: hidden;
  transition: background-color 0s ease-in-out;
}
.display-shop__app .display-shop__header {
  position: relative;
  padding: 0.2rem;
  box-shadow: 0 0rem 3rem hsla(var(--phone-preview-hue), var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l), 0.2);
  transition: box-shadow 0s ease-in-out;
  background-color: rgba(255, 255, 255, 0.9);
}
.display-shop__app .display-shop__header .display-shop__title {
  display: flex;
  padding: 0 2rem;
  justify-content: space-between;
  position: relative;
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l));
  font-weight: 400;
  font-size: 1.5rem;
  text-align: center;
  line-height: 5rem;
  transition: color 0s ease-in-out, background-color 0s ease-in-out;
}
.display-shop__app .display-shop__header .display-shop__title span {
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
  height: 1.4rem;
  width: 1.4rem;
  font-size: 1.4rem;
}
.display-shop__app .display-shop__header .display-shop__buttons-row {
  position: relative;
  display: flex;
  justify-content: space-evenly;
}
.display-shop__app .display-shop__header .display-shop__buttons-row .display-shop__buttons-row-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 6rem;
  height: 4.5rem;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 1.4rem;
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l), 0.7);
}
.display-shop__app .display-shop__header .display-shop__buttons-row .display-shop__buttons-row-button span {
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
  height: 1.6rem;
  width: 1.6rem;
  font-size: 1.6rem;
  margin-bottom: 0.8rem;
}
.display-shop__app .display-shop__header .display-shop__location {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 5rem;
  box-sizing: border-box;
  padding: 0.6rem 1.2rem;
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l), 0.7);
  background-color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l), 0.4);
  border-top: 0.1rem solid;
  border-bottom: 0.1rem solid;
  border-color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-100-s), var(--phone-preview-palette-100-l));
}
.display-shop__app .display-shop__header .display-shop__location .display-shop__location-top {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
}
.display-shop__app .display-shop__header .display-shop__location .display-shop__location-top span {
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
  height: 1.4rem;
  width: 1.4rem;
  font-size: 1.4rem;
  line-height: 1.4rem;
  margin-right: 0.4rem;
}
.display-shop__app .display-shop__header .display-shop__location .display-shop__location-address {
  font-size: 1.2rem;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-align: center;
}
.display-shop__app .display-shop__header .display-shop__search {
  position: relative;
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 5rem;
  padding: 0 2rem;
  transition: color 0s ease-in-out;
}
.display-shop__app .display-shop__header .display-shop__search span {
  margin-right: 2rem;
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-500-s), var(--phone-preview-palette-500-l), 0.6);
  height: 1.4rem;
  width: 1.4rem;
  font-size: 1.4rem;
}
.display-shop__app .display-shop__section-title {
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-700-s), var(--phone-preview-palette-700-l), 0.8);
  font-weight: 600;
  font-size: 1.6rem;
  margin-left: 1.6rem;
  margin-top: 2.2rem;
  margin-bottom: 1.2rem;
  transition: color 0s ease-in-out;
}
.display-shop__app .display-shop__categories {
  margin-top: 1.2rem;
  display: block;
  white-space: nowrap;
  margin-left: 1rem;
}
.display-shop__app .display-shop__categories .display-shop__category {
  margin: 0 0.8rem 0 0;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 1.5rem;
  background-color: rgba(255, 255, 255, 0.5);
  width: 15rem;
  height: 9rem;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4rem;
  text-transform: uppercase;
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
}
.display-shop__app .display-shop__categories .display-shop__category span {
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
  height: 2.8rem;
  width: 2.8rem;
  font-size: 2.8rem;
  margin-bottom: 1.2rem;
  margin-top: 0.6rem;
}
.display-shop__app .display-shop__product-list {
  white-space: nowrap;
  margin: 1rem 0;
  padding: 0 1rem;
}
.display-shop__app .display-shop__product-list .display-shop__product {
  height: 20rem;
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 1.2rem;
  width: 16rem;
  margin-right: 1.6rem;
  padding: 0.5rem;
  box-sizing: border-box;
  box-shadow: 0 0.5rem 1rem hsla(var(--phone-preview-hue), var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l), 0.16);
  transition: box-shadow 0s ease-in-out;
}
.display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-image {
  background-color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l));
  width: 100%;
  height: 12rem;
  border-radius: 0.8rem;
  margin-bottom: 0.6rem;
  transition: background-color 0s ease-in-out;
  overflow: hidden;
}
.display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-name {
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-800-s), var(--phone-preview-palette-800-l), 0.6);
  font-weight: 700;
  font-size: 1.3rem;
  margin-left: 0.5rem;
  line-height: 2rem;
  margin-bottom: 0.6rem;
}
.display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-price {
  display: flex;
  align-items: flex-end;
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l), 0.6);
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 2rem;
  margin-left: 0.2rem;
  margin-bottom: 0.2rem;
  transition: color 0s ease-in-out;
}
.display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-price span {
  font-size: 1.2rem;
  line-height: 1.6rem;
  margin: 0 0.3rem;
}
.display-shop__app .display-shop__product-list .display-shop__product .display-shop__product-variant {
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l), 0.5);
  font-weight: 700;
  font-size: 1rem;
  margin-left: 0.5rem;
  line-height: 1.4rem;
  margin-bottom: 0.4rem;
  transition: color 0s ease-in-out;
}
.display-shop__app .display-shop__reviews-list {
  white-space: nowrap;
  margin: 1rem;
  margin-bottom: 1.6rem;
}
.display-shop__app .display-shop__reviews-list .display-shop__review {
  position: relative;
  display: inline-block;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 1.6rem;
  width: 100%;
  margin-right: 1rem;
  padding: 1.6rem;
  box-sizing: border-box;
  box-shadow: 0 0.5rem 1rem hsla(var(--phone-preview-hue), var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l), 0.16);
  transition: box-shadow 0s ease-in-out;
}
.display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-title {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
  font-size: 1.3rem;
  line-height: 1.6rem;
  margin-bottom: 0.4rem;
}
.display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-date {
  color: rgba(0, 0, 0, 0.4);
  font-weight: 600;
  font-size: 1.1rem;
  line-height: 1.2rem;
  margin-bottom: 0.4rem;
}
.display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-rating {
  position: absolute;
  top: 1.4rem;
  right: 1.4rem;
  gap: 0.8rem;
}
.display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-rating .display-shop__review-rating-icon {
  color: #4caf50;
  height: 2.4rem;
  width: 2.4rem;
  font-size: 2.4rem;
}
.display-shop__app .display-shop__reviews-list .display-shop__review .display-shop__review-description {
  margin-top: 1rem;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.8rem;
  white-space: normal;
  text-align: start;
  letter-spacing: 0.05rem;
}
.display-shop__app .display-shop__button {
  background-color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
  color: rgb(255, 255, 255);
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 3.2rem;
  text-align: center;
  margin: 0 1rem;
  border-radius: 1.2rem;
  text-transform: uppercase;
  transition: background-color 0s ease-in-out;
}

:root {
  --phone-preview-hue: 200;
}

body.theme-dark .display-product__app {
  background: radial-gradient(ellipse at top left, hsl(var(--phone-preview-hue), var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l), 0.3), transparent), radial-gradient(ellipse at bottom right, hsl(var(--phone-preview-hue), var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l), 0.2), transparent), hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 0.1);
}
body.theme-dark .display-product__app .display-product__header .display-product__title {
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l));
}
body.theme-dark .display-product__app .display-product__header .display-product__title span {
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 1);
}
body.theme-dark .display-product__app .display-product__content {
  overflow: auto;
  height: 100%;
  background: hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 0.2);
}
body.theme-dark .display-product__app .display-product__gallery .display-product__gallery-images .display-product__gallery-image {
  box-shadow: 0 0.8rem 1rem rgba(0, 0, 0, 0);
}
body.theme-dark .display-product__app .display-product__category {
  color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .display-product__app .display-product__category .display-product__icon {
  color: rgba(255, 255, 255, 0.5);
}
body.theme-dark .display-product__app .display-product__card {
  background: hsla(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l), 0.4);
}
body.theme-dark .display-product__app .display-product__card .display-product__card-title {
  color: white;
}
body.theme-dark .display-product__app .display-product__card .display-product__card-description {
  color: white;
}
body.theme-dark .display-product__app .display-product__card-location {
  color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .display-product__app .display-product__card-location span {
  color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .display-product__app .display-product__button-wrapper {
  pointer-events: none;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
}
body.theme-dark .display-product__app .display-product__button-wrapper .display-product__button {
  background-color: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.4);
}
body.theme-dark .display-product__app .display-product__button-wrapper .display-product__button .display-product__button-left {
  color: white;
}
body.theme-dark .display-product__app .display-product__button-wrapper .display-product__button .display-product__button-right {
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l));
  background-color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l));
}

.display-product__app {
  position: relative;
  display: block;
  box-sizing: border-box;
  background: radial-gradient(ellipse at top, hsl(var(--phone-preview-hue), var(--phone-preview-palette-100-s), var(--phone-preview-palette-100-l)), hsl(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l)));
  width: 100%;
  height: 100%;
  border-radius: 1.5rem;
  padding: 0 0 1rem;
  overflow: hidden;
  transition: background-color 0s ease-in-out;
}
.display-product__app .display-product__header {
  height: 5rem;
}
.display-product__app .display-product__header .display-product__title {
  display: flex;
  padding: 0 2rem;
  justify-content: space-between;
  position: relative;
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l), 0.8);
  font-weight: 500;
  font-size: 1.4rem;
  text-align: center;
  line-height: 5rem;
  transition: color 0s ease-in-out;
}
.display-product__app .display-product__header .display-product__title span {
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l));
  height: 1.6rem;
  width: 1.6rem;
  font-size: 1.6rem;
}
.display-product__app .display-product__content {
  background: linear-gradient(rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.2));
  border-radius: 1.2rem;
  padding-top: 1.6rem;
}
.display-product__app .display-product__gallery .display-product__gallery-images .display-product__gallery-image {
  margin: 0 auto;
  width: 30rem;
  height: 22.8rem;
  border-radius: 1.2rem;
  background-color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l));
  box-shadow: 0 0.8rem 1rem rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.display-product__app .display-product__gallery .display-product__gallery-images .display-product__gallery-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.display-product__app .display-product__gallery .display-product__gallery-toolbar {
  margin: 0 auto;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  height: 0.8rem;
  width: 20rem;
  box-sizing: border-box;
  padding: 0.2rem;
  border-radius: 0.4rem;
  background-color: rgba(0, 0, 0, 0.32);
}
.display-product__app .display-product__gallery .display-product__gallery-toolbar .display-product__gallery-toolbar-indicator {
  background-color: white;
  height: 0.4rem;
  width: 0%;
  border-radius: 0.2rem;
}
.display-product__app .display-product__category {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.3);
  text-transform: uppercase;
  letter-spacing: 0.1rem;
}
.display-product__app .display-product__category .display-product__icon {
  color: rgba(0, 0, 0, 0.4);
  height: 1.6rem;
  width: 1.6rem;
  font-size: 1.6rem;
}
.display-product__app .display-product__card {
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 0.8rem;
  margin: 1rem 0.8rem;
  padding: 1.6rem;
  box-sizing: border-box;
}
.display-product__app .display-product__card .display-product__card-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
  letter-spacing: 0.05rem;
  line-height: 1.8rem;
  margin-bottom: 1rem;
}
.display-product__app .display-product__card .display-product__card-description {
  font-size: 1.2rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
}
.display-product__app .display-product__card .display-product__card-description span {
  display: block;
  margin-bottom: 2rem;
}
.display-product__app .display-product__card-location {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5.2rem;
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 600;
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l));
  gap: 2rem;
}
.display-product__app .display-product__card-location span {
  color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
  height: 1.8rem;
  width: 1.8rem;
  font-size: 1.8rem;
}
.display-product__app .display-product__button-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 14rem;
  background: linear-gradient(hsla(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l), 0), hsla(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l), 1));
  display: flex;
  align-items: flex-end;
}
.display-product__app .display-product__button-wrapper .display-product__button {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border: 0.1rem solid;
  border-color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l));
  font-weight: 700;
  font-size: 1.2rem;
  line-height: 5.2rem;
  text-align: center;
  margin: 1.6rem;
  border-radius: 1.2rem;
  backdrop-filter: blur(4px);
  transition: background-color 0s ease-in-out;
  background-color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l), 0.6);
}
.display-product__app .display-product__button-wrapper .display-product__button .display-product__button-left {
  flex: 1 1 45%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: hsla(var(--phone-preview-hue), var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l), 0.6);
  font-weight: 700;
  font-size: 2rem;
  line-height: 2rem;
  letter-spacing: 0.05rem;
}
.display-product__app .display-product__button-wrapper .display-product__button .display-product__button-left span {
  font-size: 1.2rem;
  line-height: 1.6rem;
  margin: 0 0.4rem;
  margin-top: 0.6rem;
}
.display-product__app .display-product__button-wrapper .display-product__button .display-product__button-right {
  margin: -0.1rem;
  flex: 1 1 55%;
  color: white;
  border-radius: 1.2rem;
  text-transform: uppercase;
  background-color: hsl(var(--phone-preview-hue), var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l));
}

:root {
  --phone-preview-palette-50-s: 35%;
  --phone-preview-palette-50-l: 93%;
  --phone-preview-palette-100-s: 40%;
  --phone-preview-palette-100-l: 84%;
  --phone-preview-palette-200-s: 45%;
  --phone-preview-palette-200-l: 73%;
  --phone-preview-palette-300-s: 50%;
  --phone-preview-palette-300-l: 63%;
  --phone-preview-palette-400-s: 55%;
  --phone-preview-palette-400-l: 55%;
  --phone-preview-palette-500-s: 60%;
  --phone-preview-palette-500-l: 47%;
  --phone-preview-palette-600-s: 65%;
  --phone-preview-palette-600-l: 42%;
  --phone-preview-palette-700-s: 70%;
  --phone-preview-palette-700-l: 36%;
  --phone-preview-palette-800-s: 75%;
  --phone-preview-palette-800-l: 30%;
  --phone-preview-palette-900-s: 80%;
  --phone-preview-palette-900-l: 23%;
}

:root {
  --phone-preview-hue: 200;
}

.app-switcher {
  grid-area: appswitcher;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 1.2rem;
  display: flex;
  padding: 0.4rem;
  box-sizing: border-box;
  gap: 0.5rem;
}
.app-switcher {
  background-color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.5);
}
body.theme-dark .app-switcher {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.app-switcher .app-switcher__button {
  flex: 1 1 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.8rem;
  gap: 1rem;
  border-radius: 1.2rem;
  padding: 1rem;
  cursor: pointer;
  transition: background-color 0.1s ease-in-out;
}
.app-switcher .app-switcher__button {
  color: white;
}
body.theme-dark .app-switcher .app-switcher__button {
  color: white;
}

.app-switcher .app-switcher__button .app-switcher__icon span {
  color: white;
  height: 1.8rem;
  width: 1.8rem;
  font-size: 1.8rem;
}
.app-switcher .app-switcher__button:not(.app-switcher__button--active):hover {
  background-color: rgba(255, 255, 255, 0.2);
}
body.theme-dark .app-switcher .app-switcher__button:not(.app-switcher__button--active):hover {
  background-color: rgba(0, 0, 0, 0.2);
}

.app-switcher .app-switcher__button.app-switcher__button--active {
  background-color: rgba(255, 255, 255, 0.9);
}
body.theme-dark .app-switcher .app-switcher__button.app-switcher__button--active {
  background-color: black;
}

.app-switcher .app-switcher__button.app-switcher__button--active {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .app-switcher .app-switcher__button.app-switcher__button--active {
  color: white;
}

.app-switcher .app-switcher__button.app-switcher__button--active span {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .app-switcher .app-switcher__button.app-switcher__button--active span {
  color: white;
}

.fake-phone {
  font-family: "Montserrat";
  user-select: none;
  display: block;
  width: 100%;
  max-width: 40rem;
  height: 100%;
  max-height: 82rem;
  margin: 0 auto;
  border-radius: 2.5rem;
  box-sizing: border-box;
  padding: 1.2rem 0.6rem;
  border: 0.2rem solid hsla(var(--phone-preview-hue), 30%, 75%, 1);
  letter-spacing: 0.05rem;
  box-shadow: 0 0.1rem 0.4rem hsla(var(--theme-bg-hue), 100%, 20%, 0.28), 0 0.8rem 2rem hsla(var(--theme-bg-hue), 100%, 20%, 0.12);
}
.fake-phone {
  background-color: rgb(70, 71, 73);
}
body.theme-dark .fake-phone {
  background-color: rgb(40, 41, 43);
}

.fake-phone .fake-phone__display {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 1.5rem;
  overflow: hidden;
}
.fake-phone .fake-phone__display .fake-phone__status-bar {
  display: flex;
  justify-content: space-between;
  line-height: 3rem;
  color: white;
  font-size: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  padding: 0 1.5rem;
}
.fake-phone .fake-phone__display .fake-phone__status-bar .fake-phone__status-bar-left .fake-phone__icon {
  height: 1.2rem;
  width: 1.2rem;
  font-size: 1.2rem;
  margin: 0 0 0 0.8rem;
}
.fake-phone .fake-phone__display .fake-phone__status-bar .fake-phone__status-bar-right .fake-phone__icon {
  height: 1.1rem;
  width: 1.1rem;
  font-size: 1.1rem;
  margin: 0 0 0 0.2rem;
}
.fake-phone .fake-phone__display .fake-phone__status-bar .fake-phone__status-bar-right .fake-phone__icon .fa-battery-half {
  transform: rotate3d(0, 0, 1, -90deg) scale3d(0.9, 1, 1) translate3d(0.05rem, 0, 0);
}
.fake-phone .fake-phone__app {
  flex: 1 1 auto;
  overflow: hidden;
}
.fake-phone.fake-phone--animate {
  animation: fake-phone-change 0.4s linear;
}

@keyframes fake-phone-change {
  0% {
    transform: scale3d(1, 1, 1);
  }
  20% {
    transform: scale3d(0.95, 0.95, 0.95);
  }
  50% {
    transform: scale3d(0.95, 0.95, 0.95);
  }
  80% {
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
/**
    If Page with Sidebar is a child of another Page with Sidebar,
    the sidebar will be styled differently.
*/
.page .page.page--with-sidebar .page__sidebar {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0);
}
body.theme-dark .page .page.page--with-sidebar .page__sidebar {
  background-color: rgba(0, 0, 0, 0.1);
}

.page .page.page--with-sidebar .page__view {
  border-top: none;
}
.page .page.page--with-sidebar .page__view {
  background-color: rgba(255, 255, 255, 0);
}
body.theme-dark .page .page.page--with-sidebar .page__view {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0);
}

.page.page--with-sidebar {
  display: grid;
  transition: grid var(--sidebar-transition-time) ease-in-out;
  grid-template: "sidebar details" 1fr/var(--sidebar-width) 1fr;
}
.page.page--with-sidebar {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .page.page--with-sidebar {
  color: white;
}

.page.page--with-sidebar .page__sidebar {
  z-index: 1;
  overflow: hidden;
}
.page.page--with-sidebar .page__view {
  z-index: 0;
  height: 100%;
  border-left: 0.1rem solid transparent;
}
.page.page--with-sidebar .page__view {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .page.page--with-sidebar .page__view {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.page.page--with-sidebar .page__view {
  background-color: rgba(255, 255, 255, 0.2);
}
body.theme-dark .page.page--with-sidebar .page__view {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.page.page--with-sidebar .page__view .page__view-header {
  display: none;
  justify-content: space-between;
  align-items: center;
  padding: 1.6rem 1.6rem 0;
  margin-bottom: -0.8rem;
  box-sizing: border-box;
}
@media (max-width: 480px) {
  .page.page--with-sidebar .page__view .page__view-header {
    padding: 0.8rem 0.8rem 0;
  }
}
.page.page--with-sidebar .page__view .page__view-header .page__view-title {
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  letter-spacing: 0.08rem;
  font-weight: 500;
  padding-right: 4.2rem;
  box-sizing: border-box;
}
.page.page--with-sidebar .page__view .page__view-header .page__view-title {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.8);
}
body.theme-dark .page.page--with-sidebar .page__view .page__view-header .page__view-title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.page.page--with-sidebar .page__view .page__view-content {
  display: block;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
}
@media (max-width: 1100px) {
  .page.page--with-sidebar {
    display: block;
    overflow: hidden;
  }
  .page.page--with-sidebar.page--visible .page__sidebar {
    opacity: 1;
    transform: translate3d(0, 0, 0);
    transition: opacity calc(var(--sidebar-transition-time) * 2) ease-in-out, transform var(--sidebar-transition-time) ease-in-out;
  }
  .page.page--with-sidebar.page--visible .page__view {
    transform: translate3d(calc(var(--sidebar-width) - var(--sidebar-width-offset, 7rem)), 0, 0);
  }
  .page.page--with-sidebar.page--no-children {
    --sidebar-width-offset: 0rem;
  }
  .page.page--with-sidebar.page--no-children .page__view {
    opacity: 0;
  }
  .page.page--with-sidebar .page__sidebar {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: calc(var(--sidebar-width) - var(--sidebar-width-offset));
    z-index: 0;
    opacity: 0;
    transform: translate3d(-var(--sidebar-width), 0, 0);
    transition: opacity calc(var(--sidebar-transition-time) / 2) ease-in-out, transform var(--sidebar-transition-time) ease-in-out, width var(--sidebar-transition-time) ease-in-out;
  }
}
@media (max-width: 1100px) and (max-width: 480px) {
  .page.page--with-sidebar .page__sidebar {
    width: calc(var(--sidebar-width) - var(--sidebar-width-offset, 7rem));
  }
}
@media (max-width: 1100px) {
  .page.page--with-sidebar .page__view {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-width: unset;
    z-index: 1;
    transition: transform var(--sidebar-transition-time) ease-in-out;
  }
  .page.page--with-sidebar .page__view .page__view-header {
    display: flex;
    padding: 1.6rem;
    margin-bottom: 0rem;
    box-sizing: border-box;
    border-bottom: 0.1rem solid transparent;
  }
  .page.page--with-sidebar .page__view .page__view-header {
    border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
  }
  body.theme-dark .page.page--with-sidebar .page__view .page__view-header {
    border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
  }
}

.page.page--with-tabs {
  display: grid;
  grid-template: "tabs" auto "details" 1fr/1fr;
}
.page.page--with-tabs {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .page.page--with-tabs {
  color: white;
}

.page.page--with-tabs .page__tabs {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1.2rem;
  z-index: 1;
  overflow: auto hidden;
  margin: 0 auto;
  max-width: 100%;
}
.page.page--with-tabs .page__view {
  z-index: 0;
  padding: 0;
  height: 100%;
  border-radius: 0;
  border-top: 0.1rem solid transparent;
  box-sizing: border-box;
}
.page.page--with-tabs .page__view {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .page.page--with-tabs .page__view {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.page.page--with-tabs .page__view {
  background-color: rgba(255, 255, 255, 0.2);
}
body.theme-dark .page.page--with-tabs .page__view {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.page-tab {
  cursor: pointer;
  position: relative;
  height: 6rem;
  width: fit-content;
  width: -webkit-fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  letter-spacing: 0.15rem;
  white-space: nowrap;
  font-size: 1.3rem;
  line-height: 2rem;
  padding: 0.4rem 2rem;
  box-sizing: border-box;
  border: 0.2rem solid transparent;
  transition: color 0.1s ease-in-out, background-color 0.1s ease-in-out;
}
.page-tab {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .page-tab {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.page-tab {
  border-color: transparent;
}
body.theme-dark .page-tab {
  border-color: transparent;
}

.page-tab::after {
  content: "";
  position: absolute;
  bottom: -0.4rem;
  left: 1.6rem;
  right: 1.6rem;
  border-radius: 0.2rem;
  height: 0.4rem;
  transition: background-color 0.1s ease-in-out;
}
.page-tab::after {
  background-color: transparent;
}
body.theme-dark .page-tab::after {
  background-color: transparent;
}

.page-tab:disabled {
  cursor: default;
  opacity: 0.4;
}
.page-tab:disabled .page-tab__icon {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .page-tab:disabled .page-tab__icon {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}

.page-tab:not(:disabled):hover {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .page-tab:not(:disabled):hover {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.page-tab:not(:disabled):hover::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .page-tab:not(:disabled):hover::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 1);
}

.page-tab:not(:disabled):hover .page-tab__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .page-tab:not(:disabled):hover .page-tab__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.page-tab:not(:disabled):active, .page-tab:not(:disabled):focus-visible {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .page-tab:not(:disabled):active, .page-tab:not(:disabled):focus-visible {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.page-tab:not(:disabled):active::after, .page-tab:not(:disabled):focus-visible::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}
body.theme-dark .page-tab:not(:disabled):active::after, .page-tab:not(:disabled):focus-visible::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.8);
}

.page-tab:not(:disabled):active .page-tab__icon, .page-tab:not(:disabled):focus-visible .page-tab__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .page-tab:not(:disabled):active .page-tab__icon, .page-tab:not(:disabled):focus-visible .page-tab__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.page-tab.page-tab--active {
  pointer-events: none;
}
.page-tab.page-tab--active {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .page-tab.page-tab--active {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.page-tab.page-tab--active::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}
body.theme-dark .page-tab.page-tab--active::after {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.8);
}

.page-tab.page-tab--active .page-tab__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .page-tab.page-tab--active .page-tab__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.page-tab .page-tab__icon {
  margin-right: 1.6rem;
  line-height: 1.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page-tab .page-tab__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .page-tab .page-tab__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.page-tab .page-tab__icon svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}
.page-tab.page-tab--loading .page-tab__icon {
  opacity: 0.4;
}
.page-tab.page-tab--loading .page-tab__text {
  opacity: 0.4;
}

.page.page--with-toolbar {
  display: grid;
  grid-template: "toolbar" auto "details" 1fr/1fr;
}
.page.page--with-toolbar {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .page.page--with-toolbar {
  color: white;
}

.page.page--with-toolbar .page__toolbar {
  z-index: 1;
  width: 100%;
}
.page.page--with-toolbar .page__view {
  z-index: 0;
  padding: 0;
  height: 100%;
  border-radius: 0;
  border-top: 0.1rem solid transparent;
  box-sizing: border-box;
}
.page.page--with-toolbar .page__view {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .page.page--with-toolbar .page__view {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.page.page--with-toolbar .page__view {
  background-color: hsla(var(--theme-bg-hue), 10%, 95%, 0);
}
body.theme-dark .page.page--with-toolbar .page__view {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.page {
  position: relative;
  z-index: 100;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}
.page {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .page {
  color: white;
}

.page .page__view {
  position: relative;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: auto;
}

.user-menu-dropdown {
  position: absolute;
  z-index: 9999;
  right: 0;
  top: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 32rem;
  padding: 0.2rem 0;
  box-sizing: border-box;
  border-radius: 1.6rem;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 0.1rem solid transparent;
  overflow: hidden;
}
.user-menu-dropdown {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .user-menu-dropdown {
  background-color: hsla(var(--theme-bg-hue), 15%, 24%, 0.8);
}

.user-menu-dropdown {
  border-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .user-menu-dropdown {
  border-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.2);
}

.user-menu-dropdown {
  box-shadow: 0 2rem 2.4rem hsl(var(--theme-bg-hue), 100%, 20%,0.12);
}
body.theme-dark .user-menu-dropdown {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.user-menu-dropdown .user-menu-dropdown__divider {
  height: 0.1rem;
  border-radius: 0.1rem;
  width: calc(100% - 3.2rem);
}
.user-menu-dropdown .user-menu-dropdown__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .user-menu-dropdown .user-menu-dropdown__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.user-menu-dropdown .user-menu-dropdown__section {
  z-index: 1;
  width: 100%;
  padding: 1.2rem 0.6rem;
  box-sizing: border-box;
}
.user-menu-dropdown .user-menu-dropdown__user {
  z-index: 1;
  width: 100%;
  display: flex;
  gap: 1.6rem;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
}
.user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-image {
  flex: 0 0 4rem;
  grid-area: image;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  overflow: hidden;
}
.user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-image {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-image {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-image img {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-info-stack {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  overflow: hidden;
}
.user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-info-stack .user-menu-dropdown__user-name {
  grid-area: name;
  font-weight: 500;
  font-size: 1.6rem;
  letter-spacing: 0.08rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-info-stack .user-menu-dropdown__user-name {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-info-stack .user-menu-dropdown__user-name {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-info-stack .user-menu-dropdown__user-email {
  grid-area: status;
  font-weight: 400;
  font-size: 1.3rem;
  letter-spacing: 0.04rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-info-stack .user-menu-dropdown__user-email {
  color: hsla(var(--theme-bg-hue), var(--palette-500-s), var(--palette-500-l), 1);
}
body.theme-dark .user-menu-dropdown .user-menu-dropdown__user .user-menu-dropdown__user-info-stack .user-menu-dropdown__user-email {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.user-menu-dropdown .user-menu-dropdown__version {
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.8rem 2rem 1.6rem;
  box-sizing: border-box;
  line-height: 1.4rem;
  pointer-events: none;
  user-select: none;
  text-transform: uppercase;
}
.user-menu-dropdown .user-menu-dropdown__version .user-menu-dropdown__version-build,
.user-menu-dropdown .user-menu-dropdown__version .user-menu-dropdown__version-date {
  display: flex;
  justify-content: space-between;
}
.user-menu-dropdown .user-menu-dropdown__version .user-menu-dropdown__version-key {
  display: inline-block;
  font-size: 1rem;
  font-weight: 600;
  text-align: start;
  letter-spacing: 0.1rem;
}
.user-menu-dropdown .user-menu-dropdown__version .user-menu-dropdown__version-key {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.4);
}
body.theme-dark .user-menu-dropdown .user-menu-dropdown__version .user-menu-dropdown__version-key {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.7);
}

.user-menu-dropdown .user-menu-dropdown__version .user-menu-dropdown__version-val {
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 700;
  text-align: end;
  letter-spacing: 0.2rem;
}
.user-menu-dropdown .user-menu-dropdown__version .user-menu-dropdown__version-val {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.5);
}
body.theme-dark .user-menu-dropdown .user-menu-dropdown__version .user-menu-dropdown__version-val {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.8);
}

.user-menu-dropdown-button {
  cursor: pointer;
  flex: 0 0 100%;
  width: 100%;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 2rem;
  font-size: 1.3rem;
  line-height: 2rem;
  font-weight: 500;
  letter-spacing: 0.08rem;
  box-sizing: border-box;
  padding: 0 2rem;
  border-radius: 0.8rem;
  background-color: transparent;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.user-menu-dropdown-button {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .user-menu-dropdown-button {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-dropdown-button:disabled {
  cursor: default;
  opacity: 0.4;
}
.user-menu-dropdown-button:disabled .user-menu-dropdown-button__icon {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .user-menu-dropdown-button:disabled .user-menu-dropdown-button__icon {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}

.user-menu-dropdown-button:not(:disabled):hover {
  background-color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .user-menu-dropdown-button:not(:disabled):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.user-menu-dropdown-button:not(:disabled):hover {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .user-menu-dropdown-button:not(:disabled):hover {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-dropdown-button:not(:disabled):hover .user-menu-dropdown-button__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.8);
}
body.theme-dark .user-menu-dropdown-button:not(:disabled):hover .user-menu-dropdown-button__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-dropdown-button:not(:disabled):active, .user-menu-dropdown-button:not(:disabled):focus-visible {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .user-menu-dropdown-button:not(:disabled):active, .user-menu-dropdown-button:not(:disabled):focus-visible {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.user-menu-dropdown-button:not(:disabled):active, .user-menu-dropdown-button:not(:disabled):focus-visible {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .user-menu-dropdown-button:not(:disabled):active, .user-menu-dropdown-button:not(:disabled):focus-visible {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-dropdown-button:not(:disabled):active .user-menu-dropdown-button__icon, .user-menu-dropdown-button:not(:disabled):focus-visible .user-menu-dropdown-button__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.8);
}
body.theme-dark .user-menu-dropdown-button:not(:disabled):active .user-menu-dropdown-button__icon, .user-menu-dropdown-button:not(:disabled):focus-visible .user-menu-dropdown-button__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-dropdown-button .user-menu-dropdown-button__icon {
  line-height: 1.6rem;
}
.user-menu-dropdown-button .user-menu-dropdown-button__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .user-menu-dropdown-button .user-menu-dropdown-button__icon {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-dropdown-button .user-menu-dropdown-button__icon svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}

.user-menu-trigger-button {
  cursor: pointer;
  flex: 0 0 auto;
  width: 4.4rem;
  height: 4.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.6rem;
  border-radius: 50%;
  box-sizing: border-box;
  padding: 1.2rem;
  border: 0.1rem solid transparent;
  backdrop-filter: blur(0.4rem);
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.user-menu-trigger-button {
  background-color: rgba(255, 255, 255, 0.5);
}
body.theme-dark .user-menu-trigger-button {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.2);
}

.user-menu-trigger-button {
  border-color: transparent;
}
body.theme-dark .user-menu-trigger-button {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.user-menu-trigger-button {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .user-menu-trigger-button {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.user-menu-trigger-button:not(:disabled):hover {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .user-menu-trigger-button:not(:disabled):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.3);
}

.user-menu-trigger-button:not(:disabled):hover {
  border-color: transparent;
}
body.theme-dark .user-menu-trigger-button:not(:disabled):hover {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.user-menu-trigger-button:not(:disabled):hover {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .user-menu-trigger-button:not(:disabled):hover {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-trigger-button:not(:disabled):active, .user-menu-trigger-button:not(:disabled):focus-visible {
  background-color: white;
}
body.theme-dark .user-menu-trigger-button:not(:disabled):active, .user-menu-trigger-button:not(:disabled):focus-visible {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.3);
}

.user-menu-trigger-button:not(:disabled):active, .user-menu-trigger-button:not(:disabled):focus-visible {
  border-color: transparent;
}
body.theme-dark .user-menu-trigger-button:not(:disabled):active, .user-menu-trigger-button:not(:disabled):focus-visible {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.user-menu-trigger-button:not(:disabled):active, .user-menu-trigger-button:not(:disabled):focus-visible {
  color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}
body.theme-dark .user-menu-trigger-button:not(:disabled):active, .user-menu-trigger-button:not(:disabled):focus-visible {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.user-menu-trigger-button .user-menu-trigger-button__divider {
  height: 0.1rem;
  width: 100%;
}
.user-menu-trigger-button .user-menu-trigger-button__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .user-menu-trigger-button .user-menu-trigger-button__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.user-menu-trigger-button .user-menu-trigger-button__user {
  display: flex;
  gap: 1.6rem;
  align-items: center;
}
.user-menu-trigger-button .user-menu-trigger-button__user .user-menu-trigger-button__user-image {
  grid-area: image;
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
  overflow: hidden;
}
.user-menu-trigger-button .user-menu-trigger-button__user .user-menu-trigger-button__user-image {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .user-menu-trigger-button .user-menu-trigger-button__user .user-menu-trigger-button__user-image {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}

.user-menu-trigger-button .user-menu-trigger-button__user .user-menu-trigger-button__user-image img {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-menu-trigger-button .user-menu-trigger-button__user .user-menu-trigger-button__user-info-stack {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.user-menu-trigger-button .user-menu-trigger-button__user .user-menu-trigger-button__user-info-stack .user-menu-trigger-button__user-name {
  grid-area: name;
  font-weight: 600;
  font-size: 1.5rem;
  letter-spacing: 0.08rem;
}
.user-menu-trigger-button .user-menu-trigger-button__user .user-menu-trigger-button__user-info-stack .user-menu-trigger-button__user-email {
  grid-area: status;
  font-weight: 400;
  font-size: 1.3rem;
  letter-spacing: 0.04rem;
}

.user-menu {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1;
}
@media (max-width: 1100px) {
  .user-menu {
    display: none;
  }
}

.demmi-ui-card.demmi-ui-card--no-padding .demmi-ui-card__title {
  padding: 1rem 1rem 0;
}
.demmi-ui-card.demmi-ui-card--collapsed .demmi-ui-card__title {
  margin-bottom: 0;
}
.demmi-ui-card.demmi-ui-card--collapsed .demmi-ui-card__title .demmi-ui-card__button-collapse svg {
  transform: rotate3d(0, 0, 1, 180deg);
}
.demmi-ui-card .demmi-ui-card__title {
  height: 5.4rem;
  max-height: 5.4rem;
  display: flex;
  justify-content: space-between;
  line-height: 4.4rem;
  font-size: 1.6rem;
  letter-spacing: 0.1rem;
  font-weight: 600;
  padding: 1rem 2rem 0;
  box-sizing: border-box;
  align-items: flex-end;
}
.demmi-ui-card .demmi-ui-card__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .demmi-ui-card .demmi-ui-card__title {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__button-collapse {
  margin-left: -1rem;
  margin-right: 1rem;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__button-collapse svg {
  transition: transform 0.2s ease-in-out;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__title-text {
  display: flex;
  align-items: center;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__title-text .demmi-ui-card__title-with-subtitle {
  line-height: 2rem;
  display: flex;
  align-items: start;
  flex-direction: column;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__title-text .demmi-ui-card__title-with-subtitle .demmi-ui-card__subtitle {
  display: flex;
  justify-content: space-between;
  line-height: 1.6rem;
  padding-bottom: 0.4rem;
  font-size: 1.1rem;
  letter-spacing: 0.15rem;
  font-weight: 600;
  text-transform: uppercase;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__title-text .demmi-ui-card__subtitle {
  display: flex;
  justify-content: space-between;
  line-height: 1.6rem;
  padding-bottom: 0.4rem;
  font-size: 1.1rem;
  letter-spacing: 0.15rem;
  font-weight: 600;
  text-transform: uppercase;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__extras {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
}
.demmi-ui-card .demmi-ui-card__title .demmi-ui-card__extras .demmi-ui-card__control-buttons {
  display: flex;
  gap: 1rem;
}

.demmi-ui-card .demmi-ui-card-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  overflow: auto;
  padding: 0.8rem 1.2rem;
  margin: 0 auto;
  justify-content: safe center;
}
.demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab {
  cursor: pointer;
  font-size: 1.3rem;
  font-weight: 500;
  line-height: 1.4rem;
  letter-spacing: 0.05rem;
  background-color: red;
  padding: 1rem 1.6rem;
  text-wrap: nowrap;
  border-radius: 0.8rem;
  border: 0.1rem solid transparent;
  transition: background-color 0.1s ease-in-out, border-color 0.1s ease-in-out;
}
.demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab {
  background-color: rgba(255, 255, 255, 0);
}
body.theme-dark .demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab {
  background-color: rgba(0, 0, 0, 0);
}

.demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab:hover {
  background-color: rgba(255, 255, 255, 0.6);
}
body.theme-dark .demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.15);
}

.demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab:hover {
  border-color: rgba(255, 255, 255, 0);
}
body.theme-dark .demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab:hover {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.1);
}

.demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab.demmi-ui-card-tabs__tab--active {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab.demmi-ui-card-tabs__tab--active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab.demmi-ui-card-tabs__tab--active {
  border-color: rgba(255, 255, 255, 0);
}
body.theme-dark .demmi-ui-card .demmi-ui-card-tabs .demmi-ui-card-tabs__tab.demmi-ui-card-tabs__tab--active {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.3);
}

.demmi-ui-card {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  border-radius: 1.6rem;
}
.demmi-ui-card {
  background: radial-gradient(circle at 30% 40%, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.2));
}
body.theme-dark .demmi-ui-card {
  background: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.1);
}

.demmi-ui-card.demmi-ui-card--no-padding {
  padding: 0;
}
.demmi-ui-card.demmi-ui-card--no-padding .demmi-ui-card__title {
  padding: 1rem 1rem 0;
}
.demmi-ui-card.demmi-ui-card--no-padding .demmi-ui-card__main-content {
  padding: 0;
}
body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  width: unset;
  padding: 0;
  border-radius: unset;
}
body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  background-color: unset;
}
body.theme-dark body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  background-color: unset;
}

body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  background: unset;
}
body.theme-dark body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only {
  background: unset;
}

body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only .demmi-ui-card__content {
  background-color: unset;
}
body.theme-dark body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only .demmi-ui-card__content {
  background-color: unset;
}

body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only .demmi-ui-card__content {
  background: unset;
}
body.theme-dark body:not(.theme-dark) .demmi-ui-card.demmi-ui-card--dark-only .demmi-ui-card__content {
  background: unset;
}

.demmi-ui-card.demmi-ui-card--collapsed .demmi-ui-card__title {
  margin-bottom: 0;
}
.demmi-ui-card.demmi-ui-card--collapsed .demmi-ui-card__title .demmi-ui-card__button-collapse svg {
  transform: rotate3d(0, 0, 1, 180deg);
}
.demmi-ui-card.demmi-ui-card--collapsed .demmi-ui-card__main-content {
  display: none;
}
.demmi-ui-card .demmi-ui-card__content {
  display: block;
  border-radius: 1.6rem;
}
.demmi-ui-card .demmi-ui-card__content {
  background: radial-gradient(circle at 30% 40%, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.3));
}
body.theme-dark .demmi-ui-card .demmi-ui-card__content {
  background: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.demmi-ui-card .demmi-ui-card__main-content {
  padding: 1rem;
}
.demmi-ui-card .demmi-ui-card__divider {
  margin: 1rem 0;
  height: 0.2rem;
  width: 100%;
}
.demmi-ui-card .demmi-ui-card__divider {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-card .demmi-ui-card__divider {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.2);
}

.demmi-ui-card.demmi-ui-card--loading .demmi-ui-card__main-content {
  opacity: 0.4;
}

.demmi-ui-toast {
  width: 44rem;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 1.2rem;
  backdrop-filter: blur(4px);
  transition: transform 0.05s ease-in-out, box-shadow 0.1s ease-in-out, max-height 0.3s ease-in-out, opacity 0.2s ease-in-out, background-color 0.1s ease-in-out;
  align-items: stretch;
}
.demmi-ui-toast {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 1);
}
body.theme-dark .demmi-ui-toast {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}

.demmi-ui-toast {
  background-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-ui-toast {
  background-color: hsla(var(--theme-bg-hue), 6%, 18%, 0.9);
}

.demmi-ui-toast {
  box-shadow: 0 0.9rem 1.2rem hsl(var(--theme-bg-hue), 100%, 20%,0.18);
}
body.theme-dark .demmi-ui-toast {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 8%, 16%,0.56);
}

.demmi-ui-toast::after {
  content: "";
  position: absolute;
  left: 0rem;
  top: 0rem;
  bottom: 0rem;
  width: 2.4rem;
  border-left: rgb(85, 176, 190) 0.6rem solid;
  border-radius: 1.2rem;
  box-sizing: border-box;
}
.demmi-ui-toast .demmi-ui-toast__timer {
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgb(85, 176, 190);
  opacity: 0.1;
  width: 100%;
  border-radius: 1.2rem;
  transition: max-width 0.1s linear;
}
.demmi-ui-toast.demmi-ui-toast--dismissing-1, .demmi-ui-toast.demmi-ui-toast--dismissing-2, .demmi-ui-toast.demmi-ui-toast--dismissing-3 {
  transition: transform 0.5s ease-in-out, box-shadow 0.1s ease-in-out, max-height 0.1s ease-in-out, background-color 0.1s ease-in-out, opacity 0.4s ease-in-out;
}
.demmi-ui-toast.demmi-ui-toast--dismissing-1 {
  transform: translate3d(100%, 0, 0);
  opacity: 0;
}
.demmi-ui-toast.demmi-ui-toast--dismissed {
  opacity: 0;
  max-height: 0;
}
.demmi-ui-toast:hover {
  z-index: 1;
  transform: translate3d(-1rem, 0rem, 0) scale3d(1.02, 1.02, 1.02);
}
.demmi-ui-toast:hover {
  box-shadow: 0 1.6rem 2.2rem hsl(var(--theme-bg-hue), 100%, 20%,0.14);
}
body.theme-dark .demmi-ui-toast:hover {
  box-shadow: 0 2rem 2.4rem hsl(var(--theme-bg-hue), 8%, 16%,0.24);
}

.demmi-ui-toast:hover {
  background-color: white;
}
body.theme-dark .demmi-ui-toast:hover {
  background-color: hsla(var(--theme-bg-hue), 6%, 18%, 1);
}

.demmi-ui-toast .demmi-ui-toast__content {
  padding: 1rem 1rem 1rem 1.6rem;
  display: flex;
}
.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__icon {
  padding: 0.5rem 1rem 0.5rem 0.5rem;
}
.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__icon svg {
  width: 2.2rem;
  height: 2.2rem;
  color: rgb(85, 176, 190);
}
.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__text-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.2rem 0.6rem;
}
.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__text-content .demmi-ui-toast__title {
  pointer-events: none;
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.08rem;
  line-height: 2.4rem;
}
.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__text-content .demmi-ui-toast__title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__text-content .demmi-ui-toast__title {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.8);
}

.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__text-content .demmi-ui-toast__body {
  pointer-events: none;
  font-size: 1.2rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  line-height: 2rem;
}
.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__text-content .demmi-ui-toast__body {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__text-content .demmi-ui-toast__body {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__text-content .demmi-ui-toast__body strong {
  font-weight: 500;
}
.demmi-ui-toast .demmi-ui-toast__content .demmi-ui-toast__dismiss-area {
  margin-left: 1rem;
  flex: 0 0 auto;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: end;
}

.demmi-ui-toasts-area {
  z-index: 9999;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  width: 0;
}
.demmi-ui-toasts-area .demmi-ui-toasts-area__list {
  position: absolute;
  bottom: 0;
  right: 1rem;
  display: flex;
  flex-direction: column-reverse;
  overflow: visible;
  gap: 1rem;
  padding: 1rem 0;
}

.demmi-ui-modal {
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.demmi-ui-modal.demmi-ui-modal--visible .demmi-ui-modal__content {
  opacity: 1;
}
.demmi-ui-modal.demmi-ui-modal--visible .demmi-ui-modal__backdrop {
  opacity: 1;
}
.demmi-ui-modal .demmi-ui-modal__backdrop {
  opacity: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  inset: 0;
  transition: opacity 0.3s ease-in-out;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
}
.demmi-ui-modal .demmi-ui-modal__backdrop {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.3);
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__backdrop {
  background-color: rgba(0, 0, 0, 0.6);
}

.demmi-ui-modal .demmi-ui-modal__content {
  position: relative;
  opacity: 0;
  z-index: 1;
  max-height: 100%;
  width: 100%;
  overflow: visible auto;
  transition: opacity 0.2s ease-in-out;
  justify-content: center;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper {
  overflow: hidden;
  border-radius: 2rem;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__divider {
  margin: 2rem 0;
  height: 0.1rem;
  width: 100%;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__divider {
  background-color: hsla(0, 0%, 0%, 0.06);
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__divider {
  background-color: black;
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area {
  width: 100%;
  box-sizing: border-box;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area {
  margin: unset;
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area {
  margin: 1rem 0;
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--dark {
  border-radius: unset;
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--dark {
  border-radius: 1.6rem;
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--dark {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--dark {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--light {
  border-radius: unset;
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--light {
  border-radius: 1.6rem;
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--light {
  background-color: white;
}
body.theme-dark .demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area.demmi-ui-modal__area--light {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.8);
}

.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area-title {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area-buttons {
  padding: 2rem;
  position: relative;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area-buttons.demmi-ui-modal__area-buttons--doing-request .demmi-ui-modal__action-buttons {
  opacity: 0.2;
  pointer-events: none;
}
.demmi-ui-modal .demmi-ui-modal__content .demmi-ui-modal__content-wrapper .demmi-ui-modal__area-buttons .demmi-ui-modal__action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
}

.demmi-ui-button {
  cursor: pointer;
  width: fit-content;
  width: -webkit-fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-weight: 500;
  letter-spacing: 0.15rem;
  font-size: 1.3rem;
  line-height: 2rem;
  padding: 1.2rem 2.4rem;
  border: 0.2rem solid;
  border-radius: 1rem;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.demmi-ui-button {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-button {
  background-color: rgba(0, 0, 0, 0.8);
}

.demmi-ui-button {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-button {
  border-color: transparent;
}

.demmi-ui-button {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .demmi-ui-button {
  color: white;
}

.demmi-ui-button {
  box-shadow: 0 0.2rem 0.4rem hsl(var(--theme-bg-hue), 100%, 20%,0.22);
}
body.theme-dark .demmi-ui-button {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-button:disabled {
  cursor: default;
  opacity: 0.4;
}
.demmi-ui-button:not(:disabled):hover {
  border-radius: 3rem;
}
.demmi-ui-button:not(:disabled):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-button:not(:disabled):hover {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-button:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 3rem;
}
.demmi-ui-button:not(:disabled):active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-button:not(:disabled):active {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-button:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-button.demmi-ui-button--outlined {
  background-color: rgba(255, 255, 255, 0.1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined {
  background-color: transparent;
}

.demmi-ui-button.demmi-ui-button--outlined {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined {
  border-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.5);
}

.demmi-ui-button.demmi-ui-button--outlined {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined {
  color: black;
}

.demmi-ui-button.demmi-ui-button--outlined {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 100%, 20%,0.24);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  border-color: hsla(var(--theme-bg-hue), 40%, 12%, 1);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  background-color: rgba(0, 0, 0, 0);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  border-color: hsla(var(--theme-bg-hue), 40%, 12%, 1);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  background-color: rgba(0, 0, 0, 0);
}

.demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--outlined:not(:disabled):active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-button.demmi-ui-button--delete {
  border-color: transparent;
  color: white;
}
.demmi-ui-button.demmi-ui-button--delete {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--delete {
  background-color: hsl(0, 40%, 50%);
}

.demmi-ui-button.demmi-ui-button--delete:not(:disabled):hover {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--delete:not(:disabled):hover {
  background-color: hsl(0, 40%, 50%);
}

.demmi-ui-button.demmi-ui-button--delete:not(:disabled):active {
  background-color: hsl(0, 70%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--delete:not(:disabled):active {
  background-color: hsl(0, 40%, 50%);
}

.demmi-ui-button.demmi-ui-button--save {
  border-color: transparent;
  color: white;
}
.demmi-ui-button.demmi-ui-button--save {
  background-color: hsl(90, 50%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--save {
  background-color: hsl(90, 25%, 50%);
}

.demmi-ui-button.demmi-ui-button--save:not(:disabled):hover {
  background-color: hsl(90, 50%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--save:not(:disabled):hover {
  background-color: hsl(90, 25%, 50%);
}

.demmi-ui-button.demmi-ui-button--save:not(:disabled):active {
  background-color: hsl(90, 50%, 70%);
}
body.theme-dark .demmi-ui-button.demmi-ui-button--save:not(:disabled):active {
  background-color: hsl(90, 25%, 50%);
}

.demmi-ui-button.demmi-ui-button--size-small {
  letter-spacing: 0.15rem;
  font-size: 1.1rem;
  line-height: 1.4rem;
  font-weight: 600;
  padding: 1rem 2rem;
  text-transform: uppercase;
}
.demmi-ui-button .demmi-ui-button__icon {
  margin-right: 1.2rem;
  height: 1.4rem;
  line-height: 1.4rem;
}
.demmi-ui-button .demmi-ui-button__icon svg {
  display: block;
  pointer-events: none;
  height: 1.4rem;
  width: 1.4rem;
}

.demmi-ui-toggle {
  cursor: pointer;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  font-size: 1.3rem;
  line-height: 1.6rem;
  padding: 0.8rem 0.8rem 0.8rem 1.6rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  border-radius: 1.2rem;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out;
}
.demmi-ui-toggle {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .demmi-ui-toggle {
  color: rgba(255, 255, 255, 0.8);
}

.demmi-ui-toggle input {
  display: none;
}
.demmi-ui-toggle input:checked ~ .demmi-ui-toggle__indicator:before {
  transform: translate3d(2.8rem, 0, 0);
}
.demmi-ui-toggle input:checked ~ .demmi-ui-toggle__indicator:before {
  background-color: hsla(var(--theme-bg-hue), 10%, 95%, 1);
}
body.theme-dark .demmi-ui-toggle input:checked ~ .demmi-ui-toggle__indicator:before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.demmi-ui-toggle:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-toggle:hover {
  background-color: rgba(255, 255, 255, 0.12);
}

.demmi-ui-toggle .demmi-ui-toggle__indicator {
  cursor: pointer;
  position: relative;
  width: 6rem;
  height: 3.2rem;
  border-radius: 2rem;
}
.demmi-ui-toggle .demmi-ui-toggle__indicator {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-toggle .demmi-ui-toggle__indicator {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.3);
}

.demmi-ui-toggle .demmi-ui-toggle__indicator {
  box-shadow: inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.08);
}
body.theme-dark .demmi-ui-toggle .demmi-ui-toggle__indicator {
  box-shadow: 0 0.1rem 0.1rem rgba(255, 255, 255, 0.16);
}

.demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  position: absolute;
  content: "";
  height: 2.4rem;
  width: 2.4rem;
  left: 0.4rem;
  top: 0.4rem;
  border-radius: 50%;
  transition: transform 0.2s ease-in-out, background-color 0.2s ease-in-out;
}
.demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.4);
}
body.theme-dark .demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.2);
}

.demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  box-shadow: inset 0 0.1rem 0.1rem rgb(255, 255, 255), 0 0.2rem 0.4rem rgba(0, 0, 0, 0.16);
}
body.theme-dark .demmi-ui-toggle .demmi-ui-toggle__indicator:before {
  box-shadow: inset 0 0.1rem 0.1rem rgba(255, 255, 255, 0.12), 0 0.2rem 0.4rem rgba(0, 0, 0, 0.32);
}

.demmi-ui-toggle.demmi-ui-toggle--disabled {
  pointer-events: none;
  opacity: 0.6;
}

.demmi-ui-icon-button {
  cursor: pointer;
  width: fit-content;
  width: -webkit-fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.6rem;
  border-radius: 0.8rem;
  box-sizing: border-box;
  padding: 1.2rem;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
  color: rgba(255, 255, 255, 0.8);
  border: 0.2rem solid;
  background-color: hsla(var(--theme-bg-hue), 20%, 10%, 0);
  border-color: transparent;
}
.demmi-ui-icon-button {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 100%, 20%,0.24);
}
body.theme-dark .demmi-ui-icon-button {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-icon-button {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-icon-button {
  background-color: rgba(0, 0, 0, 0.8);
}

.demmi-ui-icon-button {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-icon-button {
  border-color: transparent;
}

.demmi-ui-icon-button {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .demmi-ui-icon-button {
  color: white;
}

.demmi-ui-icon-button:disabled {
  cursor: default;
  opacity: 0.4;
}
.demmi-ui-icon-button:not(:disabled):hover {
  border-radius: 50%;
}
.demmi-ui-icon-button:not(:disabled):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):hover {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-icon-button:not(:disabled):hover {
  box-shadow: 0 0.2rem 0.4rem hsl(var(--theme-bg-hue), 100%, 20%,0.22);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-icon-button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 50%;
}
.demmi-ui-icon-button:not(:disabled):active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):active {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-icon-button:not(:disabled):active {
  box-shadow: 0 0.9rem 1.2rem hsl(var(--theme-bg-hue), 100%, 20%,0.18);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-icon-button:not(:disabled):focus-visible {
  transform: translate3d(0, -0.1rem, 0);
}
.demmi-ui-icon-button:not(:disabled):focus-visible {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):focus-visible {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-icon-button:not(:disabled):focus-visible {
  box-shadow: 0 0.2rem 0.4rem hsl(var(--theme-bg-hue), 100%, 20%,0.22);
}
body.theme-dark .demmi-ui-icon-button:not(:disabled):focus-visible {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-icon-button svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}
.demmi-ui-icon-button svg {
  color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}
body.theme-dark .demmi-ui-icon-button svg {
  color: white;
}

.demmi-ui-icon-button.demmi-ui-icon-button--transparent {
  border: none;
}
.demmi-ui-icon-button.demmi-ui-icon-button--transparent {
  background-color: transparent;
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--transparent {
  background-color: transparent;
}

.demmi-ui-icon-button.demmi-ui-icon-button--overlay {
  backdrop-filter: blur(10px);
  border: none;
}
.demmi-ui-icon-button.demmi-ui-icon-button--overlay {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.4);
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--overlay {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.8);
}

.demmi-ui-icon-button.demmi-ui-icon-button--overlay {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 100%, 20%,0.24);
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--overlay {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-icon-button.demmi-ui-icon-button--overlay:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--overlay:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-icon-button.demmi-ui-icon-button--overlay:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--overlay:not(:disabled):active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-icon-button.demmi-ui-icon-button--overlay svg {
  color: white;
}
body.theme-dark .demmi-ui-icon-button.demmi-ui-icon-button--overlay svg {
  color: white;
}

.demmi-ui-icon-button.demmi-ui-icon-button--large {
  line-height: 1.6rem;
  padding: 1.4rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--large svg {
  height: 1.6rem;
  width: 1.6rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--small {
  line-height: 1.2rem;
  padding: 1.1rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--small svg {
  height: 1.2rem;
  width: 1.2rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--mini {
  line-height: 1rem;
  padding: 0.8rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--mini svg {
  height: 1.1rem;
  width: 1.1rem;
}
.demmi-ui-icon-button.demmi-ui-icon-button--mini:not(:disabled):active {
  border-radius: 50%;
}

.demmi-ui-item-switch {
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: center;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out;
  width: fit-content;
  box-sizing: border-box;
  padding: 0rem 0.4rem;
  margin: 0 auto;
  border-radius: 0.8rem;
  gap: 0.4rem;
}
.demmi-ui-item-switch {
  background-color: rgba(255, 255, 255, 0.5);
}
body.theme-dark .demmi-ui-item-switch {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.demmi-ui-item-switch .demmi-ui-item-switch__item {
  z-index: 1;
  cursor: pointer;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding: 1.2rem 2rem;
  transition: opacity 0.1s ease-in-out;
  background: rgba(255, 0, 0, 0.1);
  background: transparent;
  opacity: 0.8;
}
.demmi-ui-item-switch .demmi-ui-item-switch__item .demmi-ui-item-switch__item-content {
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.12rem;
  text-align: center;
  overflow: hidden;
}
.demmi-ui-item-switch .demmi-ui-item-switch__item:hover:not(.demmi-ui-item-switch--active) {
  opacity: 1;
}
.demmi-ui-item-switch .demmi-ui-item-switch__item.demmi-ui-item-switch__item--active {
  opacity: 1;
}
.demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  position: absolute;
  top: 0.4rem;
  bottom: 0.4rem;
  left: 0;
  pointer-events: none;
  border-radius: 0.8rem;
  transition: all 0.3s cubic-bezier(0.38, 0.1, 0.26, 1.41);
}
.demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  background-color: white;
}
body.theme-dark .demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__item:hover:not(.demmi-ui-item-switch--active) {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__item:hover:not(.demmi-ui-item-switch--active) {
  color: white;
}

.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__item.demmi-ui-item-switch__item--active .demmi-ui-button-switch__item-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__item.demmi-ui-item-switch__item--active .demmi-ui-button-switch__item-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}

.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-button-switch__item {
  z-index: 1;
  cursor: pointer;
  flex: 0 0 auto;
  display: flex;
  height: 1.4rem;
  align-items: center;
  padding: 0;
  transition: color 0.1s ease;
  background: rgba(255, 0, 0, 0.1);
  background: transparent;
}
.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-button-switch__item {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-button-switch__item {
  color: white;
}

.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-button-switch__item .demmi-ui-button-switch__item-text {
  pointer-events: none;
  background-color: transparent;
  transition: width 0.3s ease-in-out, opacity 0.3s ease-in-out;
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: 500;
  letter-spacing: 0.12rem;
  text-align: center;
  overflow: hidden;
}
.demmi-ui-button-switch .demmi-ui-item-switch .demmi-ui-item-switch__indicator {
  top: -0.2rem;
  bottom: -0.2rem;
  left: 0;
}

.demmi-ui-input-file-button {
  display: block;
  margin: 0 auto;
  cursor: pointer;
  font-size: 1.3rem;
  box-sizing: border-box;
  line-height: 2rem;
  padding: 1.2rem 2.4rem;
  border-radius: 1rem;
  font-weight: 500;
  letter-spacing: 0.15rem;
  border: 0.2rem solid;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.demmi-ui-input-file-button {
  box-shadow: 0 0.2rem 0.4rem hsl(var(--theme-bg-hue), 100%, 20%,0.22);
}
body.theme-dark .demmi-ui-input-file-button {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-input-file-button {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-input-file-button {
  background-color: rgba(0, 0, 0, 0.8);
}

.demmi-ui-input-file-button {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-input-file-button {
  border-color: transparent;
}

.demmi-ui-input-file-button {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .demmi-ui-input-file-button {
  color: white;
}

.demmi-ui-input-file-button:not(:disabled):hover {
  border-radius: 3rem;
}
.demmi-ui-input-file-button:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-input-file-button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-input-file-button:not(:disabled):hover {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .demmi-ui-input-file-button:not(:disabled):hover {
  border-color: transparent;
}

.demmi-ui-input-file-button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 3rem;
}
.demmi-ui-input-file-button:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-input-file-button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-input-file-button:not(:disabled):active {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .demmi-ui-input-file-button:not(:disabled):active {
  border-color: transparent;
}

.demmi-ui-input-time {
  width: 18rem;
  box-sizing: border-box;
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: center;
  padding: 0.4rem;
  border-radius: 1.6rem;
}
.demmi-ui-input-time {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-input-time {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.6);
}

.demmi-ui-input-time span {
  font-size: 1.8rem;
  font-weight: 600;
}
.demmi-ui-input-time span {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .demmi-ui-input-time span {
  color: black;
}

.demmi-ui-input-time .demmi-ui-input-time__button {
  flex: 1 1 50%;
  cursor: pointer;
  width: fit-content;
  width: -webkit-fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 500;
  letter-spacing: 0.3rem;
  box-sizing: border-box;
  line-height: 1.4rem;
  padding: 1.2rem;
  border-radius: 1.4rem;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out;
}
.demmi-ui-input-time .demmi-ui-input-time__button {
  background-color: white;
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.8);
}

.demmi-ui-input-time .demmi-ui-input-time__button {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button {
  border-color: transparent;
}

.demmi-ui-input-time .demmi-ui-input-time__button {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button {
  color: white;
}

.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  border-radius: 3rem;
}
.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  background-color: white;
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 3rem;
}
.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  background-color: white;
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  background-color: rgb(0, 0, 0);
}

.demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-input-time .demmi-ui-input-time__button:not(:disabled):active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-input-time.demmi-ui-input-time--inline {
  width: 13rem;
  padding: 0.4rem;
  gap: 0.6rem;
  border-radius: 1.2rem;
  box-sizing: border-box;
}
.demmi-ui-input-time.demmi-ui-input-time--inline .demmi-ui-input-time__button {
  border-radius: 1rem;
  padding: 1rem 0;
}

.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll {
  max-height: 20rem;
  padding: 0.5rem;
  box-sizing: border-box;
  border-radius: 1.6rem;
  overflow: auto;
}
.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-input-time__overlay .demmi-ui-input-time__scroll {
  background-color: white;
}

.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item {
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.3rem;
  text-align: center;
  border-radius: 1.6rem;
  padding: 1.2rem 1.6rem;
  cursor: pointer;
  user-select: none;
}
.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item {
  color: black;
}

.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item:hover {
  background-color: white;
}
body.theme-dark .demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item:hover {
  background-color: black;
}

.demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item:hover {
  color: black;
}
body.theme-dark .demmi-ui-input-time__overlay .demmi-ui-input-time__scroll .demmi-ui-input-time__scroll-item:hover {
  color: white;
}

.demmi-ui-input {
  padding: 1rem 1.6rem;
  font-size: 1.3rem;
  letter-spacing: 0.08rem;
  line-height: 2rem;
  border-radius: 1rem;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  border: 0.2rem solid transparent;
  transition: background-color 0.1s ease-in-out, border-color 0.1s ease-in-out, border-radius 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.demmi-ui-input {
  background-color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 0.04);
}
body.theme-dark .demmi-ui-input {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.demmi-ui-input {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .demmi-ui-input {
  color: white;
}

.demmi-ui-input {
  border-color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.2);
}
body.theme-dark .demmi-ui-input {
  border-color: transparent;
}

.demmi-ui-input.demmi-ui-input--invert {
  background-color: rgba(255, 255, 255, 0.3);
}
body.theme-dark .demmi-ui-input.demmi-ui-input--invert {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.3);
}

.demmi-ui-input.demmi-ui-input--invert {
  border-color: rgb(255, 255, 255);
}
body.theme-dark .demmi-ui-input.demmi-ui-input--invert {
  border-color: transparent;
}

.demmi-ui-input:hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 0.08);
}
body.theme-dark .demmi-ui-input:hover {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.5);
}

.demmi-ui-input:hover.demmi-ui-input--invert {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .demmi-ui-input:hover.demmi-ui-input--invert {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.demmi-ui-input:focus {
  border-radius: 3rem;
}
.demmi-ui-input:focus {
  background-color: hsla(var(--theme-bg-hue), var(--palette-600-s), var(--palette-600-l), 0.08);
}
body.theme-dark .demmi-ui-input:focus {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.5);
}

.demmi-ui-input:focus {
  border-color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.2);
}
body.theme-dark .demmi-ui-input:focus {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.4);
}

.demmi-ui-input:focus {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-input:focus {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-input:focus.demmi-ui-input--invert {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .demmi-ui-input:focus.demmi-ui-input--invert {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.5);
}

.demmi-ui-input::placeholder {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .demmi-ui-input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.demmi-ui-input__wrapper {
  position: relative;
}
.demmi-ui-input__wrapper textarea.demmi-ui-input {
  height: 40rem;
  max-width: 100%;
  min-width: 100%;
  resize: none;
  box-sizing: border-box;
  padding-bottom: 3rem;
}
.demmi-ui-input__wrapper textarea.demmi-ui-input:focus {
  border-radius: 1rem;
}
.demmi-ui-input__wrapper .demmi-ui-input__max-length {
  position: absolute;
  bottom: 1rem;
  right: 0.6rem;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.4rem;
  border-radius: 0.5rem;
  text-transform: uppercase;
  margin: 0 auto;
  padding: 0.5rem 1rem;
  color: white;
  backdrop-filter: blur(10px);
}
.demmi-ui-input__wrapper .demmi-ui-input__max-length {
  background-color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 0.4);
}
body.theme-dark .demmi-ui-input__wrapper .demmi-ui-input__max-length {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.8);
}

.demmi-ui-menu {
  opacity: 0;
  transform: translate3d(0, -1.2rem, 0);
  transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
  position: fixed;
  top: 10rem;
  left: 10rem;
  z-index: 9999;
}
.demmi-ui-menu .demmi-ui-menu__card {
  box-sizing: border-box;
  background: white;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden auto;
  max-height: 40rem;
  border-radius: 2rem;
  box-shadow: 0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12), 0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);
}
.demmi-ui-menu.demmi-ui-menu--static {
  opacity: 1;
  transform: translate3d(0, 0, 0);
  position: relative;
  top: unset;
  left: unset;
}
.demmi-ui-menu.demmi-ui-menu--visible {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
.demmi-ui-menu .demmi-ui-menu__section-heading {
  padding: 2rem 0rem 0;
  margin: 0 2rem 0.8rem;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.8rem;
  letter-spacing: 0.1rem;
}
.demmi-ui-menu .demmi-ui-menu__section-heading {
  color: rgba(0, 0, 0, 0.4);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu__section-heading {
  color: rgba(255, 255, 255, 0.6);
}

.demmi-ui-menu .demmi-ui-menu__section-items {
  padding: 1rem;
}
.demmi-ui-menu .demmi-ui-menu__divider {
  height: 0.1rem;
  margin: 2rem -1rem;
}
.demmi-ui-menu .demmi-ui-menu__divider {
  background-color: rgba(0, 0, 0, 0.08);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu__divider {
  background-color: rgba(255, 255, 255, 0.08);
}

.demmi-ui-menu .demmi-ui-menu-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  border-radius: 0.8rem;
  padding: 1rem 2rem 1rem 1.6rem;
  box-sizing: border-box;
  width: 100%;
  line-height: 1.8rem;
  font-size: 1.3rem;
  letter-spacing: 0.08rem;
  font-weight: 400;
  background: transparent;
  outline: none;
  border: none;
}
.demmi-ui-menu .demmi-ui-menu-item {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu-item {
  color: black;
}

.demmi-ui-menu .demmi-ui-menu-item svg {
  width: 1.4rem;
  height: 1.4rem;
  opacity: 0.6;
}
.demmi-ui-menu .demmi-ui-menu-item:disabled {
  opacity: 0.4;
}
.demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) {
  background-color: black;
}

.demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) {
  color: rgba(0, 0, 0, 0.8);
}
body.theme-dark .demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) {
  color: white;
}

.demmi-ui-menu .demmi-ui-menu-item:hover:not(:disabled) svg {
  opacity: 0.8;
}
.demmi-ui-menu.demmi-ui-menu--visible .demmi-ui-menu__content {
  opacity: 1;
}
.demmi-ui-menu.demmi-ui-menu--visible .demmi-ui-menu__backdrop {
  opacity: 1;
}

.demmi-ui-chip {
  cursor: pointer;
  position: relative;
  width: fit-content;
  box-sizing: border-box;
  padding: 0.8rem 1.6rem;
  border-radius: 2rem;
  border: 0.2rem solid;
  transition: transform 0.1s ease-in-out, box-shadow 0.1s ease-in-out, background-color 0.1s ease-in-out;
}
.demmi-ui-chip {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.6);
}
body.theme-dark .demmi-ui-chip {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.2);
}

.demmi-ui-chip {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-chip {
  border-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.5);
}

.demmi-ui-chip input {
  display: none;
}
.demmi-ui-chip.demmi-ui-chip--active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .demmi-ui-chip.demmi-ui-chip--active {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 1);
}

.demmi-ui-chip.demmi-ui-chip--active {
  border-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 1);
}
body.theme-dark .demmi-ui-chip.demmi-ui-chip--active {
  border-color: transparent;
}

.demmi-ui-chip.demmi-ui-chip--active .demmi-ui-chip__text {
  font-weight: 500;
}
.demmi-ui-chip.demmi-ui-chip--active .demmi-ui-chip__text {
  color: white;
}
body.theme-dark .demmi-ui-chip.demmi-ui-chip--active .demmi-ui-chip__text {
  color: white;
}

.demmi-ui-chip .demmi-ui-chip__text {
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.12rem;
}
.demmi-ui-chip .demmi-ui-chip__text {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .demmi-ui-chip .demmi-ui-chip__text {
  color: white;
}

.demmi-ui-chip:not(.demmi-ui-chip--active):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-chip:not(.demmi-ui-chip--active):hover {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.6);
}

.demmi-ui-chip:not(.demmi-ui-chip--active):hover {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-chip:not(.demmi-ui-chip--active):hover {
  border-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.6);
}

.demmi-ui-chip.demmi-ui-chip--disabled {
  pointer-events: none;
  opacity: 0.4;
}

.demmi-ui-timeline {
  position: relative;
  margin: 0 1rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item {
  position: relative;
  padding-left: 3.4rem;
  padding-top: 0.2rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item:not(:last-child) {
  margin-bottom: 3rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 2.4rem;
  width: 2.4rem;
  border-radius: 50%;
  border: 0.3rem solid white;
  box-sizing: border-box;
}
.demmi-ui-timeline .demmi-ui-timeline__item::after {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-timeline .demmi-ui-timeline__item::after {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.demmi-ui-timeline .demmi-ui-timeline__item::before {
  content: "";
  position: absolute;
  left: 1rem;
  top: 2.3rem;
  bottom: 0;
  width: 0.4rem;
  border-radius: 0.2rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item::before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-timeline .demmi-ui-timeline__item::before {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 1);
}

.demmi-ui-timeline .demmi-ui-timeline__item:not(:last-child)::before {
  bottom: -3.1rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-title {
  font-size: 1.4rem;
  font-weight: 500;
  letter-spacing: 0.05rem;
  line-height: 2rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-title {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-title {
  color: white;
}

.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-date {
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.1rem;
  line-height: 2rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-date {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.6);
}
body.theme-dark .demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-date {
  color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}

.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text {
  position: relative;
  margin-top: 1.2rem;
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  line-height: 2rem;
  padding: 1rem 1.4rem 3.6rem;
  border-radius: 0.8rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text {
  background-color: hsla(var(--theme-bg-hue), 40%, 12%, 0.4);
}

.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 1);
}
body.theme-dark .demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text {
  color: white;
}

.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text .demmi-ui-timeline__item-text-badge {
  position: absolute;
  bottom: 0.8rem;
  right: 0.8rem;
  height: 2.2rem;
  line-height: 2.2rem;
  padding: 0rem 1.2rem;
  box-sizing: border-box;
  border-radius: 0.6rem;
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
}
.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text .demmi-ui-timeline__item-text-badge {
  background-color: rgba(255, 255, 255, 0.8);
}
body.theme-dark .demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text .demmi-ui-timeline__item-text-badge {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.4);
}

.demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text .demmi-ui-timeline__item-text-badge {
  color: hsla(var(--theme-bg-hue), var(--palette-800-s), var(--palette-800-l), 0.6);
}
body.theme-dark .demmi-ui-timeline .demmi-ui-timeline__item .demmi-ui-timeline__item-text .demmi-ui-timeline__item-text-badge {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 0.9);
}

.demmi-ui-select__trigger {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.6rem;
  padding-right: 1.6rem;
}
.demmi-ui-select__trigger {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-select__trigger {
  background-color: rgba(255, 255, 255, 0.8);
}

.demmi-ui-select__trigger {
  border-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .demmi-ui-select__trigger {
  border-color: transparent;
}

.demmi-ui-select__trigger {
  color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .demmi-ui-select__trigger {
  color: black;
}

.demmi-ui-select__trigger:not(:disabled):hover {
  border-radius: 3rem;
}
.demmi-ui-select__trigger:not(:disabled):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-select__trigger:not(:disabled):hover {
  background-color: white;
}

.demmi-ui-select__trigger:not(:disabled):hover {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.2);
}
body.theme-dark .demmi-ui-select__trigger:not(:disabled):hover {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-select__trigger:not(:disabled):active {
  transform: scale3d(1.1, 1.1, 1.1);
  border-radius: 3rem;
}
.demmi-ui-select__trigger:not(:disabled):active {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .demmi-ui-select__trigger:not(:disabled):active {
  background-color: white;
}

.demmi-ui-select__trigger:not(:disabled):active {
  box-shadow: 0 1.2rem 1.8rem hsl(var(--theme-bg-hue), 100%, 20%,0.16);
}
body.theme-dark .demmi-ui-select__trigger:not(:disabled):active {
  box-shadow: 0 0 0 hsl(var(--theme-bg-hue), 8%, 16%,0.72);
}

.demmi-ui-select__trigger.demmi-ui-select__trigger--has-title {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.demmi-ui-select__trigger .demmi-ui-select__trigger__content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.2rem;
}
.demmi-ui-select__trigger .demmi-ui-select__trigger__content .demmi-ui-select__trigger__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  letter-spacing: 0.1rem;
}
.demmi-ui-select__trigger .demmi-ui-select__trigger__content .demmi-ui-select__trigger__text .demmi-ui-select__trigger__text-title {
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.2rem;
  text-transform: uppercase;
}
.demmi-ui-select__trigger .demmi-ui-select__trigger__content .demmi-ui-select__trigger__text .demmi-ui-select__trigger__text-title {
  opacity: 0.6;
}
body.theme-dark .demmi-ui-select__trigger .demmi-ui-select__trigger__content .demmi-ui-select__trigger__text .demmi-ui-select__trigger__text-title {
  opacity: 0.4;
}

.demmi-ui-select__trigger .demmi-ui-select__trigger__content .demmi-ui-select__trigger__text .demmi-ui-select__trigger__text-main {
  line-height: 1.8rem;
}
.demmi-ui-select__trigger .demmi-ui-select__trigger__dropdown-icon svg {
  display: block;
  pointer-events: none;
  height: 1.6rem;
  width: 1.6rem;
}
.demmi-ui-select__trigger .demmi-ui-select__trigger__dropdown-icon svg {
  color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 1);
}
body.theme-dark .demmi-ui-select__trigger .demmi-ui-select__trigger__dropdown-icon svg {
  color: black;
}

.SelectContent {
  box-sizing: border-box;
  background: white;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  overflow: hidden auto;
  max-height: 40rem;
  border-radius: 1.2rem;
  box-shadow: 0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12), 0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);
}

.SelectViewport {
  padding: 0.5rem;
}

.SelectItem {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1.6rem;
  border-radius: 0.8rem;
  padding: 1rem 2rem 1rem 1.6rem;
  box-sizing: border-box;
  width: 100%;
  line-height: 1.8rem;
  font-size: 1.3rem;
  letter-spacing: 0.08rem;
  font-weight: 400;
  background: transparent;
  outline: none;
  border: none;
}
.SelectItem {
  color: rgba(0, 0, 0, 0.6);
}
body.theme-dark .SelectItem {
  color: black;
}

.SelectItem svg {
  width: 1.4rem;
  height: 1.4rem;
  opacity: 0.6;
}
.SelectItem:disabled {
  opacity: 0.4;
}
.SelectItem:hover:not(:disabled) {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .SelectItem:hover:not(:disabled) {
  background-color: black;
}

.SelectItem:hover:not(:disabled) {
  color: rgba(0, 0, 0, 0.8);
}
body.theme-dark .SelectItem:hover:not(:disabled) {
  color: white;
}

.SelectItem:hover:not(:disabled) svg {
  opacity: 0.8;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow,
.react-datepicker__navigation-icon::before {
  border-style: solid;
  border-width: 0.3rem 0.3rem 0 0;
  content: "";
  display: block;
  position: absolute;
  top: 0.9rem;
  height: 0.6rem;
  width: 0.6rem;
  opacity: 0.5;
}

.react-datepicker__year-read-view--down-arrow {
  border-color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .react-datepicker__year-read-view--down-arrow {
  border-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.react-datepicker__month-read-view--down-arrow {
  border-color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .react-datepicker__month-read-view--down-arrow {
  border-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.react-datepicker__month-year-read-view--down-arrow {
  border-color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .react-datepicker__month-year-read-view--down-arrow {
  border-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.react-datepicker__navigation-icon::before {
  border-color: hsla(var(--theme-bg-hue), var(--palette-700-s), var(--palette-700-l), 1);
}
body.theme-dark .react-datepicker__navigation-icon::before {
  border-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.react-datepicker-wrapper {
  display: inline-block;
  padding: 0;
  border: 0;
}

.react-datepicker {
  font-family: "Helvetica Neue", helvetica, arial, sans-serif;
  font-size: 1.2rem;
  line-height: initial;
  border-radius: 1.6rem;
  display: flex;
  overflow: auto;
}
.react-datepicker {
  border-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .react-datepicker {
  border-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.2);
}

.react-datepicker {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .react-datepicker {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.react-datepicker {
  background-color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}
body.theme-dark .react-datepicker {
  background-color: hsla(var(--theme-bg-hue), 15%, 24%, 1);
}

.react-datepicker {
  box-shadow: 0 2rem 2.4rem hsl(var(--theme-bg-hue), 100%, 20%,0.12);
}
body.theme-dark .react-datepicker {
  box-shadow: 0 0.5rem 0.8rem hsl(var(--theme-bg-hue), 8%, 16%,0.56);
}

.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}

.react-datepicker--time-only .react-datepicker__time,
.react-datepicker--time-only .react-datepicker__time-box {
  border-bottom-left-radius: 1.6rem;
  border-bottom-right-radius: 1.6rem;
}

.react-datepicker-popper {
  z-index: 1;
  line-height: 0;
}

.react-datepicker-popper .react-datepicker__triangle {
  stroke: #aeaeae;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  fill: #f0f0f0;
  color: #f0f0f0;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  fill: #fff;
  color: #fff;
}

.react-datepicker__header {
  text-align: center;
  padding: 0.8rem 0;
  position: relative;
}
.react-datepicker__header {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .react-datepicker__header {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.2);
}

.react-datepicker__header--time {
  padding-bottom: 0.8rem;
  padding-left: 0.1rem;
  padding-right: 0.5rem;
}

.react-datepicker__header--time:not(.react-datepicker__header--time--only) {
  border-top-left-radius: 0;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 1.5rem;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  margin-top: 0;
  font-weight: 500;
  font-size: 1.2rem;
}
.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.8);
}
body.theme-dark .react-datepicker__current-month, .react-datepicker-time__header, .react-datepicker-year-header {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

h2.react-datepicker__current-month {
  padding: 0;
  margin: 0;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  align-items: center;
  background: none;
  display: flex;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: absolute;
  top: 0;
  padding: 0;
  border: none;
  z-index: 1;
  height: 4.2rem;
  width: 4.2rem;
  text-indent: -999em;
  overflow: hidden;
  border-radius: 50%;
}
.react-datepicker__navigation {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 1);
}
body.theme-dark .react-datepicker__navigation {
  background-color: hsl(358, 16.85%, 34.9%);
}

.react-datepicker__navigation--previous {
  left: 0rem;
}

.react-datepicker__navigation--next {
  right: 0rem;
}

.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 8.5rem;
}

.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__navigation--years-previous {
  top: 0.4rem;
}

.react-datepicker__navigation--years-upcoming {
  top: -0.4rem;
}

.react-datepicker__navigation:hover *::before {
  opacity: 1;
}

.react-datepicker__navigation-icon {
  position: relative;
  top: -0.1rem;
  font-size: 2rem;
  width: 0;
}

.react-datepicker__navigation-icon--next {
  left: 0.1rem;
}

.react-datepicker__navigation-icon--next::before {
  transform: rotate(45deg);
  left: -0.7rem;
}

.react-datepicker__navigation-icon--previous {
  right: 0.1rem;
}

.react-datepicker__navigation-icon--previous::before {
  transform: rotate(225deg);
  right: -0.7rem;
}

.react-datepicker__month-container {
  float: left;
}

.react-datepicker__year {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__year-wrapper {
  display: flex;
  flex-wrap: wrap;
  max-width: 18rem;
}

.react-datepicker__year .react-datepicker__year-text {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}

.react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}

.react-datepicker__input-time-container {
  clear: both;
  width: 100%;
  float: left;
  margin: 0.5rem 0 1rem 1.5rem;
  text-align: left;
}

.react-datepicker__input-time-container .react-datepicker-time__caption {
  display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container {
  display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
  display: inline-block;
  margin-left: 1rem;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
  width: auto;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {
  -moz-appearance: textfield;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
  margin-left: 0.5rem;
  display: inline-block;
}

.react-datepicker__time-container {
  float: right;
  border-left: 0.1rem solid #aeaeae;
  width: 8.5rem;
}

.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 0.1rem solid #aeaeae;
  border-radius: 1.6rem;
  position: absolute;
  right: -8.7rem;
  top: 0;
}

.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
  border-bottom-right-radius: 1.6rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 8.5rem;
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
  border-bottom-right-radius: 1.6rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: 21.1rem;
  overflow-y: scroll;
  padding-right: 0;
  padding-left: 0;
  width: 100%;
  box-sizing: content-box;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 3rem;
  padding: 0.5rem 1rem;
  white-space: nowrap;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  background-color: #216ba5;
  color: white;
  font-weight: bold;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  background-color: #216ba5;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ccc;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ccc;
  display: inline-block;
  width: 3.2rem;
  line-height: 3.2rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable:not(.react-datepicker__week-number--selected,
.react-datepicker__week-number--keyboard-selected):hover {
  border-radius: 1.6rem;
  background-color: #f0f0f0;
}

.react-datepicker__week-number--selected {
  border-radius: 1.6rem;
  background-color: #216ba5;
  color: #fff;
}

.react-datepicker__week-number--selected:hover {
  background-color: rgb(29, 93, 144);
}

.react-datepicker__week-number--keyboard-selected {
  border-radius: 1.6rem;
  background-color: rgb(42, 135, 208);
  color: #fff;
}

.react-datepicker__week-number--keyboard-selected:hover {
  background-color: rgb(29, 93, 144);
}

.react-datepicker__day-names {
  white-space: nowrap;
  margin-top: 0.4rem;
  margin-bottom: -0.4rem;
}

.react-datepicker__week {
  white-space: nowrap;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  display: inline-block;
  width: 3.2rem;
  line-height: 3.2rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  cursor: pointer;
}

.react-datepicker__day:not([aria-disabled=true]):hover,
.react-datepicker__month-text:not([aria-disabled=true]):hover,
.react-datepicker__quarter-text:not([aria-disabled=true]):hover,
.react-datepicker__year-text:not([aria-disabled=true]):hover {
  border-radius: 1.6rem;
}
.react-datepicker__day:not([aria-disabled=true]):hover,
.react-datepicker__month-text:not([aria-disabled=true]):hover,
.react-datepicker__quarter-text:not([aria-disabled=true]):hover,
.react-datepicker__year-text:not([aria-disabled=true]):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.2);
}
body.theme-dark .react-datepicker__day:not([aria-disabled=true]):hover, .react-datepicker__month-text:not([aria-disabled=true]):hover, .react-datepicker__quarter-text:not([aria-disabled=true]):hover, .react-datepicker__year-text:not([aria-disabled=true]):hover {
  background-color: hsla(var(--theme-bg-hue), var(--palette-100-s), var(--palette-100-l), 0.4);
}

.react-datepicker__day--today,
.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
  font-weight: bold;
}

.react-datepicker__day--highlighted,
.react-datepicker__month-text--highlighted,
.react-datepicker__quarter-text--highlighted,
.react-datepicker__year-text--highlighted {
  border-radius: 1.6rem;
  background-color: #3dcc4a;
  color: #fff;
}

.react-datepicker__day--highlighted:not([aria-disabled=true]):hover,
.react-datepicker__month-text--highlighted:not([aria-disabled=true]):hover,
.react-datepicker__quarter-text--highlighted:not([aria-disabled=true]):hover,
.react-datepicker__year-text--highlighted:not([aria-disabled=true]):hover {
  background-color: rgb(50, 190, 63);
}

.react-datepicker__day--highlighted-custom-1,
.react-datepicker__month-text--highlighted-custom-1,
.react-datepicker__quarter-text--highlighted-custom-1,
.react-datepicker__year-text--highlighted-custom-1 {
  color: magenta;
}

.react-datepicker__day--highlighted-custom-2,
.react-datepicker__month-text--highlighted-custom-2,
.react-datepicker__quarter-text--highlighted-custom-2,
.react-datepicker__year-text--highlighted-custom-2 {
  color: green;
}

.react-datepicker__day--holidays,
.react-datepicker__month-text--holidays,
.react-datepicker__quarter-text--holidays,
.react-datepicker__year-text--holidays {
  position: relative;
  border-radius: 1.6rem;
  background-color: #ff6803;
  color: #fff;
}

.react-datepicker__day--holidays .overlay,
.react-datepicker__month-text--holidays .overlay,
.react-datepicker__quarter-text--holidays .overlay,
.react-datepicker__year-text--holidays .overlay {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 0.4rem;
  border-radius: 0.4rem;
  white-space: nowrap;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.3s ease-in-out;
}

.react-datepicker__day--holidays:not([aria-disabled=true]):hover,
.react-datepicker__month-text--holidays:not([aria-disabled=true]):hover,
.react-datepicker__quarter-text--holidays:not([aria-disabled=true]):hover,
.react-datepicker__year-text--holidays:not([aria-disabled=true]):hover {
  background-color: rgb(207, 83, 0);
}

.react-datepicker__day--holidays:hover .overlay,
.react-datepicker__month-text--holidays:hover .overlay,
.react-datepicker__quarter-text--holidays:hover .overlay,
.react-datepicker__year-text--holidays:hover .overlay {
  visibility: visible;
  opacity: 1;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  border-radius: 1.6rem;
  background-color: #216ba5;
}
.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.3);
}
body.theme-dark .react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range, .react-datepicker__month-text--selected, .react-datepicker__month-text--in-selecting-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--selected, .react-datepicker__quarter-text--in-selecting-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--selected, .react-datepicker__year-text--in-selecting-range, .react-datepicker__year-text--in-range {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  border-radius: 1.6rem;
  color: rgb(0, 0, 0);
}
.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  color: hsla(var(--theme-bg-hue), var(--palette-900-s), var(--palette-900-l), 0.7);
}
body.theme-dark .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
  color: hsla(var(--theme-bg-hue), var(--palette-50-s), var(--palette-50-l), 1);
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.3);
}
body.theme-dark .react-datepicker__day--keyboard-selected, .react-datepicker__month-text--keyboard-selected, .react-datepicker__quarter-text--keyboard-selected, .react-datepicker__year-text--keyboard-selected {
  background-color: hsla(var(--theme-bg-hue), var(--palette-300-s), var(--palette-300-l), 0.4);
}

.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range) {
  background-color: hsla(var(--theme-bg-hue), var(--palette-400-s), var(--palette-400-l), 0.1);
}
body.theme-dark .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range), .react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {
  background-color: hsla(var(--theme-bg-hue), var(--palette-200-s), var(--palette-200-l), 0.3);
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__year--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range) {
  background-color: #f0f0f0;
  color: #000;
}

.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled,
.react-datepicker__year-text--disabled {
  cursor: default;
  opacity: 0.4;
}

.react-datepicker__day--disabled .overlay,
.react-datepicker__month-text--disabled .overlay,
.react-datepicker__quarter-text--disabled .overlay,
.react-datepicker__year-text--disabled .overlay {
  position: absolute;
  bottom: 70%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 0.4rem;
  border-radius: 0.4rem;
  white-space: nowrap;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.3s ease-in-out;
}

.react-datepicker__input-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.react-datepicker__input-container .react-datepicker__calendar-icon {
  position: absolute;
  padding: 0.5rem;
  box-sizing: content-box;
}

.react-datepicker__view-calendar-icon input {
  padding: 0.6rem 1rem 0.5rem 2.5rem;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 0.1rem solid transparent;
  border-radius: 1.6rem;
  position: relative;
}

.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}

.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: rgb(179, 179, 179);
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  transform: rotate(135deg);
  right: -1.6rem;
  top: 0;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 3rem;
  z-index: 1;
  text-align: center;
  border-radius: 1.6rem;
  border: 0.1rem solid #aeaeae;
}

.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}

.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 15rem;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 2rem;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 1.6rem;
  border-top-right-radius: 1.6rem;
}

.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-bottom-left-radius: 1.6rem;
  border-bottom-right-radius: 1.6rem;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ccc;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: rgb(179, 179, 179);
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: rgb(179, 179, 179);
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 1.5rem;
}

.react-datepicker__close-icon {
  cursor: pointer;
  background-color: transparent;
  border: 0;
  outline: 0;
  padding: 0 0.6rem 0 0;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}

.react-datepicker__close-icon::after {
  cursor: pointer;
  background-color: #216ba5;
  color: #fff;
  border-radius: 50%;
  height: 1.6rem;
  width: 1.6rem;
  padding: 0.2rem;
  font-size: 1.2rem;
  line-height: 1;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  content: "×";
}

.react-datepicker__close-icon--disabled {
  cursor: default;
}

.react-datepicker__close-icon--disabled::after {
  cursor: default;
  background-color: #ccc;
}

.react-datepicker__today-button {
  background: #f0f0f0;
  border-top: 0.1rem solid #aeaeae;
  cursor: pointer;
  text-align: center;
  font-weight: bold;
  padding: 0.5rem 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}

.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}

@media (max-width: 40rem), (max-height: 55rem) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.44rem;
}

.react-datepicker__children-container {
  width: 13.8rem;
  margin: 0.4rem;
  padding-right: 0.2rem;
  padding-left: 0.2rem;
  height: auto;
}

.react-datepicker__aria-live {
  position: absolute;
  clip-path: circle(0);
  border: 0;
  height: 0.1rem;
  margin: -0.1rem;
  overflow: hidden;
  padding: 0;
  width: 0.1rem;
  white-space: nowrap;
}

.react-datepicker__calendar-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.125em;
}

.firebase-emulator-warning {
  display: none;
}

html {
  font-size: 62.5%;
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: "Montserrat", "Raleway", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.4rem;
  line-height: 1.8rem;
  font-weight: 400;
  letter-spacing: 0.05rem;
  color: hsla(172, 80%, 10%, 0.6);
}

* {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  font-family: "Montserrat", "Raleway", sans-serif;
}

button {
  outline: none;
  border: none;
  margin: 0;
  padding: 0;
}

input,
textarea {
  font-family: "Montserrat", "Raleway", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss","webpack://./src/styles/utils/_colour-palette.scss","webpack://./src/styles/utils/scrollbar.scss","webpack://./src/styles/utils/cssvars.scss","webpack://./src/styles/demmi-core.scss","webpack://./src/styles/utils/colours.scss","webpack://./src/styles/pages/404/not-found-404.scss","webpack://./src/styles/pages/analytics/analytics.scss","webpack://./src/styles/pages/coupons/_sidebar-button.scss","webpack://./src/styles/pages/coupons/coupons.scss","webpack://./src/styles/pages/inventory/_sidebar-button.scss","webpack://./src/styles/pages/inventory/_product-details.scss","webpack://./src/styles/pages/inventory/_product-variants.scss","webpack://./src/styles/pages/inventory/inventory.scss","webpack://./src/styles/pages/reviews/_sidebar-button.scss","webpack://./src/styles/pages/reviews/reviews.scss","webpack://./src/styles/pages/home/widget-order-item.scss","webpack://./src/styles/pages/home/widget-orders.scss","webpack://./src/styles/pages/home/widget-review-item.scss","webpack://./src/styles/pages/home/widget-reviews.scss","webpack://./src/styles/pages/home/widget-analytics.scss","webpack://./src/styles/pages/home/incoming-schedule.scss","webpack://./src/styles/utils/elevations.scss","webpack://./src/styles/pages/home/badges.scss","webpack://./src/styles/pages/home/home.scss","webpack://./src/styles/pages/shopManagement/_details.scss","webpack://./src/styles/pages/shopManagement/_images.scss","webpack://./src/styles/pages/shopManagement/_location.scss","webpack://./src/styles/pages/shopManagement/_delivery-days.scss","webpack://./src/styles/pages/shopManagement/_theme-item.scss","webpack://./src/styles/pages/shopManagement/_theme.scss","webpack://./src/styles/pages/shopManagement/openingHours/_time-slots.scss","webpack://./src/styles/pages/shopManagement/openingHours/_preview.scss","webpack://./src/styles/pages/shopManagement/openingHours/opening-hours.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/edit/_edit.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/preview/preview.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/_create.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/_date-picker.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/_day-preview-timeline.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/_editing-view-day.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/_editing-view.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/_list.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/_preview-view-day.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/_preview-view.scss","webpack://./src/styles/pages/shopManagement/collectionSchedule/collection-schedule.scss","webpack://./src/styles/pages/shopManagement/shop-management.scss","webpack://./src/styles/pages/demmiSupport/_sidebar-button.scss","webpack://./src/styles/pages/demmiSupport/_chat.scss","webpack://./src/styles/utils/index.scss","webpack://./src/styles/pages/demmiSupport/_snippet.scss","webpack://./src/styles/pages/demmiSupport/_chat-message.scss","webpack://./src/styles/pages/demmiSupport/demmi-support.scss","webpack://./src/styles/components/asyncImage/async-image.scss","webpack://./src/styles/components/comingSoon/coming-soon.scss","webpack://./src/styles/components/galleryEditor/gallery-editor.scss","webpack://./src/styles/components/theme-switcher.scss","webpack://./src/styles/components/modals/_modal-create-demmi-support-ticket.scss","webpack://./src/styles/components/modals/_modal-create-product.scss","webpack://./src/styles/components/modals/_modal-create-variant.scss","webpack://./src/styles/components/modals/_modal-create-coupon.scss","webpack://./src/styles/components/modals/_modal-edit-coupon.scss","webpack://./src/styles/components/modals/_modal-image.scss","webpack://./src/styles/components/modals/_modal-boolean.scss","webpack://./src/styles/components/modals/_modal-publish.scss","webpack://./src/styles/components/mobileMenu/mobile-menu.scss","webpack://./src/styles/components/login/login-card.scss","webpack://./src/styles/components/login/login.scss","webpack://./src/styles/utils/background.scss","webpack://./src/styles/components/loadingOverlay/loading-overlay.scss","webpack://./src/styles/components/loadingOverlay/element-loading-spinner.scss","webpack://./src/styles/components/toolbar/toolbar.scss","webpack://./src/styles/components/toast/_button-action.scss","webpack://./src/styles/components/toast/_button-close.scss","webpack://./src/styles/components/toast/toast.scss","webpack://./src/styles/components/sidebar/_managed-button.scss","webpack://./src/styles/components/sidebar/sidebar.scss","webpack://./src/styles/components/notifications/notifications-panel.scss","webpack://./src/styles/components/notifications/notifications-item.scss","webpack://./src/styles/components/notifications/notifications.scss","webpack://./src/styles/components/orders/orderItem/order-item-header.scss","webpack://./src/styles/components/orders/orderItem/order-item-collection.scss","webpack://./src/styles/components/orders/orderItem/order-item-coupon.scss","webpack://./src/styles/components/orders/orderItem/_tab-timeline.scss","webpack://./src/styles/components/orders/orderItem/_tab-products.scss","webpack://./src/styles/components/orders/orderItem/_tab-review.scss","webpack://./src/styles/components/orders/orderItem/_tab-refund.scss","webpack://./src/styles/components/orders/orderItem/_order-product-item.scss","webpack://./src/styles/components/orders/orderItem/order-item.scss","webpack://./src/styles/components/orders/_sidebar-button.scss","webpack://./src/styles/components/orders/orders.scss","webpack://./src/styles/components/vendorWrapper/_error.scss","webpack://./src/styles/components/vendorWrapper/_content.scss","webpack://./src/styles/components/vendorWrapper/_mobile-menu.scss","webpack://./src/styles/components/vendorWrapper/vendor-wrapper.scss","webpack://./src/styles/components/phone-preview/display-shop.scss","webpack://./src/styles/components/phone-preview/display-product.scss","webpack://./src/styles/components/phone-preview/phone-preview.scss","webpack://./src/styles/components/page/_withSidebar.scss","webpack://./src/styles/components/page/_withTabs.scss","webpack://./src/styles/components/page/_tab.scss","webpack://./src/styles/components/page/_withToolbar.scss","webpack://./src/styles/components/page/page.scss","webpack://./src/styles/components/userMenu/_dropdown.scss","webpack://./src/styles/components/userMenu/_dropdown-button.scss","webpack://./src/styles/components/userMenu/_trigger-button.scss","webpack://./src/styles/components/userMenu/user-menu.scss","webpack://./src/styles/demmi-ui/card/_title.scss","webpack://./src/styles/demmi-ui/card/_tabs.scss","webpack://./src/styles/demmi-ui/card/card.scss","webpack://./src/styles/demmi-ui/toasts/_toast.scss","webpack://./src/styles/demmi-ui/toasts/_toasts-area.scss","webpack://./src/styles/demmi-ui/_modal.scss","webpack://./src/styles/demmi-ui/_button.scss","webpack://./src/styles/demmi-ui/_toggle.scss","webpack://./src/styles/demmi-ui/_icon-button.scss","webpack://./src/styles/demmi-ui/_item-switch.scss","webpack://./src/styles/demmi-ui/_button-switch.scss","webpack://./src/styles/demmi-ui/_input-file-button.scss","webpack://./src/styles/demmi-ui/_input-time.scss","webpack://./src/styles/demmi-ui/_input.scss","webpack://./src/styles/demmi-ui/_menu.scss","webpack://./src/styles/demmi-ui/_chip.scss","webpack://./src/styles/demmi-ui/_timeline.scss","webpack://./src/styles/demmi-ui/radix.scss","webpack://./src/styles/overrides/react-datepicker.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACGhB;EACI,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oBAAA;EAEA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;EAKA;;;;GAAA;ADCJ;;AE/EI;EACI,aAAA;EACA,cAAA;EACA,6BAAA;AFkFR;AEhFiB;EACL,gCAAA;EACA,qBAAA;EACA,4BAAA;EACA,aAAA;EACA,0CAAA;AFkFZ;AEhFY;EACI,oBAAA;EACA,0CAAA;AFkFhB;AEhFY;EACI,oBAAA;EACA,0CAAA;AFkFhB;;AE/EiB;EACL,uBAAA;EACA,mBAAA;AFkFZ;;AEhFiB;EACL,6BAAA;AFmFZ;;AE7EI;EACI,6BAAA;AFgFR;AE9EiB;EACL,gCAAA;EACA,4FAAA;AFgFZ;AE9EY;EACI,0FAAA;AFgFhB;AE9EY;EACI,0FAAA;AFgFhB;;AE7EiB;EACL,uBAAA;AFgFZ;;AE9EiB;EACL,6BAAA;AFiFZ;;AG9HA;EACI,sBAAA;EACA,4BAAA;EACA,+BAAA;EAEA,iCAAA;EACA,gCAAA;AHgIJ;AG9HI;EARJ;IASQ,qBAAA;EHiIN;AACF;;AG9HA;EAEI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,uDAAA;EACA,2DAAA;AHgIJ;;AI5JA;EACI,uBAAA;AJ+JJ;;AI5JA;EACI,YAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AJ+JJ;AKpII;EAaY,oCDrCR;AJ+JR;AKtHiB;EAkBG,8BD1DZ;AJiKR;;AI3JQ;EACI,aAAA;AJ8JZ;AI5JQ;EACI,cAAA;AJ8JZ;AIzJY;EACI,cAAA;AJ2JhB;AIzJY;EACI,aAAA;AJ2JhB;;AIrJA,mCAAA;AACA;EACI,oCAAA;AJwJJ;;AIrJA;EACI,kCAAA;AJwJJ;;AIrJA,iCAAA;AACA;EACI;IACI,UAAA;EJwJN;AACF;AIrJA;EACI;IACI,UAAA;EJuJN;AACF;AIpJA;EACI;IACI,kCAAA;IACA,UAAA;EJsJN;EIpJE;IACI,kCAAA;IACA,UAAA;EJsJN;EIpJE;IAEI,UAAA;EJqJN;AACF;AIlJA;EACI;IAEI,UAAA;EJmJN;EIjJE;IACI,kCAAA;IACA,UAAA;EJmJN;EIjJE;IACI,kCAAA;IACA,UAAA;EJmJN;AACF;AIhJA;EACI,gBAAA;AJkJJ;AI9IA,yCAAA;AACA;EACI,UAAA;EACA,sCAAA;AJgJJ;;AI7IA;EACI,UAAA;EACA,oCAAA;AJgJJ;;AI5IA;EACI,qCAAA;AJ+IJ;;AI5IA;EACI,oCAAA;AJ+IJ;;AI5IA,0BAAA;AASA,uDAAA;AACA;EACI,UAAA;AJuIJ;;AInIA,oEAAA;AACA;EACI,aAAA,EAAA,6CAAA;AJsIJ;;AM3QA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,gEACI;EAEJ,gBAAA;EACA,YAAA;EACA,sBAAA;AN4QJ;AM1QI;EACI,gBAAA;EACA,WAAA;AN4QR;AM1QQ;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;AN4QZ;AKpQI;EAEQ,iFAAA;ALqQZ;AKtPiB;EAED,+EAAA;ALuPhB;;AM1QY;EACI,gBAAA;AN6QhB;AK9QI;EAEQ,+EAAA;AL+QZ;AKhQiB;EAED,+EAAA;ALiQhB;;AM9QQ;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,6BAAA;ANiRZ;AK9RI;EAEQ,+EAAA;AL+RZ;AKhRiB;EAED,+EAAA;ALiRhB;;AMnRQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,0CAAA;EACA,wCAAA;ANsRZ;AK9SI;EAEQ,iFAAA;AL+SZ;AKhSiB;EAED,+EAAA;ALiShB;;AOzVA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AP4VJ;;AQrWA;EAEI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;ARuWJ;AQrWI;EACI,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;ARuWR;AKhVI;EAEQ,0FAAA;ALiVZ;AKlUiB;EAED,4FAAA;ALmUhB;;AQpWI;EACI,sBAAA;EACA,gBAAA;EACA,iBAAA;ARuWR;AQpWI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;ARsWR;;ASpYA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ATuYJ;;ASlYA;EAEI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AToYJ;ASlYI;EACI,aAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,YAfA;ATmZR;ASjYI;EACI,kBAAA;ATmYR;AK/YI;EACI,+GImBI;AT8XZ;AKhZiB;EACL,6GIkBA;ATgYZ;;AS7XQ;EACI,kBAAA;EACA,aAAA;EACA,YAlCJ;EAmCI,qBAAA;EACA,4JAAA;EAUA,sCACI;EAEJ,qCAAA;EACA,wCACI;EAEJ,kCAAA;EACA,wBAAA;ATmXZ;AKlaI;EACI,kGIkDQ;ATkXhB;AKnaiB;EACL,sMIqDI;ATgXhB;;AS1WY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AT6WhB;AKhaI;EAEQ,6FAAA;ALiaZ;AKlZiB;EAED,4FAAA;ALmZhB;;ASxWQ;EACI,kBAAA;EACA,QAAA;AT2WZ;ASzWY;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AT2WhB;AKlbI;EAaY,iFI6DI;AT2WpB;AKpaiB;EAkBG,+EIwCA;AT6WpB;;ASzWY;EACI,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AT4WhB;ASzWgB;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AT0WpB;AK7cI;EAaY,iFIyFQ;AT0WxB;AK/biB;EAkBG,+EIoEI;AT4WxB;;ASxWgB;EACI,aAAA;EACA,8BAAA;AT2WpB;ASzWoB;EACI,4BAAA;AT2WxB;ASzWoB;EACI,eAAA;AT2WxB;ASvWgB;EACI,mBAAA;ATyWpB;AKjeI;EAaY,iFI8GQ;ATyWxB;AKndiB;EAkBG,6EIyFI;AT2WxB;;ASxWoB;EACI,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;AT2WxB;ASxWoB;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;AT0WxB;AStWgB;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;ATwWpB;AKlgBI;EAaY,0CIgJQ;ATwWxB;AKpfiB;EAED,4FAAA;ALqfhB;;AKxgBI;EAaY,iFIuJQ;ATwWxB;AK3fiB;EAkBG,+EIkII;AT0WxB;;AK/gBI;EAEQ,sFAAA;ALihBZ;AKlgBiB;EAkBG,yBIyIQ;AT0W5B;;AKthBI;EAEQ,0FAAA;ALwhBZ;AKzgBiB;EAED,4FAAA;AL0gBhB;;AK7hBI;EAaY,YIsKkD;AT8WlE;AKhhBiB;EAkBG,YIgJqD;ATiXzE;;AKpiBI;EAEQ,sFAAA;ALsiBZ;AKvhBiB;EAkBG,yBIuJQ;ATiX5B;;AK3iBI;EAEQ,0FAAA;AL6iBZ;AK9hBiB;EAED,4FAAA;AL+hBhB;;AKljBI;EAaY,YIoLkD;ATqXlE;AKriBiB;EAkBG,YI8JqD;ATwXzE;;ASjXI;EACI;IACI,YAAA;EToXV;ESjXU;IACI,YAAA;ETmXd;AACF;;AUzmBA;EAEI,sBAAA;EACA,SAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AV2mBJ;AUxmBQ;EACI,oBAAA;AV0mBZ;AK9kBI;EAaY,8BKtCA;AV0mBhB;AKhkBiB;EAkBG,8BK3DJ;AV4mBhB;;AUvmBI;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;AV0mBR;AUxmBQ;EACI,aAAA;EACA,YAAA;EACA,iBAAA;AV0mBZ;AUvmBQ;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;AVymBZ;AKrnBI;EAaY,YAAA;AL2mBhB;AKvmBiB;EAkBG,YKtByC;AV8mB7D;;AK3nBI;EAaY,kCKGA;AV+mBhB;AK9mBiB;EAkBG,kCKlBJ;AVinBhB;;AU5mBI;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;AV+mBR;AU7mBQ;EACI,iBAAA;EACA,mBAAA;AV+mBZ;;AWnrBA;EAEI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AXqrBJ;AWnrBI;EAZJ;IAaQ,kBAAA;EXsrBN;AACF;AWprBI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;AXsrBR;AK5qBI;EAEQ,sFAAA;AL6qBZ;AK9pBiB;EAED,sFAAA;AL+pBhB;;AKlrBI;EAEQ,wFAAA;ALorBZ;AKrqBiB;EAkBG,6BM3C6C;AXisBjE;;AKzrBI;EAEQ,+EAAA;AL2rBZ;AK5qBiB;EAED,+EAAA;AL6qBhB;;AWrsBQ;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;AXwsBZ;AKxsBI;EAEQ,sFAAA;ALysBZ;AK1rBiB;EAkBG,yBM/B8C;AX0sBlE;;AK9sBI;EAEQ,0FAAA;ALgtBZ;AKjsBiB;EAED,4FAAA;ALksBhB;;AKrtBI;EAaY,YMHsC;AX+sBtD;AKxsBiB;EAkBG,YMzByC;AXktB7D;;AK5tBI;EAaY,yBMEA;AXitBhB;AK/sBiB;EAkBG,yBMnBJ;AXmtBhB;;AKnuBI;EAaY,kCMOA;AXmtBhB;AKttBiB;EAkBG,kCMdJ;AXqtBhB;;AK1uBI;EAaY,YMUsC;AXutBtD;AK7tBiB;EAkBG,YMZyC;AX0tB7D;;AWttBI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AXytBR;AWvtBQ;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AXytBZ;AWrtBI;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,uBAAA;EACA,oBAAA;AXutBR;AWrtBQ;EACI,0BAAA;EACA,YAAA;AXutBZ;;AWltBA;EAEI,aAAA;EACA,eAAA;AXotBJ;AK7wBI;EAaY,yBM+CR;AXotBR;AK/vBiB;EAkBG,+BM0BZ;AXstBR;;AWntBI;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;AXstBR;AWptBQ;EACI,aAAA;EACA,SAAA;AXstBZ;;AW9sBI;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;AXitBR;AKvyBI;EAEQ,iFAAA;ALwyBZ;AKzxBiB;EAED,6EAAA;AL0xBhB;;AW/sBI;EACI,aAAA;EAEA,eAAA;EACA,SAAA;EACA,mBAAA;AXitBR;AW/sBQ;EACI,aAAA;EACA,SAAA;AXitBZ;;AY/1BA;EAEI,WAAA;EACA,YAAA;EACA,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AZi2BJ;AY/1BI;EAdJ;IAeQ,kBAAA;EZk2BN;AACF;AYh2BI;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AZk2BR;AKl1BI;EAaY,yBO1BJ;AZk2BZ;AKp0BiB;EAkBG,+BO/CR;AZo2BZ;;AY/1BA;EAEI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AZi2BJ;AKj2BI;EAaY,yBOZ8B;AZm2B9C;AKn1BiB;EAkBG,YOlC8C;AZs2BlE;;AYp2BI;EACI,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AZu2BR;;AYn2BA;EAEI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AZq2BJ;AYn2BI;EACI,WAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AZq2BR;AYn2BQ;EACI,WAAA;AZq2BZ;AYn2BY;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AZq2BhB;AYl2BY;EACI,WAAA;AZo2BhB;;Aax6BA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;Ab26BJ;Aaz6BI;EACI,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;Ab26BR;Aaz6BQ;EACI,aAAA;Ab26BZ;Aax6BQ;EACI,YAAA;EACA,cAAA;Ab06BZ;Aav6BgB;EACI,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;Aby6BpB;Aav6BoB;EACI;IACI,iBAAA;Eby6B1B;AACF;Aan6BQ;EACI,6BAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,iBAAA;Abq6BZ;AKh7BI;EAaY,0CQEA;Abo6BhB;AKl6BiB;EAkBG,0DQnBJ;Abs6BhB;;Aal6BQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;EACA,yBAAA;EACA,gBAAA;EACA,sEACI;EAEJ,UAAA;EACA,6BAAA;Abm6BZ;AK18BI;EAEQ,iFAAA;AL28BZ;AK57BiB;EAED,6EAAA;AL67BhB;;Aah6BQ;EACI,UAAA;Abm6BZ;AKp9BI;EAEQ,iFAAA;ALq9BZ;AKt8BiB;EAkBG,YQkBJ;Abq6BhB;;AK19BI;EAaY,uBQ6CA;Abo6BhB;AK78BiB;EAED,4FAAA;AL88BhB;;Aaj6BQ;EACI;IACI,oBApGM;EbwgCpB;Eal6BU;IACI,oBAvGM;Eb2gCpB;AACF;Aa/5BQ;EACI,2DAAA;Abi6BZ;Aa/5BY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;Abi6BhB;Aa/5BgB;EACI,mBAAA;Abi6BpB;Aa/5BoB;EAHJ;IAIQ,gBAAA;Ebk6BtB;AACF;Aa95BY;EACI,oBAAA;Abg6BhB;Aa95BY;EACI,oBAAA;Abg6BhB;Aa75BY;EACI;IACI,oBA3IE;Eb0iCpB;Ea75Bc;IACI,oBA9IE;Eb6iCpB;AACF;;AcnjCA;EAEI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;AdqjCJ;AKvhCI;EAEQ,iFAAA;ALwhCZ;AKzgCiB;EAED,6EAAA;AL0gChB;;AcxjCI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;Ad2jCR;AczjCQ;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;Ad2jCZ;AcxjCQ;EACI,aAAA;EACA,WAAA;Ad0jCZ;AKrjCI;EAEQ,+EAAA;ALsjCZ;AKviCiB;EAED,6EAAA;ALwiChB;;AczjCI;EACI,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;Ad4jCR;AKnkCI;EAEQ,6FAAA;ALokCZ;AKrjCiB;EAED,4FAAA;ALsjChB;;AczjCQ;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;Ad4jCZ;AczjCQ;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,gBAAA;Ad2jCZ;AcvjCI;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AdyjCR;;Ae1oCA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;Af6oCJ;;Ae1oCA;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;Af6oCJ;;Ae1oCA;EAEI,aAAA;EACA,8EACI;EAGJ,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;AfyoCJ;AKloCI;EAaY,yBUnB8B;Af2oC9C;AKpnCiB;EAkBG,YUzC8C;Af8oClE;;Ae5oCI;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;Af+oCR;Ae7oCQ;EACI,aAAA;EACA,WAAA;Af+oCZ;AKppCI;EAEQ,+EAAA;ALqpCZ;AKtoCiB;EAkBG,YU5B2C;AfmpC/D;;Ae/oCQ;EACI,iBAAA;EACA,gBAAA;AfkpCZ;AehpCY;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AfkpChB;Ae7oCI;EACI,eAAA;EACA,mBAAA;Af+oCR;Ae7oCQ;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;Af+oCZ;Ae7oCQ;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;Af+oCZ;Ae7oCY;EACI,cAAA;Af+oChB;Ae1oCI;EACI,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;Af4oCR;AK7rCI;EAEQ,wFAAA;AL8rCZ;AK/qCiB;EAgBG,0DAAA;ALkqCpB;;Ae/oCQ;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AfkpCZ;AK3sCI;EAaY,yBU+CA;AfkpChB;AK7rCiB;EAkBG,YU0BJ;AfopChB;;AehpCQ;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;AfmpCZ;AK1tCI;EAaY,yBU6DA;AfmpChB;AK5sCiB;EAkBG,YUwCJ;AfqpChB;;AejpCQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AfopCZ;AejpCQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AfmpCZ;Ae/oCI;EACI,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AfipCR;AKrvCI;EAEQ,wFAAA;ALsvCZ;AKvuCiB;EAgBG,0DAAA;AL0tCpB;;AeppCQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AfupCZ;AerpCY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AfupChB;AenpCQ;EACI,gBAAA;AfqpCZ;AelpCQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AfopCZ;AehpCI;EAzJJ;IA0JQ,4GACI;EfkpCV;Ee7oCM;IACI,eAAA;IACA,mBAAA;Ef+oCV;Ee5oCM;IACI,eAAA;IACA,aAAA;Ef8oCV;AACF;;AgB50CA;EAEI,mBAAA;AhB80CJ;AgB50CI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;AhB80CR;AKlzCI;EAEQ,iFAAA;ALmzCZ;AKpyCiB;EAkBG,YW9DmC;AhBm1CvD;;AgBj1CQ;EACI,aAAA;AhBo1CZ;AgBl1CY;EACI,iBAAA;AhBo1ChB;AgBn1CgB;EACI,sBAAA;AhBq1CpB;AgBl1CY;EACI,eAAA;AhBo1ChB;AgBl1CY;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AhBo1ChB;AgBl1CY;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AhBo1ChB;AgB/0CI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AhBi1CR;AgB/0CQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AhBi1CZ;AKh2CI;EAEQ,wFAAA;ALi2CZ;AKl1CiB;EAgBG,0DAAA;ALq0CpB;;AKt2CI;EAaY,yBWMA;AhBu1ChB;AKz1CiB;EAkBG,YWfJ;AhBy1ChB;;AgBt1CY;EACI,8BAAA;EACA,+BAAA;AhBy1ChB;AgBv1CgB;EACI,4BAAA;AhBy1CpB;AgBt1CY;EACI,iCAAA;EACA,kCAAA;AhBw1ChB;AgBt1CgB;EACI,+BAAA;AhBw1CpB;AgBp1CY;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AhBs1ChB;AgBp1CgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhBs1CpB;AgBl1CY;EACI,iBAAA;EACA,gBAAA;AhBo1ChB;AgBj1CY;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AhBm1ChB;AgBh1CY;EACI,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AhBk1ChB;AgBh1CgB;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AhBk1CpB;;AiBv8CA;EAEI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AjBy8CJ;AiBv8CI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AjBy8CR;AKv7CI;EAaY,yBY9BkC;AjB28ClD;AKz6CiB;EAkBG,YYpDkD;AjB88CtE;;AkBj+CI;EACI,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;AlBo+CR;AkBl+CQ;EACI,aAAA;EACA,WAAA;EACA,iBAAA;AlBo+CZ;AK18CI;EAEQ,+EAAA;AL28CZ;AK57CiB;EAkBG,Ya3D2C;AlBw+C/D;;AkBp+CQ;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AlBu+CZ;AkBr+CY;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AlBu+ChB;AkBl+CI;EACI,eAAA;EACA,eAAA;EACA,mBAAA;AlBo+CR;AKj+CI;EAEQ,wFAAA;ALk+CZ;AKn9CiB;EAgBG,0DAAA;ALs8CpB;;AkBl+CQ;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;AlBq+CZ;AkBn+CQ;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AlBq+CZ;AkBn+CY;EACI,gBAAA;AlBq+ChB;;AmB5hDA;EAEI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AnB8hDJ;AmB5hDI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AnB8hDR;AKzgDI;EAaY,yBcjCkC;AnBgiDlD;AK3/CiB;EAkBG,YcvDkD;AnBmiDtE;;AoBpjDA;EAEI,oBAAA;EACA,aAAA;EACA,gBAAA;ApBsjDJ;AoBpjDI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;ApBsjDR;AKjiDI;EAEQ,iFAAA;ALkiDZ;AKnhDiB;EAED,6EAAA;ALohDhB;;AqBxkDA;EAEI,4BAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;ArB0kDJ;AqBxkDI;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;ArB0kDR;AqBxkDQ;EACI,kBAAA;EACA,kBAAA;EAIA,MAAA;EACA,YAAA;EACA,QAAA;EACA,cAAA;EACA,qBAAA;ArBukDZ;AK/jDI;EAEQ,0FAAA;ALgkDZ;AKjjDiB;EAED,0FAAA;ALkjDhB;;AqB1kDY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;ArB6kDhB;AK/kDI;EAEQ,0FAAA;ALglDZ;AKjkDiB;EAED,0FAAA;ALkkDhB;;AqB7kDI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;ArBglDR;AqB9kDQ;EACI,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;ArBglDZ;AKzmDI;EAaY,0CgBeA;ArBglDhB;AK3lDiB;EAED,4FAAA;AL4lDhB;;AK/mDI;EAEQ,+EAAA;ALinDZ;AKlmDiB;EAkBG,yBAAA;ALmlDpB;;AqB7kDA;EAEI,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,6CAAA;EACA,YAAA;ArB+kDJ;AKtoDI;EAEQ,0FAAA;ALuoDZ;AKxnDiB;EAED,6FAAA;ALynDhB;;AqB1kDI;EACI,UAAA;ArB6kDR;AqB1kDI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;ArB4kDR;AqB1kDQ;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAnHU;EAoHV,sBAAA;ArB4kDZ;AK7pDI;EAEQ,+EAAA;AL8pDZ;AK/oDiB;EAkBG,YgB+CuC;ArBilD3D;;AqB/kDQ;EACI,cAAA;EACA,WAAA;ArBklDZ;AKxqDI;EAEQ,0FAAA;ALyqDZ;AK1pDiB;EAED,0FAAA;AL2pDhB;;AqBnlDI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;ArBslDR;AqBplDQ;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gCAAA;EACA,uCAAA;ArBslDZ;AKjsDI;EAaY,uBgBiGA;ArBslDhB;AKnrDiB;EAED,4FAAA;ALorDhB;;AqBplDY;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;ArBulDhB;AKntDI;EAEQ,iFAAA;ALotDZ;AKrsDiB;EAkBG,YgB6FA;ArBylDpB;;AKztDI;EAEQ,wFAAA;AL2tDZ;AK5sDiB;EAgBG,0DAAA;AL+rDpB;;AqB3lDY;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;ArB8lDhB;AKxuDI;EAEQ,+EAAA;ALyuDZ;AK1tDiB;EAkBG,YgBwG2C;ArBmmD/D;;AqBjmDY;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ArBomDhB;AKrvDI;EAEQ,+EAAA;ALsvDZ;AKvuDiB;EAkBG,YgB+G2C;ArBymD/D;;AsBlwDI;EACI,mEAAA;AtBqwDR;AsBhwDiB;EACL,kEAAA;AtBkwDZ;;AuBtyDA;EACI,iBAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AvByyDJ;AuBvyDI;EACI,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,sBAAA;AvByyDR;AKrxDI;EAaY,0CkB9BJ;AvByyDZ;AKvwDiB;EAED,4FAAA;ALwwDhB;;AuBtyDY;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;AvByyDhB;AKjyDI;EAEQ,+EAAA;ALkyDZ;AKnxDiB;EAkBG,yBkBvCA;AvB2yDpB;;AuBtyDY;EACI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AvByyDhB;AK9yDI;EAEQ,iFAAA;AL+yDZ;AKhyDiB;EAkBG,+BkB1BA;AvB2yDpB;;AuBryDQ;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AvBwyDZ;AK3zDI;EAEQ,+EAAA;AL4zDZ;AK7yDiB;EAkBG,yBkBZJ;AvB0yDhB;;AwBl2DA;EAEI,WAAA;EACA,YAAA;EACA,aAAA;EACA,yIACI;EAGJ,WAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;AxBi2DJ;;AwB91DA;EACI,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;AxBg2DJ;AKr1DI;EAaY,0CmBpBR;AxB+1DR;AKv0DiB;EAED,4FAAA;ALw0DhB;;AwB51DQ;EACI,YAAA;AxB+1DZ;AwB31DI;EACI,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AxB61DR;AwB11DI;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AxB41DR;AKj3DI;EAEQ,iFAAA;ALk3DZ;AKn2DiB;EAED,6EAAA;ALo2DhB;;AwB/1DQ;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AxBk2DZ;AKh4DI;EAEQ,4FAAA;ALi4DZ;AKl3DiB;EAED,4FAAA;ALm3DhB;;AyB76DA;EAEI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;AzB+6DJ;AK74DI;EAaY,yBoB5CR;AzB+6DR;AK/3DiB;EAkBG,+BoBjEZ;AzBi7DR;;AyB96DI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AzBi7DR;;A0Bn8DA;EAEI,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;A1Bq8DJ;A0Bn8DI;EACI,aAAA;EACA,4DAAA;EACA,cAAA;EACA,SAAA;A1Bq8DR;A0Bn8DQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;A1Bq8DZ;AKh7DI;EAEQ,0FAAA;ALi7DZ;AKl6DiB;EAkBG,oCqBpDJ;A1Bu8DhB;;A0Bn8DY;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A1Bs8DhB;A0Bp8DgB;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;A1Bs8DpB;A0Bl8DY;EACI,aAAA;EACA,WAAA;A1Bo8DhB;;A2Bh/DA;EAEI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;A3Bk/DJ;AKj9DI;EAaY,yBsB7C8B;A3Bo/D9C;AKn8DiB;EAkBG,YsBnE8C;A3Bu/DlE;;A2Br/DI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;A3Bw/DR;A2Bt/DQ;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;A3Bw/DZ;A2Bp/DI;EACI,kBAAA;EACA,aAAA;EACA,SAAA;A3Bs/DR;A2Bn/DI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;A3Bq/DR;A2Bn/DQ;EACI,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;A3Bq/DZ;A2Bn/DY;EACI,aAAA;EACA,sBAAA;EACA,aAAA;A3Bq/DhB;A2Bn/DgB;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;A3Bq/DpB;A2Bl/DgB;EACI,WAAA;A3Bo/DpB;A2B9+DI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;A3Bg/DR;A2B9+DQ;EACI,mBAAA;A3Bg/DZ;A2B9+DY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,+BAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,gCAAA;EACA,gCAAA;EACA,yIACI;A3B++DpB;A2Bv+DI;EA/FJ;IAgGQ,SAAA;E3B0+DN;E2Bt+Dc;IACI,cAAA;E3Bw+DlB;AACF;;A2Bl+DA;EAEI,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;A3Bo+DJ;A2Bl+DI;EACI,YAAA;EACA,sBAAA;A3Bo+DR;AKljEI;EAEQ,wFAAA;ALmjEZ;AKpiEiB;EAgBG,0DAAA;ALuhEpB;;A2Bv+DQ;EACI,UAAA;A3B0+DZ;AsBnkEI;EACI,oEAAA;AtBqkER;AsBhkEiB;EACL,kEAAA;AtBkkEZ;;AKlkEI;EAEQ,wFAAA;ALokEZ;AKrjEiB;EAgBG,0DAAA;ALwiEpB;;A2Bl/DQ;EACI,UAAA;A3Bq/DZ;AK7kEI;EAEQ,wFAAA;AL8kEZ;AK/jEiB;EAgBG,0DAAA;ALkjEpB;;A2Bt/DI;EACI,kBAAA;EACA,sBAAA;A3By/DR;A2Bv/DQ;EACI,iBAAA;A3By/DZ;A2Br/DI;EACI,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0HACI;A3Bs/DZ;;A4B5oEA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;A5B+oEJ;;A6BppEA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;A7BupEJ;AK3nEI;EAaY,0CwBtCR;A7BupER;AK7mEiB;EAkBG,oCwB3DZ;A7BypER;;A6BtpEI;EACI,YAAA;EACA,WAAA;EACA,qBAAA;A7BypER;AKvoEI;EAaY,oCwBzBJ;A7BspEZ;AKznEiB;EAkBG,uBwB9CR;A7BwpEZ;;A8BvqEA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,4FAnBe;A9B6rEnB;AK1pEI;EAaY,yByB1BR;A9B0qER;AK5oEiB;EAkBG,+ByB/CZ;A9B4qER;;A8BzqEI;EACI,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;A9B4qER;A8BzqEI;EACI,gBAAA;A9B2qER;A8BxqEI;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;A9B0qER;A8BvqEI;EAvCJ;IAwCQ,WAAA;IACA,eAAA;IACA,8FAjDU;E9B2tEhB;AACF;A8BxqEI;EA7CJ;IA8CQ,aAAA;IACA,cAAA;IACA,4FAzDW;E9BouEjB;AACF;A8BzqEI;EAnDJ;IAoDQ,WAAA;IACA,eAAA;IACA,8FA7DU;E9ByuEhB;AACF;A8B1qEI;EAzDJ;IA0DQ,WAAA;IACA,oBAAA;IACA,8FAjEc;E9B8uEpB;AACF;A8B3qEI;EA/DJ;IAgEQ,gBAAA;IACA,SAAA;IACA,iFArEa;E9BmvEnB;E8B7qEM;IACI,aAAA;IACA,oBAAA;E9B+qEV;AACF;A8B5qEI;EACI;IACI,YAAA;E9B8qEV;AACF;A8B3qEI;EACI;IACI,YAAA;E9B6qEV;AACF;;A+BzwEI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,qBAAA;A/B4wER;A+B1wEQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;A/B4wEZ;AK7vEI;EAEQ,+EAAA;AL8vEZ;AK/uEiB;EAED,6EAAA;ALgvEhB;;A+B9wEQ;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;A/BixEZ;AK/wEI;EAEQ,4FAAA;ALgxEZ;AKjwEiB;EAkBG,oC0BjCJ;A/BmxEhB;;A+B/wEY;EACI,cAAA;A/BkxEhB;A+BhxEgB;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;A/BkxEpB;AKjyEI;EAEQ,iFAAA;ALkyEZ;AKnxEiB;EAkBG,Y0BhBI;A/BoxExB;;A+B9wEY;EAEQ;IACI,YAAA;E/BgxEtB;AACF;A+B5wEY;EAEQ;IACI,YAAA;E/B6wEtB;AACF;A+BzwEY;EApDJ;IAqDQ,WAAA;IACA,aAAA;IACA,gEACI;E/B2wElB;E+BvwEkB;IACI,oBAAA;E/BywEtB;E+BvwEkB;IACI,kBAAA;E/BywEtB;E+BvwEkB;IACI,YAAA;E/BywEtB;E+BrwEc;IACI,oBAAA;IACA,iBAAA;E/BuwElB;AACF;;AgC12EI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AhC62ER;AKj1EI;EAEQ,4FAAA;ALk1EZ;AKn0EiB;EAkBG,oC2B3DR;AhC+2EZ;;AgC12EQ;EACI,kBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AhC62EZ;AK/1EI;EAEQ,iFAAA;ALg2EZ;AKj1EiB;EAED,6EAAA;ALk1EhB;;AgC32EY;EACI,cAAA;EACA,kBAAA;AhC82EhB;AgC12EQ;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AhC42EZ;AgC12EY;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;AhC42EhB;AKz3EI;EAaY,uB2BGI;AhC42EpB;AK32EiB;EAED,0FAAA;AL42EhB;;AgC12EY;EACI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,qBAAA;EACA,6CAAA;AhC62EhB;AgC32EgB;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AhC62EpB;AgC32EoB;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AhC62ExB;AK55EI;EAEQ,iFAAA;AL65EZ;AK94EiB;EAkBG,Y2BgBQ;AhC+2E5B;;AgC12EoB;EACI,aAAA;EACA,YAAA;AhC62ExB;AKv6EI;EAEQ,0FAAA;ALw6EZ;AKz5EiB;EAED,0FAAA;AL05EhB;;AgCv2EY;EACI,YAAA;EACA,gBAAA;AhC02EhB;;AiCt9EA;EAEI,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AjCw9EJ;AK57EI;EAaY,yB4BtCR;AjCw9ER;AK96EiB;EAkBG,+B4B3DZ;AjC09ER;;AiCv9EI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AjC09ER;AiCx9EQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;AjC09EZ;AKt9EI;EAEQ,+EAAA;ALu9EZ;AKx8EiB;EAED,+EAAA;ALy8EhB;;AiC79EY;EACI,eAAA;AjCg+EhB;AiC79EY;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AjC+9EhB;AK5+EI;EAEQ,+EAAA;AL6+EZ;AK99EiB;EAkBG,Y4BrB2C;AjCo+E/D;;AiCj+EY;EACI,gBAAA;AjCo+EhB;;AkC7hFA;EAEI,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AlC+hFJ;AkC7hFI;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AlC+hFR;AK3gFI;EAEQ,iFAAA;AL4gFZ;AK7/EiB;EAED,6EAAA;AL8/EhB;;AkCjiFI;EACI,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AlCoiFR;AK3hFI;EAEQ,0FAAA;AL4hFZ;AK7gFiB;EAED,4FAAA;AL8gFhB;;AKjiFI;EAEQ,iFAAA;ALmiFZ;AKphFiB;EAED,6EAAA;ALqhFhB;;AkCviFI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AlC0iFR;AkCxiFQ;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AlC0iFZ;AKtjFI;EAEQ,iFAAA;ALujFZ;AKxiFiB;EAED,6EAAA;ALyiFhB;;AmCnmFA;EAEI,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AnCqmFJ;AmCnmFI;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AnCqmFR;AKjlFI;EAEQ,iFAAA;ALklFZ;AKnkFiB;EAED,6EAAA;ALokFhB;;AoC9nFA;EAEI,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;ApCgoFJ;AoC9nFI;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ApCgoFR;AK5mFI;EAEQ,iFAAA;AL6mFZ;AK9lFiB;EAED,6EAAA;AL+lFhB;;AoCjoFQ;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ApCooFZ;AK7nFI;EAEQ,iFAAA;AL8nFZ;AK/mFiB;EAED,6EAAA;ALgnFhB;;AoCloFY;EACI,gBAAA;EACA,gBAAA;ApCqoFhB;AoChoFI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;ApCkoFR;;AqCzrFA;EAEI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;ArC2rFJ;AqCzrFI;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;ArC2rFR;AKlqFI;EAEQ,iFAAA;ALmqFZ;AKppFiB;EAED,6EAAA;ALqpFhB;;AqC5rFA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;ArC+rFJ;;AqC5rFA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;ArC8rFJ;AK7rFI;EAEQ,+EAAA;AL8rFZ;AK/qFiB;EAED,+EAAA;ALgrFhB;;AqCjsFI;EACI,eAAA;ArCosFR;AqCjsFI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;ArCmsFR;AKntFI;EAEQ,+EAAA;ALotFZ;AKrsFiB;EAkBG,YgClBmC;ArCwsFvD;;AqCrsFI;EACI,gBAAA;ArCwsFR;;AsCpwFA;EAEI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AtCswFJ;AKxuFI;EAEQ,4FAAA;ALyuFZ;AK1tFiB;EAkBG,oCiC7DZ;AtCwwFR;;AsCnwFI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;AtCswFR;AsCpwFQ;EACI,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;AtCswFZ;AKlwFI;EAaY,0CiCdA;AtCswFhB;AKpvFiB;EAED,4FAAA;ALqvFhB;;AKxwFI;EAEQ,+EAAA;AL0wFZ;AK3vFiB;EAkBG,yBiC7BJ;AtCywFhB;;AsCpwFI;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,cAAA;EACA,UAAA;AtCuwFR;AsCrwFQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;AtCuwFZ;AKhyFI;EAaY,uBiCaiD;AtCywFjE;AKlxFiB;EAED,0FAAA;ALmxFhB;;AsCzwFQ;EACI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,qBAAA;EACA,6CAAA;AtC4wFZ;AsC1wFY;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;AtC4wFhB;AsC1wFgB;EACI,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AtC4wFpB;AKn0FI;EAEQ,iFAAA;ALo0FZ;AKrzFiB;EAkBG,YiCwBI;AtC8wFxB;;AsCzwFgB;EACI,aAAA;EACA,YAAA;AtC4wFpB;AK90FI;EAEQ,0FAAA;AL+0FZ;AKh0FiB;EAED,0FAAA;ALi0FhB;;AsCtwFQ;EACI,YAAA;EACA,gBAAA;AtCywFZ;;AuCh4FA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AvCk4FJ;AKj2FI;EAEQ,+EAAA;ALk2FZ;AKn1FiB;EAED,+EAAA;ALo1FhB;;AuCr4FI;EACI,eAAA;AvCw4FR;AuCr4FI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AvCu4FR;AKv3FI;EAEQ,+EAAA;ALw3FZ;AKz2FiB;EAkBG,YkClDmC;AvC44FvD;;AuCz4FI;EACI,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AvC44FR;AKv4FI;EAEQ,0FAAA;ALw4FZ;AKz3FiB;EAED,4FAAA;AL03FhB;;AK74FI;EAEQ,+EAAA;AL+4FZ;AKh4FiB;EAkBG,YkCjCmC;AvCk5FvD;;AuC/4FI;EACI,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;AvCk5FR;AK95FI;EAEQ,0FAAA;AL+5FZ;AKh5FiB;EAED,4FAAA;ALi5FhB;;AKp6FI;EAEQ,+EAAA;ALs6FZ;AKv5FiB;EAkBG,YkChBmC;AvCw5FvD;;AuCr5FI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AvCw5FR;AuCt5FQ;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;AvCw5FZ;AuCt5FY;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AvCw5FhB;AuCr5FY;EACI,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AvCu5FhB;AuCr5FgB;EACI,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;AvCu5FpB;AKj+FI;EAEQ,+EAAA;ALk+FZ;AKn9FiB;EAED,6EAAA;ALo9FhB;;AuCx5FY;EACI;IACI,4BAAA;EvC25FlB;AACF;AuCx5FY;EApDJ;IAqDQ,WAAA;IACA,sBAAA;IACA,WAAA;EvC25Fd;EuCz5Fc;IACI,WAAA;IACA,sBAAA;IACA,WAAA;EvC25FlB;EuCz5Fc;IACI,WAAA;IACA,8BAAA;IACA,mBAAA;EvC25FlB;AACF;AuCv5FQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EAEA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;AvCw5FZ;AKxgGI;EAEQ,4FAAA;ALygGZ;AK1/FiB;EAkBG,oCkCiFJ;AvC05FhB;;AuCt5FY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;AvCy5FhB;AK3hGI;EAEQ,+EAAA;AL4hGZ;AK7gGiB;EAkBG,YkCgG2C;AvC85F/D;;AuC35FY;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AvC85FhB;AuC55FgB;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;AvC85FpB;AKrjGI;EAaY,uBkC6IQ;AvC85FxB;AKviGiB;EAED,4FAAA;ALwiGhB;;AuC35FgB;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;AvC85FpB;AuC55FoB;EACI,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;AvC85FxB;AK7kGI;EAEQ,iFAAA;AL8kGZ;AK/jGiB;EAkBG,YkCiJQ;AvC+5F5B;;AuCz5FgB;EApDJ;IAqDQ,sBAAA;IACA,WAAA;EvC65FlB;EuC35FkB;IACI,WAAA;IACA,sBAAA;IACA,WAAA;EvC65FtB;EuC35FkB;IACI,WAAA;IACA,8BAAA;IACA,mBAAA;EvC65FtB;AACF;AuC15FY;EACI,kBAAA;AvC45FhB;AuCv5FI;EACI,gBAAA;AvCy5FR;;AwCjpGA;EAEI,WAAA;EAEA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AxCkpGJ;AwChpGI;EACI,eAAA;AxCkpGR;AwCjpGQ;EACI,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AxCmpGZ;AKjoGI;EAEQ,iFAAA;ALkoGZ;AKnnGiB;EAED,6EAAA;ALonGhB;;AwCjpGY;EACI,gBAAA;EACA,gBAAA;AxCopGhB;AwC/oGI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AxCipGR;AwC9oGI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kBAAA;AxCgpGR;AKlqGI;EAaY,YmCMkC;AxCkpGlD;AKppGiB;EAED,+EAAA;ALqpGhB;;AKxqGI;EAEQ,0FAAA;AL0qGZ;AK3pGiB;EAED,4FAAA;AL4pGhB;;AwCppGQ;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AxCupGZ;AwCppGQ;EACI,uBAAA;EACA,gBAAA;EACA,iBAAA;AxCspGZ;;AyCnuGA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AzCquGJ;AyCnuGI;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AzCquGR;AK9sGI;EAEQ,iFAAA;AL+sGZ;AKhsGiB;EAED,6EAAA;ALisGhB;;AyCvuGI;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;AzC0uGR;AKjuGI;EAEQ,4FAAA;ALkuGZ;AKntGiB;EAED,4FAAA;ALotGhB;;AKvuGI;EAEQ,4FAAA;ALyuGZ;AK1tGiB;EAED,4FAAA;AL2tGhB;;AyCpuGQ;EACI,oBAAA;AzCuuGZ;AyCpuGQ;EACI,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AzCsuGZ;AyCpuGY;EACI,eAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,iBAAA;AzCsuGhB;AKhwGI;EAEQ,iFAAA;ALiwGZ;AKlvGiB;EAkBG,YoCLA;AzCwuGpB;;AyCpuGgB;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;AzCuuGpB;AyCruGgB;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AzCuuGpB;AyCluGQ;EACI,aAAA;EACA,iBAAA;EACA,WAAA;AzCouGZ;AyCjuGQ;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;AzCmuGZ;AKtyGI;EAEQ,iFAAA;ALuyGZ;AKxxGiB;EAkBG,YoCoCJ;AzCquGhB;;AK5yGI;EAEQ,0FAAA;AL8yGZ;AK/xGiB;EAED,4FAAA;ALgyGhB;;A0C11GA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,0BAAA;A1C41GJ;AK5zGI;EAEQ,+EAAA;AL6zGZ;AK9yGiB;EAED,+EAAA;AL+yGhB;;A0C/1GI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A1Ck2GR;AKh1GI;EAEQ,+EAAA;ALi1GZ;AKl0GiB;EAkBG,YqCpDmC;A1Cu2GvD;;A0Cr2GQ;EACI,cAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;A1Cw2GZ;AKv2GI;EAEQ,4FAAA;ALw2GZ;AKz1GiB;EAkBG,oCqChCJ;A1C02GhB;;A0Cp2GI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;A1Cu2GR;A0Cr2GQ;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;A1Cu2GZ;A0Cr2GY;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;A1Cu2GhB;A0Cp2GY;EACI,0BAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;A1Cs2GhB;AK95GI;EAEQ,+EAAA;AL+5GZ;AKh5GiB;EAkBG,YqCsB2C;A1C22G/D;;A0Cz2GgB;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;A1C42GpB;AK76GI;EAEQ,iFAAA;AL86GZ;AK/5GiB;EAED,+EAAA;ALg6GhB;;A0Cz2GgB;EACI,iBAAA;EACA,qBAAA;A1C42GpB;A0Cx2GY;EA7DJ;IA8DQ,sBAAA;IACA,WAAA;E1C22Gd;E0Cz2Gc;IACI,WAAA;IACA,sBAAA;IACA,WAAA;E1C22GlB;E0Cz2Gc;IACI,WAAA;IACA,8BAAA;IACA,mBAAA;E1C22GlB;AACF;A0Cv2GQ;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;A1Cy2GZ;A0Cv2GY;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;A1Cy2GhB;AK/9GI;EAEQ,+EAAA;ALg+GZ;AKj9GiB;EAkBG,YqCoF2C;A1C82G/D;;A0C32GY;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,oBAAA;A1C82GhB;AKh/GI;EAEQ,4FAAA;ALi/GZ;AKl+GiB;EAkBG,oCqCmGA;A1Cg3GpB;;A0C52GgB;EACI,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;A1C+2GpB;A0C72GoB;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;A1C+2GxB;AKrgHI;EAEQ,iFAAA;ALsgHZ;AKv/GiB;EAkBG,YqCuHQ;A1Ci3G5B;;A0Cx2GI;EACI,gBAAA;A1C22GR;;A2CtjHA;EAEI,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;A3CwjHJ;A2CtjHI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;A3CwjHR;A2CpjHQ;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;A3CsjHZ;AK5iHI;EAEQ,iFAAA;AL6iHZ;AK9hHiB;EAED,6EAAA;AL+hHhB;;A2CpjHY;EACI,gBAAA;EACA,gBAAA;A3CujHhB;;A4CnlHA;EAEI,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;A5CqlHJ;AKlkHI;EAaY,yBuC7BR;A5CqlHR;AKpjHiB;EAkBG,+BuClDZ;A5CulHR;;A6CpmHA;EACI,sBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;A7CumHJ;A6CrmHI;EACI,aAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;A7CumHR;A6CrmHQ;EANJ;IAOQ,eAAA;E7CwmHV;AACF;;A8CjoHA;EAEI,aAAA;EACA,wFACI;EAGJ,kBAAA;EACA,sBAAA;EACA,mBAAA;A9CgoHJ;A8C9nHI;EACI,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A9CgoHR;AK3mHI;EAEQ,+EAAA;AL4mHZ;AK7lHiB;EAkBG,YyCvDmC;A9CqoHvD;;A8CloHI;EACI,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;A9CqoHR;AK9nHI;EAEQ,wFAAA;AL+nHZ;AKhnHiB;EAED,4FAAA;ALinHhB;;AKpoHI;EAEQ,+EAAA;ALsoHZ;AKvnHiB;EAkBG,YyCnCmC;A9C2oHvD;;A8CxoHI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;A9C2oHR;AKxpHI;EAEQ,+EAAA;ALypHZ;AK1oHiB;EAkBG,YyCrBmC;A9CgpHvD;;A8C7oHI;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A9CgpHR;AKvqHI;EAEQ,iFAAA;ALwqHZ;AKzpHiB;EAED,+EAAA;AL0pHhB;;A+CjtHA;EAEI,eAAA;EACA,UAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;A/CmtHJ;AgD9tHI;EACI,YAAA;AhDguHR;AgD5tHQ;EACI,YAAA;AhD8tHZ;;A+CrtHI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0CAAA;EACA,sBAAA;A/CwtHR;AKjtHI;EAEQ,iFAAA;ALktHZ;AKnsHiB;EAkBG,Y0CzCmC;A/C6tHvD;;AKvtHI;EAaY,0C0ChBJ;A/C8tHZ;AK1sHiB;EAkBG,oC0CrCR;A/CguHZ;;A+C5tHI;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,0CAAA;EACA,sBAAA;EACA,cAAA;A/C+tHR;AKxuHI;EAaY,0C0CDJ;A/C+tHZ;AK1tHiB;EAkBG,oC0CtBR;A/CiuHZ;;A+C9tHQ;EACI,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;A/CiuHZ;A+C/tHY;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;A/CiuHhB;AKlwHI;EAEQ,iFAAA;ALmwHZ;AKpvHiB;EAED,+EAAA;ALqvHhB;;A+C5tHI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;A/C+tHR;AgDjzHI;EACI,YAAA;AhDmzHR;AgD/yHQ;EACI,YAAA;AhDizHZ;;AiD1zHI;EAEI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AjD4zHR;AKhyHI;EAEQ,iFAAA;ALiyHZ;AKlxHiB;EAkBG,Y4C9DmC;AjDi0HvD;;AKtyHI;EAaY,oC4CrCJ;AjDk0HZ;AKzxHiB;EAED,4FAAA;AL0xHhB;;AiD5zHQ;EACI,aAAA;EACA,cAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AjD+zHZ;AiD5zHQ;EACI,gBAAA;AjD8zHZ;AiD5zHY;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AjD8zHhB;AiD3zHY;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AjD6zHhB;;AkD52HA;EAII,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qCAAA;EACA,UAAA;AlD42HJ;AKh1HI;EAaY,0D6CpDE;AlD03HlB;AKl0HiB;EAkBG,wD6CzEH;AlD43HjB;;AkD32HI;EACI,UAAA;EACA,4BAAA;EACA,qCAAA;AlD82HR;AkD52HQ;EACI,WAAA;EACA,WAAA;AlD82HZ;AkD12HI;EACI,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AlD42HR;AK72HI;EAaY,0D6CpDE;AlDu5HlB;AK/1HiB;EAkBG,wD6CzEH;AlDy5HjB;;AkD12HI;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AlD62HR;AK13HI;EAEQ,+EAAA;AL23HZ;AK52HiB;EAkBG,Y6CrBmC;AlDk3HvD;;AkD/2HI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AlDk3HR;AK74HI;EAEQ,iFAAA;AL84HZ;AK/3HiB;EAED,+EAAA;ALg4HhB;;AmDr7HA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AnDw7HJ;;AoDj8HA;EAEI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ApDm8HJ;AoDh8HQ;EACI,sCAAA;ApDk8HZ;AoDh8HQ;EACI,wCAAA;ApDk8HZ;AoD97HI;EACI,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ApDg8HR;AoD77HI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ApD+7HR;AoD77HQ;EAWI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,4CAAA;ApDq7HZ;AKn9HI;EACI,sM+CesB;ApDs8H9B;AKp9HiB;EACL,gE+CkBiB;ApDo8H7B;;AoDp7HY;EACI,WAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;ApDu7HhB;AKn+HI;EACI,sM+CesB;ApDs9H9B;AKp+HiB;EACL,gE+CkBiB;ApDo9H7B;;AoDr7HY;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;ApDw7HhB;AK/9HI;EAaY,kC+C6BI;ApDw7HpB;AKj9HiB;EAgBG,0DAAA;ALo8HpB;;AoDn7HA;EACI;IACI,uBAAA;EpDs7HN;EoDp7HE;IACI,yBAAA;EpDs7HN;AACF;AoDn7HA;EACI;IACI,UAAA;EpDq7HN;EoDn7HE;IACI,UAAA;EpDq7HN;AACF;AoDl7HA;EACI;IACI,UAAA;EpDo7HN;EoDl7HE;IACI,UAAA;EpDo7HN;AACF;AqDriIA;EAEI,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ArDsiIJ;AqDpiII;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;ArDsiIR;AKhhII;EAEQ,+EAAA;ALihIZ;AKlgIiB;EAED,+EAAA;ALmgIhB;;AqDziII;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ArD4iIR;AK/hII;EAEQ,iFAAA;ALgiIZ;AKjhIiB;EAED,+EAAA;ALkhIhB;;AsD5kIA;EAEI,cAAA;AtD8kIJ;AsD5kII;EACI,iCAAA;EACA,6BAAA;EACA,aAAA;EACA,sFAAA;EAIA,2BAAA;EACA,iCAAA;AtD2kIR;AsDzkIQ;EACI,cAAA;EACA,kBAAA;AtD2kIZ;AsDzkIY;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;AtD2kIhB;;AsDrkIA;EAEI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;AtDukIJ;AK3kII;EAEQ,wFAAA;AL4kIZ;AK7jIiB;EAED,wFAAA;AL8jIhB;;AsDpkII;EACI,gBAAA;AtDukIR;AKrlII;EAaY,mBiDIJ;AtDukIZ;AKvkIiB;EAED,sFAAA;ALwkIhB;;AsDnkII;EACI,oBAAA;AtDskIR;AsDpkIQ;EACI,oBAAA;AtDskIZ;;AsDjkIA;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AtDokIJ;AK3mII;EAaY,2CiD6BR;AtDokIR;AK7lIiB;EAgBG,0DAAA;ALglIpB;;AsDnkII;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AtDskIR;;AuD/pIA;EAEI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uCAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AvDiqIJ;AKtoII;EAaY,0CkDrCR;AvDiqIR;AKxnIiB;EAED,4FAAA;ALynIhB;;AuD/pII;EACI,UAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;AvDkqIR;AuDhqIQ;EACI,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,+BAAA;AvDkqIZ;AK9pII;EAEQ,iFAAA;AL+pIZ;AKhpIiB;EAkBG,YkDnCJ;AvDoqIhB;;AuDjqIY;EACI,cAAA;AvDoqIhB;AuDjqIQ;EACI,4DACI;EAEJ,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AvDiqIZ;AKlrII;EAEQ,iFAAA;ALmrIZ;AKpqIiB;EAkBG,YkDdJ;AvDmqIhB;;AKxrII;EAEQ,iFAAA;AL0rIZ;AK3qIiB;EAkBG,YkDJA;AvDgqIpB;;AK/rII;EAEQ,iFAAA;ALisIZ;AKlrIiB;EAkBG,YkDC2C;AvDkqI/D;;AuD7pIY;EACI,oCAAA;AvDgqIhB;AuD9pIY;EACI,UAAA;EACA,QAAA;AvDgqIhB;AuD3pII;EACI,UAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,+BAAA;AvD6pIR;AKxtII;EAaY,uBkD+C6C;AvD+pI7D;AK1sIiB;EAED,0FAAA;AL2sIhB;;AsBruII;EACI,mEAAA;AtBwuIR;AsBnuIiB;EACL,wDAAA;AtBquIZ;;AuDpqIQ;EACI,oCAAA;AvDuqIZ;AuDnqIQ;EACI,qCAAA;AvDqqIZ;AuDjqIQ;EACI,YAAA;AvDmqIZ;;AwDtxIA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;AxDwxIJ;AwDtxII;EAPJ;IAQQ,wBAAA;IACA,mBAAA;ExDyxIN;AACF;AwDvxII;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AxDyxIR;AKtwII;EAEQ,+EAAA;ALuwIZ;AKxvIiB;EAkBG,YmDrDmC;AxD8xIvD;;AwD3xII;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AxD8xIR;AKzxII;EAaY,YmDjBkC;AxDgyIlD;AK3wIiB;EAkBG,YmDvCqC;AxDmyIzD;;AK/xII;EAaY,kCmDdJ;AxDoyIZ;AKlxIiB;EAkBG,kCmDnCR;AxDsyIZ;;AwDlyII;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;AxDqyIR;AKh0II;EACI,oBmD2ByC;AxDuyIjD;AKj0IiB;EACL,UmDyBkD;AxD0yI9D;;AwDxyIQ;EACI,mBAAA;AxD2yIZ;;AyDh2IA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;AzDk2IJ;AyDh2II;EAPJ;IAQQ,wBAAA;IACA,iBAAA;EzDm2IN;AACF;AyDj2II;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AzDm2IR;AKh1II;EAEQ,+EAAA;ALi1IZ;AKl0IiB;EAkBG,YoDrDmC;AzDw2IvD;;AyDr2II;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;AzDw2IR;AK/2II;EACI,oBoDOyC;AzD02IjD;AKh3IiB;EACL,UoDKkD;AzD62I9D;;AyD32IQ;EACI,mBAAA;AzD82IZ;;A0D/4IA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;A1Di5IJ;AK/2II;EAEQ,+EAAA;ALg3IZ;AKj2IiB;EAkBG,YqDpE+B;A1Ds5InD;;A0Dp5II;EARJ;IASQ,wBAAA;IACA,mBAAA;E1Dw5IN;AACF;A0Dt5II;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A1Dw5IR;A0Dr5II;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;A1Du5IR;AK95II;EACI,oBqDOyC;A1Dy5IjD;AK/5IiB;EACL,UqDKkD;A1D45I9D;;A2D17IA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;A3D47IJ;A2D17II;EAPJ;IAQQ,wBAAA;IACA,mBAAA;E3D67IN;AACF;A2D37II;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A3D67IR;AK16II;EAEQ,+EAAA;AL26IZ;AK55IiB;EAkBG,YsDrDmC;A3Dk8IvD;;A2D/7II;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;A3Dk8IR;AK77II;EAaY,YsDjBkC;A3Do8IlD;AK/6IiB;EAkBG,YsDvCqC;A3Du8IzD;;AKn8II;EAaY,kCsDdJ;A3Dw8IZ;AKt7IiB;EAkBG,kCsDnCR;A3D08IZ;;A2Dt8II;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;A3Dy8IR;AKn+II;EACI,oBsD0ByC;A3D28IjD;AKp+IiB;EACL,UsDwBkD;A3D88I9D;;A2D58IQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;A3D+8IZ;A2D78IY;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;A3D+8IhB;AKp+II;EAaY,yBsDWI;A3D+8IpB;AKt9IiB;EAkBG,+BsDVA;A3Di9IpB;;A2D58IQ;EACI,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;A3D+8IZ;AKl/II;EAaY,yBsDyBA;A3D+8IhB;AKp+IiB;EAkBG,+BsDIJ;A3Di9IhB;;A2D98IY;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;A3Di9IhB;A2D98IY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;A3Dg9IhB;A2D98IgB;EACI,aAAA;EACA,kBAAA;A3Dg9IpB;A2D78IgB;EACI,YAAA;A3D+8IpB;A2Dz8IY;EACI,gBAAA;A3D28IhB;;A4DxjJA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;A5D0jJJ;A4DxjJI;EAPJ;IAQQ,wBAAA;IACA,mBAAA;E5D2jJN;AACF;A4DzjJI;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A5D2jJR;AKxiJI;EAEQ,+EAAA;ALyiJZ;AK1hJiB;EAkBG,YuDrDmC;A5DgkJvD;;A4D7jJI;EACI,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;A5DgkJR;AK3jJI;EAaY,YuDjBkC;A5DkkJlD;AK7iJiB;EAkBG,YuDvCqC;A5DqkJzD;;AKjkJI;EAaY,kCuDdJ;A5DskJZ;AKpjJiB;EAkBG,kCuDnCR;A5DwkJZ;;A4DpkJI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;A5DukJR;AKjmJI;EACI,oBuD0ByC;A5DykJjD;AKlmJiB;EACL,UuDwBkD;A5D4kJ9D;;A4D1kJQ;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;A5D6kJZ;AK9lJI;EAaY,yBuDOA;A5D6kJhB;AKhlJiB;EAkBG,+BuDdJ;A5D+kJhB;;A4D3kJQ;EACI,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;A5D8kJZ;AK5mJI;EAaY,yBuDoBA;A5D8kJhB;AK9lJiB;EAkBG,+BuDDJ;A5DglJhB;;A4D7kJY;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;A5DglJhB;A4D7kJY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;A5D+kJhB;A4D7kJgB;EACI,aAAA;EACA,kBAAA;A5D+kJpB;A4D5kJgB;EACI,YAAA;A5D8kJpB;A4DxkJY;EACI,gBAAA;A5D0kJhB;;A6DlrJA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;A7DorJJ;A6DlrJI;EAPJ;IAQQ,wBAAA;IACA,mBAAA;E7DqrJN;AACF;A6DnrJI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;A7DqrJR;A6DnrJQ;EACI,aAAA;A7DqrJZ;A6DjrJI;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,UAAA;A7DmrJR;AKjrJI;EAaY,yBwDdkC;A7DqrJlD;AKnqJiB;EAkBG,YwDpCkD;A7DwrJtE;;A6DtrJQ;EACI,UAAA;A7DyrJZ;A6DrrJI;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;A7DurJR;A6DprJI;EACI,aAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;A7DsrJR;AK/sJI;EAaY,2CwDeJ;A7DsrJZ;AKjsJiB;EAgBG,0DAAA;ALorJpB;;A6DrrJQ;EACI,aAAA;A7DwrJZ;A6DrrJQ;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;A7DurJZ;;A8DtwJA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;A9DwwJJ;A8DtwJI;EAPJ;IAQQ,wBAAA;IACA,mBAAA;E9DywJN;AACF;A8DvwJI;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A9DywJR;AKtvJI;EAEQ,+EAAA;ALuvJZ;AKxuJiB;EAkBG,YyDrDmC;A9D8wJvD;;A8D3wJI;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A9D8wJR;AKxwJI;EAEQ,+EAAA;ALywJZ;AK1vJiB;EAkBG,YyDxCmC;A9DmxJvD;;A8DhxJI;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A9DmxJR;AKzxJI;EAEQ,+EAAA;AL0xJZ;AK3wJiB;EAkBG,YyD5BmC;A9DwxJvD;;A8DrxJI;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;A9DwxJR;;A+Dh1JA;EAEI,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;A/Dk1JJ;A+Dh1JI;EAPJ;IAQQ,wBAAA;IACA,mBAAA;E/Dm1JN;AACF;A+Dj1JI;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A/Dm1JR;AKh0JI;EAEQ,+EAAA;ALi0JZ;AKlzJiB;EAkBG,Y0DrDmC;A/Dw1JvD;;A+Dr1JI;EACI,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A/Dw1JR;AKj1JI;EAEQ,+EAAA;ALk1JZ;AKn0JiB;EAkBG,Y0DzCmC;A/D61JvD;;A+D11JI;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;A/D61JR;;AgEt4JA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AhEy4JJ;AgEv4JI;EACI,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;AhEy4JR;AKh3JI;EAEQ,4FAAA;ALi3JZ;AKl2JiB;EAED,4FAAA;ALm2JhB;;AgEr4JI;EACI,UAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AhEw4JR;AgEt4JQ;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AhEw4JZ;AKz4JI;EAEQ,0FAAA;AL04JZ;AK33JiB;EAED,0FAAA;AL43JhB;;AgE34JY;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AhE84JhB;AgE14JQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AhE44JZ;AgE14JY;EACI,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AhE44JhB;AKt6JI;EAEQ,+EAAA;ALu6JZ;AKx5JiB;EAED,+EAAA;ALy5JhB;;AgE94JY;EACI,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;AhEi5JhB;AKt7JI;EAEQ,+EAAA;ALu7JZ;AKx6JiB;EAED,+EAAA;ALy6JhB;;AgEj5JI;EACI,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AhEo5JR;AgEl5JQ;EACI,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sIACI;AhEm5JhB;AKh9JI;EAEQ,iFAAA;ALi9JZ;AKl8JiB;EAkBG,Y2DiCJ;AhEk5JhB;;AKt9JI;EAaY,uB2D8DI;AhE+4JpB;AKz8JiB;EAED,0FAAA;AL08JhB;;AK79JI;EAEQ,iFAAA;AL+9JZ;AKh9JiB;EAkBG,Y2D8CA;AhEm5JpB;;AKp+JI;EAEQ,iFAAA;ALs+JZ;AKv9JiB;EAkBG,Y2DsDI;AhEk5JxB;;AgE54JY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AhE+4JhB;AKr/JI;EAEQ,iFAAA;ALs/JZ;AKv+JiB;EAkBG,Y2DuEA;AhEi5JpB;;AgE74JY;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AhEg5JhB;AKlgKI;EAaY,0C2D2GI;AhE64JpB;AKp/JiB;EAED,4FAAA;ALq/JhB;;AgE14JY;EACI,0CAAA;AhE64JhB;AK5gKI;EAaY,0C2DqHI;AhE64JpB;AK9/JiB;EAED,4FAAA;AL+/JhB;;AgEx4JI;EACI,UAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,yBAAA;AhE24JR;AgEz4JQ;;EAEI,aAAA;EACA,8BAAA;AhE24JZ;AgEx4JQ;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AhE04JZ;AK5iKI;EAEQ,+EAAA;AL6iKZ;AK9hKiB;EAED,+EAAA;AL+hKhB;;AgE54JQ;EACI,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AhE+4JZ;AK1jKI;EAEQ,+EAAA;AL2jKZ;AK5iKiB;EAED,+EAAA;AL6iKhB;;AiErmKA;EAEI,YAAA;EACA,+BAAA;AjEumKJ;AiErmKI;EACI,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,wFACI;AjEsmKZ;AKnnKI;EACI,kCAAA;ALqnKR;AKpnKiB;EACL,kCAAA;ALsnKZ;;AiExmKQ;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AjE2mKZ;AiEzmKY;EACI,YAAA;AjE2mKhB;AiExmKY;EACI,cAAA;EACA,qBAAA;EACA,eAAA;AjE0mKhB;AiEtmKQ;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AjEwmKZ;AKppKI;EACI,uBAAA;ALspKR;AKrpKiB;EACL,uBAAA;ALupKZ;;AiExmKA;EAEI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;EACA,iHACI;AjEymKR;AiEtmKI;EACI,UAAA;EACA,aAAA;AjEwmKR;AiErmKI;EACI,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,0HACI;AjEsmKZ;;AkEzrKA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,kCAAA;EACA,gEACI;AlE2rKR;AkEzrKI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;ECsEJ,UAAA;EACA,+NAboB;EAcpB,0BAAA;EACA,4BAAA;AnEsnKJ;AmErnKI;EACI,WAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,oCAAA;AnEunKR;AmErnKI;EACI,UAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,+BAAA;EACA,2BAAA;EACA,8BAAA;AnEunKR;AkE1sKI;EACI,kCAAA;EACA,UAAA;AlE4sKR;AkExsKQ;EACI,gBAAA;AlE0sKZ;AkExsKQ;EACI,gBAAA;AlE0sKZ;AkErsKQ;EACI,oBAAA;EACA,UAAA;EACA,oCAAA;AlEusKZ;AkEpsKQ;EACI,qBAAA;EACA,kCAAA;EACA,UAAA;AlEssKZ;AkEnsKQ;EACI,gBAAA;AlEqsKZ;AkEjsKI;EACI,UAAA;EACA,iBAAA;EACA,6DAAA;AlEmsKR;AkEhsKI;EACI,wFACI;AlEisKZ;AK/vKI;EACI,kCAAA;ALiwKR;AKhwKiB;EACL,kCAAA;ALkwKZ;;AKrwKI;EACI,8BAAA;ALwwKR;AKvwKiB;EACL,8BAAA;ALywKZ;;AK5wKI;EACI,sBAAA;AL+wKR;AK9wKiB;EACL,sBAAA;ALgxKZ;;AkE/sKQ;EACI,wFACI;AlEitKhB;AKvxKI;EACI,kCAAA;ALyxKR;AKxxKiB;EACL,kCAAA;AL0xKZ;;AkEltKQ;EACI,wFACI;AlEotKhB;AKjyKI;EACI,kCAAA;ALmyKR;AKlyKiB;EACL,kCAAA;ALoyKZ;;AkEptKI;EACI,gBAAA;AlEutKR;AK3yKI;EACI,kCAAA;AL6yKR;AK5yKiB;EACL,kCAAA;AL8yKZ;;AKjzKI;EACI,uBAAA;ALozKR;AKnzKiB;EACL,uBAAA;ALqzKZ;;AKxzKI;EACI,8BAAA;AL2zKR;AK1zKiB;EACL,8BAAA;AL4zKZ;;AK/zKI;EACI,uBAAA;ALk0KR;AKj0KiB;EACL,uBAAA;ALm0KZ;;AKt0KI;EACI,kCAAA;ALy0KR;AKx0KiB;EACL,kCAAA;AL00KZ;;AK70KI;EACI,8BAAA;ALg1KR;AK/0KiB;EACL,8BAAA;ALi1KZ;;AkEnvKQ;EACI,gBAAA;AlEsvKZ;AKx1KI;EACI,kCAAA;AL01KR;AKz1KiB;EACL,kCAAA;AL21KZ;;AK91KI;EACI,8BAAA;ALi2KR;AKh2KiB;EACL,8BAAA;ALk2KZ;;AkE7vKI;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;AlEgwKR;AkE7vKI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,kCAAA;EACA,UAAA;EACA,uKACI;AlE8vKZ;AkEzvKI;EACI,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,qCAAA;EACA,oHACI;AlE0vKZ;;AoEj4KA;EAEI,eAAA;EACA,QAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;ApEm4KJ;AKv2KI;EAaY,wC+DrCR;ApEk4KR;AKz1KiB;EAkBG,kC+D1DZ;ApEo4KR;;AK72KI;EAaY,uF+D/Bc;ApEm4K9B;AKh2KiB;EAkBG,wF+DhDS;ApEi4K7B;;AKp3KI;EAaY,uF+D/Bc;ApE04K9B;AKv2KiB;EAkBG,wF+DhDS;ApEw4K7B;;AoEl3KQ;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;ApEq3KZ;AoEl3KQ;EACI,sCAAA;EACA,qBAAA;EACA,UAAA;ApEo3KZ;AoEh3KI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;ApEk3KR;AoE/2KI;EACI,kBAAA;ApEi3KR;AoE/2KQ;EACI,YAAA;ApEi3KZ;AoE72KI;EACI,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,0BAAA;EACA,oBAAA;EACA,iBAAA;ApE+2KR;AoE52KI;EAOI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8CAAA;EACA,oCAAA;EACA,2FAba;EAcb,YAAA;ApEw2KR;AoEt2KQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,2FAvBS;ApE+3KrB;AoEr2KQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;ApEu2KZ;AK17KI;EAaY,kC+DyEA;ApEu2KhB;AK56KiB;EAkBG,kC+DoDJ;ApEy2KhB;;AoEn2KQ;EACI,UAAA;EACA,eAAA;ApEs2KZ;;AoEj2KA;EACI;IACI,cAAA;IACA,UAAA;EpEo2KN;EoEj2KE;IACI,cAAA;IACA,UAAA;IACA,mBAAA;EpEm2KN;AACF;AoE/1KA;EACI;IACI,mBAAA;EpEi2KN;EoE91KE;IACI,UAAA;EpEg2KN;AACF;AoE51KA;EACI;IACI,uBAAA;EpE81KN;EoE51KE;IACI,yBAAA;EpE81KN;AACF;AoE31KA;EACI;IACI,2BAAA;IACA,UAAA;EpE61KN;EoE11KE;IACI,6BAAA;IACA,YAAA;EpE41KN;EoEz1KE;IACI,2BAAA;IACA,UAAA;EpE21KN;AACF;AoEx1KA;EACI;IACI,aAAA;EpE01KN;EoEv1KE;IACI,cAAA;IACA,UAAA;EpEy1KN;EoEt1KE;IACI,SAAA;IACA,UAAA;EpEw1KN;AACF;AoEt1KA;EACI;IACI,cAAA;EpEw1KN;EoEr1KE;IACI,eAAA;IACA,UAAA;EpEu1KN;EoEp1KE;IACI,SAAA;IACA,UAAA;EpEs1KN;AACF;AqEhjLA;EAEI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ArEijLJ;AqE/iLI;EACI,aAAA;ArEijLR;AqE9iLI;EAWI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,yDAAA;ArEsiLR;AK5iLI;EACI,sMgEVkB;ArEwjL1B;AK7iLiB;EACL,gEgEPa;ArEsjLzB;;AqEriLQ;EACI,WAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;ArEwiLZ;AK5jLI;EACI,sMgEVkB;ArEwkL1B;AK7jLiB;EACL,gEgEPa;ArEskLzB;;AqEtiLQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;ArEyiLZ;AKxjLI;EAaY,kCgEKA;ArEyiLhB;AK1iLiB;EAgBG,0DAAA;AL6hLpB;;AqEriLA;EACI;IACI,uBAAA;ErEwiLN;EqEtiLE;IACI,yBAAA;ErEwiLN;AACF;AsE5mLA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AtE8mLJ;AsE5mLI;EACI,aAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;AtE8mLR;AKnlLI;EAEQ,wFAAA;ALolLZ;AKrkLiB;EAED,4FAAA;ALskLhB;;AsE5mLQ;EACI,eAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sIACI;AtE8mLhB;AKpmLI;EAEQ,iFAAA;ALqmLZ;AKtlLiB;EAkBG,YiEtCJ;AtE6mLhB;;AK1mLI;EAaY,uBiETI;AtE0mLpB;AK7lLiB;EAED,0FAAA;AL8lLhB;;AKjnLI;EAEQ,iFAAA;ALmnLZ;AKpmLiB;EAkBG,YiEzBA;AtE8mLpB;;AsB/nLI;EACI,mEAAA;AtBkoLR;AsB7nLiB;EACL,wDAAA;AtB+nLZ;;AK/nLI;EAEQ,iFAAA;ALioLZ;AKlnLiB;EAkBG,YiEhBI;AtEmnLxB;;AsE7mLY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AtEgnLhB;AKhpLI;EAEQ,iFAAA;ALipLZ;AKloLiB;EAkBG,YiECA;AtEknLpB;;AsE9mLY;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AtEinLhB;AK7pLI;EAaY,0CiEqCI;AtE8mLpB;AK/oLiB;EAED,4FAAA;ALgpLhB;;AsB1qLI;EACI,mEAAA;AtB6qLR;AsBxqLiB;EACL,wDAAA;AtB0qLZ;;AsEjnLY;EACI,0CAAA;AtEonLhB;AK9qLI;EAaY,0CiEgDI;AtEonLpB;AKhqLiB;EAED,4FAAA;ALiqLhB;;AsB3rLI;EACI,oEAAA;AtB8rLR;AsBzrLiB;EACL,wDAAA;AtB2rLZ;;AuE/tLI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,qEACI;AvEiuLZ;AK3tLI;EACI,qCkEHI;AvEguLZ;AK5tLiB;EACL,2CkEJA;AvEkuLZ;;AKjuLI;EACI,2BkEEI;AvEkuLZ;AKnuLiB;EACL,6BkECA;AvEouLZ;;AKxuLI;EACI,qCkESQ;AvEkuLhB;AK1uLiB;EACL,2CkEQI;AvEouLhB;;AK/uLI;EACI,qCkEkBQ;AvEguLhB;AKjvLiB;EACL,2CkEiBI;AvEkuLhB;;AwEzwLI;EACI,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qEACI;AxE2wLZ;AKpwLI;EACI,kCmEJI;AxE0wLZ;AKrwLiB;EACL,wCmELA;AxE4wLZ;;AK1wLI;EACI,qCmEGQ;AxE0wLhB;AK5wLiB;EACL,2CmEEI;AxE4wLhB;;AKjxLI;EACI,yBmESY;AxE2wLpB;AKnxLiB;EACL,+BmEQQ;AxE6wLpB;;AKxxLI;EACI,qCmEmBQ;AxEwwLhB;AK1xLiB;EACL,2CmEkBI;AxE0wLhB;;AK/xLI;EACI,yBmEyBY;AxEywLpB;AKjyLiB;EACL,+BmEwBQ;AxE2wLpB;;AwEtwLQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AxEywLZ;AK7yLI;EACI,0BmEsCQ;AxEywLhB;AK9yLiB;EACL,+BmEqCI;AxE2wLhB;;AyEt0LA;EACI,wBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AzEy0LJ;;AyEvyLA;EAEI,qBAAA;EACA,qGACI;EAEJ,eAAA;EACA,aAAA;EACA,oEACI;EAEJ,4CAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AzEqyLJ;AKj1LI;EACI,oCoEMO;AzE60Lf;AKl1LiB;EACL,oCoEKE;AzE+0Ld;;AKv1LI;EACI,oCoEMO;AzEo1Lf;AKz1LiB;EACL,oCoEKE;AzEs1Ld;;AK91LI;EACI,yBoEQW;AzEy1LnB;AKh2LiB;EACL,yBoEOM;AzE21LlB;;AKr2LI;EACI,oCoEYK;AzE41Lb;AKv2LiB;EACL,oCoEWA;AzE81LZ;;AK52LI;EACI,yBoEcS;AzEi2LjB;AK92LiB;EACL,yBoEaI;AzEm2LhB;;AKn3LI;EACI,mCoEkBO;AzEo2Lf;AKr3LiB;EACL,mCoEiBE;AzEs2Ld;;AK13LI;EACI,wBoEoBW;AzEy2LnB;AK53LiB;EACL,wBoEmBM;AzE22LlB;;AKj4LI;EACI,mCoEwBI;AzE42LZ;AKn4LiB;EACL,mCoEuBD;AzE82LX;;AKx4LI;EACI,wBoE0BQ;AzEi3LhB;AK14LiB;EACL,wBoEyBG;AzEm3Lf;;AyEpxLI;EACI,sDAAA;AzEuxLR;AyErxLI;EACI,6BAAA;AzEuxLR;AyErxLI;EACI,sDAAA;AzEuxLR;AyErxLI;EACI,wBAAA;EACA,oCAAA;AzEuxLR;AyErxLI;EACI,kCAAA;AzEuxLR;AyEpxLI;EACI,kBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,qBAAA;EACA,WAAA;AzEsxLR;AyEnxLI;EACI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AzEqxLR;AKj7LI;EACI,2BoE8JI;AzEqxLZ;AKl7LiB;EACL,6BoE6JA;AzEuxLZ;;AyEnxLI;EACI,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AzEsxLR;AK/7LI;EACI,2BoE2KI;AzEsxLZ;AKh8LiB;EACL,6BoE0KA;AzEwxLZ;;AyEpxLI;EACI,eAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AzEuxLR;AKh9LI;EACI,uBoEyLkD;AzEyxL1D;AKj9LiB;EACL,uBoEuLqD;AzE4xLjE;;AyE1xLQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AzE6xLZ;AK79LI;EACI,yBoEMO;AzEy9Lf;AK99LiB;EACL,yBoEKE;AzE29Ld;;AyE7xLA;EACI;IACI,UAAA;EzEgyLN;EyE9xLE;IACI,UAAA;EzEgyLN;AACF;AyE7xLA;EACI;IACI,2DAAA;EzE+xLN;EyE7xLE;IACI,wBAAA;EzE+xLN;AACF;AyE5xLA;EACI;IACI,qDAAA;EzE8xLN;EyE5xLE;IACI,2DAAA;EzE8xLN;AACF;A0ElhMA;EAEI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;A1EmhMJ;AKv/LI;EAEQ,iFAAA;ALw/LZ;AKz+LiB;EAED,+EAAA;AL0+LhB;;A0EthMI;EACI,aAAA;A1EyhMR;A0EthMI;EACI,cAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;A1EwhMR;AKxgMI;EAEQ,iFAAA;ALygMZ;AK1/LiB;EAED,+EAAA;AL2/LhB;;A0ExhMA;EACI,eAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,6BAAA;EACA,6CAAA;A1E2hMJ;AK7hMI;EAEQ,iFAAA;AL8hMZ;AK/gMiB;EAED,6EAAA;ALghMhB;;A0E9hMI;EACI,YAAA;A1EiiMR;AKviMI;EAaY,0CqEDJ;A1E8hMZ;AKzhMiB;EAED,4FAAA;AL0hMhB;;AK7iMI;EAaY,0CqEQJ;A1E4hMZ;AKhiMiB;EAED,4FAAA;ALiiMhB;;AKpjMI;EAaY,0CqEkBJ;A1EyhMZ;AKviMiB;EAED,4FAAA;ALwiMhB;;A0ErhMA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;A1EwhMJ;A0EthMI;EACI,cAAA;EACA,aAAA;EACA,mBAAA;A1EwhMR;A0EthMQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;A1EwhMZ;A0EnhMQ;EACI,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;A1EqhMZ;AK5lMI;EAEQ,0FAAA;AL6lMZ;AK9kMiB;EAED,4FAAA;AL+kMhB;;A0EhhMA;EAEI,cAAA;EACA,UAAA;A1EkhMJ;;A0E/gMA;EACI,gBAAA;EACA,cAAA;EACA,WAAA;A1EkhMJ;AK7mMI;EAEQ,0FAAA;AL8mMZ;AK/lMiB;EAED,4FAAA;ALgmMhB;;A2EtpMA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gEAAA;A3EypMJ;A2EvpMI;EACI,2BAAA;EACA,cAAA;EACA,8DAAA;EACA,eAAA;EACA,sBAAA;A3EypMR;A2EvpMQ;EACI,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;A3EypMZ;AKlpMI;EAEQ,iFAAA;ALmpMZ;AKpoMiB;EAkBG,YsEtCJ;A3E2pMhB;;A2EvpMY;EACI,cAAA;EACA,WAAA;EACA,cAAA;A3E0pMhB;A2EvpMY;EACI,aAAA;EACA,mBAAA;EACA,WAAA;A3EypMhB;A2ErpMQ;EACI,gBAAA;A3EupMZ;A2EnpMI;EACI,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,sBAAA;EACA,8DAAA;A3EqpMR;A2ElpMI;EACI,+BAAA;A3EopMR;A2EnpMQ;EACI,UAAA;A3EqpMZ;A2EnpMQ;EACI,UAAA;A3EqpMZ;;A4EluMA;EAEI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;A5EouMJ;A4EjuMQ;EACI,UAAA;A5EmuMZ;A4EjuMQ;EACI,UAAA;A5EmuMZ;A4EhuMQ;EACI,mCAAA;EACA,oCAAA;A5EkuMZ;A4E/tMQ;EACI;IACI,+BAAA;E5EiuMd;AACF;A4E7tMI;EACI,UAAA;EACA,kBAAA;EACA,QAAA;EACA,oCAAA;A5E+tMR;AKztMI;EAaY,oCuEhBJ;A5E+tMZ;AK3sMiB;EAkBG,oCuErCR;A5EiuMZ;;A4E3tMA;EAEI,wBAAA;EACA,gBAJI;EAKJ,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,SAAA;EACA,qBAAA;EACA,mCAAA;EACA,kCAAA;EACA,2BAAA;EACA,mCAAA;A5E6tMJ;AsBrvMI;EACI,oEAAA;AtBuvMR;AsBlvMiB;EACL,iEAAA;AtBovMZ;;AKpvMI;EAaY,yBuEM8B;A5EquM9C;AKvuMiB;EAkBG,YuEhB8C;A5EwuMlE;;AK3vMI;EAaY,uBuESR;A5EyuMR;AK9uMiB;EAkBG,yDuEZZ;A5E2uMR;;AKnxMI;EACI,uGuE2CA;A5E2uMR;AKrxMiB;EACL,+CuE0CJ;A5E6uMR;;A4E1uMI;EACI,WAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;A5E6uMR;AKlxMI;EAaY,0CuE2BJ;A5E6uMZ;AKpwMiB;EAED,4FAAA;ALqwMhB;;A4E1uMI;EACI,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;A5E6uMR;AKhyMI;EAEQ,iFAAA;ALiyMZ;AKlxMiB;EAED,6EAAA;ALmxMhB;;A4E/uMI;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;A5EkvMR;A4E/uMI;EA1DJ;IA2DQ,gBAAA;IACA,YAAA;IACA,iBAAA;IACA,WAAA;E5EkvMN;E4EhvMM;IACI,cAAA;E5EkvMV;AACF;;A6E/1MA;EAEI,kBAAA;EACA,aAAA;EACA,4FACI;EAGJ,oBAAA;EACA,oCAAA;EACA,6CAAA;A7E81MJ;A6E51MI;EACI,mBAAA;A7E81MR;AKp0MI;EAEQ,wFAAA;ALq0MZ;AKtzMiB;EAED,wFAAA;ALuzMhB;;AK10MI;EAEQ,6FAAA;AL40MZ;AK7zMiB;EAED,4FAAA;AL8zMhB;;A6Er1MQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;A7Ew1MZ;AK31MI;EAaY,oCwEPA;A7Ew1MhB;AK70MiB;EAkBG,oCwE5BJ;A7E01MhB;;A6Ep1MI;EACI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;A7Eu1MR;AKj3MI;EAEQ,iFAAA;ALk3MZ;AKn2MiB;EAED,6EAAA;ALo2MhB;;AKv3MI;EAEQ,wFAAA;ALy3MZ;AK12MiB;EAED,4FAAA;AL22MhB;;A6E31MQ;EACI,kBAAA;EACA,cAAA;A7E81MZ;A6E11MI;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;A7E41MR;AK74MI;EAEQ,iFAAA;AL84MZ;AK/3MiB;EAED,6EAAA;ALg4MhB;;A6E91MI;EACI,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;A7Ei2MR;AsBn6MI;EACI,0DAAA;AtBq6MR;AsBh6MiB;EACL,wDAAA;AtBk6MZ;;A6Eh2MI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;A7Em2MR;AK16MI;EAEQ,iFAAA;AL26MZ;AK55MiB;EAED,6EAAA;AL65MhB;;A6Et2MQ;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wBAAA;A7Ey2MZ;A6Ev2MY;EACI,gBAAA;A7Ey2MhB;;A8E79MA;EACI,kBAAA;A9Eg+MJ;A8E99MI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;A9Eg+MR;AK78MI;EAaY,oCyE7BJ;A9Eg+MZ;AK/7MiB;EAkBG,oCyElDR;A9Ek+MZ;;A+E1/MA;EAEI,aAAA;EACA,8BAAA;EACA,uBAAA;A/E4/MJ;A+E1/MI;EACI,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;A/E4/MR;AKh+MI;EAEQ,iFAAA;ALi+MZ;AKl9MiB;EAED,+EAAA;ALm9MhB;;A+E9/MI;EACI,aAAA;EACA,SAAA;A/EigNR;A+E//MQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;A/EigNZ;AKx/MI;EAEQ,4FAAA;ALy/MZ;AK1+MiB;EAED,4FAAA;AL2+MhB;;AK9/MI;EAaY,Y0EdsC;A/EmgNtD;AKj/MiB;EAkBG,Y0EpCyC;A/EsgN7D;;A+ElgNI;EA1CJ;IA2CQ,8BAAA;E/EsgNN;E+EpgNM;IACI,iBAAA;E/EsgNV;AACF;;AgFrjNA;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,aAAA;AhFsjNJ;AKxhNI;EAEQ,4FAAA;ALyhNZ;AK1gNiB;EAED,4FAAA;AL2gNhB;;AK9hNI;EAaY,Y2EnC8B;AhFwjN9C;AKjhNiB;EAkBG,Y2EzDiC;AhF2jNrD;;AgFzjNI;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AhF4jNR;AK7iNI;EAEQ,6EAAA;AL8iNZ;AK/hNiB;EAED,+EAAA;ALgiNhB;;AgF9jNI;EACI,SAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AhFikNR;AgF9jNI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;AhFgkNR;AgF9jNQ;EACI,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AhFgkNZ;AgF9jNY;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AhFgkNhB;AK9kNI;EAEQ,6EAAA;AL+kNZ;AKhkNiB;EAED,+EAAA;ALikNhB;;AgFnkNY;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AhFskNhB;AgFnkNY;EACI,eAAA;AhFqkNhB;AgFhkNI;EACI;IACI,mBAAA;EhFkkNV;AACF;AgFhkNI;EACI;IACI,mBAAA;EhFkkNV;EgF/jNM;IACI,sBAAA;IACA,WAAA;EhFikNV;EgF/jNU;IACI,kBAAA;EhFikNd;EgFhkNc;IACI,kBAAA;EhFkkNlB;AACF;;AiFrpNA;EAEI,WANI;EAOJ,gBANO;EAOP,wBAAA;EACA,kBAAA;AjFupNJ;AK1oNI;EACI,6G4EXA;AjFupNR;AK3oNiB;EACL,6G4EZJ;AjFypNR;;AiFtpNI;EACI,kBAAA;EACA,aAhBC;EAiBD,WAnBA;EAoBA,gBAnBG;EAoBH,qBAAA;EACA,4JAAA;EAUA,sCACI;EAEJ,qCAAA;EACA,wCACI;EAEJ,kCAAA;EACA,wBAAA;AjF4oNR;AK9pNI;EACI,wM4E0BI;AjFsoNZ;AK/pNiB;EACL,sM4E6BA;AjFooNZ;;AiF9nNQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AjFioNZ;AK5pNI;EAEQ,0FAAA;AL6pNZ;AK9oNiB;EAED,4FAAA;AL+oNhB;;AiF5nNI;EACI,kBAAA;EACA,QAAA;AjF+nNR;AiF7nNQ;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AjF+nNZ;AK9qNI;EAaY,iF4EqCA;AjF+nNhB;AKhqNiB;EAkBG,+E4EgBJ;AjFioNhB;;AiF7nNQ;EACI,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,SAAA;AjFgoNZ;AiF9nNY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;AjFgoNhB;AK1sNI;EAaY,iF4EgEI;AjFgoNpB;AK5rNiB;EAkBG,+E4E2CA;AjFkoNpB;;AiF9nNY;EACI,aAAA;EACA,8BAAA;AjFioNhB;AiF/nNgB;EACI,4BAAA;AjFioNpB;AiF/nNgB;EACI,eAAA;AjFioNpB;AK3tNI;EAEQ,iFAAA;AL4tNZ;AK7sNiB;EAkBG,Y4E+DA;AjF+nNpB;;AiF3nNgB;EACI,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;AjF8nNpB;AiF3nNgB;EACI,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;AjF6nNpB;;AkFrxNI;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;AlFwxNR;AkFtxNQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AlFwxNZ;AKhwNI;EAEQ,iFAAA;ALiwNZ;AKlvNiB;EAkBG,Y6EvDJ;AlF0xNhB;;AkFtxNY;EACI,kBAAA;AlFyxNhB;AkFtxNY;EACI,gBAAA;AlFwxNhB;AkFpxNQ;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;AlFsxNZ;AgDtzNI;EACI,YAAA;AhDwzNR;AgDpzNQ;EACI,YAAA;AhDszNZ;;AkFzxNY;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AlF4xNhB;AKpyNI;EAEQ,iFAAA;ALqyNZ;AKtxNiB;EAkBG,Y6EvBA;AlF8xNpB;;AkFzxNY;EACI,aAAA;AlF4xNhB;AkFzxNY;EACI,aAAA;EACA,eAAA;EACA,SAAA;AlF2xNhB;AkFzxNgB;EACI,cAAA;AlF2xNpB;;AmF11NI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AnF61NR;;AoFh2NI;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;ApFm2NR;AKr0NI;EAEQ,iFAAA;ALs0NZ;AKvzNiB;EAkBG,Y+EhEmC;ApFw2NvD;;AoFr2NI;EACI,kBAAA;EACA,aAAA;ApFw2NR;AoFt2NQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;ApFw2NZ;AKv1NI;EAEQ,+EAAA;ALw1NZ;AKz0NiB;EAkBG,Y+ElD2C;ApF42N/D;;AoFz2NQ;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;ApF42NZ;AoFz2NY;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ApF22NhB;AoFv2NQ;EACI,iBAAA;EACA,iBAAA;EACA,gBAAA;ApFy2NZ;AoFv2NQ;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;ApFy2NZ;AoFv2NY;EACI,cAAA;ApFy2NhB;AoFr2NQ;EACI,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;ApFu2NZ;AK94NI;EACI,mB+EuCmD;ApFy2N3D;AK/4NiB;EACL,qB+EqCqD;ApF42NjE;;AKn4NI;EAEQ,wFAAA;ALq4NZ;AKt3NiB;EAgBG,0DAAA;ALy2NpB;;AoFh3NY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;ApFm3NhB;AoFj3NgB;EACI,aAAA;EACA,mBAAA;EACA,WAAA;ApFm3NpB;AoF/2NY;EACI,gBAAA;ApFi3NhB;AoF92NY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ApFg3NhB;;AqF38NA;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ArF88NJ;;AqF38NA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;ArF88NJ;AK37NI;EAEQ,iFAAA;AL47NZ;AK76NiB;EAkBG,YgFrD+B;ArFm9NnD;;AqFh9NA;EACI,WAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;ArFm9NJ;AK18NI;EAaY,yBgFrB8B;ArFq9N9C;AK57NiB;EAkBG,YgF3C8C;ArFw9NlE;;AgDj/NI;EACI,YAAA;AhDo/NR;AgDh/NQ;EACI,YAAA;AhDk/NZ;;AqF59NI;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ArF+9NR;AKh+NI;EAEQ,iFAAA;ALi+NZ;AKl9NiB;EAkBG,YgFjCmC;ArFo+NvD;;AqFl+NQ;EACI,kBAAA;ArFq+NZ;AqFl+NQ;EACI,gBAAA;ArFo+NZ;AqFh+NI;EACI,iBAAA;ArFk+NR;AqF/9NI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;ArFi+NR;AgDxhOI;EACI,YAAA;AhD0hOR;AgDthOQ;EACI,YAAA;AhDwhOZ;;AqFp+NQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ArFu+NZ;AKtgOI;EAEQ,iFAAA;ALugOZ;AKx/NiB;EAkBG,YAAA;ALy+NpB;;AqFp+NQ;EACI,aAAA;ArFu+NZ;AqFp+NQ;EACI,aAAA;EACA,eAAA;EACA,SAAA;ArFs+NZ;AqFp+NY;EACI,0BAAA;ArFs+NhB;AqFj+NI;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ArFm+NR;AKhiOI;EAEQ,wFAAA;ALiiOZ;AKlhOiB;EAgBG,0DAAA;ALqgOpB;;AKtiOI;EAEQ,iFAAA;ALwiOZ;AKzhOiB;EAkBG,YgF4BmC;ArF8+NvD;;AqF5+NQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ArF++NZ;AqF5+NQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;ArF8+NZ;AKhkOI;EAaY,uBgFwEA;ArF8+NhB;AKljOiB;EAED,4FAAA;ALmjOhB;;AqF3+NQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;ArF8+NZ;AKhlOI;EAaY,uBgFwFA;ArF8+NhB;AKlkOiB;EAED,4FAAA;ALmkOhB;;AqF5+NY;EACI,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;ArF++NhB;AqF7+NgB;EACI,iBAAA;EACA,gBAAA;ArF++NpB;AqF7+NgB;EACI,iBAAA;EACA,gBAAA;ArF++NpB;;AsF3oOI;EACI,aAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AtF8oOR;AKhnOI;EAaY,uBiF1C6C;AtFgpO7D;AKlmOiB;EAgBG,0DAAA;ALqlOpB;;AKtnOI;EAEQ,iFAAA;ALwnOZ;AKzmOiB;EAkBG,YiF/DmC;AtFypOvD;;AsFvpOQ;EACI,YAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AtF0pOZ;AsFxpOY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AtF0pOhB;AsFtpOQ;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,eAAA;AtFwpOZ;AsFtpOY;EACI,iBAAA;EACA,gBAAA;AtFwpOhB;AsFrpOY;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;AtFupOhB;AsFppOY;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;AtFspOhB;AsFppOgB;EACI,gBAAA;EACA,iBAAA;AtFspOpB;AsFjpOQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AtFmpOZ;AsFhpOQ;EACI,oBAAA;EACA,gBAAA;AtFkpOZ;AKlrOI;EAaY,6BiFsBA;AtFkpOhB;AKpqOiB;EAkBG,6BiFCJ;AtFopOhB;;AsFlpOY;EACI,uCAAA;AtFqpOhB;AK5rOI;EAEQ,sFAAA;AL6rOZ;AK9qOiB;EAED,wFAAA;AL+qOhB;;AsFjpOQ;EACI,WAAA;AtFopOZ;AsFlpOY;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AtFopOhB;AsFjpOY;EACI,iBAAA;AtFmpOhB;AsFjpOgB;EACI,iBAAA;AtFmpOpB;AsFhpOgB;EACI,kBAAA;EACA,iBAAA;AtFkpOpB;AsF/oOgB;EACI,iBAAA;AtFipOpB;AsF7oOY;EACI,iBAAA;AtF+oOhB;AsF3oOQ;EArHJ;IAsHQ,aAAA;IACA,iDACI;IAEJ,gBAAA;IACA,eAAA;EtF4oOV;EsF1oOU;IACI,gBAAA;IACA,YAAA;IACA,aAAA;IACA,cAAA;EtF4oOd;EsFzoOU;IACI,eAAA;IACA,UAAA;IACA,WAAA;EtF2oOd;EsFzoOc;IACI,aAAA;EtF2oOlB;EsFzoOc;IACI,aAAA;EtF2oOlB;EsFvoOU;IACI,eAAA;EtFyoOd;AACF;;AuFrxOA;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;AvFwxOJ;;AuFrxOA;EAEI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;AvFuxOJ;AK7wOI;EAaY,yBkFtB8B;AvFyxO9C;AK/vOiB;EAkBG,YkF5C8C;AvF4xOlE;;AuF1xOI;EACI,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AvF6xOR;AuF3xOQ;EACI,iBAAA;EACA,gBAAA;AvF6xOZ;AuF3xOQ;EACI,iBAAA;EACA,gBAAA;AvF6xOZ;AuFzxOI;EACI,iBAAA;EACA,cAAA;EACA,wBAAA;AvF2xOR;AKxyOI;EAEQ,4FAAA;ALyyOZ;AK1xOiB;EAED,0FAAA;AL2xOhB;;AuFvxOI;EA5CJ;IA6CQ,eAAA;IACA,gBAAA;IACA,iBAAA;EvF2xON;EuFzxOM;IACI,sBAAA;EvF2xOV;AACF;;AwFh2OA;EAEI,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,0EACI;EAEJ,sBAAA;EACA,sBAAA;AxFg2OJ;AKl0OI;EAaY,yBmF1C8B;AxFk2O9C;AKpzOiB;EAkBG,YmFhE8C;AxFq2OlE;;AwFn2OI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AxFs2OR;AKt1OI;EAEQ,0FAAA;ALu1OZ;AKx0OiB;EAED,4FAAA;ALy0OhB;;AwFn2OI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;AxFs2OR;AwFn2OI;EACI,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;AxFq2OR;AwFn2OQ;EACI,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AxFq2OZ;AKl3OI;EAEQ,iFAAA;ALm3OZ;AKp2OiB;EAED,+EAAA;ALq2OhB;;AwFl2OQ;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AxFq2OZ;AwFl2OQ;EACI,eAAA;AxFo2OZ;;AyFp6OA;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;AzFu6OJ;AK94OI;EAaY,yBoFrC8B;AzFy6O9C;AKh4OiB;EAkBG,YoF3D8C;AzF46OlE;;A0Fx7OI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;A1F27OR;AKj6OI;EAEQ,0FAAA;ALk6OZ;AKn5OiB;EAED,4FAAA;ALo5OhB;;AKv6OI;EAEQ,iFAAA;ALy6OZ;AK15OiB;EAED,+EAAA;AL25OhB;;AsBr7OI;EACI,mEAAA;AtBw7OR;AsBn7OiB;EACL,wDAAA;AtBq7OZ;;A0Fp8OQ;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;A1Fu8OZ;A0Fp8OQ;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;A1Fs8OZ;A0Fn8OQ;EACI,gBAAA;A1Fq8OZ;;A2F1+OI;EACI,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,oCAAA;A3F6+OR;AKl9OI;EAaY,0CsFrCJ;A3F6+OZ;AKp8OiB;EAED,4FAAA;ALq8OhB;;AKz+OI;EACI,YsFF4C;A3F8+OpD;AK3+OiB;EACL,YsFJ8C;A3Fi/O1D;;AK/9OI;EAaY,6BsF5BA;A3Fk/OhB;AKl9OiB;EAkBG,6BsFjDJ;A3Fo/OhB;;AsB7+OI;EACI,0DAAA;AtBg/OR;AsB3+OiB;EACL,wDAAA;AtB6+OZ;;A4FphPA;EACI,aAAA;EACA,kBAAA;EACA,QAAA;A5FuhPJ;A4FphPQ;EACI,UAAA;A5FshPZ;AKt/OI;EAEQ,wFAAA;ALu/OZ;AKx+OiB;EAkBG,wDuF5DZ;A5FqhPR;;A4FlhPI;EAjBJ;IAkBQ,cAAA;E5FshPN;AACF;A4FphPI;EACI,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,oCAAA;A5FshPR;;A6FnjPA;EAEI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,6DACI;EAGJ,YAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;A7FkjPJ;AK/hPI;EAaY,oCwF7BR;A7FkjPR;AKjhPiB;EAkBG,8BwFlDZ;A7FojPR;;A6FjjPI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;A7FojPR;AK3iPI;EAaY,0F8DXR;AnE4iPR;AK7hPiB;EAkBG,uD8D3BZ;AnEyiPR;;AmEtiPI;EACI,WAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,oNArDsB;EAsDtB,0BAAA;EACA,4BAAA;AnEyiPR;AmEtiPI;EACI,UAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,+BAAA;AnEwiPR;AKplPI;EACI,0B8D4C4C;AnE0iPpD;AKrlPiB;EACL,2B8D0CoD;AnE6iPhE;;AK1lPI;EACI,Y8D6CqC;AnEgjP7C;AK5lPiB;EACL,Y8D2CsC;AnEmjPlD;;AmE/iPQ;EACI,YAAA;EACA,8OA3DiB;AnE6mP7B;;A6F1lPI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,qCAAA;A7F6lPR;AK9lPI;EAaY,0F8DXR;AnE+lPR;AKhlPiB;EAkBG,uD8D3BZ;AnE4lPR;;AmEzlPI;EACI,WAAA;EACA,UAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,oNArDsB;EAsDtB,0BAAA;EACA,4BAAA;AnE4lPR;AmEzlPI;EACI,UAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,+BAAA;AnE2lPR;AKvoPI;EACI,0B8D4C4C;AnE6lPpD;AKxoPiB;EACL,2B8D0CoD;AnEgmPhE;;AK7oPI;EACI,Y8D6CqC;AnEmmP7C;AK/oPiB;EACL,Y8D2CsC;AnEsmPlD;;AmElmPQ;EACI,YAAA;EACA,8OA3DiB;AnEgqP7B;;A6FpoPQ;EAEI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,aALO;EAMP,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;A7FsoPZ;A6FpoPY;EACI,cAZG;EAaH,aAbG;A7FmpPnB;AKxpPI;EAEQ,+EAAA;ALypPZ;AK1oPiB;EAED,+EAAA;AL2oPhB;;A6FtoPI;EACI,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;A7FyoPR;A6FvoPQ;EACI,aAAA;EACA,WAAA;EACA,UAAA;A7FyoPZ;A6FvoPY;EACI,aAAA;A7FyoPhB;A6FpoPI;EACI,kBAAA;EACA,UAAA;A7FsoPR;A6FnoPI;EACI,kBAAA;EACA,UAAA;A7FqoPR;A6FloPI;EAxFJ;IAyFQ,aAAA;IACA,8CACI;IAEJ,UAAA;IACA,sGACI;E7FkoPV;E6F9nPM;IACI,iEAAA;IACA,mBAAA;E7FgoPV;E6F9nPU;IACI,oBAAA;IACA,YAAA;E7FgoPd;E6F7nPU;IACI,eAAA;IACA,qBAAA;IACA,UAAA;IACA,UAAA;E7F+nPd;E6F3nPM;IACI,aAAA;IACA,2BAAA;IACA,eAAA;E7F6nPV;E6F3nPU;IACI,aAAA;E7F6nPd;E6F1nPU;IACI,WAAA;E7F4nPd;E6F1nPc;IACI,cAAA;IACA,kBAAA;E7F4nPlB;E6FvnPM;IACI,SAAA;E7FynPV;E6FtnPM;IACI,aAAA;E7FwnPV;AACF;;A6FpnPA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;A7FunPJ;AKpvPI;EAEQ,iFAAA;ALqvPZ;AKtuPiB;EAED,6EAAA;ALuuPhB;;A8F3wPA;EACI,wBAAA;A9F8wPJ;;A8FtwPI;EACI,ybAAA;A9FywPR;A8F7vPQ;EACI,6HAAA;A9F+vPZ;A8FzvPY;EACI,YAAA;A9F2vPhB;A8F1vPgB;EACI,+BAAA;A9F4vPpB;A8FtvPoB;EACI,+BAAA;A9FwvPxB;A8FnvPY;EACI,+BAAA;EACA,6HAAA;EAKA,yHAAA;A9FivPhB;A8F1uPoB;EACI,+BAAA;A9F4uPxB;A8FvuPY;EACI,YAAA;A9FyuPhB;A8FxuPgB;EACI,+BAAA;A9F0uPpB;A8FruPQ;EACI,4GAAA;A9FuuPZ;A8FnuPY;EACI,+BAAA;EACA,6HAAA;A9FquPhB;A8FhuPgB;EACI,+BAAA;A9FkuPpB;A8F5tPY;EACI,gBAAA;EACA,6HAAA;A9F8tPhB;A8FztPgB;EACI,uDAAA;A9F2tPpB;A8FrtPgB;EACI,yBAAA;A9FutPpB;A8FrtPgB;EACI,yBAAA;A9FutPpB;A8FrtPgB;EACI,+BAAA;A9FutPpB;A8FjtPY;EACI,gBAAA;EACA,6HAAA;A9FmtPhB;A8F9sPgB;EACI,yBAAA;A9FgtPpB;A8F9sPgB;EACI,+BAAA;A9FgtPpB;A8F5sPoB;EACI,cAAA;A9F8sPxB;A8F3sPgB;EACI,yBAAA;A9F6sPpB;;A8FtsPA;EACI,cAAA;EACA,sBAAA;EACA,6XAAA;EASA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;A9FisPJ;A8F/rPI;EACI,kBAAA;EACA,eAAA;EACA,mIAAA;EAEA,qCAAA;EACA,0CAAA;A9FgsPR;A8F9rPQ;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,4GAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iEACI;A9F+rPhB;A8F5rPY;EACI,4GAAA;EAEA,cADO;EAEP,aAFO;EAGP,iBAHO;A9FgsPvB;A8FzrPQ;EACI,kBAAA;EACA,aAAA;EACA,6BAAA;A9F2rPZ;A8FtrPY;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kHAAA;A9FwrPhB;A8FlrPgB;EACI,4GAAA;EAMA,cADO;EAEP,aAFO;EAGP,iBAHO;EAIP,qBAAA;A9F+qPpB;A8F1qPQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,kHAAA;EACA,2HAAA;EAKA,wBAAA;EACA,2BAAA;EACA,mHAAA;A9FwqPZ;A8FtqPY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;A9FwqPhB;A8FtqPgB;EACI,4GAAA;EAKA,cADO;EAEP,aAFO;EAGP,iBAHO;EAIP,mBAJO;EAKP,oBAAA;A9FoqPpB;A8FhqPY;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;A9FkqPhB;A8F9pPQ;EACI,kBAAA;EACA,4GAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gCAAA;A9FgqPZ;A8F9pPY;EACI,kBAAA;EACA,kHAAA;EAMA,cADO;EAEP,aAFO;EAGP,iBAHO;A9F8pPvB;A8FtpPI;EACI,kHAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gCAAA;A9FwpPR;A8FrpPI;EACI,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;A9FupPR;A8FrpPQ;EACI,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,0CAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4GAAA;A9FupPZ;A8FrpPY;EACI,4GAAA;EAEA,cADO;EAEP,aAFO;EAGP,iBAHO;EAIP,qBAAA;EACA,kBAAA;A9FspPhB;A8FjpPI;EACI,mBAAA;EACA,cAAA;EACA,eAAA;A9FmpPR;A8FjpPQ;EACI,aAAA;EACA,qBAAA;EACA,0CAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,sBAAA;EACA,sIAAA;EAEA,qCAAA;A9FkpPZ;A8FhpPY;EACI,qHAAA;EAIA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,2CAAA;EACA,gBAAA;A9F+oPhB;A8F7oPgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A9F+oPpB;A8F5oPY;EACI,kHAAA;EAKA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;A9F0oPhB;A8FxoPY;EACI,aAAA;EACA,qBAAA;EACA,kHAAA;EAKA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;A9FsoPhB;A8FroPgB;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;A9FuoPpB;A8FpoPY;EACI,kHAAA;EAKA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gCAAA;A9FkoPhB;A8F7nPI;EACI,mBAAA;EACA,YAAA;EACA,qBAAA;A9F+nPR;A8F7nPQ;EACI,kBAAA;EACA,qBAAA;EACA,0CAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,sIAAA;EAEA,qCAAA;A9F8nPZ;A8F5nPY;EACI,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;A9F8nPhB;A8F5nPY;EACI,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;A9F8nPhB;A8F3nPY;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;A9F6nPhB;A8FznPgB;EACI,cAAA;EAEA,cADO;EAEP,aAFO;EAGP,iBAHO;A9F6nP3B;A8FtnPY;EACI,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;A9FwnPhB;A8FnnPI;EACI,uHAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,2CAAA;A9FqnPR;;A+FnnQA;EACI,wBAAA;A/FsnQJ;;A+F9mQI;EACI,ybAAA;A/FinQR;A+FpmQY;EACI,2GAAA;A/FsmQhB;A+FpmQgB;EACI,gHAAA;A/FsmQpB;A+F7lQQ;EACI,cAAA;EACA,YAAA;EACA,uHAAA;A/F+lQZ;A+FtlQgB;EAKI,0CAAA;A/FolQpB;A+FzkQQ;EACI,+BAAA;A/F2kQZ;A+F1kQY;EACI,+BAAA;A/F4kQhB;A+FxkQQ;EACI,uHAAA;A/F0kQZ;A+FrkQY;EACI,YAAA;A/FukQhB;A+FrkQY;EACI,YAAA;A/FukQhB;A+FnkQQ;EACI,+BAAA;A/FqkQZ;A+FpkQY;EACI,+BAAA;A/FskQhB;A+FlkQQ;EACI,oBAAA;EACA,iEAAA;A/FokQZ;A+FlkQY;EACI,2CAAA;EACA,sCAAA;A/FokQhB;A+FnkQgB;EACI,YAAA;A/FqkQpB;A+FnkQgB;EACI,4GAAA;EAIA,qHAAA;A/FkkQpB;;A+FxjQA;EACI,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,yPAAA;EAKA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,2CAAA;A/FujQJ;A+FrjQI;EACI,YAAA;A/FujQR;A+FrjQQ;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;EACA,kHAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gCAAA;A/FujQZ;A+FrjQY;EACI,4GAAA;EAEA,cADO;EAEP,aAFO;EAGP,iBAHO;A/FyjQvB;A+FjjQI;EACI,+EAAA;EAIA,qBAAA;EACA,mBAAA;A/FgjQR;A+F3iQY;EACI,cAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,qHAAA;EAIA,4CAAA;EACA,gBAAA;A/F0iQhB;A+FxiQgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A/F0iQpB;A+FtiQQ;EACI,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,qCAAA;A/FwiQZ;A+FtiQY;EACI,uBAAA;EACA,cAAA;EACA,SAAA;EACA,qBAAA;A/FwiQhB;A+FniQI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;A/FqiQR;A+FniQQ;EACI,yBAAA;EAEA,cADO;EAEP,aAFO;EAGP,iBAHO;A/FuiQnB;A+FhiQI;EACI,0CAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;A/FkiQR;A+FhiQQ;EACI,iBAAA;EACA,gBAAA;EACA,4GAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;A/FkiQZ;A+FhiQQ;EACI,iBAAA;EACA,gBAAA;EACA,yBAAA;A/FkiQZ;A+FhiQY;EACI,cAAA;EACA,mBAAA;A/FkiQhB;A+F7hQI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4GAAA;EACA,SAAA;A/F+hQR;A+F7hQQ;EACI,4GAAA;EAEA,cADO;EAEP,aAFO;EAGP,iBAHO;A/FiiQnB;A+F1hQI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,6OAAA;EAIA,aAAA;EACA,qBAAA;A/FyhQR;A+FvhQQ;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,mHAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;EACA,2CAAA;EACA,2HAAA;A/FyhQZ;A+FnhQY;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kHAAA;EAKA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;A/FihQhB;A+F/gQgB;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;A/FihQpB;A+F7gQY;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,uHAAA;A/F+gQhB;;AgGp3QA;EACI,iCAAA;EACA,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;AhGu3QJ;;AgG91QA;EACI,wBAAA;AhGi2QJ;;AgG91QA;EAEI,sBAAA;EACA,WAAA;EACA,oCAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AhGg2QJ;AKt3QI;EAEQ,4FAAA;ALu3QZ;AKx2QiB;EAED,4FAAA;ALy2QhB;;AgG71QI;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,6CAAA;AhGg2QR;AK34QI;EAaY,Y2F+BkC;AhGk2QlD;AK73QiB;EAkBG,Y2FSqC;AhGq2QzD;;AgGl2QY;EACI,YAAA;EAEA,cADO;EAEP,aAFO;EAGP,iBAHO;AhGu2QvB;AKx5QI;EAaY,0C2F8CA;AhGg2QhB;AK14QiB;EAkBG,oC2FyBJ;AhGk2QhB;;AK95QI;EAaY,0C2FsDA;AhG+1QhB;AKj5QiB;EAkBG,uB2FiCJ;AhGi2QhB;;AKr6QI;EAEQ,+EAAA;ALu6QZ;AKx5QiB;EAkBG,Y2FmCuC;AhGs2Q3D;;AK56QI;EAEQ,+EAAA;AL86QZ;AK/5QiB;EAkBG,Y2FqC2C;AhG22Q/D;;AgGp2QA;EAEI,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gEAAA;EACA,uBAAA;EAEA,gIACI;AhGo2QR;AKp8QI;EAaY,iC2FuFR;AhGm2QR;AKt7QiB;EAkBG,iC2FkEZ;AhGq2QR;;AgGl2QI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,qBAAA;EACA,gBAAA;AhGq2QR;AgGn2QQ;EACI,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AhGq2QZ;AgGl2QgB;EAEI,cADO;EAEP,aAFO;EAGP,iBAHO;EAIP,oBAAA;AhGm2QpB;AgG/1QgB;EAEI,cADO;EAEP,aAFO;EAGP,iBAHO;EAIP,oBAAA;AhGg2QpB;AgG91QoB;EACI,kFAAA;AhGg2QxB;AgGx1QI;EACI,cAAA;EACA,gBAAA;AhG01QR;AgGv1QI;EACI,wCAAA;AhGy1QR;;AgGr1QA;EACI;IACI,2BAAA;EhGw1QN;EgGt1QE;IACI,oCAAA;EhGw1QN;EgGt1QE;IACI,oCAAA;EhGw1QN;EgGt1QE;IACI,oCAAA;EhGw1QN;EgGt1QE;IACI,2BAAA;EhGw1QN;AACF;AiG1iRA;;;CAAA;A5FoCI;EAEQ,0FAAA;AL2gRZ;AK5/QiB;EAkBG,oC4F7DJ;AjG0iRhB;;AiGriRQ;EACI,gBAAA;AjGwiRZ;AKphRI;EAaY,wC4F9BA;AjGwiRhB;AKtgRiB;EAED,0FAAA;ALugRhB;;AiGniRA;EACI,aAAA;EACA,2DAAA;EACA,6DAAA;AjGsiRJ;AKhiRI;EAaY,yB4FlB8B;AjGwiR9C;AKlhRiB;EAkBG,Y4FxC8C;AjG2iRlE;;AiGziRI;EACI,UAAA;EACA,gBAAA;AjG4iRR;AiGziRI;EACI,UAAA;EACA,YAAA;EACA,qCAAA;AjG2iRR;AKhjRI;EAEQ,sFAAA;ALijRZ;AKliRiB;EAED,wFAAA;ALmiRhB;;AKtjRI;EAaY,0C4FCJ;AjG4iRZ;AKziRiB;EAED,4FAAA;AL0iRhB;;AiG1iRQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,sBAAA;AjG6iRZ;AiG3iRY;EARJ;IASQ,wBAAA;EjG8iRd;AACF;AiG5iRY;EACI,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AjG8iRhB;AKplRI;EAEQ,iFAAA;ALqlRZ;AKtkRiB;EAED,6EAAA;ALukRhB;;AiG3iRQ;EACI,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AjG8iRZ;AiG1iRI;EAjEJ;IAkEQ,cAAA;IACA,gBAAA;EjG6iRN;EiGziRU;IACI,UAAA;IACA,+BAAA;IACA,8HACI;EjG0iRlB;EiGviRU;IACI,4FAAA;EjGyiRd;EiGjiRM;IACI,4BAAA;EjGmiRV;EiGliRU;IACI,UAAA;EjGoiRd;EiGhiRM;IACI,kBAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,+DAAA;IACA,UAAA;IACA,UAAA;IACA,mDAAA;IACA,gLACI;EjGiiRd;AACF;AiG9hRY;EAdJ;IAeQ,qEAAA;EjGiiRd;AACF;AiG9kRI;EAgDI;IACI,aAAA;IACA,sBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,gEAAA;EjGiiRV;EiG/hRU;IACI,aAAA;IACA,eAAA;IACA,mBAAA;IACA,sBAAA;IACA,uCAAA;EjGiiRd;EKvpRE;IAEQ,sFAAA;ELwpRV;EKzoRe;IAED,wFAAA;EL0oRd;AACF;;AkGnsRA;EACI,aAAA;EACA,4CACI;AlGqsRR;AKnqRI;EAaY,yB6F7C8B;AlGssR9C;AKrpRiB;EAkBG,Y6FnE8C;AlGysRlE;;AkGvsRI;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;AlG0sRR;AkGvsRI;EACI,UAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;AlGysRR;AK5rRI;EAEQ,sFAAA;AL6rRZ;AK9qRiB;EAED,wFAAA;AL+qRhB;;AKlsRI;EAaY,0C6FjBJ;AlG0sRZ;AKrrRiB;EAED,4FAAA;ALsrRhB;;AmG9uRA;EAEI,eAAA;EACA,kBAAA;EACA,YANK;EAOL,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,gCAAA;EACA,qEACI;AnG+uRR;AK7tRI;EAEQ,iFAAA;AL8tRZ;AK/sRiB;EAED,+EAAA;ALgtRhB;;AKnuRI;EAaY,yB8F5BqC;AnGsvRrD;AKttRiB;EAkBG,yB8FlDiC;AnGyvRrD;;AmGvvRI;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,6CAAA;AnG0vRR;AKrvRI;EAaY,6B8FjB6C;AnG4vR7D;AKvuRiB;EAkBG,6B8FvCyC;AnG+vR7D;;AmG5vRI;EACI,eAAA;EACA,YAAA;AnG+vRR;AKhwRI;EAEQ,wFAAA;ALiwRZ;AKlvRiB;EAED,0FAAA;ALmvRhB;;AKtwRI;EAEQ,iFAAA;ALwwRZ;AKzvRiB;EAED,+EAAA;AL0vRhB;;AK7wRI;EAEQ,0FAAA;AL+wRZ;AKhwRiB;EAED,0FAAA;ALiwRhB;;AKpxRI;EAEQ,iFAAA;ALsxRZ;AKvwRiB;EAED,+EAAA;ALwwRhB;;AK3xRI;EAEQ,iFAAA;AL6xRZ;AK9wRiB;EAED,6EAAA;AL+wRhB;;AKlyRI;EAEQ,0FAAA;ALoyRZ;AKrxRiB;EAED,4FAAA;ALsxRhB;;AKzyRI;EAEQ,iFAAA;AL2yRZ;AK5xRiB;EAED,6EAAA;AL6xRhB;;AmGpwRI;EACI,oBAAA;AnGuwRR;AKpzRI;EAEQ,+EAAA;ALqzRZ;AKtyRiB;EAED,6EAAA;ALuyRhB;;AK1zRI;EAEQ,0FAAA;AL4zRZ;AK7yRiB;EAED,4FAAA;AL8yRhB;;AKj0RI;EAEQ,iFAAA;ALm0RZ;AKpzRiB;EAED,6EAAA;ALqzRhB;;AmGvwRI;EACI,oBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AnG0wRR;AKh1RI;EAEQ,iFAAA;ALi1RZ;AKl0RiB;EAED,+EAAA;ALm0RhB;;AmG7wRQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AnGgxRZ;AmG3wRQ;EACI,YAAA;AnG6wRZ;AmG3wRQ;EACI,YAAA;AnG6wRZ;;AoGx4RA;EACI,aAAA;EACA,+CACI;ApG04RR;AKx2RI;EAaY,yB+F7C8B;ApG24R9C;AK11RiB;EAkBG,Y+FnE8C;ApG84RlE;;AoG54RI;EACI,UAAA;EACA,WAAA;ApG+4RR;AoG54RI;EACI,UAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;ApG84RR;AK33RI;EAEQ,sFAAA;AL43RZ;AK72RiB;EAED,sFAAA;AL82RhB;;AKj4RI;EAWY,wDAAA;AL03RhB;AKp3RiB;EAED,4FAAA;ALq3RhB;;AqGx6RA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;ArG26RJ;AKj5RI;EAaY,yBgGtC8B;ArG66R9C;AKn4RiB;EAkBG,YgG5D8C;ArGg7RlE;;AqG96RI;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;ArGi7RR;;AsGp8RA;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,gBAAA;AtGu8RJ;AKj7RI;EAEQ,wFAAA;ALk7RZ;AKn6RiB;EAkBG,0DiGrDZ;AtGy8RR;;AKv7RI;EAEQ,oFAAA;ALy7RZ;AK16RiB;EAED,wFAAA;AL26RhB;;AsBr8RI;EACI,kEAAA;AtBw8RR;AsBn8RiB;EACL,wDAAA;AtBq8RZ;;AsGl9RI;EACI,cAAA;EACA,qBAAA;EACA,0BAAA;AtGq9RR;AK38RI;EAEQ,0FAAA;AL48RZ;AK77RiB;EAED,4FAAA;AL87RhB;;AsGl9RI;EACI,UAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;AtGq9RR;AsGl9RI;EACI,UAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AtGo9RR;AsGl9RQ;EACI,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AtGo9RZ;AKz+RI;EAEQ,0FAAA;AL0+RZ;AK39RiB;EAED,4FAAA;AL49RhB;;AsGl9RY;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AtGq9RhB;AsGj9RQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;AtGm9RZ;AsGj9RY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AtGm9RhB;AKtgSI;EAEQ,+EAAA;ALugSZ;AKx/RiB;EAED,6EAAA;ALy/RhB;;AsGr9RY;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AtGw9RhB;AKthSI;EAEQ,+EAAA;ALuhSZ;AKxgSiB;EAED,+EAAA;ALygShB;;AsGx9RI;EACI,UAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,yBAAA;AtG29RR;AsGz9RQ;;EAEI,aAAA;EACA,8BAAA;AtG29RZ;AsGx9RQ;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AtG09RZ;AKtjSI;EAEQ,iFAAA;ALujSZ;AKxiSiB;EAED,iFAAA;ALyiShB;;AsGt9RQ;EACI,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AtGy9RZ;AKpkSI;EAEQ,iFAAA;ALqkSZ;AKtjSiB;EAED,iFAAA;ALujShB;;AuG7mSA;EAEI,eAAA;EACA,cAAA;EACA,WAAA;EACA,cAPK;EAQL,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,6BAAA;EACA,qKACI;AvG8mSR;AK9lSI;EAEQ,iFAAA;AL+lSZ;AKhlSiB;EAED,6EAAA;ALilShB;;AuG7mSI;EACI,eAAA;EACA,YAAA;AvGgnSR;AKzmSI;EAEQ,wFAAA;AL0mSZ;AK3lSiB;EAED,0FAAA;AL4lShB;;AK/mSI;EAaY,0CkGVJ;AvGgnSZ;AKlmSiB;EAED,4FAAA;ALmmShB;;AKtnSI;EAEQ,iFAAA;ALwnSZ;AKzmSiB;EAED,6EAAA;AL0mShB;;AK7nSI;EAEQ,iFAAA;AL+nSZ;AKhnSiB;EAED,6EAAA;ALinShB;;AKpoSI;EAaY,oCkGUJ;AvGinSZ;AKvnSiB;EAED,4FAAA;ALwnShB;;AK3oSI;EAEQ,iFAAA;AL6oSZ;AK9nSiB;EAED,6EAAA;AL+nShB;;AKlpSI;EAEQ,iFAAA;ALopSZ;AKroSiB;EAED,6EAAA;ALsoShB;;AuGlnSI;EACI,mBAAA;AvGqnSR;AK7pSI;EAEQ,iFAAA;AL8pSZ;AK/oSiB;EAED,6EAAA;ALgpShB;;AuGxnSQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AvG2nSZ;;AwG/sSA;EAEI,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,6BAAA;EACA,qKACI;AxGgtSR;AK3rSI;EAaY,0CmG3BR;AxG4sSR;AK7qSiB;EAED,4FAAA;AL8qShB;;AKjsSI;EAaY,yBmGrBR;AxG6sSR;AKprSiB;EAED,wFAAA;ALqrShB;;AKxsSI;EAEQ,+EAAA;AL0sSZ;AK3rSiB;EAED,+EAAA;AL4rShB;;AK/sSI;EAaY,0CmGZJ;AxGktSZ;AKlsSiB;EAED,4FAAA;ALmsShB;;AKttSI;EAaY,yBmGNJ;AxGmtSZ;AKzsSiB;EAED,wFAAA;AL0sShB;;AK7tSI;EAEQ,+EAAA;AL+tSZ;AKhtSiB;EAED,6EAAA;ALitShB;;AKpuSI;EAaY,uBmGKJ;AxGstSZ;AKvtSiB;EAED,4FAAA;ALwtShB;;AK3uSI;EAaY,yBmGWJ;AxGutSZ;AK9tSiB;EAED,wFAAA;AL+tShB;;AKlvSI;EAEQ,+EAAA;ALovSZ;AKruSiB;EAED,6EAAA;ALsuShB;;AwG1tSI;EACI,cAAA;EACA,WAAA;AxG6tSR;AK9vSI;EAEQ,0FAAA;AL+vSZ;AKhvSiB;EAED,0FAAA;ALivShB;;AwG/tSI;EACI,aAAA;EACA,WAAA;EACA,mBAAA;AxGkuSR;AwGhuSQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AxGkuSZ;AKjxSI;EAEQ,0FAAA;ALkxSZ;AKnwSiB;EAED,0FAAA;ALowShB;;AwGruSY;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AxGwuShB;AwGpuSQ;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AxGsuSZ;AwGpuSY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AxGsuShB;AwGnuSY;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AxGquShB;;AyGj1SA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AzGo1SJ;AyGl1SI;EANJ;IAOQ,aAAA;EzGq1SN;AACF;;A0G/1SQ;EACI,oBAAA;A1Gk2SZ;A0G71SQ;EACI,gBAAA;A1G+1SZ;A0G51SgB;EACI,oCAAA;A1G81SpB;A0Gx1SI;EACI,cAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;A1G01SR;AKn1SI;EAEQ,iFAAA;ALo1SZ;AKr0SiB;EAED,+EAAA;ALs0ShB;;A0G71SQ;EACI,kBAAA;EACA,kBAAA;A1Gg2SZ;A0G/1SY;EACI,sCAAA;A1Gi2ShB;A0G71SQ;EACI,aAAA;EACA,mBAAA;A1G+1SZ;A0G71SY;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;A1G+1ShB;A0G71SgB;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;A1G+1SpB;A0G31SY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBAAA;A1G61ShB;A0Gz1SQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;A1G21SZ;A0Gz1SY;EACI,aAAA;EACA,SAAA;A1G21ShB;;A2G76SI;EACI,aAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;EACA,4BAAA;A3Gg7SR;A2G96SQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gCAAA;EACA,4EACI;A3G+6ShB;AKj6SI;EAaY,wCsGvBA;A3G86ShB;AKn5SiB;EAkBG,kCsG5CJ;A3Gg7ShB;;AKv6SI;EAaY,0CsGhBI;A3G86SpB;AK15SiB;EAED,6FAAA;AL25ShB;;AK96SI;EAaY,oCsGVI;A3G+6SpB;AKj6SiB;EAED,wFAAA;ALk6ShB;;AKr7SI;EAaY,0CsGDI;A3G66SpB;AKx6SiB;EAED,4FAAA;ALy6ShB;;AK57SI;EAaY,oCsGKI;A3G86SpB;AK/6SiB;EAED,wFAAA;ALg7ShB;;A4Gr+SA;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;A5Gw+SJ;AK18SI;EAaY,kGuGxCR;A5Gw+SR;AK57SiB;EAED,sFAAA;AL67ShB;;A4Gl+SI;EACI,UAAA;A5Gq+SR;A4Gn+SQ;EACI,oBAAA;A5Gq+SZ;A4Gl+SQ;EACI,UAAA;A5Go+SZ;A4G/9SiB;EACL,YAAA;EACA,UAAA;EACA,oBAAA;A5Gi+SZ;AK/9SI;EAaY,uBuGdiD;A5Gm+SjE;AKj9SiB;EAkBG,uBuGpCoD;A5Gs+SxE;;AKr+SI;EAaY,iBuGb2C;A5Gy+S3D;AKx9SiB;EAkBG,iBuGnC8C;A5G4+SlE;;AK5+SI;EAaY,uBuGTI;A5G4+SpB;AK/9SiB;EAkBG,uBuG9BA;A5G8+SpB;;AKn/SI;EAaY,iBuGN+C;A5Gg/S/D;AKt+SiB;EAkBG,iBuG5BkD;A5Gm/StE;;A4G7+SQ;EACI,gBAAA;A5Gg/SZ;A4G7+SgB;EACI,oCAAA;A5G++SpB;A4G3+SQ;EACI,aAAA;A5G6+SZ;A4Gz+SI;EACI,cAAA;EACA,qBAAA;A5G2+SR;AKxgTI;EAaY,kGuGmBJ;A5G2+SZ;AK1/SiB;EAED,sFAAA;AL2/ShB;;A4Gp+SI;EACI,aAAA;A5Gu+SR;A4Gp+SI;EACI,cAAA;EACA,cAAA;EACA,WAAA;A5Gs+SR;AKvhTI;EAEQ,wFAAA;ALwhTZ;AKzgTiB;EAgBG,0DAAA;AL4/SpB;;A4Gv+SQ;EACI,YAAA;A5G0+SZ;;A6G9jTA;EACI,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,qBALW;EAMX,0BAAA;EACA,8JACI;EAKJ,oBAAA;A7G4jTJ;AK3iTI;EAEQ,+EAAA;AL4iTZ;AK7hTiB;EAED,+EAAA;AL8hThB;;AKjjTI;EAaY,oCwG1BR;A7GkkTR;AKpiTiB;EAkBG,yDwG/CZ;A7GokTR;;AsB/jTI;EACI,oEAAA;AtBkkTR;AsB7jTiB;EACL,kEAAA;AtB+jTZ;;A6GtkTI;EAEI,WAAA;EACA,kBAAA;EACA,UAHS;EAIT,SAJS;EAKT,YALS;EAMT,aAAA;EACA,2CAAA;EACA,qBAhCO;EAiCP,sBAAA;A7GwkTR;A6GrkTI;EAEI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,mCA7CI;EA8CJ,YAAA;EACA,WAAA;EACA,qBA7CO;EA8CP,iCAAA;A7GskTR;A6GnkTI;EAGI,6JACI;A7GkkTZ;A6G3jTI;EACI,kCAAA;EACA,UAAA;A7G6jTR;A6G3jTI;EACI,UAAA;EACA,aAAA;A7G6jTR;A6G1jTI;EAEI,UAAA;EACA,gEAAA;A7G2jTR;AsB5mTI;EACI,oEAAA;AtB8mTR;AsBzmTiB;EACL,gEAAA;AtB2mTZ;;AK3mTI;EAaY,uBwGkCJ;A7GgkTZ;AK9lTiB;EAkBG,uDwGaR;A7GkkTZ;;A6G9jTI;EACI,8BAAA;EACA,aAAA;A7GikTR;A6G/jTQ;EACI,kCAAA;A7GikTZ;A6GhkTY;EACI,aAAA;EACA,cAAA;EACA,wBA9FJ;A7GgqTZ;A6G9jTQ;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;A7GgkTZ;A6G9jTY;EACI,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A7GgkThB;AK7oTI;EAEQ,iFAAA;AL8oTZ;AK/nTiB;EAED,+EAAA;ALgoThB;;A6G5jTY;EACI,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;A7G+jThB;AK3pTI;EAEQ,iFAAA;AL4pTZ;AK7oTiB;EAED,6EAAA;AL8oThB;;A6G7jTgB;EACI,gBAAA;A7GgkTpB;A6G3jTQ;EACI,iBAAA;EACA,cAAA;EAEA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;A7G4jTZ;;A8GltTA;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,QAAA;A9GqtTJ;A8GntTI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;A9GqtTR;;A+GruTA;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;A/GwuTJ;A+GruTQ;EACI,UAAA;A/GuuTZ;A+GruTQ;EACI,UAAA;A/GuuTZ;A+GnuTI;EACI,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,oCAAA;EACA,2BAAA;EACA,mCAAA;A/GquTR;AK1tTI;EAEQ,0FAAA;AL2tTZ;AK5sTiB;EAkBG,oC0G1CR;A/GuuTZ;;A+GluTI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,oCAAA;EACA,uBAAA;A/GquTR;A+GnuTQ;EACI,gBAAA;EACA,mBAAA;A/GquTZ;AsBtvTI;EACI,oEAAA;AtBwvTR;AsBnvTiB;EACL,wDAAA;AtBqvTZ;;A+GxuTY;EACI,cAAA;EACA,cAAA;EACA,WAAA;A/G2uThB;AK3vTI;EAaY,uC0GMI;A/G2uTpB;AK7uTiB;EAkBG,uB0GfA;A/G6uTpB;;A+GzuTY;EACI,WAAA;EACA,sBAAA;A/G4uThB;AKvxTI;EACI,a0G2CgD;A/G8uTxD;AKxxTiB;EACL,c0GyCmD;A/GivT/D;;AK7xTI;EACI,oB0GgDgB;A/GgvTxB;AK/xTiB;EACL,qB0G+CY;A/GkvTxB;;AKnxTI;EAEQ,wFAAA;ALqxTZ;AKtwTiB;EAED,4FAAA;ALuwThB;;AK3yTI;EACI,oB0G8DgB;A/GgvTxB;AK7yTiB;EACL,qB0G6DY;A/GkvTxB;;AKjyTI;EAaY,uB0GsCQ;A/GkvTxB;AKpxTiB;EAED,4FAAA;ALqxThB;;A+G9uTY;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;A/GivThB;A+G9uTY;EACI,aAAA;EACA,kBAAA;A/GgvThB;A+G7uToB;EACI,YAAA;EACA,oBAAA;A/G+uTxB;A+G3uTgB;EACI,aAAA;EACA,yBAAA;EACA,SAAA;A/G6uTpB;;AgHn2TA;EAEI,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qKACI;AhHo2TR;AK90TI;EAEQ,wFAAA;AL+0TZ;AKh0TiB;EAkBG,oC2GjDZ;AhHk2TR;;AKp1TI;EAEQ,sFAAA;ALs1TZ;AKv0TiB;EAkBG,yB2G/CsC;AhHu2T1D;;AK31TI;EAEQ,+EAAA;AL61TZ;AK90TiB;EAkBG,Y2G9C+B;AhH62TnD;;AsBz2TI;EACI,oEAAA;AtB42TR;AsBv2TiB;EACL,wDAAA;AtBy2TZ;;AgHj3TI;EACI,eAAA;EACA,YAAA;AhHo3TR;AgHj3TI;EACI,mBAAA;AhHm3TR;AKj3TI;EAEQ,wFAAA;ALk3TZ;AKn2TiB;EAkBG,8B2GjCR;AhHq3TZ;;AsB93TI;EACI,mEAAA;AtBi4TR;AsB53TiB;EACL,wDAAA;AtB83TZ;;AgHv3TI;EACI,iCAAA;EACA,mBAAA;AhH03TR;AKn4TI;EAEQ,wFAAA;ALo4TZ;AKr3TiB;EAkBG,8B2GtBR;AhH43TZ;;AsBh5TI;EACI,oEAAA;AtBm5TR;AsB94TiB;EACL,wDAAA;AtBg5TZ;;AKh5TI;EAaY,0C2GQJ;AhH+3TZ;AKn4TiB;EAkBG,6B2GbR;AhHi4TZ;;AKv5TI;EAEQ,sFAAA;ALy5TZ;AK14TiB;EAgBG,sDAAA;AL63TpB;;AK95TI;EAEQ,+EAAA;ALg6TZ;AKj5TiB;EAkBG,Y2GVmC;AhH44TvD;;AsB56TI;EACI,0DAAA;AtB+6TR;AsB16TiB;EACL,wDAAA;AtB46TZ;;AK56TI;EAEQ,sFAAA;AL86TZ;AK/5TiB;EAgBG,oDAAA;ALk5TpB;;AKn7TI;EAEQ,wFAAA;ALq7TZ;AKt6TiB;EAkBG,kC2GFJ;AhHy5ThB;;AsBj8TI;EACI,mEAAA;AtBo8TR;AsB/7TiB;EACL,wDAAA;AtBi8TZ;;AKj8TI;EAEQ,sFAAA;ALm8TZ;AKp7TiB;EAgBG,oDAAA;ALu6TpB;;AKx8TI;EAEQ,wFAAA;AL08TZ;AK37TiB;EAkBG,kC2GQJ;AhHo6ThB;;AsBt9TI;EACI,oEAAA;AtBy9TR;AsBp9TiB;EACL,wDAAA;AtBs9TZ;;AgHr6TI;EACI,yBAAA;EACA,YAAA;AhHw6TR;AK39TI;EAaY,kC2GyCJ;AhHw6TZ;AK78TiB;EAkBG,kC2GoBR;AhH06TZ;;AKj+TI;EAaY,kC2GgDA;AhHw6ThB;AKp9TiB;EAkBG,kC2G2BJ;AhH06ThB;;AKx+TI;EAaY,kC2GwDA;AhHu6ThB;AK39TiB;EAkBG,kC2GmCJ;AhHy6ThB;;AgHp6TI;EACI,yBAAA;EACA,YAAA;AhHu6TR;AKp/TI;EAaY,mC2GmEJ;AhHu6TZ;AKt+TiB;EAkBG,mC2G8CR;AhHy6TZ;;AK1/TI;EAaY,mC2G0EA;AhHu6ThB;AK7+TiB;EAkBG,mC2GqDJ;AhHy6ThB;;AKjgUI;EAaY,mC2GkFA;AhHs6ThB;AKp/TiB;EAkBG,mC2G6DJ;AhHw6ThB;;AgHn6TI;EACI,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AhHs6TR;AgHn6TI;EACI,oBAAA;EACA,cAAA;EACA,mBAAA;AhHq6TR;AgHn6TQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AhHq6TZ;;AiHnkUA;EAEI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,sGACI;AjHokUR;AK7iUI;EAaY,yB4G9BR;AjHikUR;AK/hUiB;EAkBG,+B4GnDZ;AjHmkUR;;AiHhkUI;EACI,aAAA;AjHmkUR;AiHhkUY;EACI,oCAAA;AjHkkUhB;AK1jUI;EAWY,wDAAA;ALkjUhB;AK5iUiB;EAED,0FAAA;AL6iUhB;;AKhkUI;EAEQ,wFAAA;ALkkUZ;AKnjUiB;EAkBG,2C4GjCR;AjHqkUZ;;AiHjkUI;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;AjHokUR;AK/kUI;EAEQ,0FAAA;ALglUZ;AKjkUiB;EAgBG,0DAAA;ALojUpB;;AKrlUI;EAaY,qD4GEJ;AjH0kUZ;AKxkUiB;EAkBG,qD4GnBR;AjH4kUZ;;AiHzkUQ;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yEACI;AjH2kUhB;AKvmUI;EAEQ,0FAAA;ALwmUZ;AKzlUiB;EAED,4FAAA;AL0lUhB;;AK7mUI;EAaY,yF4G4BA;AjHwkUhB;AKhmUiB;EAkBG,gG4GQJ;AjHykUhB;;AiHnkUI;EACI,oBAAA;EACA,YAAA;AjHskUR;;AkHhqUA;EAEI,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,qKACI;EAKJ,+BAAA;EACA,oBAAA;EACA,wDAAA;EACA,yBAAA;AlH6pUJ;AsBlpUI;EACI,0DAAA;AtBopUR;AsB/oUiB;EACL,wDAAA;AtBipUZ;;AKjpUI;EAEQ,wFAAA;ALmpUZ;AKpoUiB;EAkBG,oC6GhDZ;AlHqqUR;;AKxpUI;EAEQ,sFAAA;AL0pUZ;AK3oUiB;EAkBG,yB6G9CsC;AlH0qU1D;;AK/pUI;EAaY,yB6GvB8B;AlH6qU9C;AKlpUiB;EAkBG,Y6G7C8C;AlHgrUlE;;AkH9qUI;EACI,eAAA;EACA,YAAA;AlHirUR;AkH9qUI;EACI,kBAAA;AlHgrUR;AK9qUI;EAEQ,wFAAA;AL+qUZ;AKhqUiB;EAkBG,8B6GjCR;AlHkrUZ;;AsB3rUI;EACI,oEAAA;AtB8rUR;AsBzrUiB;EACL,wDAAA;AtB2rUZ;;AkHprUI;EACI,iCAAA;EACA,kBAAA;AlHurUR;AKhsUI;EAEQ,wFAAA;ALisUZ;AKlrUiB;EAkBG,8B6GtBR;AlHyrUZ;;AsB7sUI;EACI,oEAAA;AtBgtUR;AsB3sUiB;EACL,wDAAA;AtB6sUZ;;AkH3rUI;EACI,qCAAA;AlH8rUR;AKjtUI;EAEQ,wFAAA;ALktUZ;AKnsUiB;EAkBG,8B6GZR;AlHgsUZ;;AsB9tUI;EACI,oEAAA;AtBiuUR;AsB5tUiB;EACL,wDAAA;AtB8tUZ;;AkHlsUI;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;AlHqsUR;AKruUI;EAEQ,+EAAA;ALsuUZ;AKvtUiB;EAkBG,Y6GFmC;AlH0sUvD;;AkHvsUI;EACI,YAAA;AlH0sUR;AK/uUI;EAaY,6B6G2BJ;AlH0sUZ;AKjuUiB;EAkBG,6B6GMR;AlH4sUZ;;AkHxsUI;EACI,2BAAA;EACA,YAAA;AlH2sUR;AK1vUI;EAEQ,4FAAA;AL2vUZ;AK5uUiB;EAgBG,0DAAA;AL+tUpB;;AsBvwUI;EACI,0DAAA;AtB0wUR;AsBrwUiB;EACL,wDAAA;AtBuwUZ;;AsB9wUI;EACI,mEAAA;AtBixUR;AsB5wUiB;EACL,wDAAA;AtB8wUZ;;AsBrxUI;EACI,oEAAA;AtBwxUR;AsBnxUiB;EACL,wDAAA;AtBqxUZ;;AKrxUI;EAaY,Y6GoDsC;AlHwtUtD;AKxwUiB;EAkBG,Y6G8BkC;AlH2tUtD;;AkHvtUI;EACI,mBAAA;EACA,eAAA;AlH0tUR;AkHxtUQ;EACI,cAAA;EACA,aAAA;AlH0tUZ;AkHttUI;EACI,mBAAA;EACA,eAAA;AlHwtUR;AkHttUQ;EACI,cAAA;EACA,aAAA;AlHwtUZ;AkHptUI;EACI,iBAAA;EACA,eAAA;AlHstUR;AkHptUQ;EACI,cAAA;EACA,aAAA;AlHstUZ;AkHntUQ;EACI,kBAAA;AlHqtUZ;;AmH/1UA;EAEI,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,sGACI;EAGJ,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;AnH81UJ;AKt0UI;EAaY,0C8GlCR;AnH81UR;AKxzUiB;EAED,4FAAA;ALyzUhB;;AmH51UI;EACI,UAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,oCAAA;EACA,gCAAA;EACA,uBAAA;EACA,YAAA;AnH+1UR;AmH71UQ;EACI,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,4DACI;EAEJ,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AnH61UZ;AmH11UQ;EACI,UAAA;AnH41UZ;AmH11UQ;EACI,UAAA;AnH41UZ;AmHx1UI;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,OAAA;EACA,oBAAA;EACA,qBAAA;EACA,wDAAA;AnH01UR;AKt3UI;EAaY,uB8GgB6C;AnH41U7D;AKx2UiB;EAED,0FAAA;ALy2UhB;;AsBn4UI;EACI,mEAAA;AtBs4UR;AsBj4UiB;EACL,wDAAA;AtBm4UZ;;AKn4UI;EAEQ,iFAAA;ALq4UZ;AKt3UiB;EAkBG,Y+GhEA;ApHu6UpB;;AK14UI;EAEQ,iFAAA;AL44UZ;AK73UiB;EAED,+EAAA;AL83UhB;;AoH95UQ;EACI,UAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,UAAA;EACA,2BAAA;EACA,gCAAA;EACA,uBAAA;ApHi6UZ;AK95UI;EAEQ,iFAAA;AL+5UZ;AKh5UiB;EAkBG,Y+GlCJ;ApHm6UhB;;AoH/5UY;EACI,oBAAA;EACA,6BAAA;EACA,4DACI;EAEJ,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;ApHg6UhB;AoH55UQ;EACI,YAAA;EACA,eAAA;EACA,OAAA;ApH85UZ;;AqH59UA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qKACI;ArH89UR;AsB38UI;EACI,oEAAA;AtB68UR;AsBx8UiB;EACL,wDAAA;AtB08UZ;;AK18UI;EAEQ,wFAAA;AL48UZ;AK77UiB;EAkBG,oCgHpDZ;ArHk+UR;;AKj9UI;EAEQ,sFAAA;ALm9UZ;AKp8UiB;EAkBG,yBgHlDsC;ArHu+U1D;;AKx9UI;EAEQ,+EAAA;AL09UZ;AK38UiB;EAkBG,YgHjD+B;ArH6+UnD;;AqH3+UI;EACI,mBAAA;ArH8+UR;AsB1+UI;EACI,mEAAA;AtB4+UR;AsBv+UiB;EACL,wDAAA;AtBy+UZ;;AKz+UI;EAEQ,sFAAA;AL2+UZ;AK59UiB;EAkBG,yBgH5C0C;ArHy/U9D;;AqHt/UI;EACI,iCAAA;EACA,mBAAA;ArHy/UR;AsB5/UI;EACI,oEAAA;AtB8/UR;AsBz/UiB;EACL,wDAAA;AtB2/UZ;;AK3/UI;EAEQ,sFAAA;AL6/UZ;AK9+UiB;EAkBG,yBgHrC0C;ArHogV9D;;AsHviVA;EACI,YAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AtH0iVJ;AK7gVI;EAEQ,0FAAA;AL8gVZ;AK//UiB;EAED,4FAAA;ALggVhB;;AsHxiVI;EACI,iBAAA;EACA,gBAAA;AtH2iVR;AKxhVI;EAEQ,+EAAA;ALyhVZ;AK1gViB;EAkBG,YiHrDmC;AtHgjVvD;;AsH7iVI;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,qKACI;AtH+iVZ;AKhjVI;EAaY,uBiHP6C;AtH6iV7D;AKliViB;EAgBG,0DAAA;ALqhVpB;;AKtjVI;EAEQ,sFAAA;ALwjVZ;AKziViB;EAkBG,yBiH5B0C;AtHsjV9D;;AK7jVI;EAEQ,+EAAA;AL+jVZ;AKhjViB;EAkBG,YiH3BmC;AtH4jVvD;;AsH1jVQ;EACI,mBAAA;AtH6jVZ;AKxkVI;EAaY,uBiHCA;AtH6jVhB;AK1jViB;EAkBG,8BiHpBJ;AtH+jVhB;;AsBrlVI;EACI,mEAAA;AtBwlVR;AsBnlViB;EACL,wDAAA;AtBqlVZ;;AsHjkVQ;EACI,iCAAA;EACA,mBAAA;AtHokVZ;AK1lVI;EAaY,uBiHYA;AtHokVhB;AK5kViB;EAkBG,8BiHTJ;AtHskVhB;;AsBvmVI;EACI,oEAAA;AtB0mVR;AsBrmViB;EACL,wDAAA;AtBumVZ;;AsHvkVI;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AtH0kVR;AsHxkVQ;EACI,mBAAA;EACA,eAAA;AtH0kVZ;;AsHpkVI;EACI,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;AtHukVR;AK3nVI;EAEQ,wFAAA;AL4nVZ;AK7mViB;EAkBG,uBiHkB6C;AtH4kVjE;;AsH1kVQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AtH6kVZ;AK5oVI;EAEQ,+EAAA;AL6oVZ;AK9nViB;EAkBG,YiH6BuC;AtHklV3D;;AKlpVI;EAaY,uBiHwDI;AtHilVpB;AKroViB;EAkBG,uBiHmCA;AtHmlVpB;;AKzpVI;EAaY,YiH2D0C;AtHqlV1D;AK5oViB;EAkBG,YiHqC6C;AtHwlVjE;;AuHvsVA;EAEI,oBAAA;EACA,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,gCAAA;EACA,yIACI;AvHwsVR;AK7qVI;EAEQ,6FAAA;AL8qVZ;AK/pViB;EAgBG,0DAAA;ALkpVpB;;AKnrVI;EAEQ,+EAAA;ALqrVZ;AKtqViB;EAkBG,YkHnD+B;AvH0sVnD;;AK1rVI;EAEQ,wFAAA;AL4rVZ;AK7qViB;EAkBG,yBkH/CZ;AvH6sVR;;AKjsVI;EAaY,0CkHlBJ;AvH0sVZ;AKprViB;EAgBG,0DAAA;ALuqVpB;;AKxsVI;EAaY,gCkHbJ;AvH4sVZ;AK3rViB;EAkBG,yBkHlCR;AvH8sVZ;;AK/sVI;EAEQ,6FAAA;ALitVZ;AKlsViB;EAgBG,0DAAA;ALqrVpB;;AKttVI;EAaY,0CkHGA;AvH0sVhB;AKzsViB;EAgBG,0DAAA;AL4rVpB;;AuHvsVI;EACI,mBAAA;AvH0sVR;AKjuVI;EAEQ,6FAAA;ALkuVZ;AKntViB;EAgBG,0DAAA;ALssVpB;;AKvuVI;EAEQ,wFAAA;ALyuVZ;AK1tViB;EAED,wFAAA;AL2tVhB;;AsBrvVI;EACI,mEAAA;AtBwvVR;AsBnvViB;EACL,wDAAA;AtBqvVZ;;AKrvVI;EAaY,0CkH6BA;AvH+sVhB;AKxuViB;EAgBG,0DAAA;AL2tVpB;;AK5vVI;EAaY,yBkHsCJ;AvH6sVZ;AK/uViB;EAkBG,+BkHiBR;AvH+sVZ;;AuH1sVA;EACI,kBAAA;AvH6sVJ;AuH3sVI;EACI,aAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,oBAAA;AvH6sVR;AuH5sVQ;EACI,mBAAA;AvH8sVZ;AuH1sVI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,YAAA;EACA,2BAAA;AvH4sVR;AKhyVI;EAEQ,4FAAA;ALiyVZ;AKlxViB;EAgBG,0DAAA;ALqwVpB;;AwH30VA;EACI,UAAA;EACA,qCAAA;EACA,gEACI;EAEJ,eAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AxH40VJ;AwH10VI;EACI,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0HACI;AxH20VZ;AwHv0VI;EACI,UAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AxHy0VR;AwHv0VI;EACI,UAAA;EACA,+BAAA;AxHy0VR;AwHt0VI;EACI,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AxHw0VR;AK70VI;EAaY,yBmHLJ;AxHw0VZ;AK/zViB;EAkBG,+BmH1BR;AxH00VZ;;AwHt0VI;EACI,aAAA;AxHy0VR;AwHv0VI;EACI,cAAA;EACA,kBAAA;AxHy0VR;AK31VI;EAaY,qCmHQJ;AxHy0VZ;AK70ViB;EAkBG,2CmHbR;AxH20VZ;;AwHv0VI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AxH00VR;AKn3VI;EAaY,yBmH6BkC;AxH40VlD;AKr2ViB;EAkBG,YmHOkD;AxH+0VtE;;AwH70VQ;EACI,aAAA;EACA,cAAA;EACA,YAAA;AxHg1VZ;AwH70VQ;EACI,YAAA;AxH+0VZ;AKl4VI;EAEQ,wFAAA;ALm4VZ;AKp3ViB;EAkBG,uBmHoBiD;AxHi1VrE;;AKx4VI;EAaY,yBmH8CA;AxHi1VhB;AK33ViB;EAkBG,YmHyBJ;AxHm1VhB;;AwHh1VY;EACI,YAAA;AxHm1VhB;AwH70VQ;EACI,UAAA;AxH+0VZ;AwH70VQ;EACI,UAAA;AxH+0VZ;;AyHh8VA;EAEI,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,sGACI;AzHi8VR;AKp6VI;EAEQ,0FAAA;ALq6VZ;AKt5ViB;EAgBG,0DAAA;ALy4VpB;;AK16VI;EAEQ,sFAAA;AL46VZ;AK75ViB;EAgBG,sDAAA;ALg5VpB;;AyHn8VI;EACI,aAAA;AzHs8VR;AKr7VI;EAEQ,0FAAA;ALs7VZ;AKv6ViB;EAgBG,wDAAA;AL05VpB;;AK37VI;EAEQ,sFAAA;AL67VZ;AK96ViB;EAkBG,yBoH/C0C;AzH88V9D;;AyH58VQ;EACI,gBAAA;AzH+8VZ;AKt8VI;EAaY,YoHrBsC;AzHi9VtD;AKx7ViB;EAkBG,YoH3CkC;AzHo9VtD;;AyHh9VI;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AzHm9VR;AKn9VI;EAEQ,+EAAA;ALo9VZ;AKr8ViB;EAkBG,YoHlCmC;AzHw9VvD;;AKz9VI;EAEQ,wFAAA;AL29VZ;AK58ViB;EAgBG,0DAAA;AL+7VpB;;AKh+VI;EAEQ,sFAAA;ALk+VZ;AKn9ViB;EAgBG,sDAAA;ALs8VpB;;AyH99VI;EACI,oBAAA;EACA,YAAA;AzHi+VR;;A0HhhWA;EACI,kBAAA;EACA,cAAA;A1HmhWJ;A0HhhWI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;A1HkhWR;A0HhhWQ;EACI,mBARC;A1H0hWb;A0H/gWQ;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAtBO;EAuBP,aAvBO;EAwBP,kBAAA;EACA,0BAAA;EACA,sBAAA;A1HihWZ;AKpgWI;EAEQ,sFAAA;ALqgWZ;AKt/ViB;EAED,sFAAA;ALu/VhB;;A0HnhWQ;EAEI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,aANY;EAOZ,qBAAA;A1HqhWZ;AKphWI;EAEQ,0FAAA;ALqhWZ;AKtgWiB;EAED,0FAAA;ALugWhB;;A0HvhWQ;EACI,eAAA;A1H0hWZ;A0HvhWQ;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;A1HyhWZ;AKpiWI;EAEQ,+EAAA;ALqiWZ;AKthWiB;EAkBG,YqHpBJ;A1H2hWhB;;A0HthWQ;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;A1HyhWZ;AKjjWI;EAEQ,iFAAA;ALkjWZ;AKniWiB;EAED,+EAAA;ALoiWhB;;A0HthWQ;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;A1HyhWZ;AKlkWI;EAEQ,wFAAA;ALmkWZ;AKpjWiB;EAgBG,0DAAA;ALuiWpB;;AKxkWI;EAEQ,+EAAA;AL0kWZ;AK3jWiB;EAkBG,YqHWJ;A1HiiWhB;;A0H7hWY;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;A1HgiWhB;AK9lWI;EAaY,0CqHoDI;A1HgiWpB;AKhlWiB;EAED,4FAAA;ALilWhB;;AKpmWI;EAaY,iFqH0DI;A1HiiWpB;AKvlWiB;EAkBG,+EqHqCA;A1HmiWpB;;A2HhpWA;EAEI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;A3HkpWJ;AKnnWI;EAEQ,wFAAA;ALonWZ;AKrmWiB;EAkBG,0CsH9DZ;A3HopWR;;AKznWI;EAEQ,sFAAA;AL2nWZ;AK5mWiB;EAkBG,yBsH5DsC;A3HypW1D;;AKhoWI;EAEQ,+EAAA;ALkoWZ;AKnnWiB;EAkBG,YsH3D+B;A3H+pWnD;;A2H7pWI;EACI,mBAAA;A3HgqWR;AK3oWI;EAEQ,wFAAA;AL4oWZ;AK7nWiB;EAkBG,uBsHvD6C;A3HqqWjE;;AsBxpWI;EACI,mEAAA;AtB2pWR;AsBtpWiB;EACL,wDAAA;AtBwpWZ;;A2HxqWI;EACI,iCAAA;EACA,mBAAA;A3H2qWR;AK7pWI;EAEQ,wFAAA;AL8pWZ;AK/oWiB;EAkBG,uBsHhD6C;A3HgrWjE;;AsB1qWI;EACI,oEAAA;AtB6qWR;AsBxqWiB;EACL,wDAAA;AtB0qWZ;;A2HnrWI;EACI,mBAAA;EACA,sBAAA;A3HsrWR;A2HnrWI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;A3HqrWR;A2HnrWQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;A3HqrWZ;A2HnrWY;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;A3HqrWhB;AKltWI;EACI,YsH6BiD;A3HurWzD;AKntWiB;EACL,YsH2BkD;A3H0rW9D;;A2HxrWY;EACI,mBAAA;A3H2rWhB;A2HrrWQ;EACI,cAAA;EACA,oBAAA;EACA,cAAA;EACA,aAAA;A3HurWZ;AKjtWI;EAEQ,+EAAA;ALktWZ;AKnsWiB;EAkBG,YsHRuC;A3H4rW3D;;A2HvrWA;EACI,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,0HACI;A3HyrWR;;A2HrrWA;EACI,eAAA;A3HwrWJ;;A2HrrWA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;A3HwrWJ;AKxvWI;EAaY,yBsHoD8B;A3H0rW9C;AK1uWiB;EAkBG,YsH8B8C;A3H6rWlE;;A2H3rWI;EACI,aAAA;EACA,cAAA;EACA,YAAA;A3H8rWR;A2H3rWI;EACI,YAAA;A3H6rWR;AKvwWI;EAEQ,wFAAA;ALwwWZ;AKzvWiB;EAkBG,uBsH2C6C;A3H+rWjE;;AK7wWI;EAaY,yBsHmEkC;A3HisWlD;AKhwWiB;EAkBG,YsH6CkD;A3HosWtE;;A2HlsWQ;EACI,YAAA;A3HqsWZ;;A4H/zWA;;;;EAII,mBAAA;EACA,+BAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;A5Hk0WJ;;AKvyWI;EAEQ,sFAAA;ALyyWZ;AK1xWiB;EAED,oFAAA;AL2xWhB;;AK9yWI;EAEQ,sFAAA;ALgzWZ;AKjyWiB;EAED,oFAAA;ALkyWhB;;AKrzWI;EAEQ,sFAAA;ALuzWZ;AKxyWiB;EAED,oFAAA;ALyyWhB;;AK5zWI;EAEQ,sFAAA;AL8zWZ;AK/yWiB;EAED,oFAAA;ALgzWhB;;A4Hh1WA;EACI,qBAAA;EACA,UAAA;EACA,SAAA;A5Hm1WJ;;A4Hh1WA;EACI,2DAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,cAAA;A5Hm1WJ;AKl1WI;EAEQ,oFAAA;ALm1WZ;AKp0WiB;EAED,wFAAA;ALq0WhB;;AKx1WI;EAEQ,iFAAA;AL01WZ;AK30WiB;EAED,6EAAA;AL40WhB;;AK/1WI;EAEQ,wFAAA;ALi2WZ;AKl1WiB;EAkBG,wDuH9BZ;A5Hi2WR;;AsB72WI;EACI,kEAAA;AtBg3WR;AsB32WiB;EACL,kEAAA;AtB62WZ;;A4Hn2WA;EACI,cAAA;A5Hs2WJ;;A4Hp2WA;;EAEI,iCAAA;EACA,kCAAA;A5Hu2WJ;;A4Hp2WA;EACI,UAAA;EACA,cAAA;A5Hu2WJ;;A4Hr2WA;EACI,eAAA;A5Hw2WJ;;A4Ht2WA;EACI,aAAA;EACA,cAAA;A5Hy2WJ;;A4Hv2WA;EACI,UAAA;EACA,WAAA;A5H02WJ;;A4Hv2WA;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;A5H02WJ;AKh5WI;EAEQ,0FAAA;ALi5WZ;AKl4WiB;EAED,4FAAA;ALm4WhB;;A4Hx2WA;EACI,sBAAA;EACA,oBAAA;EACA,qBAAA;A5H22WJ;;A4Hz2WA;EACI,yBAAA;A5H42WJ;;A4Ht2WA;;;;;;EAMI,qBAAA;EACA,gBAAA;A5Hy2WJ;;A4Ht2WA;;;EAGI,aAAA;EACA,gBAAA;EACA,iBAAA;A5Hy2WJ;AKl7WI;;;EAEQ,iFAAA;ALq7WZ;AKt6WiB;EAED,6EAAA;ALu6WhB;;A4H72WA;EACI,UAAA;EACA,SAAA;A5Hg3WJ;;A4H72WA;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;A5Hg3WJ;;A4H72WA;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;A5Hg3WJ;AKx9WI;EAEQ,0FAAA;ALy9WZ;AK18WiB;EAkBG,yCuHyEZ;A5Hk3WR;;A4H/2WA;EACI,UAAA;A5Hk3WJ;;A4Hh3WA;EACI,WAAA;A5Hm3WJ;;A4Hj3WA;EAGI,aAAA;A5Hk3WJ;;A4Hh3WA;EACI,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A5Hm3WJ;;A4Hj3WA;EACI,WAAA;A5Ho3WJ;;A4Hl3WA;EACI,YAAA;A5Hq3WJ;;A4Hn3WA;EAEI,UAAA;A5Hq3WJ;;A4Hl3WA;EACI,kBAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;A5Hq3WJ;;A4Hn3WA;EACI,YAAA;A5Hs3WJ;;A4Hp3WA;EACI,wBAAA;EACA,aAAA;A5Hu3WJ;;A4Hr3WA;EACI,aAAA;A5Hw3WJ;;A4Ht3WA;EACI,yBAAA;EACA,cAAA;A5Hy3WJ;;A4Ht3WA;EACI,WAAA;A5Hy3WJ;;A4Hn3WA;EACI,cAAA;EACA,kBAAA;A5Hs3WJ;;A4Hp3WA;EACI,aAAA;EACA,eAAA;EACA,gBAAA;A5Hu3WJ;;A4Hr3WA;EACI,qBAAA;EACA,WAAA;EACA,cAAA;A5Hw3WJ;;A4Hr3WA;EACI,cAAA;EACA,kBAAA;A5Hw3WJ;;A4Ht3WA;;EAEI,qBAAA;EACA,WAAA;EACA,cAAA;A5Hy3WJ;;A4Ht3WA;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,4BAAA;EACA,gBAAA;A5Hy3WJ;;A4Hv3WA;EACI,qBAAA;A5H03WJ;;A4Hx3WA;EAEI,qBAAA;A5H03WJ;;A4Hx3WA;EAGI,qBAAA;EACA,iBAAA;A5Hy3WJ;;A4Hv3WA;EAII,WAAA;A5Hu3WJ;;A4Hr3WA;;EAQI,wBAAA;EACA,SAAA;A5Hk3WJ;;A4Hh3WA;EAII,0BAAA;A5Hg3WJ;;A4H92WA;EAGI,mBAAA;EACA,qBAAA;A5H+2WJ;;A4H52WA;EACI,YAAA;EACA,iCAAA;EACA,aAAA;A5H+2WJ;;A4H72WA;EACI,eAAA;EACA,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,MAAA;A5Hg3WJ;;A4H92WA;EACI,kBAAA;EACA,iBAAA;EACA,kCAAA;A5Hi3WJ;;A4H/2WA;EAGI,aAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;A5Hg3WJ;;A4H92WA;EAII,gBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;A5H82WJ;;A4H52WA;EAKI,YAAA;EACA,oBAAA;EACA,mBAAA;A5H22WJ;;A4Hz2WA;EAKI,eAAA;EACA,yBAAA;A5Hw2WJ;;A4Ht2WA;EAKI,yBAAA;EACA,YAAA;EACA,iBAAA;A5Hq2WJ;;A4Hn2WA;EAKI,yBAAA;A5Hk2WJ;;A4Hh2WA;EAKI,WAAA;A5H+1WJ;;A4H71WA;EAKI,eAAA;EACA,6BAAA;A5H41WJ;;A4Hz1WA;EACI,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;A5H41WJ;;A4H11WA;EACI,eAAA;A5H61WJ;;A4H31WA;;EAII,qBAAA;EACA,yBAAA;A5H41WJ;;A4H11WA;EACI,qBAAA;EACA,yBAAA;EACA,WAAA;A5H61WJ;;A4H31WA;EACI,kCAAA;A5H81WJ;;A4H51WA;EACI,qBAAA;EACA,mCAAA;EACA,WAAA;A5H+1WJ;;A4H71WA;EACI,kCAAA;A5Hg2WJ;;A4H71WA;EACI,mBAAA;EACA,kBAAA;EACA,sBAAA;A5Hg2WJ;;A4H71WA;EACI,mBAAA;A5Hg2WJ;;A4H71WA;;;EAII,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;A5H+1WJ;;A4H51WA;;;;EAII,eAAA;A5H+1WJ;;A4H71WA;;;;EAII,qBAAA;A5Hg2WJ;AK/uXI;;;;EAEQ,4FAAA;ALmvXZ;AKpuXiB;EAED,4FAAA;ALquXhB;;A4Hh2WA;;;;EAII,iBAAA;A5Hm2WJ;;A4Hj2WA;;;;EAII,qBAAA;EACA,yBAAA;EACA,WAAA;A5Ho2WJ;;A4Hl2WA;;;;EAII,kCAAA;A5Hq2WJ;;A4Hn2WA;;;;EAII,cAAA;A5Hs2WJ;;A4Hp2WA;;;;EAII,YAAA;A5Hu2WJ;;A4Hr2WA;;;;EAII,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;A5Hw2WJ;;A4Ht2WA;;;;EAII,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,mDACI;A5Hw2WR;;A4Hr2WA;;;;EAII,iCAAA;A5Hw2WJ;;A4Ht2WA;;;;EAII,mBAAA;EACA,UAAA;A5Hy2WJ;;A4Hv2WA;;;;;;;;;;;;EAYI,qBAAA;EACA,yBAAA;A5H02WJ;AKx1XI;;;;;;;;;;;;EAEQ,4FAAA;ALo2XZ;AKr1XiB;EAED,4FAAA;ALs1XhB;;A4H51WA;;;;EAII,qBAAA;EAEA,mBAAA;A5H81WJ;AKj3XI;;;;EAEQ,iFAAA;ALq3XZ;AKt2XiB;EAED,6EAAA;ALu2XhB;;AK13XI;;;;EAEQ,4FAAA;AL+3XZ;AKh3XiB;EAED,4FAAA;ALi3XhB;;AKp4XI;;;;;;;;;;;;;;;;EAEQ,4FAAA;ALq5XZ;AKt4XiB;EAED,4FAAA;ALu4XhB;;A4H/0WA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwDI,yBAAA;EACA,WAAA;A5H0zWJ;;A4HxzWA;;;;EAII,eAAA;EAEA,YAAA;A5H0zWJ;;A4HxzWA;;;;EAII,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,mDACI;A5H0zWR;;A4HtzWA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;A5HyzWJ;;A4HvzWA;EACI,kBAAA;EACA,eAAA;EACA,uBAAA;A5H0zWJ;;A4HvzWA;EACI,kCAAA;A5H0zWJ;;A4HvzWA;;;EAGI,gCAAA;EACA,qBAAA;EACA,kBAAA;A5H0zWJ;;A4HxzWA;;;EAGI,eAAA;A5H2zWJ;;A4HzzWA;;;;;;EAYI,oCAAA;A5HszWJ;;A4HpzWA;;;EAGI,yBAAA;EACA,cAAA;EACA,MAAA;A5HuzWJ;;A4HpzWA;;;EAGI,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;A5HuzWJ;;A4HrzWA;;;EAGI,eAAA;A5HwzWJ;;A4HtzWA;;;EAGI,aAAA;EACA,kBAAA;A5HyzWJ;;A4HtzWA;;;EAGI,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A5HyzWJ;;A4HvzWA;;;EAGI,8BAAA;EACA,+BAAA;A5H0zWJ;;A4HxzWA;;;EAGI,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,iCAAA;EACA,kCAAA;A5H2zWJ;;A4HzzWA;;;EAGI,sBAAA;A5H4zWJ;;A4H1zWA;;;EAMI,uCAAA;A5H0zWJ;;A4HxzWA;;;EAMI,oCAAA;A5HwzWJ;;A4HtzWA;;;EAGI,kBAAA;EACA,YAAA;A5HyzWJ;;A4HtzWA;EACI,eAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;A5HyzWJ;;A4HvzWA;EACI,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;A5H0zWJ;;A4HxzWA;EACI,eAAA;A5H2zWJ;;A4HzzWA;EACI,eAAA;EACA,sBAAA;A5H4zWJ;;A4HzzWA;EACI,mBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;A5H4zWJ;;A4HzzWA;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;A5H4zWJ;;A4H1zWA;;;EAGI,WAAA;EACA,iBAAA;A5H6zWJ;;A4H3zWA;EACI;;;IAGI,WAAA;IACA,iBAAA;E5H8zWN;AACF;A4H5zWA;;EAEI,kBAAA;A5H8zWJ;;A4H3zWA;EACI,cAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;EACA,YAAA;A5H8zWJ;;A4H3zWA;EACI,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;A5H8zWJ;;A4H3zWA;EACI,UAAA;EACA,WAAA;EACA,wBAAA;A5H8zWJ;;AApuYA;EACI,aAAA;AAuuYJ;;AApuYA;EACI,gBAAA;EACA,YAAA;AAuuYJ;;AApuYA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,2DAAA;EACA,mCAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;AAuuYJ;;AApuYA;EACI,mDAAA;EACA,gDAAA;AAuuYJ;;AApuYA;EACI,aAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAuuYJ;;AApuYA;;EAEI,gDAAA;AAuuYJ","sourcesContent":["@use './utils/utils';\n\n@use './demmi-core';\n@use './pages/pages';\n@use './components/components';\n@use './demmi-ui/demmi-ui';\n@use './overrides/react-datepicker';\n\n.firebase-emulator-warning {\n    display: none;\n}\n\nhtml {\n    font-size: 62.5%;\n    height: 100%;\n}\n\nbody {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    overflow: hidden;\n    font-family: 'Montserrat', 'Raleway', sans-serif !important;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: 1.4rem;\n    line-height: 1.8rem;\n    font-weight: 400;\n    letter-spacing: 0.05rem;\n    color: hsla(172, 80%, 10%, 0.6);\n}\n\n* {\n    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);\n    font-family: 'Montserrat', 'Raleway', sans-serif;\n}\n\nbutton {\n    outline: none;\n    border: none;\n    margin: 0;\n    padding: 0;\n}\n\ninput,\ntextarea {\n    font-family: 'Montserrat', 'Raleway', sans-serif;\n}\n","@use 'sass:list';\n@use 'sass:meta';\n\n:root {\n    --demmi-50: #eff2ed;\n    --demmi-100: #d4ddd0;\n    --demmi-200: #b7c4b0;\n    --demmi-300: #99ae8f;\n    --demmi-400: #849b78;\n    --demmi-500: #6f8a60;\n    --demmi-600: #607854;\n    --demmi-700: #506345;\n    --demmi-800: #40493c;\n    --demmi-900: #2d312b;\n\n    --palette-50-s: 35%;\n    --palette-50-l: 93%;\n    --palette-100-s: 40%;\n    --palette-100-l: 84%;\n    --palette-200-s: 45%;\n    --palette-200-l: 73%;\n    --palette-300-s: 50%;\n    --palette-300-l: 63%;\n    --palette-400-s: 55%;\n    --palette-400-l: 55%;\n    --palette-500-s: 60%;\n    --palette-500-l: 47%;\n    --palette-600-s: 65%;\n    --palette-600-l: 42%;\n    --palette-700-s: 70%;\n    --palette-700-l: 36%;\n    --palette-800-s: 75%;\n    --palette-800-l: 30%;\n    --palette-900-s: 80%;\n    --palette-900-l: 23%;\n\n    --palette-50: hsl(\n        var(--theme-bg-hue),\n        var(--palette-50-s),\n        var(--palette-50-l)\n    );\n    --palette-100: hsl(\n        var(--theme-bg-hue),\n        var(--palette-100-s),\n        var(--palette-100-l)\n    );\n    --palette-200: hsl(\n        var(--theme-bg-hue),\n        var(--palette-200-s),\n        var(--palette-200-l)\n    );\n    --palette-300: hsl(\n        var(--theme-bg-hue),\n        var(--palette-300-s),\n        var(--palette-300-l)\n    );\n    --palette-400: hsl(\n        var(--theme-bg-hue),\n        var(--palette-400-s),\n        var(--palette-400-l)\n    );\n    --palette-500: hsl(\n        var(--theme-bg-hue),\n        var(--palette-500-s),\n        var(--palette-500-l)\n    );\n    --palette-600: hsl(\n        var(--theme-bg-hue),\n        var(--palette-600-s),\n        var(--palette-600-l)\n    );\n    --palette-700: hsl(\n        var(--theme-bg-hue),\n        var(--palette-700-s),\n        var(--palette-700-l)\n    );\n    --palette-800: hsl(\n        var(--theme-bg-hue),\n        var(--palette-800-s),\n        var(--palette-800-l)\n    );\n    --palette-900: hsl(\n        var(--theme-bg-hue),\n        var(--palette-900-s),\n        var(--palette-900-l)\n    );\n}\n","@use './index' as Utils;\n\nbody:not(.isCapacitor):not(.isMobile) * {\n    ::-webkit-scrollbar {\n        width: 1.6rem;\n        height: 1.6rem;\n        background-color: transparent;\n\n        @at-root #{&}-thumb {\n            border: 0.5rem solid transparent;\n            border-radius: 0.8rem;\n            background-clip: padding-box;\n            outline: none;\n            background-color: rgba(255, 255, 255, 0.7);\n\n            &:hover {\n                border-width: 0.4rem;\n                background-color: rgba(255, 255, 255, 0.9);\n            }\n            &:active {\n                border-width: 0.4rem;\n                background-color: rgba(255, 255, 255, 0.9);\n            }\n        }\n        @at-root #{&}-track {\n            background: transparent;\n            border-radius: 1rem;\n        }\n        @at-root #{&}-corner {\n            background-color: transparent;\n        }\n    }\n}\n\nbody.theme-dark:not(.isCapacitor):not(.isMobile) * {\n    ::-webkit-scrollbar {\n        background-color: transparent;\n\n        @at-root #{&}-thumb {\n            border: 0.5rem solid transparent;\n            background-color: Utils.theme-get(100, 0.6);\n\n            &:hover {\n                background-color: Utils.theme-get(100, 1);\n            }\n            &:active {\n                background-color: Utils.theme-get(100, 1);\n            }\n        }\n        @at-root #{&}-track {\n            background: transparent;\n        }\n        @at-root #{&}-corner {\n            background-color: transparent;\n        }\n    }\n}\n","@use './index.scss' as Utils;\n\n$sidebarWidth: 34rem;\n$sidebarTransitionTime: 0.3s;\n\n$colour-light: hsl(99, 30%, 74%);\n$colour-dark: hsl(99, 22%, 57%);\n\n:root {\n    --sidebar-width: #{$sidebarWidth};\n    --sidebar-width-offset: 7rem;\n    --sidebar-transition-time: #{$sidebarTransitionTime};\n\n    --colour-light: #{$colour-light};\n    --colour-dark: #{$colour-dark};\n\n    @media (max-width: Utils.$mobileUIWidth) {\n        --sidebar-width: 100%;\n    }\n}\n\n:root {\n    // Overridden in React code\n    --theme-bg-hue: 200;\n    --theme-bg-01: 120;\n    --theme-bg-02: 160;\n    --theme-bg-pos: 20;\n    --theme-bg-intensity: 0.6;\n    --theme-bg-grain: 0.4;\n    --theme-bg-svg: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 1000 1000' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\");\n    --theme-config-svg: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\");\n}\n","@use './utils' as Utils;\n\nbody {\n    background-color: black;\n}\n\n#demmi-dash {\n    height: 100%;\n    width: 100vw;\n    box-sizing: border-box;\n    overflow: hidden;\n    justify-items: start;\n    position: relative;\n    color: rgba(0, 0, 0, 0.6);\n    z-index: 0;\n    @include Utils.theme-paletteColour(\n        background-color,\n        var(--palette-100),\n        rgba(0, 0, 0, 1)\n    );\n}\n\nbody {\n    .emdee-logo {\n        img.emdee-logo__image--light {\n            display: none;\n        }\n        img.emdee-logo__image--dark {\n            display: block;\n        }\n    }\n    &.theme-dark {\n        .emdee-logo {\n            img.emdee-logo__image--light {\n                display: block;\n            }\n            img.emdee-logo__image--dark {\n                display: none;\n            }\n        }\n    }\n}\n\n/* Define main content transition */\n.vendor-wrapper__content {\n    view-transition-name: vendor-content;\n}\n\n.vendor-wrapper__error {\n    view-transition-name: vendor-error;\n}\n\n/* Define transition animations */\n@keyframes fade-in {\n    from {\n        opacity: 0;\n    }\n}\n\n@keyframes fade-out {\n    to {\n        opacity: 0;\n    }\n}\n\n@keyframes inAnimation {\n    from {\n        transform: translate3d(0, 4rem, 0);\n        opacity: 0;\n    }\n    35% {\n        transform: translate3d(0, 4rem, 0);\n        opacity: 0;\n    }\n    to {\n        // transform: scale(1);\n        opacity: 1;\n    }\n}\n\n@keyframes outAnimation {\n    from {\n        // transform: scale(1);\n        opacity: 1;\n    }\n    35% {\n        transform: translate3d(0, 4rem, 0);\n        opacity: 0;\n    }\n    to {\n        transform: translate3d(0, 4rem, 0);\n        opacity: 0;\n    }\n}\n\n@view-transition {\n    navigation: auto;\n}\n\n$animDuration: 600ms;\n/* Apply animations to view transitions */\n::view-transition-old(vendor-content) {\n    z-index: 1;\n    animation: outAnimation $animDuration ease-out;\n}\n\n::view-transition-new(vendor-content) {\n    z-index: 1;\n    animation: inAnimation $animDuration ease-in;\n    // animation-delay: 1000ms;\n}\n\n::view-transition-old(vendor-error) {\n    animation: 400ms fade-out ease-in-out;\n}\n\n::view-transition-new(vendor-error) {\n    animation: 400ms fade-in ease-in-out;\n}\n\n/* For all other content */\n::view-transition-old(root) {\n    // animation: 200ms fade-out ease-in-out;\n}\n\n::view-transition-new(root) {\n    // animation: 400ms fade-in ease-in-out;\n}\n\n/* Optional: Add this to your ::view-transition-group */\n::view-transition-group(vendor-content) {\n    z-index: 5;\n    // isolation: isolate; /* Creates a stacking context */\n}\n\n/* Add this if your loading overlay is also using view transitions */\n::view-transition-group(root) {\n    z-index: auto; /* Let normal document flow handle stacking */\n}\n","@use 'sass:list';\n@use 'sass:meta';\n\n@use './colour-palette';\n\n@mixin demmi($prop, $shade) {\n    & {\n        #{$prop}: var(--demmi-#{$shade});\n        @at-root body.theme-dark #{&} {\n            #{$prop}: var(--demmi-#{$shade});\n        }\n    }\n}\n\n@function get($hue, $alpha: 1) {\n    @return hsla(\n        var(--theme-bg-hue),\n        var(--palette-#{$hue}-s),\n        var(--palette-#{$hue}-l),\n        $alpha\n    );\n}\n\n@mixin customProp($prop, $light, $dark: $light) {\n    & {\n        #{$prop}: $light;\n        @at-root body.theme-dark #{&} {\n            #{$prop}: $dark;\n        }\n    }\n}\n\n$swatches: 50, 100, 200, 300, 400, 500, 600, 700, 800, 900;\n\n@mixin paletteColour(\n    $prop,\n    $light,\n    $dark: $light,\n    $alphaLight: 1,\n    $alphaDark: 1\n) {\n    & {\n        @if list.index($swatches, $light) {\n            #{$prop}: hsla(\n                var(--theme-bg-hue),\n                var(--palette-#{$light}-s),\n                var(--palette-#{$light}-l),\n                $alphaLight\n            );\n        } @else {\n            @if meta.type-of($light) == 'number' and $light >= 0 and $light <= 1\n            {\n                #{$prop}: hsla(var(--theme-bg-hue), 10%, 95%, $light);\n            } @else {\n                #{$prop}: $light;\n            }\n        }\n\n        @at-root body.theme-dark #{&} {\n            @if list.index($swatches, $dark) {\n                #{$prop}: hsla(\n                    var(--theme-bg-hue),\n                    var(--palette-#{$dark}-s),\n                    var(--palette-#{$dark}-l),\n                    $alphaDark\n                );\n            } @else {\n                @if meta.type-of($dark) ==\n                    'number' and\n                    $dark >=\n                    0 and\n                    $dark <=\n                    1\n                {\n                    #{$prop}: hsla(var(--theme-bg-hue), 40%, 12%, $dark);\n                } @else {\n                    #{$prop}: $dark;\n                }\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.not-found-404';\n\n.not-found-404__wrapper {\n    padding: 2rem;\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 2rem;\n    z-index: 1;\n    transition:\n        transform 0.3s ease-in-out,\n        opacity 0.3s ease-in-out;\n    overflow: hidden;\n    height: 100%;\n    box-sizing: border-box;\n\n    .not-found-404__content {\n        max-width: 50rem;\n        width: 100%;\n\n        #{$block}__title {\n            width: 100%;\n            text-align: center;\n            font-weight: 100;\n            white-space: nowrap;\n            line-height: min(6rem, 10vw);\n            font-size: min(6.4rem, 11vw);\n            letter-spacing: min(0.5rem, 1vw);\n            margin-bottom: min(2rem, 4vw);\n            @include Utils.theme-paletteColour(\n                color,\n                300,\n                300,\n                $alphaLight: 0.8\n            );\n\n            span {\n                font-weight: 200;\n                @include Utils.theme-paletteColour(color, 200, 300);\n            }\n        }\n\n        #{$block}__subtitle {\n            text-align: center;\n            font-weight: 400;\n            margin-bottom: 5rem;\n            white-space: nowrap;\n            letter-spacing: 0.1rem;\n            line-height: min(2.2rem, 4vw);\n            font-size: min(2.2rem, 3.8vw);\n            @include Utils.theme-paletteColour(color, 300, 300);\n        }\n\n        #{$block}__description {\n            max-width: 100%;\n            text-align: center;\n            font-weight: 500;\n            letter-spacing: 0.1rem;\n            margin-top: 3rem;\n            line-height: max(min(2.4rem, 5vw), 2.2rem);\n            font-size: max(min(1.5rem, 3vw), 1.3rem);\n            @include Utils.theme-paletteColour(\n                color,\n                800,\n                100,\n                $alphaLight: 0.6\n            );\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.analytics';\n\n#{$block} {\n    width: 100%;\n    height: 100%;\n    display: grid;\n    gap: 1.6rem;\n    padding: 0.6rem;\n    box-sizing: border-box;\n    overflow: auto;\n}\n","@use '../../utils' as Utils;\n\n.coupons-sidebar-button {\n    $block: &;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    padding: 1.2rem 1.6rem;\n    box-sizing: border-box;\n\n    #{$block}__type {\n        letter-spacing: 0.1rem;\n        font-weight: 700;\n        font-size: 1rem;\n        padding: 0.4rem 0.8rem;\n        border-radius: 0.8rem;\n        text-align: center;\n        text-transform: uppercase;\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            200,\n            $alphaDark: 0.2\n        );\n    }\n\n    #{$block}__code {\n        letter-spacing: 0.2rem;\n        font-weight: 600;\n        font-size: 1.2rem;\n    }\n\n    #{$block}__expiration {\n        font-size: 1.2rem;\n        letter-spacing: 0.1rem;\n        font-weight: 400;\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './sidebar-button';\n\n$block: '.coupons';\n\n#{$block} {\n    position: relative;\n    z-index: 100;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n}\n\n$width: 42rem;\n\n.coupon-detail {\n    $block: &;\n    grid-area: details;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    #{$block}__buttons {\n        display: flex;\n        justify-content: end;\n        gap: 1rem;\n        margin-top: 2rem;\n        width: $width;\n    }\n\n    #{$block}__wrapper {\n        position: relative;\n        // filter: drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.75));\n        // -webkit-filter: drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.75));\n        // -moz-filter: drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.75));\n        // -ms-filter: drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.75));\n        // -o-filter: drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.75));\n        @include Utils.theme-customProp(\n            filter,\n            drop-shadow(0 0.4rem 1.2rem Utils.theme-get(900, 0.2)),\n            drop-shadow(0 0.4rem 1.2rem Utils.theme-get(900, 0))\n        );\n\n        #{$block}__wrapper-background {\n            position: relative;\n            height: 23rem;\n            width: $width;\n            border-radius: 1.2rem;\n            -webkit-mask-image: radial-gradient(\n                    circle at 1rem 5rem,\n                    transparent 1rem,\n                    red 1rem\n                ),\n                radial-gradient(\n                    closest-side circle at 50%,\n                    red 99%,\n                    transparent 100%\n                );\n            -webkit-mask-size:\n                100%,\n                1.2rem 0.4rem;\n            -webkit-mask-repeat: repeat, repeat-x;\n            -webkit-mask-position:\n                -1rem,\n                50% 4.8rem;\n            -webkit-mask-composite: source-out;\n            mask-composite: subtract;\n\n            @include Utils.theme-customProp(\n                background,\n                radial-gradient(\n                    circle at 30% 40%,\n                    rgba(255, 255, 255, 0.8),\n                    rgba(255, 255, 255, 0.4)\n                ),\n                radial-gradient(\n                    circle at 30% 40%,\n                    Utils.theme-get(200, 0.5),\n                    Utils.theme-get(200, 0.2)\n                )\n            );\n            &::after {\n                content: '';\n                position: absolute;\n                top: 0;\n                left: 0;\n                right: 0;\n                height: 5rem;\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    200,\n                    200,\n                    0.15,\n                    0.3\n                );\n            }\n        }\n\n        #{$block}__content {\n            position: absolute;\n            inset: 0;\n\n            #{$block}__code {\n                line-height: 5rem;\n                text-align: center;\n                font-weight: 700;\n                font-size: 1.3rem;\n                letter-spacing: 0.4rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    Utils.theme-get(800, 0.6),\n                    Utils.theme-get(50, 0.9) // white\n                );\n            }\n\n            #{$block}__content-details {\n                position: relative;\n                box-sizing: border-box;\n                padding: 0.8rem 1.6rem;\n                padding-bottom: 4rem;\n                height: calc(100% - 5rem);\n                display: flex;\n                flex-direction: column;\n                gap: 1rem;\n                // justify-content: space-evenly;\n\n                #{$block}__type {\n                    display: flex;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 1rem;\n                    // padding: 0 0 1rem;\n                    font-weight: 600;\n                    font-size: 1.3rem;\n                    letter-spacing: 0.1rem;\n                    line-height: 4rem;\n                    @include Utils.theme-paletteColour(\n                        color,\n                        Utils.theme-get(900, 0.4),\n                        Utils.theme-get(50, 0.8) // white\n                    );\n                }\n\n                #{$block}__detail-split {\n                    display: flex;\n                    justify-content: space-between;\n\n                    #{$block}__detail:first-child {\n                        text-align: start !important;\n                    }\n                    #{$block}__detail:last-child {\n                        text-align: end;\n                    }\n                }\n\n                #{$block}__detail {\n                    line-height: 1.6rem;\n                    @include Utils.theme-paletteColour(\n                        color,\n                        Utils.theme-get(900, 0.7),\n                        Utils.theme-get(50, 1)\n                    );\n\n                    #{$block}__detail-key {\n                        text-transform: uppercase;\n                        font-weight: 700;\n                        font-size: 1rem;\n                        letter-spacing: 0.2rem;\n                        opacity: 0.7;\n                    }\n\n                    #{$block}__detail-value {\n                        font-weight: 500;\n                        font-size: 1.3rem;\n                        letter-spacing: 0.1rem;\n                    }\n                }\n\n                #{$block}__status {\n                    position: absolute;\n                    bottom: 0.8rem;\n                    right: 0.8rem;\n                    height: 2.2rem;\n                    line-height: 2.2rem;\n                    padding: 0rem 1.2rem;\n                    box-sizing: border-box;\n                    border-radius: 0.6rem;\n                    font-size: 1rem;\n                    font-weight: 700;\n                    text-transform: uppercase;\n                    letter-spacing: 0.05rem;\n                    @include Utils.theme-paletteColour(\n                        background-color,\n                        rgba(255, 255, 255, 0.8),\n                        200,\n                        $alphaDark: 0.4\n                    );\n\n                    @include Utils.theme-paletteColour(\n                        color,\n                        Utils.theme-get(800, 0.6),\n                        Utils.theme-get(50, 0.9) // white\n                    );\n\n                    &#{$block}__status--disabled {\n                        @include Utils.theme-paletteColour(\n                            border-color,\n                            200,\n                            transparent\n                        );\n                        @include Utils.theme-paletteColour(\n                            background-color,\n                            200,\n                            $alphaDark: 0.4\n                        );\n                        @include Utils.theme-paletteColour(color, white, white);\n                    }\n\n                    &#{$block}__status--expired {\n                        @include Utils.theme-paletteColour(\n                            border-color,\n                            200,\n                            transparent\n                        );\n                        @include Utils.theme-paletteColour(\n                            background-color,\n                            200,\n                            $alphaDark: 0.4\n                        );\n                        @include Utils.theme-paletteColour(color, white, white);\n                    }\n                }\n            }\n        }\n    }\n\n    @media (max-width: 480px) {\n        #{$block}__buttons {\n            width: 38rem;\n        }\n        #{$block}__wrapper {\n            #{$block}__wrapper-background {\n                width: 38rem;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.inventory-sidebar-button {\n    $block: &;\n    padding: 1.2rem 1.2rem;\n    gap: 2rem;\n    border-radius: 1.2rem;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n\n    &#{$block}--archived {\n        #{$block}__image {\n            border: 0.3rem solid;\n            @include Utils.theme-paletteColour(\n                border-color,\n                hsl(0, 70%, 70%),\n                hsl(0, 40%, 50%)\n            );\n        }\n    }\n\n    #{$block}__image {\n        position: relative;\n        flex: 0 0 6.8rem;\n        overflow: hidden;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        box-sizing: border-box;\n        border-radius: 0.8rem;\n        width: 6.8rem;\n        height: 5rem;\n\n        img {\n            width: 6.8rem;\n            height: 5rem;\n            object-fit: cover;\n        }\n\n        #{$block}__status {\n            position: absolute;\n            height: 2rem;\n            bottom: -0.3rem;\n            left: -0.3rem;\n            right: -0.3rem;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            box-sizing: border-box;\n            font-size: 1rem;\n            font-weight: 700;\n            text-transform: uppercase;\n            letter-spacing: 0.04rem;\n            @include Utils.theme-paletteColour(color, white, white);\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsl(0, 70%, 70%),\n                hsl(0, 40%, 50%)\n            );\n        }\n    }\n\n    #{$block}__text {\n        display: flex;\n        flex-direction: column;\n        text-align: start;\n        gap: 0.4rem;\n        letter-spacing: 0.1rem;\n\n        #{$block}__description {\n            font-size: 1.2rem;\n            line-height: 1.4rem;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.product-details';\n\n.product-details {\n    $block: &;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    padding: 2rem;\n    box-sizing: border-box;\n    overflow: auto;\n\n    @media (max-width: 1400px) {\n        padding: 2rem 1rem;\n    }\n\n    #{$block}__status {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 1rem;\n        padding: 1.2rem;\n        box-sizing: border-box;\n        border-radius: 1rem;\n        border: 0.2rem solid;\n        margin-bottom: -1rem;\n        @include Utils.theme-paletteColour(border-color, 200);\n        @include Utils.theme-paletteColour(background-color, 50, transparent);\n        @include Utils.theme-paletteColour(color, 200);\n\n        #{$block}__status-text {\n            font-size: 1.3rem;\n            font-weight: 700;\n            line-height: 2rem;\n            text-transform: uppercase;\n            letter-spacing: 0.2rem;\n        }\n\n        &#{$block}__status--published {\n            @include Utils.theme-paletteColour(border-color, 200, transparent);\n            @include Utils.theme-paletteColour(\n                background-color,\n                200,\n                $alphaDark: 0.4\n            );\n            @include Utils.theme-paletteColour(color, white, white);\n        }\n        &#{$block}__status--archived {\n            @include Utils.theme-paletteColour(\n                border-color,\n                transparent,\n                transparent\n            );\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsl(0, 70%, 70%),\n                hsl(0, 40%, 50%)\n            );\n            @include Utils.theme-paletteColour(color, white, white);\n        }\n    }\n\n    #{$block}__details {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 2rem;\n\n        #{$block}__details-description {\n            display: flex;\n            flex-direction: column;\n            gap: 1rem;\n        }\n    }\n\n    #{$block}__buttons-row {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 1rem;\n        justify-content: center;\n        align-items: stretch;\n\n        .demmi-ui-button {\n            flex: 1 1 calc(50% - 1rem);\n            height: auto;\n        }\n    }\n}\n\n.product-category {\n    $block: &;\n    display: flex;\n    flex-wrap: wrap;\n    @include Utils.theme-paletteColour(\n        color,\n        rgba(0, 0, 0, 0.6),\n        rgba(255, 255, 255, 0.8)\n    );\n\n    #{$block}__list {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 1rem;\n        padding: 1rem;\n\n        #{$block}__tag {\n            display: flex;\n            gap: 1rem;\n        }\n    }\n}\n\n.product-images {\n    $block: &;\n\n    #{$block}__no-images {\n        font-size: 1.2rem;\n        font-weight: 400;\n        line-height: 2rem;\n        text-align: center;\n        letter-spacing: 0.08rem;\n        margin: 1rem auto;\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.6);\n    }\n}\n\n.product-tags {\n    $block: &;\n\n    #{$block}__list {\n        display: flex;\n        // flex-direction: column;\n        flex-wrap: wrap;\n        gap: 1rem;\n        margin: 0 1rem 1rem;\n\n        #{$block}__tag {\n            display: flex;\n            gap: 1rem;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.product-variants {\n    $block: &;\n    width: 100%;\n    height: 100%;\n    margin: 0 auto;\n    border-radius: 1.2rem;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    padding: 2rem;\n    box-sizing: border-box;\n    overflow: auto;\n\n    @media (max-width: 1400px) {\n        padding: 2rem 1rem;\n    }\n\n    #{$block}__title {\n        font-size: 1.6rem;\n        letter-spacing: 0.05rem;\n        font-weight: 500;\n        line-height: 2rem;\n        text-align: center;\n        @include Utils.theme-paletteColour(\n            color,\n            rgba(0, 0, 0, 0.6),\n            rgba(255, 255, 255, 0.8)\n        );\n    }\n}\n\n.product-variant {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    padding: 2rem 1rem;\n    margin: 0 auto;\n    align-items: center;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.5), white);\n\n    #{$block}__buttons-row {\n        margin-top: 2rem;\n        align-items: center;\n        display: flex;\n        gap: 1rem;\n    }\n}\n\n.product-variant-inputs {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    width: 100%;\n\n    #{$block}__details-row {\n        width: 100%;\n        display: flex;\n        gap: 1rem;\n        align-items: center;\n\n        #{$block}__details-item {\n            width: 100%;\n\n            #{$block}__details-title {\n                font-size: 1.3rem;\n                letter-spacing: 0.05rem;\n                font-weight: 500;\n                line-height: 1.4rem;\n                margin: 0.5rem 1rem 1rem;\n            }\n\n            .demmi-ui-button {\n                width: 100%;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './_sidebar-button';\n@use './_product-details';\n@use './_product-variants';\n\n$block: '.inventory';\n$swiperBottomPadding: 6rem;\n\n#{$block} {\n    position: relative;\n    z-index: 100;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n\n    #{$block}__details {\n        height: 100%;\n        width: 100%;\n        box-sizing: border-box;\n        overflow: hidden;\n\n        #{$block}__live-preview {\n            display: none;\n        }\n\n        #{$block}__swiper {\n            height: 100%;\n            margin: 0 auto;\n\n            #{$block}__pane {\n                &#{$block}__pane--preview {\n                    display: flex;\n                    align-items: center;\n                    padding: 2rem;\n                    box-sizing: border-box;\n\n                    @media (max-width: 1600px) {\n                        .fake-phone {\n                            max-height: 76rem;\n                        }\n                    }\n                }\n            }\n        }\n\n        .swiper-pagination-bullets {\n            --swiper-pagination-bottom: 0;\n            overflow: visible;\n            backdrop-filter: blur(10px);\n            -webkit-backdrop-filter: blur(10px);\n            padding: 0.5rem 0;\n\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0.6),\n                hsla(var(--theme-bg-hue), 16%, 24%, 0.6)\n            );\n        }\n\n        .swiper-pagination-bullet {\n            position: relative;\n            width: auto;\n            height: auto;\n            text-align: center;\n            line-height: 1.4rem;\n            border-radius: 0.6rem;\n            padding: 1rem 2.2rem;\n            box-sizing: border-box;\n            font-size: 1.1rem;\n            font-weight: 600;\n            letter-spacing: 0.2rem;\n            opacity: 1;\n            text-transform: uppercase;\n            margin: 0 0.1rem;\n            transition:\n                transform 0.1s ease-in-out,\n                border-radius 0.1s ease-in-out;\n            z-index: 1;\n            background-color: transparent;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                50,\n                $alphaLight: 0.7\n            );\n        }\n\n        .swiper-pagination-bullet-active {\n            z-index: 2;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 0.9\n            );\n            @include Utils.theme-paletteColour(\n                background-color,\n                white,\n                200,\n                $alphaDark: 0.4\n            );\n        }\n\n        @media (max-width: 800px) {\n            .product-details {\n                padding-bottom: $swiperBottomPadding;\n            }\n            .product-variants {\n                padding-bottom: $swiperBottomPadding;\n            }\n        }\n    }\n\n    &#{$block}--live-preview {\n        #{$block}__details {\n            grid-template: 'preview details variants' 1fr / 42rem 3fr 2fr;\n\n            #{$block}__live-preview {\n                grid-area: preview;\n                width: 100%;\n                height: 100%;\n                display: flex;\n                justify-content: center;\n                box-sizing: border-box;\n                overflow: hidden auto;\n\n                .fake-phone {\n                    margin: 0.5rem auto;\n\n                    @media (max-height: 930px) {\n                        align-self: auto;\n                    }\n                }\n            }\n\n            .product-details {\n                padding: 2rem 0.5rem;\n            }\n            .product-variants {\n                padding: 2rem 0.5rem;\n            }\n\n            @media (max-width: 1500px) {\n                .product-details {\n                    padding-bottom: $swiperBottomPadding;\n                }\n                .product-variants {\n                    padding-bottom: $swiperBottomPadding;\n                }\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.reviews-sidebar-button {\n    $block: &;\n    position: relative;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n    padding: 1rem 1.6rem;\n    border-radius: 1.2rem;\n    box-sizing: border-box;\n    @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n\n    #{$block}__top {\n        width: 100%;\n        height: 2.4rem;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        #{$block}__customer-name {\n            line-height: 2rem;\n            letter-spacing: 0.1rem;\n            font-weight: 400;\n            font-size: 1.4rem;\n            text-align: start;\n            display: -webkit-box;\n            -webkit-line-clamp: 1;\n            line-clamp: 1;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n        }\n\n        #{$block}__rating {\n            display: flex;\n            gap: 0.4rem;\n            svg {\n                @include Utils.theme-paletteColour(color, 300, 50);\n            }\n        }\n    }\n\n    #{$block}__content {\n        width: calc(100% + 1rem);\n        box-sizing: border-box;\n        padding: 0.8rem 1.2rem;\n        border-radius: 0.8rem;\n        margin: 0 -0.5rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            800,\n            200,\n            $alphaLight: 0.08,\n            $alphaDark: 0.2\n        );\n\n        #{$block}__title {\n            line-height: 2rem;\n            letter-spacing: 0.05rem;\n            font-weight: 600;\n            font-size: 1.3rem;\n            text-align: start;\n            margin-bottom: 0.5rem;\n        }\n\n        #{$block}__body {\n            line-height: 1.8rem;\n            letter-spacing: 0.05rem;\n            font-weight: 500;\n            font-size: 1.2rem;\n            text-align: start;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n        }\n    }\n\n    #{$block}__date {\n        width: 100%;\n        line-height: 2rem;\n        font-size: 1.2rem;\n        letter-spacing: 0.1rem;\n        font-weight: 500;\n        opacity: 0.8;\n        text-align: end;\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './sidebar-button';\n\n$block: '.reviews';\n\n#{$block} {\n    position: relative;\n    z-index: 100;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: auto;\n}\n\n.review-item__wrapper {\n    grid-area: details;\n    margin: 0 auto;\n    width: 100%;\n    max-width: 90rem;\n    padding: 2rem 1rem;\n    box-sizing: border-box;\n}\n\n.review-item {\n    $block: &;\n    display: grid;\n    grid-template:\n        'header customer' 1fr\n        'body body'\n        'response response' / 1fr 30rem;\n    gap: 0rem;\n    position: relative;\n    align-items: start;\n    padding: 2rem !important;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n    #{$block}__header {\n        grid-area: header;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin-bottom: 4rem;\n\n        #{$block}__rating {\n            display: flex;\n            gap: 0.4rem;\n            svg {\n                @include Utils.theme-paletteColour(color, 300, white);\n            }\n        }\n\n        #{$block}__timestamp {\n            font-size: 1.4rem;\n            font-weight: 500;\n\n            span {\n                text-transform: uppercase;\n                font-size: 1.3rem;\n                font-weight: 700;\n                margin-left: 1rem;\n            }\n        }\n    }\n\n    #{$block}__review {\n        grid-area: body;\n        margin-bottom: 2rem;\n\n        #{$block}__review-title {\n            font-size: 1.5rem;\n            line-height: 2rem;\n            font-weight: 500;\n        }\n        #{$block}__review-description {\n            font-size: 1.3rem;\n            font-weight: 400;\n            line-height: 1.8rem;\n\n            #{$block}__review-description-paragraph {\n                margin: 1rem 0;\n            }\n        }\n    }\n\n    #{$block}__customer {\n        grid-area: customer;\n        padding: 1.2rem 1.6rem;\n        margin-top: -1rem;\n        margin-right: -1rem;\n        border-radius: 1.2rem;\n        @include Utils.theme-paletteColour(background-color, 50, 0.4);\n\n        #{$block}__not-found {\n            font-size: 1.2rem;\n            font-weight: 500;\n            margin-bottom: 0.5rem;\n            letter-spacing: 0.1rem;\n            line-height: 2rem;\n            @include Utils.theme-paletteColour(\n                color,\n                rgba(0, 0, 0, 0.4),\n                white\n            );\n        }\n\n        #{$block}__title {\n            font-size: 1.2rem;\n            font-weight: 700;\n            margin-bottom: 0.5rem;\n            letter-spacing: 0.1rem;\n            text-transform: uppercase;\n            line-height: 2rem;\n            @include Utils.theme-paletteColour(\n                color,\n                rgba(0, 0, 0, 0.4),\n                white\n            );\n        }\n\n        #{$block}__customer-name {\n            font-size: 1.3rem;\n            font-weight: 400;\n            letter-spacing: 0.1rem;\n            line-height: 2rem;\n        }\n\n        #{$block}__customer-number {\n            font-size: 1.3rem;\n            font-weight: 400;\n            letter-spacing: 0.1rem;\n            line-height: 2rem;\n        }\n    }\n\n    #{$block}__review-response {\n        grid-area: response;\n        padding: 0.8rem 1.6rem 0.2rem;\n        font-size: 1.3rem;\n        font-weight: 400;\n        line-height: 1.8rem;\n        border-radius: 1.2rem;\n        @include Utils.theme-paletteColour(background-color, 50, 0.4);\n\n        #{$block}__review-response-title {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            font-size: 1.5rem;\n            font-weight: 500;\n            margin-bottom: 1rem;\n            margin-right: -0.8rem;\n\n            #{$block}__review-response-title-buttons {\n                display: flex;\n                align-items: center;\n                gap: 0.8rem;\n            }\n        }\n\n        #{$block}__review-description-paragraph {\n            margin: 1.2rem 0;\n        }\n\n        #{$block}__review-no-response {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            text-align: center;\n            gap: 1.6rem;\n            font-size: 1.4rem;\n            font-weight: 400;\n            padding: 1.6rem 0;\n        }\n    }\n\n    @media (max-width: 640px) {\n        grid-template:\n            'customer customer' auto\n            'header header' auto\n            'body body' auto\n            'response response' / auto 30rem;\n\n        #{$block}__customer {\n            margin: -0.8rem;\n            margin-bottom: 2rem;\n        }\n\n        #{$block}__review-response {\n            margin: -0.8rem;\n            margin-top: 0;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.widget-order-item {\n    $block: &;\n    line-height: 1.8rem;\n\n    #{$block}__collection-info {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        border-radius: 1rem;\n        text-align: center;\n        margin-bottom: 0.8rem;\n        padding: 0.4rem 1rem;\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 0.6);\n\n        #{$block}__collection-item {\n            flex: 0 0 1fr;\n\n            &:first-child {\n                text-align: start;\n                #{$block}__collection-item-value {\n                    letter-spacing: 0.3rem;\n                }\n            }\n            &:last-child {\n                text-align: end;\n            }\n            #{$block}__collection-item-heading {\n                font-size: 1rem;\n                font-weight: 600;\n                letter-spacing: 0.1rem;\n                line-height: 1.4rem;\n                text-transform: uppercase;\n            }\n            #{$block}__collection-item-value {\n                font-size: 1.4rem;\n                font-weight: 700;\n                letter-spacing: 0.15rem;\n                line-height: 2.2rem;\n            }\n        }\n    }\n\n    #{$block}__products-list {\n        display: flex;\n        flex-direction: column;\n        gap: 0.2rem;\n        border-radius: 1rem;\n\n        #{$block}__product {\n            display: flex;\n            gap: 1.6rem;\n            align-items: center;\n            box-sizing: border-box;\n            border-radius: 0.4rem;\n            padding: 0.4rem;\n            @include Utils.theme-paletteColour(background-color, 50, 0.6);\n            @include Utils.theme-paletteColour(\n                color,\n                rgba(0, 0, 0, 0.7),\n                white\n            );\n\n            &:first-child {\n                border-top-left-radius: 1.2rem;\n                border-top-right-radius: 1.2rem;\n\n                #{$block}__product-image {\n                    border-top-left-radius: 1rem;\n                }\n            }\n            &:last-child {\n                border-bottom-left-radius: 1.2rem;\n                border-bottom-right-radius: 1.2rem;\n\n                #{$block}__product-image {\n                    border-bottom-left-radius: 1rem;\n                }\n            }\n\n            #{$block}__product-image {\n                width: 6rem;\n                height: 5rem;\n                box-sizing: border-box;\n                overflow: hidden;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                border-radius: 0.3rem;\n\n                img {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                }\n            }\n\n            #{$block}__product-name {\n                font-size: 1.3rem;\n                font-weight: 600;\n            }\n\n            #{$block}__product-variant {\n                margin-top: 0.4rem;\n                font-size: 1.2rem;\n                line-height: 1.4rem;\n                font-weight: 400;\n            }\n\n            #{$block}__product-quantity {\n                margin-left: auto;\n                margin-right: 1rem;\n                font-size: 1.8rem;\n                font-weight: 400;\n\n                #{$block}__product-quantity-unit {\n                    font-size: 1.1rem;\n                    font-weight: 700;\n                    margin-left: 0.4rem;\n                    text-transform: uppercase;\n                    opacity: 0.6;\n                }\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './widget-order-item';\n\n.widget-orders {\n    $block: &;\n    grid-area: orders;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    min-width: 50rem;\n    overflow: auto;\n\n    #{$block}__list {\n        width: 100%;\n        height: 100%;\n        box-sizing: border-box;\n        border-radius: 1.5rem;\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 1.2rem;\n        padding: 1rem 0;\n        @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n    }\n}\n","@use '../../utils' as Utils;\n\n.widget-review-item {\n    $block: &;\n\n    #{$block}__header {\n        grid-area: header;\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 1rem;\n        padding: 0.6rem 0.8rem 0.4rem;\n\n        #{$block}__rating {\n            display: flex;\n            gap: 0.4rem;\n            font-size: 1.3rem;\n            svg {\n                @include Utils.theme-paletteColour(color, 300, white);\n            }\n        }\n\n        #{$block}__timestamp {\n            font-size: 1.3rem;\n            font-weight: 500;\n            line-height: 1.4rem;\n\n            span {\n                text-transform: uppercase;\n                font-size: 1.2rem;\n                font-weight: 700;\n                margin-left: 1rem;\n            }\n        }\n    }\n\n    #{$block}__review {\n        grid-area: body;\n        padding: 1.2rem;\n        border-radius: 1rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            0.5,\n            $alphaDark: 0.4\n        );\n\n        #{$block}__review-title {\n            font-size: 1.4rem;\n            line-height: 2rem;\n            font-weight: 500;\n        }\n        #{$block}__review-description {\n            font-size: 1.2rem;\n            font-weight: 400;\n            line-height: 1.7rem;\n            letter-spacing: 0.02rem;\n            text-align: justify;\n\n            #{$block}__review-description-paragraph {\n                margin: 1rem 0 0;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './widget-review-item';\n\n.widget-reviews {\n    $block: &;\n    grid-area: reviews;\n    display: flex;\n    flex-direction: column;\n    min-width: 42rem;\n\n    #{$block}__list {\n        width: 100%;\n        height: 100%;\n        box-sizing: border-box;\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 1.2rem;\n        padding: 1rem 0;\n        @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './widget-review-item';\n\n.widget-analytics {\n    $block: &;\n    grid-area: analytics;\n    display: flex;\n    min-width: 40rem;\n\n    #{$block}__coming-soon {\n        position: absolute;\n        inset: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 1.4rem;\n        letter-spacing: 0.2rem;\n        font-weight: 600;\n        line-height: 3.8rem;\n        text-transform: uppercase;\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.6);\n    }\n}\n","@use '../../utils' as Utils;\n\n$listPadding: 1rem;\n$slotPaddingVertical: 1rem;\n$slotPaddingHorizontal: 1.2rem;\n$slotMarginVertical: 0.4rem;\n$slotTitleLineHeight: 1.4rem;\n\n.widget-incoming-schedule {\n    $block: &;\n    grid-area: incoming-schedule;\n    height: 100%;\n    padding: 0;\n    position: relative;\n    overflow: hidden;\n\n    #{$block}__list {\n        position: relative;\n        height: 100%;\n        overflow: auto;\n        padding: $listPadding 0;\n        box-sizing: border-box;\n\n        #{$block}__time-indicator {\n            position: absolute;\n            margin-top: calc(\n                $listPadding + $slotPaddingVertical + $slotMarginVertical +\n                    ($slotTitleLineHeight / 2) - 0.2rem\n            );\n            top: 0;\n            left: 6.4rem;\n            right: 0;\n            height: 0.4rem;\n            border-radius: 0.2rem;\n            @include Utils.theme-paletteColour(background-color, 400, 300);\n\n            &::before {\n                content: '';\n                position: absolute;\n                top: -0.4rem;\n                right: 0rem;\n                width: 1.2rem;\n                height: 1.2rem;\n                border-radius: 50%;\n                @include Utils.theme-paletteColour(background-color, 400, 300);\n            }\n        }\n    }\n\n    #{$block}__message {\n        position: absolute;\n        inset: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        pointer-events: none;\n\n        #{$block}__message-text {\n            border-radius: 1.2rem;\n            padding: 1.2rem 2rem;\n            box-sizing: border-box;\n            font-size: 1.3rem;\n            font-weight: 500;\n            line-height: 2rem;\n            backdrop-filter: blur(4px);\n            white-space: pre-line;\n            text-align: center;\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0.7),\n                200,\n                $alphaDark: 0.3\n            );\n            @include Utils.theme-paletteColour(\n                color,\n                700,\n                rgba(255, 255, 255, 1)\n            );\n        }\n    }\n}\n\n.widget-incoming-schedule-slot {\n    $block: &;\n    margin: $slotMarginVertical 0;\n    user-select: none;\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    align-items: flex-start;\n    min-height: 7rem;\n    max-height: 7rem;\n    padding: $slotPaddingVertical $slotPaddingHorizontal;\n    box-sizing: border-box;\n    border-radius: 0.8rem;\n    transition: background-color 0.1s ease-in-out;\n    opacity: 0.4;\n\n    &:not(&#{$block}--has-passed)#{$block}--is-open:hover {\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            200,\n            $alphaDark: 0.28\n        );\n    }\n\n    &#{$block}--is-open {\n        opacity: 1;\n    }\n\n    #{$block}__time {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        gap: 1.2rem;\n\n        #{$block}__time-text {\n            width: 5rem;\n            font-size: 1.2rem;\n            font-weight: 500;\n            line-height: $slotTitleLineHeight;\n            letter-spacing: 0.2rem;\n            @include Utils.theme-paletteColour(color, 900, white);\n        }\n        #{$block}__time-line {\n            height: 0.1rem;\n            width: 100%;\n            @include Utils.theme-paletteColour(background-color, 200, 200);\n        }\n    }\n\n    #{$block}__orders-list {\n        display: flex;\n        flex-direction: column;\n        gap: 0.6rem;\n        width: 100%;\n        box-sizing: border-box;\n        padding: 1rem 0rem 0;\n\n        #{$block}__order {\n            cursor: pointer;\n            position: relative;\n            width: 100%;\n            box-sizing: border-box;\n            padding: 0.6rem 0.8rem;\n            border-radius: 0.8rem;\n            border: 0.3rem solid transparent;\n            transition: box-shadow 0.1s ease-in-out;\n            @include Utils.theme-paletteColour(\n                background-color,\n                white,\n                200,\n                $alphaDark: 0.5\n            );\n\n            #{$block}__order-status {\n                width: 100%;\n                font-weight: 700;\n                font-size: 1.1rem;\n                line-height: 2.2rem;\n                text-transform: uppercase;\n                letter-spacing: 0.2rem;\n                text-align: center;\n                border-radius: 0.4rem;\n                margin-bottom: 0.8rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    white,\n                    $alphaLight: 0.6\n                );\n                @include Utils.theme-paletteColour(background-color, 50, 0.4);\n            }\n            #{$block}__order-id {\n                font-size: 1.2rem;\n                font-weight: 600;\n                line-height: 1.6rem;\n                letter-spacing: 0.1rem;\n                margin-bottom: 0.2rem;\n                @include Utils.theme-paletteColour(color, 900, white);\n            }\n            #{$block}__order-customer {\n                font-size: 1.3rem;\n                font-weight: 500;\n                line-height: 1.8rem;\n                letter-spacing: 0.02rem;\n                @include Utils.theme-paletteColour(color, 900, white);\n            }\n\n            &:hover {\n                @include Utils.shadow-get(2);\n            }\n        }\n    }\n}\n","$_offset: (\n    0: 0 0 0,\n    1: 0 0.2rem 0.4rem,\n    2: 0 0.5rem 0.8rem,\n    3: 0 0.9rem 1.2rem,\n    4: 0 1.2rem 1.8rem,\n    5: 0 1.6rem 2.2rem,\n    6: 0 2rem 2.4rem,\n);\n\n@function _getAlpha($palette, $level) {\n    @if $palette == light {\n        @return 0.22 - ($level - 1) * 0.02;\n    } @else {\n        @return 0.64 - ($level - 1) * 0.08;\n    }\n}\n\n@function _getHue($palette) {\n    @if $palette == light {\n        @return 'var(--theme-bg-hue), 100%, 20%';\n    } @else {\n        @return 'var(--theme-bg-hue), 8%, 16%';\n    }\n}\n\n@function getShadowValue($palette, $level) {\n    $offset: map-get($_offset, $level);\n    $value: $offset + ' hsl(' + _getHue($palette) + ',' +\n        _getAlpha($palette, $level) + ')';\n    @return #{$value};\n}\n\n@mixin get($level, $levelDarkMode: $level, $scale: false, $growth: $level) {\n    & {\n        box-shadow: getShadowValue(light, $level);\n        @if $scale {\n            $s: calc(1 + 0.02 * $growth);\n            transform: scale3d($s, $s, $s);\n        }\n        @at-root body.theme-dark #{&} {\n            box-shadow: getShadowValue(dark, $levelDarkMode);\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './widget-review-item';\n\n$block: '.dashboard-badge';\n.dashboard-badges {\n    grid-area: badges;\n    display: flex;\n    gap: 2rem;\n    justify-content: center;\n    align-items: center;\n\n    #{$block} {\n        pointer-events: none;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        height: 6rem;\n        width: 26rem;\n        border-radius: 1.6rem;\n        padding: 1.2rem 2rem;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.7),\n            200,\n            $alphaDark: 0.3\n        );\n\n        #{$block}__text {\n            #{$block}__title {\n                font-size: 1.5rem;\n                font-weight: 500;\n                line-height: 2.2rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    rgba(255, 255, 255, 1),\n                    $alphaLight: 1\n                );\n            }\n\n            #{$block}__subtitle {\n                font-size: 1rem;\n                line-height: 1.4rem;\n                font-weight: 700;\n                text-transform: uppercase;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    rgba(255, 255, 255, 0.6),\n                    $alphaLight: 0.5\n                );\n            }\n        }\n\n        #{$block}__value {\n            font-size: 2.4rem;\n            font-weight: 300;\n            line-height: 2rem;\n            letter-spacing: 0.2rem;\n            @include Utils.theme-paletteColour(\n                color,\n                700,\n                rgba(255, 255, 255, 1)\n            );\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './widget-orders';\n@use './widget-reviews';\n@use './widget-analytics';\n@use './incoming-schedule';\n@use './badges';\n\n.home {\n    $block: &;\n    width: 100%;\n    height: 100%;\n    display: grid;\n    grid-template:\n        'badges badges badges' 6rem\n        'incoming-schedule analytics analytics' 30rem\n        'incoming-schedule orders reviews' / 26rem 1fr 1fr;\n    gap: 1.6rem;\n    padding: 0.6rem;\n    box-sizing: border-box;\n    overflow: auto hidden;\n}\n\n.dashboard-section {\n    position: relative;\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    overflow: auto;\n    border-radius: 2rem;\n\n    @include Utils.theme-paletteColour(\n        background-color,\n        rgba(255, 255, 255, 0.5),\n        200,\n        $alphaDark: 0.2\n    );\n\n    &#{$block}--loading {\n        #{$block}__content {\n            opacity: 0.4;\n        }\n    }\n\n    #{$block}__content {\n        display: flex;\n        flex-direction: column;\n        padding: 1rem 1rem 0 1rem;\n        overflow: hidden;\n    }\n\n    #{$block}__title {\n        position: relative;\n        flex: 0 0 0.1rem;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 1.6rem;\n        letter-spacing: 0.05rem;\n        font-weight: 500;\n        line-height: 3.8rem;\n        padding: 0 0 1rem 1.5rem;\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n\n        &::before {\n            content: '';\n            position: absolute;\n            bottom: 0;\n            left: -1rem;\n            right: -1rem;\n            height: 0.1rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                800,\n                200,\n                $alphaLight: 0.2,\n                $alphaDark: 0.6\n            );\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.shop-management-details {\n    $block: &;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    @include Utils.theme-paletteColour(\n        color,\n        rgba(0, 0, 0, 0.5),\n        rgba(255, 255, 255, 0.8)\n    );\n\n    #{$block}__description {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        padding: 1rem;\n        box-sizing: border-box;\n    }\n}\n","@use '../../utils' as Utils;\n\n.shop-management-images {\n    $block: &;\n    border-radius: 1rem;\n    padding: 1rem;\n    box-sizing: border-box;\n    overflow: auto;\n\n    #{$block}__grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));\n        overflow: auto;\n        gap: 1rem;\n\n        #{$block}__image-item {\n            display: flex;\n            flex-direction: column;\n            gap: 0.5rem;\n            border-radius: 1.5rem;\n            padding: 0.5rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                50,\n                rgba(0, 0, 0, 0.2),\n                $alphaLight: 0.5\n            );\n\n            #{$block}__image-wrapper {\n                width: 100%;\n                box-sizing: border-box;\n                height: 30rem;\n                overflow: hidden;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n\n                img {\n                    max-height: 100%;\n                    max-width: 100%;\n                    border-radius: 0.5rem;\n                }\n            }\n\n            #{$block}__image-details {\n                display: flex;\n                gap: 0.5rem;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.shop-management-location {\n    $block: &;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    max-width: 80rem !important;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.5), white);\n\n    #{$block}__button-not-found {\n        display: flex;\n        flex-direction: column;\n        gap: 1.2rem;\n        align-items: center;\n\n        #{$block}__button-not-found-text {\n            font-size: 1.3rem;\n            letter-spacing: 0.05rem;\n            font-weight: 500;\n            line-height: 1.4rem;\n            text-align: center;\n        }\n    }\n\n    #{$block}__buttons {\n        align-self: center;\n        display: flex;\n        gap: 1rem;\n    }\n\n    #{$block}__address {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        box-sizing: border-box;\n\n        #{$block}__inputs-area {\n            align-items: center;\n            border-radius: 1.5rem;\n            box-sizing: border-box;\n            display: flex;\n            flex-wrap: wrap;\n            margin: 0 -1rem;\n\n            #{$block}__details-item {\n                flex: 0 1 50%;\n                box-sizing: border-box;\n                padding: 1rem;\n\n                #{$block}__details-title {\n                    font-size: 1.3rem;\n                    letter-spacing: 0.05rem;\n                    font-weight: 500;\n                    line-height: 1.4rem;\n                    margin: 0.5rem 1rem 1rem;\n                }\n\n                .demmi-ui-button {\n                    width: 100%;\n                }\n            }\n        }\n    }\n\n    #{$block}__geo {\n        width: 100%;\n        height: 40rem;\n        box-sizing: border-box;\n\n        #gmaps-view {\n            border-radius: 1rem;\n\n            #{$block}__geo-input-search {\n                position: absolute;\n                top: 1rem;\n                right: 1rem;\n                padding: 1rem 1.6rem !important;\n                font-size: 1.3rem;\n                letter-spacing: 0.08rem;\n                line-height: 2rem;\n                width: 30rem !important;\n                height: auto !important;\n                box-sizing: border-box;\n                outline: none;\n                border-radius: 0.8rem !important;\n                border: 0.2rem solid transparent;\n                transition:\n                    background-color 0.1s ease-in-out,\n                    border-color 0.1s ease-in-out,\n                    border-radius 0.2s ease-in-out,\n                    box-shadow 0.2s ease-in-out;\n            }\n        }\n    }\n\n    @media (max-width: 580px) {\n        gap: 2rem;\n\n        #{$block}__address {\n            #{$block}__inputs-area {\n                #{$block}__details-item {\n                    flex: 0 1 100%;\n                }\n            }\n        }\n    }\n}\n\n.gmap-autocomplete {\n    $block: &;\n    width: 30rem;\n    box-sizing: border-box;\n    margin-top: 0.8rem;\n    margin-left: 0.8rem;\n\n    .demmi-ui-input {\n        opacity: 0.9;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(background-color, 50, 0.8);\n\n        &:hover {\n            opacity: 1;\n            @include Utils.shadow-get(3);\n            @include Utils.theme-paletteColour(background-color, 50, 0.8);\n        }\n\n        &:focus {\n            opacity: 1;\n            @include Utils.theme-paletteColour(background-color, 50, 0.8);\n        }\n    }\n\n    .demmi-ui-menu {\n        margin-top: 0.8rem;\n        box-sizing: border-box;\n\n        .demmi-ui-menu-item {\n            text-align: start;\n        }\n    }\n\n    #{$block}__predictions {\n        box-sizing: border-box;\n        background: white;\n        backdrop-filter: blur(10px);\n        -webkit-backdrop-filter: blur(10px);\n        overflow: hidden auto;\n        max-height: 40rem;\n        border-radius: 2rem;\n        box-shadow:\n            0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12),\n            0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);\n    }\n}\n","@use '../../utils' as Utils;\n\n.shop-management-delivery-days {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 30rem;\n    overflow: hidden;\n}\n","@use '../../utils' as Utils;\n\n$block: '.shop-management-theme-item';\n\n#{$block} {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.4rem;\n    border-radius: 1rem;\n    padding: 0.5rem;\n    box-sizing: border-box;\n    cursor: pointer;\n    @include Utils.theme-paletteColour(\n        background-color,\n        rgba(255, 255, 255, 0.4),\n        rgba(0, 0, 0, 0.4)\n    );\n\n    #{$block}__block {\n        height: 100%;\n        width: 100%;\n        border-radius: 0.5rem;\n    }\n\n    &:hover {\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 1),\n            black\n        );\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './_theme-item';\n\n$block: '.shop-management-theme';\n\n$mainGridTemplate: 'phone appswitcher' 5rem 'phone themes' 75rem\n    'buttons buttons' 6rem / auto 1fr;\n$altGridTemplate: 'phone appswitcher' 5rem 'phone themes' 68rem\n    'buttons buttons' 6rem / 36rem auto;\n$altMiniGridTemplate: 'phone appswitcher' 5rem 'phone themes' 62rem\n    'buttons buttons' 6rem / 32rem auto;\n$mobileGridTemplate: 'appswitcher' 5rem 'phone' 72rem 'themes' 70rem 'buttons'\n    auto / 1fr;\n\n#{$block} {\n    padding: 2rem;\n    box-sizing: border-box;\n    margin: 0 auto;\n    max-height: 100%;\n    width: 100%;\n    max-width: 100rem;\n    align-self: center;\n    gap: 2rem 3rem;\n    display: grid;\n    grid-template: $mainGridTemplate;\n    @include Utils.theme-paletteColour(\n        color,\n        rgba(0, 0, 0, 0.5),\n        rgba(255, 255, 255, 0.8)\n    );\n\n    #{$block}__items {\n        grid-area: themes;\n        overflow: auto;\n        border-radius: 1rem;\n        height: 100%;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        gap: 0.4rem;\n    }\n\n    .fake-phone {\n        grid-area: phone;\n    }\n\n    #{$block}__buttons {\n        grid-area: buttons;\n        display: flex;\n        gap: 1rem;\n        margin: 1rem auto 0;\n    }\n\n    @media (max-width: 1350px) {\n        gap: 1.6rem;\n        padding: 1.6rem;\n        grid-template: $altGridTemplate;\n    }\n\n    @media (max-width: Utils.$tabletUIWidth) {\n        padding: 2rem;\n        gap: 2rem 3rem;\n        grid-template: $mainGridTemplate;\n    }\n\n    @media (max-width: 900px) {\n        gap: 1.6rem;\n        padding: 1.6rem;\n        grid-template: $altGridTemplate;\n    }\n\n    @media (max-width: 800px) {\n        gap: 0.8rem;\n        padding: 2rem 1.2rem;\n        grid-template: $altMiniGridTemplate;\n    }\n\n    @media (max-width: 700px) {\n        max-width: 46rem;\n        gap: 2rem;\n        grid-template: $mobileGridTemplate;\n        #{$block}__buttons {\n            margin-top: 0;\n            padding-bottom: 2rem;\n        }\n    }\n\n    @media (max-width: 440px) {\n        .fake-phone {\n            width: 36rem;\n        }\n    }\n\n    @media (max-width: 400px) {\n        .fake-phone {\n            width: 34rem;\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n.shop-management-opening-hours {\n    $block: &;\n\n    #{$block}__slots-container {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.8rem;\n        border-radius: 1.6rem;\n        margin-bottom: 1.2rem;\n\n        #{$block}__slots-title {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            width: 100%;\n            font-size: 1.4rem;\n            letter-spacing: 0.05rem;\n            font-weight: 500;\n            line-height: 1.8rem;\n            padding: 0 0.8rem 0 1.6rem;\n            margin-top: 2.4rem;\n            text-align: start;\n            box-sizing: border-box;\n            @include Utils.theme-paletteColour(color, 400, 50);\n        }\n\n        #{$block}__slot-row {\n            position: relative;\n            flex: 1 1 auto;\n            display: flex;\n            gap: 2rem;\n            box-sizing: border-box;\n            align-items: center;\n            justify-content: center;\n            border-radius: 2.4rem;\n            padding: 1.2rem 1.2rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                100,\n                rgba(0, 0, 0, 0.2),\n                $alphaLight: 0.5\n            );\n\n            #{$block}__slot-item {\n                flex: 1 1 auto;\n\n                #{$block}__slot-title {\n                    font-size: 1.1rem;\n                    letter-spacing: 0.05rem;\n                    font-weight: 600;\n                    line-height: 1.2rem;\n                    text-transform: uppercase;\n                    margin: 0rem 0 0.8rem 1rem;\n                    @include Utils.theme-paletteColour(\n                        color,\n                        800,\n                        white,\n                        $alphaLight: 0.6\n                    );\n                }\n            }\n\n            @media (max-width: 580px) {\n                #{$block}__slot-item {\n                    .demmi-ui-input-time {\n                        width: 17rem;\n                    }\n                }\n            }\n\n            @media (max-width: 520px) {\n                #{$block}__slot-item {\n                    .demmi-ui-input-time {\n                        width: 15rem;\n                    }\n                }\n            }\n\n            @media (max-width: 480px) {\n                width: 100%;\n                display: grid;\n                grid-template:\n                    'slotStart button'\n                    'slotEnd button' auto / 1fr auto;\n\n                #{$block}__slot-item {\n                    &:nth-child(1) {\n                        grid-area: slotStart;\n                    }\n                    &:nth-child(2) {\n                        grid-area: slotEnd;\n                    }\n                    .demmi-ui-input-time {\n                        width: 18rem;\n                    }\n                }\n\n                .demmi-ui-icon-button {\n                    margin-right: 0.8rem;\n                    grid-area: button;\n                }\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n.shop-management-opening-hours {\n    $block: &;\n\n    #{$block}__preview {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        width: 100%;\n        box-sizing: border-box;\n        position: relative;\n        margin-top: 1.2rem;\n        border-radius: 0.8rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            rgba(0, 0, 0, 0.2),\n            $alphaLight: 0.4,\n            $alphaDark: 0.2\n        );\n\n        #{$block}__preview-text {\n            text-align: center;\n            padding: 1.2rem 0 1.6rem;\n            font-size: 1.3rem;\n            font-weight: 500;\n            line-height: 1.8rem;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                50,\n                $alphaLight: 0.8\n            );\n\n            span {\n                display: block;\n                margin-top: 0.4rem;\n            }\n        }\n\n        #{$block}__preview-timeline {\n            position: relative;\n            display: flex;\n            flex-wrap: nowrap;\n            overflow: auto;\n            padding: 0;\n\n            #{$block}__open-slot {\n                position: absolute;\n                top: 3.2rem;\n                bottom: 0;\n                border-radius: 0.8rem;\n                margin-left: 1rem;\n                padding-right: 0.6rem;\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    white,\n                    100\n                );\n            }\n\n            #{$block}__time-slot {\n                flex: 0 0 6rem;\n                height: 6rem;\n                text-align: center;\n                user-select: none;\n                display: flex;\n                flex-direction: column;\n                gap: 0.2rem;\n                align-items: flex-start;\n                padding: 1rem 1.2rem 0.4rem;\n                box-sizing: border-box;\n                border-radius: 0.8rem;\n                transition: background-color 0.1s ease-in-out;\n\n                #{$block}__time {\n                    height: 100%;\n                    display: flex;\n                    flex-direction: column;\n                    align-items: start;\n                    gap: 1.2rem;\n\n                    #{$block}__time-text {\n                        flex: 0 0 auto;\n                        font-size: 1.1rem;\n                        font-weight: 600;\n                        line-height: 1.4rem;\n                        letter-spacing: 0.08rem;\n                        @include Utils.theme-paletteColour(\n                            color,\n                            900,\n                            white,\n                            $alphaLight: 0.8\n                        );\n                    }\n\n                    #{$block}__time-line {\n                        width: 0.2rem;\n                        height: 100%;\n                        @include Utils.theme-paletteColour(\n                            background-color,\n                            200,\n                            200\n                        );\n                    }\n                }\n            }\n        }\n\n        &#{$block}__preview--closed {\n            #{$block}__preview-timeline {\n                opacity: 0.4;\n                overflow: hidden;\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n@use './_time-slots';\n@use './_preview';\n\n.shop-management-opening-hours {\n    $block: &;\n    max-width: 64rem !important;\n    border-radius: 2rem;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    margin: 0 auto;\n    @include Utils.theme-paletteColour(\n        color,\n        rgba(0, 0, 0, 0.5),\n        rgba(255, 255, 255, 0.8)\n    );\n\n    #{$block}__days {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        border-radius: 1.5rem;\n        box-sizing: border-box;\n        gap: 2rem;\n        padding: 0;\n\n        #{$block}__day {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            width: 100%;\n            padding: 1.2rem;\n            box-sizing: border-box;\n            border-radius: 1.6rem;\n            @include Utils.theme-paletteColour(color, 700, 200);\n\n            #{$block}__day-toggle {\n                flex: 0 0 14rem;\n            }\n\n            #{$block}__day-title {\n                width: 100%;\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                font-size: 1.5rem;\n                letter-spacing: 0.05rem;\n                font-weight: 400;\n                line-height: 1.4rem;\n                padding: 0 0 0 2.4rem;\n                box-sizing: border-box;\n                @include Utils.theme-paletteColour(color, 500, white);\n            }\n\n            #{$block}__buttons {\n                margin-top: 2rem;\n            }\n        }\n    }\n}\n","@use '../../../../utils' as Utils;\n\n.sm-collection-schedule-edit {\n    $block: &;\n    width: 100%;\n    max-width: 72rem !important;\n    border-radius: 2rem;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    margin: 0 auto;\n\n    #{$block}__title {\n        width: 100%;\n        margin-top: 1.6rem;\n        text-align: center;\n        font-size: 1.8rem;\n        letter-spacing: 0.04rem;\n        font-weight: 400;\n        line-height: 2.4rem;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 800, 50, $alphaLight: 0.8);\n    }\n\n    #{$block}__no-edit {\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        font-size: 1.2rem;\n        padding: 0.8rem 1.6rem;\n        border-radius: 0.8rem;\n        text-align: center;\n        margin: 0.8rem 0;\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            200,\n            $alphaDark: 0.2\n        );\n        @include Utils.theme-paletteColour(color, 800, 50, $alphaLight: 0.8);\n    }\n\n    #{$block}__delete {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 1.2rem;\n\n        #{$block}__warning {\n            font-size: 1.2rem;\n            letter-spacing: 0.04rem;\n            font-weight: 500;\n            line-height: 1.4rem;\n            box-sizing: border-box;\n            @include Utils.theme-paletteColour(\n                color,\n                800,\n                50,\n                $alphaLight: 0.8\n            );\n        }\n    }\n}\n","@use '../../../../utils' as Utils;\n\n.sm-collection-schedule-preview {\n    $block: &;\n    width: 100%;\n    max-width: 64rem !important;\n    border-radius: 2rem;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    margin: 0 auto;\n\n    #{$block}__title {\n        width: 100%;\n        margin-top: 1.6rem;\n        text-align: center;\n        font-size: 1.8rem;\n        letter-spacing: 0.04rem;\n        font-weight: 400;\n        line-height: 2.4rem;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 800, 50, $alphaLight: 0.8);\n    }\n}\n","@use '../../../utils' as Utils;\n\n.sm-collection-schedule-create {\n    $block: &;\n    width: 100%;\n    max-width: 68rem !important;\n    border-radius: 2rem;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    margin: 0 auto;\n\n    #{$block}__title {\n        width: 100%;\n        margin-top: 1.6rem;\n        text-align: center;\n        font-size: 1.8rem;\n        letter-spacing: 0.04rem;\n        font-weight: 400;\n        line-height: 2.4rem;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 800, 50, $alphaLight: 0.8);\n    }\n\n    #{$block}__date {\n        #{$block}__date-text {\n            width: 100%;\n            margin-top: 2.4rem;\n            text-align: center;\n            font-size: 1.5rem;\n            letter-spacing: 0.04rem;\n            font-weight: 400;\n            line-height: 1.8rem;\n            box-sizing: border-box;\n            @include Utils.theme-paletteColour(\n                color,\n                800,\n                50,\n                $alphaLight: 0.8\n            );\n\n            span {\n                font-weight: 500;\n                margin: 0 1.6rem;\n            }\n        }\n    }\n\n    #{$block}__days {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        border-radius: 1.5rem;\n        box-sizing: border-box;\n        gap: 2rem;\n        padding: 0;\n    }\n}\n","@use '../../../utils' as Utils;\n\n.sm-collection-schedule-date-picker {\n    $block: &;\n    margin: 1rem 0;\n    display: flex;\n    flex-direction: column;\n    gap: 1.6rem;\n\n    #{$block}-title {\n        width: 100%;\n        text-align: center;\n        font-size: 1.5rem;\n        letter-spacing: 0.04rem;\n        font-weight: 500;\n        line-height: 1.8rem;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 800, 50, $alphaLight: 0.8);\n    }\n}\n\n.sm-collection-schedule-create__days {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    border-radius: 1.5rem;\n    box-sizing: border-box;\n    gap: 2rem;\n    padding: 0;\n}\n\n.sm-collection-schedule-day-edit {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    padding: 1.2rem;\n    box-sizing: border-box;\n    border-radius: 1.6rem;\n    @include Utils.theme-paletteColour(color, 600, 100);\n\n    #{$block}__toggle {\n        flex: 0 0 17rem;\n    }\n\n    #{$block}__title {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 1.5rem;\n        letter-spacing: 0.05rem;\n        font-weight: 400;\n        line-height: 1.4rem;\n        padding: 0 0 0 2.4rem;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 500, white);\n    }\n\n    #{$block}__buttons {\n        margin-top: 2rem;\n    }\n    // }\n}\n","@use '../../../utils' as Utils;\n\n.sm-collection-schedule-day-preview-timeline {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    box-sizing: border-box;\n    position: relative;\n    margin-top: 1.2rem;\n    border-radius: 0.8rem;\n    @include Utils.theme-paletteColour(\n        background-color,\n        100,\n        rgba(0, 0, 0, 0.2),\n        $alphaLight: 0.4,\n        $alphaDark: 0.2\n    );\n\n    #{$block}__preview-text {\n        position: absolute;\n        inset: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        pointer-events: none;\n\n        span {\n            border-radius: 1.2rem;\n            padding: 1.2rem 2rem;\n            box-sizing: border-box;\n            font-size: 1.3rem;\n            font-weight: 500;\n            line-height: 2rem;\n            backdrop-filter: blur(4px);\n            white-space: pre-line;\n            text-align: center;\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0.7),\n                200,\n                $alphaDark: 0.3\n            );\n            @include Utils.theme-paletteColour(\n                color,\n                700,\n                rgba(255, 255, 255, 1)\n            );\n        }\n    }\n\n    #{$block}__preview-timeline {\n        position: relative;\n        display: flex;\n        flex-wrap: nowrap;\n        overflow: auto;\n        padding: 0;\n\n        #{$block}__available-slot {\n            position: absolute;\n            top: 3.2rem;\n            bottom: 0;\n            border-radius: 0.8rem;\n            margin-left: 1rem;\n            padding-right: 0.6rem;\n            scroll-margin: 1.6rem;\n            @include Utils.theme-paletteColour(background-color, white, 100);\n        }\n\n        #{$block}__time-slot {\n            flex: 0 0 6rem;\n            height: 6rem;\n            text-align: center;\n            user-select: none;\n            display: flex;\n            flex-direction: column;\n            gap: 0.2rem;\n            align-items: flex-start;\n            padding: 1rem 1.2rem 0.4rem;\n            box-sizing: border-box;\n            border-radius: 0.8rem;\n            transition: background-color 0.1s ease-in-out;\n\n            #{$block}__time {\n                height: 100%;\n                display: flex;\n                flex-direction: column;\n                align-items: start;\n                gap: 1.2rem;\n\n                #{$block}__time-text {\n                    flex: 0 0 auto;\n                    font-size: 1.1rem;\n                    font-weight: 600;\n                    line-height: 1.4rem;\n                    letter-spacing: 0.08rem;\n                    @include Utils.theme-paletteColour(\n                        color,\n                        900,\n                        white,\n                        $alphaLight: 0.8\n                    );\n                }\n\n                #{$block}__time-line {\n                    width: 0.2rem;\n                    height: 100%;\n                    @include Utils.theme-paletteColour(\n                        background-color,\n                        200,\n                        200\n                    );\n                }\n            }\n        }\n    }\n\n    &#{$block}__preview--closed {\n        #{$block}__preview-timeline {\n            opacity: 0.4;\n            overflow: hidden;\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n.sm-collection-schedule-editing-view__day {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    @include Utils.theme-paletteColour(color, 600, 100);\n\n    #{$block}__toggle {\n        flex: 0 0 17rem;\n    }\n\n    #{$block}__title {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 1.5rem;\n        letter-spacing: 0.05rem;\n        font-weight: 400;\n        line-height: 1.6rem;\n        padding: 0 0 0 1.6rem;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 500, white);\n    }\n\n    #{$block}__badge {\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        font-size: 1.2rem;\n        padding: 0.8rem 1.6rem;\n        border-radius: 0.8rem;\n        text-align: center;\n        margin: 0.8rem 0.8rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            200,\n            $alphaDark: 0.2\n        );\n        @include Utils.theme-paletteColour(color, 500, white);\n    }\n\n    #{$block}__error {\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        font-size: 1.2rem;\n        padding: 0.8rem 1.6rem;\n        border-radius: 0.8rem;\n        text-align: center;\n        margin: 0.8rem 0;\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            200,\n            $alphaDark: 0.2\n        );\n        @include Utils.theme-paletteColour(color, 500, white);\n    }\n\n    #{$block}__days-container {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.8rem;\n        border-radius: 1.6rem;\n        margin-top: 1.2rem;\n        padding: 0 1rem 1rem;\n        box-sizing: border-box;\n\n        #{$block}__day {\n            position: relative;\n            flex: 1 1 auto;\n            display: flex;\n            box-sizing: border-box;\n            align-items: start;\n            border-radius: 1.6rem;\n            padding: 0.8rem 0;\n            flex-wrap: wrap;\n            gap: 1.2rem;\n            justify-content: space-between;\n\n            #{$block}__day-time {\n                position: relative;\n                width: 100%;\n                flex: 1 1 auto;\n                display: flex;\n                box-sizing: border-box;\n                align-items: center;\n                gap: 0.8rem;\n                justify-content: space-between;\n            }\n\n            #{$block}__day-section {\n                flex: 0 0 calc(50% - 3rem);\n                flex-direction: row;\n                position: relative;\n                display: flex;\n                gap: 1.2rem;\n                box-sizing: border-box;\n                align-items: center;\n                justify-content: space-between;\n\n                #{$block}__day-section-title {\n                    width: 100%;\n                    font-size: 1.3rem;\n                    letter-spacing: 0.05rem;\n                    font-weight: 500;\n                    line-height: 1.8rem;\n                    margin-left: 0.8rem;\n                    text-align: start;\n                    box-sizing: border-box;\n                    @include Utils.theme-paletteColour(color, 400, 50);\n                }\n            }\n\n            @media (max-width: 600px) {\n                #{$block}__day-section {\n                    flex: 0 0 calc(50% - 1.2rem);\n                }\n            }\n\n            @media (max-width: 500px) {\n                width: 100%;\n                flex-direction: column;\n                gap: 0.8rem;\n\n                #{$block}__day-time {\n                    width: 100%;\n                    flex-direction: column;\n                    gap: 0.8rem;\n                }\n                #{$block}__day-section {\n                    width: 100%;\n                    justify-content: space-between;\n                    flex-direction: row;\n                }\n            }\n        }\n\n        #{$block}__breaks-container {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            // gap: 1.6rem;\n            box-sizing: border-box;\n            align-items: center;\n            margin-top: 0.8rem;\n            padding: 2.4rem 1.6rem 1.6rem;\n            border-radius: 1.6rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                100,\n                rgba(0, 0, 0, 0.2),\n                $alphaLight: 0.5\n            );\n\n            #{$block}__breaks-title {\n                width: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 1.5rem;\n                letter-spacing: 0.05rem;\n                font-weight: 400;\n                line-height: 1.4rem;\n                box-sizing: border-box;\n                margin-bottom: 1.6rem;\n                @include Utils.theme-paletteColour(color, 500, white);\n            }\n\n            #{$block}__break-row {\n                width: 100%;\n                position: relative;\n                flex: 1 1 auto;\n                display: flex;\n                gap: 2rem;\n                box-sizing: border-box;\n                align-items: center;\n                justify-content: center;\n                padding: 1.2rem 1.2rem;\n\n                &::after {\n                    position: absolute;\n                    content: '';\n                    left: 0;\n                    right: 0;\n                    bottom: 0;\n                    height: 0.1rem;\n                    @include Utils.theme-paletteColour(\n                        background-color,\n                        white,\n                        100,\n                        $alphaDark: 0.5\n                    );\n                }\n\n                #{$block}__break-item {\n                    flex: 1 1 auto;\n                    display: flex;\n                    box-sizing: border-box;\n                    align-items: center;\n                    gap: 0.8rem;\n                    justify-content: space-between;\n\n                    #{$block}__break-title {\n                        width: 100%;\n                        font-size: 1.3rem;\n                        letter-spacing: 0.05rem;\n                        font-weight: 500;\n                        line-height: 1.8rem;\n                        text-align: start;\n                        box-sizing: border-box;\n                        // text-transform: uppercase;\n                        @include Utils.theme-paletteColour(\n                            color,\n                            800,\n                            white,\n                            $alphaLight: 0.6\n                        );\n                    }\n                }\n\n                @media (max-width: 620px) {\n                    flex-direction: column;\n                    gap: 0.8rem;\n\n                    #{$block}__day-time {\n                        width: 100%;\n                        flex-direction: column;\n                        gap: 0.8rem;\n                    }\n                    #{$block}__break-item {\n                        width: 100%;\n                        justify-content: space-between;\n                        flex-direction: row;\n                    }\n                }\n            }\n            .demmi-ui-button {\n                margin-top: 1.6rem;\n            }\n        }\n    }\n\n    #{$block}__buttons {\n        margin-top: 2rem;\n    }\n}\n","@use '../../../utils' as Utils;\n\n.sm-collection-schedule-editing-view {\n    $block: &;\n    width: 100%;\n    // max-width: 72rem !important;\n    border-radius: 2rem;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    margin: 0 auto;\n\n    #{$block}__date {\n        max-width: 100%;\n        #{$block}__date-text {\n            width: 100%;\n            margin-top: 2.4rem;\n            text-align: center;\n            font-size: 1.5rem;\n            letter-spacing: 0.04rem;\n            font-weight: 400;\n            line-height: 1.8rem;\n            box-sizing: border-box;\n            @include Utils.theme-paletteColour(\n                color,\n                800,\n                50,\n                $alphaLight: 0.8\n            );\n\n            span {\n                font-weight: 500;\n                margin: 0 1.6rem;\n            }\n        }\n    }\n\n    #{$block}__days {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        border-radius: 1.5rem;\n        box-sizing: border-box;\n        gap: 2rem;\n        padding: 0;\n    }\n\n    #{$block}__error {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        gap: 1.2rem;\n        letter-spacing: 0.08rem;\n        font-weight: 500;\n        font-size: 1.5rem;\n        padding: 1.6rem 2rem;\n        border-radius: 0.8rem;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, white, 900, $alphaLight: 0.8);\n        @include Utils.theme-paletteColour(\n            background-color,\n            300,\n            100,\n            $alphaDark: 0.8\n        );\n\n        span {\n            display: flex;\n            gap: 0.8rem;\n            text-align: center;\n            justify-content: center;\n            align-items: center;\n        }\n\n        #{$block}__error-message {\n            letter-spacing: 0.12rem;\n            font-weight: 400;\n            font-size: 1.2rem;\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n.sm-collection-schedule-list {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.2rem;\n    margin: 0.8rem 0;\n\n    #{$block}__title {\n        width: 100%;\n        text-align: center;\n        font-size: 1.5rem;\n        letter-spacing: 0.04rem;\n        font-weight: 500;\n        line-height: 1.8rem;\n        margin: 2rem 0 1.2rem;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 800, 50, $alphaLight: 0.8);\n    }\n\n    #{$block}__item {\n        position: relative;\n        flex: 1 1 auto;\n        width: 38rem;\n        display: flex;\n        gap: 1.2rem;\n        box-sizing: border-box;\n        align-items: center;\n        justify-content: flex-start;\n        border-radius: 1.6rem;\n        padding: 1.2rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            200,\n            $alphaLight: 0.4,\n            $alphaDark: 0.2\n        );\n\n        &:hover {\n            @include Utils.theme-paletteColour(\n                background-color,\n                100,\n                200,\n                $alphaLight: 0.8,\n                $alphaDark: 0.4\n            );\n        }\n\n        &#{$block}__item--expired {\n            pointer-events: none;\n        }\n\n        #{$block}__item-dates {\n            width: 100%;\n            display: flex;\n            justify-content: flex-start;\n            align-items: center;\n            gap: 2rem;\n\n            #{$block}__item-date-item {\n                flex: 0 0 10rem;\n                display: flex;\n                flex-direction: column;\n                justify-content: flex-start;\n                padding: 0 0.4rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    800,\n                    white,\n                    $alphaLight: 0.8\n                );\n\n                #{$block}__item-date-title {\n                    font-size: 1.1rem;\n                    letter-spacing: 0.16rem;\n                    font-weight: 700;\n                    line-height: 1.8rem;\n                    box-sizing: border-box;\n                    opacity: 0.6;\n                    text-transform: uppercase;\n                }\n                #{$block}__item-date {\n                    font-size: 1.4rem;\n                    letter-spacing: 0.12rem;\n                    font-weight: 400;\n                    line-height: 1.8rem;\n                    box-sizing: border-box;\n                }\n            }\n        }\n\n        #{$block}__item-controls {\n            display: flex;\n            margin-left: auto;\n            gap: 0.8rem;\n        }\n\n        #{$block}__item-badge {\n            margin-left: auto;\n            letter-spacing: 0.16rem;\n            font-weight: 600;\n            font-size: 1.1rem;\n            padding: 0.4rem 0.8rem;\n            border-radius: 0.8rem;\n            text-align: center;\n            text-transform: uppercase;\n            @include Utils.theme-paletteColour(\n                color,\n                800,\n                white,\n                $alphaLight: 0.8\n            );\n            @include Utils.theme-paletteColour(\n                background-color,\n                100,\n                200,\n                $alphaDark: 0.2\n            );\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n.sm-collection-schedule-preview-view__day {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 0.4rem !important;\n    @include Utils.theme-paletteColour(color, 600, 100);\n\n    #{$block}__title {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 1.5rem;\n        letter-spacing: 0.08rem;\n        font-weight: 400;\n        line-height: 4.8rem;\n        padding: 0 1.6rem;\n        margin: 0.8rem 0;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 500, white);\n\n        #{$block}__title-badge {\n            flex: 0 0 auto;\n            position: relative;\n            display: flex;\n            gap: 4rem;\n            box-sizing: border-box;\n            align-items: center;\n            justify-content: space-between;\n            border-radius: 0.8rem;\n            padding: 0.8rem 1.2rem;\n            font-size: 1.12rem;\n            letter-spacing: 0.12rem;\n            line-height: 1.4rem;\n            font-weight: 600;\n            text-transform: uppercase;\n            @include Utils.theme-paletteColour(\n                background-color,\n                100,\n                rgba(0, 0, 0, 0.2),\n                $alphaLight: 0.5\n            );\n        }\n    }\n\n    #{$block}__days-container {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.8rem;\n        border-radius: 1.6rem;\n        margin-top: 1.2rem;\n        box-sizing: border-box;\n\n        #{$block}__day {\n            width: 100%;\n            position: relative;\n            flex: 1 1 auto;\n            display: flex;\n            box-sizing: border-box;\n            align-items: start;\n            border-radius: 1.6rem;\n            padding: 0 1.2rem;\n            margin-top: -0.8rem;\n            flex-wrap: wrap;\n            gap: 0.8rem;\n            justify-content: space-between;\n\n            #{$block}__day-time {\n                position: relative;\n                flex: 1 1 auto;\n                display: flex;\n                box-sizing: border-box;\n                align-items: center;\n                width: 100%;\n                gap: 0.8rem;\n                justify-content: space-between;\n            }\n\n            #{$block}__day-section {\n                flex: 0 0 calc(50% - 2rem);\n                justify-content: space-between;\n                flex-direction: row;\n                position: relative;\n                display: flex;\n                gap: 0.8rem;\n                box-sizing: border-box;\n                align-items: center;\n                font-size: 1.5rem;\n                letter-spacing: 0.05rem;\n                font-weight: 400;\n                line-height: 1.8rem;\n                @include Utils.theme-paletteColour(color, 500, white);\n\n                #{$block}__day-section-title {\n                    font-size: 1.3rem;\n                    letter-spacing: 0.05rem;\n                    font-weight: 500;\n                    line-height: 1.8rem;\n                    text-align: start;\n                    box-sizing: border-box;\n                    @include Utils.theme-paletteColour(\n                        color,\n                        700,\n                        100,\n                        $alphaLight: 0.6\n                    );\n                }\n\n                span {\n                    font-size: 1.2rem;\n                    display: inline-block;\n                }\n            }\n\n            @media (max-width: 400px) {\n                flex-direction: column;\n                gap: 0.8rem;\n\n                #{$block}__day-time {\n                    width: 100%;\n                    flex-direction: column;\n                    gap: 0.8rem;\n                }\n                #{$block}__day-section {\n                    width: 100%;\n                    justify-content: space-between;\n                    flex-direction: row;\n                }\n            }\n        }\n\n        #{$block}__breaks-container {\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 0.8rem;\n            box-sizing: border-box;\n            align-items: flex-start;\n            margin-top: 2rem;\n            padding: 0 1.2rem;\n\n            #{$block}__breaks-title {\n                width: 100%;\n                display: flex;\n                align-items: center;\n                justify-content: flex-start;\n                font-size: 1.5rem;\n                letter-spacing: 0.08rem;\n                font-weight: 400;\n                line-height: 1.4rem;\n                margin: 0.8rem 0;\n                padding-left: 0.4rem;\n                box-sizing: border-box;\n                @include Utils.theme-paletteColour(color, 500, white);\n            }\n\n            #{$block}__break-row {\n                position: relative;\n                display: flex;\n                gap: 4rem;\n                box-sizing: border-box;\n                align-items: center;\n                justify-content: space-between;\n                border-radius: 0.8rem;\n                padding: 1rem 1.2rem;\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    100,\n                    rgba(0, 0, 0, 0.2),\n                    $alphaLight: 0.5\n                );\n\n                #{$block}__break-item {\n                    flex: 0 0 8rem;\n                    width: 8rem;\n                    display: flex;\n                    align-items: center;\n                    justify-content: space-between;\n                    line-height: 1.4rem;\n\n                    #{$block}__break-title {\n                        font-size: 1.1rem;\n                        letter-spacing: 0.05rem;\n                        font-weight: 600;\n                        text-transform: uppercase;\n                        @include Utils.theme-paletteColour(\n                            color,\n                            800,\n                            white,\n                            $alphaLight: 0.6\n                        );\n                    }\n                }\n            }\n        }\n    }\n\n    #{$block}__buttons {\n        margin-top: 2rem;\n    }\n}\n","@use '../../../utils' as Utils;\n\n.sm-collection-schedule-preview-view {\n    $block: &;\n    width: 100%;\n    border-radius: 2rem;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    margin: 0 auto;\n\n    #{$block}__days {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        border-radius: 1.5rem;\n        box-sizing: border-box;\n        gap: 2rem;\n        padding: 0;\n    }\n\n    #{$block}__date {\n        #{$block}__date-text {\n            width: 100%;\n            text-align: center;\n            font-size: 1.5rem;\n            letter-spacing: 0.04rem;\n            font-weight: 400;\n            line-height: 1.8rem;\n            box-sizing: border-box;\n            @include Utils.theme-paletteColour(\n                color,\n                800,\n                50,\n                $alphaLight: 0.8\n            );\n\n            span {\n                font-weight: 500;\n                margin: 0 1.6rem;\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n@use './edit/edit';\n@use './preview/preview';\n@use './_create';\n@use './_date-picker';\n@use './_day-preview-timeline';\n@use './_editing-view-day';\n@use './_editing-view';\n@use './_list';\n@use './_preview-view-day';\n@use './_preview-view';\n\n.sm-collection-schedule {\n    $block: &;\n    width: 100%;\n    max-width: 68rem !important;\n    border-radius: 2rem;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 3rem;\n    margin: 0 auto;\n    @include Utils.theme-paletteColour(\n        color,\n        rgba(0, 0, 0, 0.5),\n        rgba(255, 255, 255, 0.8)\n    );\n}\n","@use '../../utils' as Utils;\n\n@use './_details';\n@use './_images';\n@use './_location';\n@use './_delivery-days';\n@use './_theme';\n\n@use './openingHours/opening-hours';\n@use './collectionSchedule/collection-schedule';\n\n$block: '.shop-management';\n\n#{$block} {\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n\n    #{$block}__content-wrapper {\n        padding: 2rem;\n        max-width: 90rem;\n        margin: 0 auto;\n        box-sizing: border-box;\n\n        @media (max-width: 480px) {\n            padding: 1.2rem;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.demmi-support-sidebar-button {\n    $block: &;\n    display: grid;\n    grid-template:\n        'title time' 2.4rem\n        'order order' auto\n        'message message' 1.8rem / auto auto;\n    gap: 0.8rem 1.5rem;\n    padding: 1.6rem 1.6rem;\n    align-items: center;\n\n    #{$block}__text {\n        grid-area: title;\n        font-size: 1.5rem;\n        letter-spacing: 0.05rem;\n        font-weight: 400;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 1);\n    }\n\n    #{$block}__order-info {\n        grid-area: order;\n        font-size: 1.1rem;\n        letter-spacing: 0.05rem;\n        font-weight: 500;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        padding: 0.6rem 1.2rem;\n        text-align: center;\n        border-radius: 0.8rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            100,\n            $alphaDark: 0.1\n        );\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 1);\n    }\n\n    #{$block}__message {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        grid-area: message;\n        font-size: 1.2rem;\n        letter-spacing: 0.05rem;\n        font-weight: 400;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 1);\n    }\n\n    #{$block}__time {\n        grid-area: time;\n        text-align: end;\n        line-height: 2rem;\n        font-size: 1.3rem;\n        font-weight: 600;\n        letter-spacing: 0.2rem;\n        @include Utils.theme-paletteColour(\n            color,\n            900,\n            50,\n            $alphaLight: 0.5,\n            $alphaDark: 0.8\n        );\n    }\n}\n","@use '../../utils' as Utils;\n\n$radOuter: 2.4rem;\n$radInner: 1.2rem;\n\n.demmi-support-chat {\n    $block: &;\n    grid-area: chat;\n    padding: 0;\n    box-sizing: border-box;\n    height: 100%;\n    width: 100%;\n    position: relative;\n    display: flex;\n    min-width: 34rem;\n    max-width: 72rem;\n    margin: 0 auto;\n    flex-direction: column;\n    overflow: hidden;\n    gap: 0.8rem;\n\n    @include Utils.loadingOpacity();\n\n    #{$block}__title {\n        width: 100%;\n        flex: 0 0 auto;\n        display: flex;\n        flex-direction: column;\n        line-height: 5rem;\n        text-align: center;\n        font-size: 1.4rem;\n        letter-spacing: 0.05rem;\n        font-weight: 600;\n        border-radius: $radOuter $radOuter $radInner $radInner;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 0.6);\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.4),\n            rgba(0, 0, 0, 0.2)\n        );\n    }\n\n    #{$block}__content {\n        flex: 1 1 auto;\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        border-radius: $radInner $radInner $radOuter $radOuter;\n        box-sizing: border-box;\n        overflow: auto;\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.4),\n            rgba(0, 0, 0, 0.2)\n        );\n\n        #{$block}__messages {\n            flex: 1 1 auto;\n            overflow: hidden auto;\n            box-sizing: border-box;\n            padding: 1rem 0;\n            position: relative;\n\n            #{$block}__no-messages {\n                position: absolute;\n                inset: 0;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.4rem;\n                letter-spacing: 0.1rem;\n                font-weight: 300;\n                line-height: 1.8rem;\n                text-align: center;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    100,\n                    $alphaLight: 0.8\n                );\n            }\n        }\n    }\n\n    #{$block}__input-area {\n        position: relative;\n        flex: 0 0 auto;\n        display: flex;\n        gap: 1rem;\n        margin: 0 1rem 1rem;\n        @include Utils.loadingOpacity();\n    }\n}\n","@forward 'colours' as theme-*;\n@forward 'background' as bg-*;\n@forward 'elevations' as shadow-*;\n\n$tabletUIWidth: 1100px;\n$mobileUIWidth: 480px;\n\n@mixin loadingOpacity($loadingClass: 'is-loading') {\n    &#{&}--#{$loadingClass} > *:not(.element-loading-indicator) {\n        opacity: 0.4;\n    }\n\n    @at-root body.theme-dark #{&}--#{$loadingClass} {\n        > :not(.element-loading-indicator) {\n            opacity: 0.4;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.demmi-support-chat {\n    $block: &;\n\n    #{$block}--snippet {\n        $gap: 1.2rem;\n        flex: 0 0 auto;\n        display: flex;\n        flex-direction: column;\n        padding: 1rem 1.6rem 2rem 2rem;\n        margin: 0 $gap $gap $gap;\n        border-radius: 1.2rem;\n        text-align: start;\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 0.8);\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 1),\n            300,\n            $alphaDark: 0.2\n        );\n    }\n\n    #{$block}-snippet-order {\n        $blockScoped: #{$block}-snippet-order;\n\n        #{$blockScoped}__title {\n            display: flex;\n            flex: 1 1 auto;\n            justify-content: space-between;\n            align-items: center;\n            text-align: center;\n            font-size: 1.4rem;\n            letter-spacing: 0.05rem;\n            font-weight: 500;\n        }\n\n        #{$block}__key-val {\n            margin: 1rem 0 0;\n\n            #{$block}__key {\n                font-weight: 500;\n                font-size: 1.2rem;\n                letter-spacing: 0.1rem;\n                opacity: 0.7;\n                line-height: 1.4rem;\n            }\n\n            #{$block}__value {\n                font-weight: 400;\n                font-size: 1.2rem;\n                letter-spacing: 0.1rem;\n                line-height: 1.8rem;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$backgroundLight: hsla(var(--theme-bg-hue), 100%, 100%, 1);\n$backgroundDark: hsla(var(--theme-bg-hue), 15%, 38%, 1);\n\n.demmi-support-chat-message {\n    $block: &;\n    $radius: 1.6rem;\n    $sidePadding: 6rem;\n    position: relative;\n    padding: 1rem 1.5rem;\n    margin: 0 1.5rem 1rem calc($sidePadding + 0.5rem);\n    border-radius: $radius 0 $radius $radius;\n    opacity: 1;\n    @include Utils.theme-paletteColour(\n        background-color,\n        $backgroundLight,\n        $backgroundDark\n    );\n\n    &#{$block}--demmi {\n        opacity: 1;\n        margin: 0 calc($sidePadding + 0.5rem) 1rem 1.5rem;\n        border-radius: 0 $radius $radius $radius;\n\n        &:after {\n            left: -1rem;\n            right: auto;\n        }\n    }\n\n    &:after {\n        content: ' ';\n        position: absolute;\n        width: 0;\n        height: 0;\n        right: -1rem;\n        left: auto;\n        top: 0;\n        bottom: auto;\n        border: 1rem solid;\n        box-sizing: border-box;\n        border-color: transparent;\n        @include Utils.theme-paletteColour(\n            border-top-color,\n            $backgroundLight,\n            $backgroundDark\n        );\n    }\n\n    #{$block}__text {\n        font-size: 1.3rem;\n        letter-spacing: 0.05rem;\n        font-weight: 400;\n        line-height: 2rem;\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 1);\n    }\n\n    #{$block}__timestamp {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 1rem;\n        text-align: end;\n        margin-top: 1rem;\n        line-height: 2rem;\n        font-size: 1.2rem;\n        font-weight: 600;\n        letter-spacing: 0.15rem;\n        @include Utils.theme-paletteColour(\n            color,\n            900,\n            50,\n            $alphaLight: 0.5,\n            $alphaDark: 0.8\n        );\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './_sidebar-button';\n@use './_chat';\n@use './_snippet';\n@use './_chat-message';\n\n.demmi-support {\n    position: relative;\n    z-index: 100;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 2rem 1rem;\n}\n","@use '../../utils/' as Utils;\n\n$fade-duration: 0.2s;\n\n.async-image {\n    $block: &;\n    content: '';\n    position: relative;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &#{$block}--loaded {\n        img {\n            animation: image-fade-in $fade-duration forwards;\n        }\n        #{$block}__loading-indicator-wrapper {\n            animation: loader-fade-out $fade-duration forwards;\n        }\n    }\n\n    img {\n        pointer-events: none;\n        max-height: 100%;\n        max-width: 100%;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n\n    #{$block}__loading-indicator-wrapper {\n        position: absolute;\n        inset: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        #{$block}__loading-indicator {\n            $backgroundLight: linear-gradient(\n                Utils.theme-get(400),\n                hsla(99deg, 90%, 80%, 0),\n                Utils.theme-get(300)\n            );\n            $backgroundDark: linear-gradient(\n                white,\n                hsla(99deg, 90%, 80%, 0),\n                white\n            );\n            width: 3rem;\n            height: 3rem;\n            border-radius: 50%;\n            opacity: 0.6;\n            animation: image-loader 1.2s linear infinite;\n            @include Utils.theme-customProp(\n                background,\n                $backgroundLight,\n                $backgroundDark\n            );\n\n            &:before {\n                content: '';\n                inset: 0;\n                position: absolute;\n                width: 100%;\n                height: 100%;\n                border-radius: 50%;\n                filter: blur(0.4rem);\n                @include Utils.theme-customProp(\n                    background,\n                    $backgroundLight,\n                    $backgroundDark\n                );\n            }\n\n            &:after {\n                content: '';\n                position: absolute;\n                inset: 0.2rem;\n                border-radius: 50%;\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    hsla(99deg, 0%, 98%, 1),\n                    0.8\n                );\n            }\n        }\n    }\n}\n\n@keyframes image-loader {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes image-fade-in {\n    0% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes loader-fade-out {\n    0% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n","@use '../../utils' as Utils;\n\n.coming-soon {\n    $block: &;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 2rem;\n    padding: 2rem;\n\n    #{$block}__title {\n        line-height: 5rem;\n        text-align: center;\n        font-weight: 200;\n        font-size: 3.2rem;\n        letter-spacing: 0.5rem;\n        margin-bottom: 2rem;\n        white-space: nowrap;\n        @include Utils.theme-paletteColour(color, 500, 300);\n    }\n    #{$block}__description {\n        max-width: 34rem;\n        line-height: 2.2rem;\n        text-align: center;\n        font-weight: 400;\n        font-size: 1.3rem;\n        letter-spacing: 0.15rem;\n        @include Utils.theme-paletteColour(color, 900, 100, $alphaLight: 0.8);\n    }\n}\n","@use '../../utils/' as Utils;\n\n.gallery-editor {\n    $block: &;\n    display: block;\n\n    #{$block}__thumbnails {\n        --gallery-thumbnail-height: 12rem;\n        --gallery-thumbnail-gap: 1rem;\n        display: grid;\n        grid-template-columns: repeat(\n            auto-fill,\n            minmax(var(--gallery-thumbnail-height), 1fr)\n        );\n        align-content: space-evenly;\n        gap: var(--gallery-thumbnail-gap);\n\n        #{$block}__thumbnail-wrapper {\n            display: block;\n            position: relative;\n\n            #{$block}__button-delete {\n                position: absolute;\n                bottom: 0.5rem;\n                left: 0.5rem;\n                right: 0.5rem;\n                display: flex;\n                justify-content: flex-end;\n                gap: 0.5rem;\n            }\n        }\n    }\n}\n\n.gallery-editor__thumbnail {\n    $block: &;\n    position: relative;\n    cursor: grab;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    transform-origin: 0 0;\n    user-select: none;\n    border-radius: 0.8rem;\n    border: 0.4rem solid;\n    overflow: hidden;\n    @include Utils.theme-paletteColour(\n        border-color,\n        200,\n        200,\n        $alphaLight: 0.5,\n        $alphaDark: 0.6\n    );\n\n    &#{$block}--overlay {\n        cursor: grabbing;\n        @include Utils.theme-paletteColour(\n            border-color,\n            white,\n            50,\n            $alphaLight: 0.8,\n            $alphaDark: 0.8\n        );\n    }\n\n    .async-image {\n        pointer-events: none;\n\n        img {\n            pointer-events: none;\n        }\n    }\n}\n\n.gallery-editor-modal-delete__thumbnail {\n    margin: 1rem auto 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 1.5rem;\n    padding: 1rem;\n    @include Utils.theme-paletteColour(\n        background-color,\n        rgba(255, 255, 255, 0.05),\n        0.2\n    );\n\n    img {\n        max-height: 25rem;\n        max-width: 100%;\n        border-radius: 1rem;\n        box-sizing: border-box;\n    }\n}\n","@use '../utils' as Utils;\n\n.theme-switcher {\n    $block: &;\n    position: relative;\n    display: flex;\n    gap: 0.4rem;\n    width: fit-content;\n    box-sizing: border-box;\n    padding: 0 0.4rem;\n    transition: box-shadow 0.1s ease-in-out;\n    border-radius: 2rem;\n    z-index: 100;\n    background-color: red;\n    margin: 0.8rem auto;\n    @include Utils.theme-paletteColour(\n        background-color,\n        rgba(255, 255, 255, 0.5),\n        200,\n        $alphaDark: 0.4\n    );\n\n    #{$block}__item {\n        z-index: 1;\n        cursor: pointer;\n        flex: 0 0 auto;\n        display: flex;\n        height: 4rem;\n        align-items: center;\n        padding: 0 2rem;\n        gap: 1.2rem;\n        transition: color 0.1s ease;\n\n        #{$block}__item-icon {\n            flex: 0 0 1.2rem;\n            width: 1.2rem;\n            font-size: 1.2rem;\n            transition: transform 0.2s ease;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 0.5\n            );\n            svg {\n                display: block;\n            }\n        }\n        #{$block}__item-text {\n            transition:\n                width 0.3s ease-in-out,\n                opacity 0.3s ease-in-out;\n            width: 6rem;\n            font-size: 1.2rem;\n            line-height: 1.2rem;\n            font-weight: 500;\n            letter-spacing: 0.1rem;\n            text-align: center;\n            overflow: hidden;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 0.8\n            );\n        }\n\n        &#{$block}--active {\n            #{$block}__item-text {\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    black,\n                    $alphaLight: 0.8\n                );\n            }\n            #{$block}__item-icon {\n                @include Utils.theme-paletteColour(color, 900, black, 0.5, 0.6);\n            }\n        }\n\n        &:not(#{$block}--active) {\n            #{$block}__item-icon {\n                transform: translate3d(0.6rem, 0, 0);\n            }\n            #{$block}__item-text {\n                opacity: 0;\n                width: 0;\n            }\n        }\n    }\n\n    #{$block}__indicator {\n        z-index: 0;\n        pointer-events: none;\n        width: 12.4rem;\n        border-radius: 1rem;\n        position: absolute;\n        top: 0rem;\n        bottom: 0rem;\n        transition: transform 0.2s ease;\n        @include Utils.theme-paletteColour(background-color, white, 100);\n        @include Utils.shadow-get(2, 0);\n    }\n\n    &#{$block}--light {\n        #{$block}__indicator {\n            transform: translate3d(6.8rem, 0, 0);\n        }\n    }\n    &#{$block}--dark {\n        #{$block}__indicator {\n            transform: translate3d(13.6rem, 0, 0);\n        }\n    }\n    &#{$block}--system {\n        #{$block}__indicator {\n            left: 0.4rem;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.modal-create-demmi-support-ticket {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 50rem;\n    margin: 4rem auto;\n\n    @media (max-width: 480px) {\n        width: calc(100% - 2rem);\n        margin: 1rem auto 0;\n    }\n\n    #{$block}__title {\n        line-height: 2rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.16rem;\n        padding: 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__error {\n        margin-top: 1rem;\n        line-height: 1.4rem;\n        font-size: 1.2rem;\n        font-weight: 500;\n        letter-spacing: 0.05rem;\n        padding: 1.6rem 1.6rem;\n        width: 100%;\n        border-radius: 1rem;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, white, white);\n        @include Utils.theme-paletteColour(\n            background-color,\n            hsl(0, 70%, 70%),\n            hsl(0, 40%, 50%)\n        );\n    }\n\n    #{$block}__content {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 1rem;\n        margin: 0 auto;\n        box-sizing: border-box;\n        @include Utils.theme-customProp(padding, 0 1rem 1rem, 0);\n\n        input {\n            margin-bottom: 1rem;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.modal-create-product {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 60rem;\n    margin: 4rem auto;\n\n    @media (max-width: 480px) {\n        width: calc(100% - 2rem);\n        margin: 1rem auto;\n    }\n\n    #{$block}__title {\n        line-height: 2rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.16rem;\n        padding: 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__content {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin: 0 auto;\n        box-sizing: border-box;\n        @include Utils.theme-customProp(padding, 0 1rem 1rem, 0);\n\n        input {\n            margin-bottom: 1rem;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.modal-create-variant {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 54rem;\n    margin: 4rem auto;\n    @include Utils.theme-paletteColour(color, 900, white);\n\n    @media (max-width: 480px) {\n        width: calc(100% - 2rem);\n        margin: 1rem auto 0;\n    }\n\n    #{$block}__title {\n        line-height: 2rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.16rem;\n        padding: 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n    }\n\n    #{$block}__content {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin: 0 auto;\n        box-sizing: border-box;\n        @include Utils.theme-customProp(padding, 0 1rem 1rem, 0);\n    }\n}\n","@use '../../utils' as Utils;\n\n.modal-create-coupon {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 50rem;\n    margin: 4rem auto;\n\n    @media (max-width: 480px) {\n        width: calc(100% - 2rem);\n        margin: 1rem auto 0;\n    }\n\n    #{$block}__title {\n        line-height: 2rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.16rem;\n        padding: 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__error {\n        margin-top: 1rem;\n        line-height: 1.4rem;\n        font-size: 1.2rem;\n        font-weight: 500;\n        letter-spacing: 0.05rem;\n        padding: 1.6rem 1.6rem;\n        width: 100%;\n        border-radius: 1rem;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, white, white);\n        @include Utils.theme-paletteColour(\n            background-color,\n            hsl(0, 70%, 70%),\n            hsl(0, 40%, 50%)\n        );\n    }\n\n    #{$block}__content {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin: 0 auto;\n        box-sizing: border-box;\n        @include Utils.theme-customProp(padding, 0 1rem 1rem, 0);\n\n        #{$block}__code-row {\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n            padding-left: 1rem;\n\n            #{$block}__code-prefix {\n                font-size: 1.5rem;\n                font-weight: 600;\n                letter-spacing: 0.2rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    rgba(0, 0, 0, 0.4),\n                    rgba(255, 255, 255, 0.8)\n                );\n            }\n        }\n\n        #{$block}__details-item {\n            margin: 1rem 0;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            width: 100%;\n            @include Utils.theme-paletteColour(\n                color,\n                rgba(0, 0, 0, 0.6),\n                rgba(255, 255, 255, 0.8)\n            );\n\n            #{$block}__details-title {\n                font-size: 1.3rem;\n                letter-spacing: 0.1rem;\n                font-weight: 500;\n                line-height: 1.4rem;\n                margin: 0.5rem 1rem;\n            }\n\n            #{$block}__details-input {\n                display: flex;\n                align-items: center;\n                gap: 1rem;\n                font-weight: 600;\n                font-size: 1.4rem;\n\n                #{$block}__details-text {\n                    width: 1.4rem;\n                    text-align: center;\n                }\n\n                input {\n                    width: 14rem;\n                }\n            }\n        }\n\n        #{$block}__toggle-item {\n            input {\n                margin-top: 1rem;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.modal-edit-coupon {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 50rem;\n    margin: 4rem auto;\n\n    @media (max-width: 480px) {\n        width: calc(100% - 2rem);\n        margin: 1rem auto 0;\n    }\n\n    #{$block}__title {\n        line-height: 2rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.16rem;\n        padding: 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__error {\n        margin-top: 1rem;\n        line-height: 1.4rem;\n        font-size: 1.2rem;\n        font-weight: 500;\n        letter-spacing: 0.1rem;\n        padding: 1.2rem 1.6rem;\n        width: 100%;\n        border-radius: 1rem;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, white, white);\n        @include Utils.theme-paletteColour(\n            background-color,\n            hsl(0, 70%, 70%),\n            hsl(0, 40%, 50%)\n        );\n    }\n\n    #{$block}__content {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin: 0 auto;\n        box-sizing: border-box;\n        @include Utils.theme-customProp(padding, 0 1rem 1rem, 0);\n\n        #{$block}__code {\n            text-align: center;\n            font-size: 1.5rem;\n            font-weight: 600;\n            letter-spacing: 0.2rem;\n            padding: 1rem 0;\n            @include Utils.theme-paletteColour(\n                color,\n                rgba(0, 0, 0, 0.4),\n                rgba(255, 255, 255, 0.8)\n            );\n        }\n\n        #{$block}__details-item {\n            margin: 1rem 0;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            width: 100%;\n            @include Utils.theme-paletteColour(\n                color,\n                rgba(0, 0, 0, 0.6),\n                rgba(255, 255, 255, 0.8)\n            );\n\n            #{$block}__details-title {\n                font-size: 1.3rem;\n                letter-spacing: 0.1rem;\n                font-weight: 500;\n                line-height: 1.4rem;\n                margin: 0.5rem 1rem;\n            }\n\n            #{$block}__details-input {\n                display: flex;\n                align-items: center;\n                gap: 1rem;\n                font-weight: 600;\n                font-size: 1.4rem;\n\n                #{$block}__details-text {\n                    width: 1.4rem;\n                    text-align: center;\n                }\n\n                input {\n                    width: 10rem;\n                }\n            }\n        }\n\n        #{$block}__toggle-item {\n            input {\n                margin-top: 1rem;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.modal-image {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 36rem;\n    margin: 4rem auto;\n\n    @media (max-width: 480px) {\n        width: calc(100% - 2rem);\n        margin: 1rem auto 0;\n    }\n\n    #{$block}__upload-area {\n        display: flex;\n        flex-direction: column;\n        gap: 2rem;\n        margin: 0 auto;\n        padding: 2rem;\n        box-sizing: border-box;\n\n        input {\n            display: none;\n        }\n    }\n\n    #{$block}__selected {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 1.3rem;\n        line-height: 1.8rem;\n        font-weight: 400;\n        letter-spacing: 0.15rem;\n        box-sizing: border-box;\n        border-radius: 1.5rem;\n        margin: 0 auto;\n        opacity: 1;\n        @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n        &#{$block}__selected--active {\n            opacity: 1;\n        }\n    }\n\n    #{$block}__buttons {\n        position: absolute;\n        bottom: -6rem;\n        right: 0;\n        width: 24rem;\n        display: flex;\n        gap: 2rem;\n        justify-content: flex-end;\n    }\n\n    #{$block}__image-wrapper {\n        display: none;\n        margin: 0 auto;\n        max-width: 32rem;\n        box-sizing: border-box;\n        overflow: hidden;\n        justify-content: center;\n        align-items: center;\n        border-radius: 1.5rem;\n        padding: 1rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.05),\n            0.4\n        );\n\n        &#{$block}__image-wrapper--active {\n            display: flex;\n        }\n\n        img {\n            max-height: 25rem;\n            max-width: 100%;\n            border-radius: 1rem;\n            box-sizing: border-box;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.modal-boolean {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 36rem;\n    margin: 4rem auto;\n\n    @media (max-width: 480px) {\n        width: calc(100% - 2rem);\n        margin: 1rem auto 0;\n    }\n\n    #{$block}__text {\n        line-height: 2rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.16rem;\n        padding: 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__name {\n        line-height: 2rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.2rem;\n        padding: 0 2rem;\n        margin-bottom: 2.6rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__description {\n        line-height: 1.4rem;\n        font-size: 1.2rem;\n        font-weight: 400;\n        letter-spacing: 0.08rem;\n        padding: 0 2rem 1.2rem 2rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__buttons {\n        position: absolute;\n        bottom: -6rem;\n        right: 0;\n        width: 24rem;\n        display: flex;\n        gap: 2rem;\n        justify-content: flex-end;\n    }\n}\n","@use '../../utils' as Utils;\n\n.modal-publish {\n    $block: &;\n    position: relative;\n    width: calc(100% - 4rem);\n    max-width: 36rem;\n    margin: 4rem auto;\n\n    @media (max-width: 480px) {\n        width: calc(100% - 2rem);\n        margin: 1rem auto 0;\n    }\n\n    #{$block}__text {\n        line-height: 2.4rem;\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.16rem;\n        padding: 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__description {\n        line-height: 1.8rem;\n        font-size: 1.2rem;\n        font-weight: 400;\n        letter-spacing: 0.08rem;\n        padding: 0 4rem 2.4rem;\n        width: 100%;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(color, 900, white);\n    }\n\n    #{$block}__buttons {\n        position: absolute;\n        bottom: -6rem;\n        right: 0;\n        width: 24rem;\n        display: flex;\n        gap: 2rem;\n        justify-content: flex-end;\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.mobile-menu';\n\n#{$block} {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2rem;\n    overflow: auto;\n\n    #{$block}__divider {\n        flex: 0 0 0.1rem;\n        height: 0.1rem;\n        border-radius: 0.1rem;\n        width: calc(100% - 3.2rem);\n        @include Utils.theme-paletteColour(\n            background-color,\n            200,\n            200,\n            $alphaLight: 0.6,\n            $alphaDark: 0.2\n        );\n    }\n\n    #{$block}__vendor {\n        z-index: 1;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 2rem;\n        align-items: center;\n        padding: 0 2rem;\n        box-sizing: border-box;\n        margin-top: 3rem;\n\n        #{$block}__vendor-image {\n            flex: 0 0 12rem;\n            width: 16rem;\n            height: 12rem;\n            border-radius: 1.6rem;\n            overflow: hidden;\n            @include Utils.theme-paletteColour(background-color, 200);\n\n            img {\n                max-height: 100%;\n                max-width: 100%;\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n        #{$block}__vendor-info-stack {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 0.4rem;\n            overflow: hidden;\n\n            #{$block}__vendor-name {\n                font-weight: 500;\n                font-size: 1.6rem;\n                letter-spacing: 0.08rem;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                @include Utils.theme-paletteColour(color, 500, 100);\n            }\n\n            #{$block}__vendor-email {\n                font-weight: 700;\n                font-size: 1.1rem;\n                letter-spacing: 0.04rem;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                text-transform: uppercase;\n                @include Utils.theme-paletteColour(color, 500, 200);\n            }\n        }\n    }\n\n    #{$block}__section {\n        width: 100%;\n        padding: 0rem 0.4rem;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        gap: 0.4rem;\n\n        #{$block}__item {\n            cursor: pointer;\n            user-select: none;\n            display: flex;\n            align-items: center;\n            gap: 2rem;\n            padding: 1.2rem 2rem;\n            border-radius: 0.8rem;\n            color: rgba(0, 0, 0, 0.6);\n            transition:\n                transform 0.1s ease-in-out,\n                box-shadow 0.1s ease-in-out,\n                background-color 0.1s ease-in-out,\n                border-radius 0.2s ease-in-out;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 0.8\n            );\n\n            &#{$block}__item--active {\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    white,\n                    100\n                );\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    black,\n                    $alphaLight: 0.8\n                );\n\n                #{$block}__item-icon {\n                    @include Utils.theme-paletteColour(\n                        color,\n                        900,\n                        black,\n                        $alphaLight: 0.5\n                    );\n                }\n            }\n\n            #{$block}__item-icon {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                width: 1.6rem;\n                height: 1.6rem;\n                font-size: 1.6rem;\n                line-height: 1.6rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    white,\n                    $alphaLight: 0.5\n                );\n            }\n            #{$block}__item-text {\n                font-size: 1.3rem;\n                line-height: 2rem;\n                font-weight: 500;\n                letter-spacing: 0.05rem;\n            }\n\n            &:not(#{$block}__item--active):not(:disabled):hover {\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    rgba(255, 255, 255, 0.6),\n                    200,\n                    $alphaDark: 0.4\n                );\n            }\n\n            &:not(#{$block}__item--active):not(:disabled):active {\n                background-color: rgba(255, 255, 255, 0.8);\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    rgba(255, 255, 255, 0.8),\n                    200,\n                    $alphaDark: 0.6\n                );\n            }\n        }\n    }\n\n    #{$block}__version {\n        z-index: 1;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 0.6rem;\n        padding: 0.8rem 2rem 1.6rem;\n        box-sizing: border-box;\n        line-height: 1.4rem;\n        pointer-events: none;\n        user-select: none;\n        text-transform: uppercase;\n\n        #{$block}__version-build,\n        #{$block}__version-date {\n            display: flex;\n            justify-content: space-between;\n        }\n\n        #{$block}__version-key {\n            display: inline-block;\n            font-size: 1rem;\n            font-weight: 600;\n            text-align: start;\n            letter-spacing: 0.1rem;\n            @include Utils.theme-paletteColour(color, 200, 100);\n        }\n\n        #{$block}__version-val {\n            display: inline-block;\n            font-size: 1.2rem;\n            font-weight: 700;\n            text-align: end;\n            letter-spacing: 0.2rem;\n            @include Utils.theme-paletteColour(color, 300, 300);\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.login-card';\n\n#{$block} {\n    $block: &;\n    width: 34rem;\n    color: rgba(255, 255, 255, 0.8);\n\n    #{$block}__content {\n        padding: 1.6rem;\n        box-sizing: border-box;\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        border-radius: 2rem;\n        overflow: hidden;\n        box-shadow:\n            0 0.8rem 2rem hsla(99, 40%, 10%, 0.12),\n            0 4rem 8rem hsla(99, 40%, 10%, 0.08);\n        @include Utils.theme-demmi(background-color, 900);\n\n        #{$block}__title {\n            line-height: 2rem;\n            font-weight: 600;\n            font-size: 1.6rem;\n            letter-spacing: 0.5rem;\n            text-align: center;\n            margin: 1.5rem auto;\n            color: var(--colour-dark);\n            text-transform: uppercase;\n\n            img {\n                width: 12rem;\n            }\n\n            span {\n                display: block;\n                margin-right: -0.6rem;\n                text-align: end;\n            }\n        }\n\n        #{$block}__description {\n            line-height: 1.6rem;\n            font-weight: 400;\n            font-size: 1.3rem;\n            letter-spacing: 0.05rem;\n            text-align: center;\n            margin: 0 0 1rem;\n            @include Utils.theme-demmi(color, 300);\n        }\n    }\n}\n\n#{$block}-error {\n    $block: &;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: 0;\n    opacity: 0;\n    margin-top: -5rem;\n    pointer-events: none;\n    transition:\n        opacity 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66),\n        margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);\n\n    &#{$block}--visible {\n        opacity: 1;\n        margin-top: 0;\n    }\n\n    #{$block}__error {\n        height: 5rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: rgba(176, 51, 46, 0.5);\n        line-height: 2rem;\n        font-weight: 500;\n        font-size: 1.3rem;\n        letter-spacing: 0.05rem;\n        text-align: center;\n        color: white;\n        border-radius: 2rem;\n        box-shadow:\n            0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12),\n            0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './login-card';\n\n$block: '.login';\n\n#{$block}__wrapper {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 2rem;\n    z-index: 1;\n    background-color: hsl(99, 10%, 5%);\n    transition:\n        transform 0.3s ease-in-out,\n        opacity 0.3s ease-in-out;\n    &:before {\n        content: '';\n        position: absolute;\n        inset: 0;\n        z-index: 0;\n\n        @include Utils.bg-radialBackgroundLogin();\n    }\n\n    &#{$block}--hide {\n        transform: translate3d(0, 4rem, 0);\n        opacity: 0;\n    }\n\n    &#{$block}--error {\n        #{$block}__sign-in {\n            margin-top: 0rem;\n        }\n        #{$block}__submit-button {\n            margin-top: 0rem;\n        }\n    }\n\n    &#{$block}--register-visible {\n        #{$block}__sign-in {\n            pointer-events: none;\n            opacity: 0;\n            transform: rotate3d(0, 1, 0, 180deg);\n        }\n\n        #{$block}__register {\n            pointer-events: unset;\n            transform: rotate3d(0, 1, 0, 0deg);\n            opacity: 1;\n        }\n\n        #{$block}__submit-button {\n            margin-top: 0rem;\n        }\n    }\n\n    #{$block}__submit-button {\n        z-index: 1;\n        margin-top: -3rem;\n        transition: margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);\n    }\n\n    .demmi-ui-button {\n        box-shadow:\n            0 0.8rem 2rem hsla(99, 40%, 10%, 0.12),\n            0 4rem 8rem hsla(99, 40%, 10%, 0.08);\n        @include Utils.theme-demmi(background-color, 700);\n        @include Utils.theme-demmi(border-color, 500);\n        @include Utils.theme-demmi(color, 50);\n\n        &:not(:disabled):hover {\n            box-shadow:\n                0 0.8rem 2rem hsla(99, 40%, 10%, 0.12),\n                0 4rem 8rem hsla(99, 40%, 10%, 0.08);\n            @include Utils.theme-demmi(background-color, 700);\n        }\n\n        &:not(:disabled):active {\n            box-shadow:\n                0 0.8rem 2rem hsla(99, 40%, 10%, 0.12),\n                0 4rem 8rem hsla(99, 40%, 10%, 0.08);\n            @include Utils.theme-demmi(background-color, 600);\n        }\n    }\n\n    .demmi-ui-input {\n        box-shadow: none;\n        @include Utils.theme-demmi(background-color, 900);\n        @include Utils.theme-demmi(color, 100);\n        @include Utils.theme-demmi(border-color, 800);\n\n        &::placeholder {\n            @include Utils.theme-demmi(color, 200);\n        }\n\n        &:hover {\n            @include Utils.theme-demmi(background-color, 800);\n            @include Utils.theme-demmi(border-color, 800);\n        }\n        &:focus {\n            box-shadow: none;\n            @include Utils.theme-demmi(background-color, 800);\n            @include Utils.theme-demmi(border-color, 700);\n        }\n    }\n\n    #{$block}__content-position {\n        position: relative;\n        height: 34rem;\n        width: 34rem;\n        perspective: 400px;\n    }\n\n    #{$block}__sign-in {\n        margin-top: 3rem;\n        position: absolute;\n        inset: 0;\n        pointer-events: unset;\n        transform: rotate3d(0, 1, 0, 0deg);\n        opacity: 1;\n        transition:\n            opacity 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66),\n            transform 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66),\n            margin 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);\n    }\n\n    #{$block}__register {\n        pointer-events: none;\n        position: absolute;\n        inset: 0;\n        opacity: 0;\n        transform: rotate3d(0, 1, 0, -180deg);\n        transition:\n            opacity 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66),\n            transform 0.4s cubic-bezier(0.68, -0.53, 0.34, 1.66);\n    }\n}\n","@use 'sass:list';\n@use 'sass:meta';\n\n@use './colours.scss' as Colours;\n\n$radialBackgroundThemedLight: radial-gradient(\n        circle at calc(1% * var(--theme-bg-pos)) top,\n        white,\n        transparent,\n        transparent\n    ),\n    radial-gradient(\n        circle at calc(100% - 1% * var(--theme-bg-pos)) bottom,\n        white,\n        transparent,\n        transparent\n    );\n$radialBackgroundThemedDark: radial-gradient(\n        circle at calc(1% * var(--theme-bg-pos)) top,\n        var(--theme-bg-01),\n        transparent,\n        transparent\n    ),\n    radial-gradient(\n        circle at calc(100% - 1% * var(--theme-bg-pos)) bottom,\n        var(--theme-bg-02),\n        transparent,\n        transparent\n    );\n\n@mixin getBackgroundColour($opacity: 1) {\n    & {\n        @include Colours.themedValue(\n            background,\n            100,\n            rgba(19, 19, 19, $opacity)\n        );\n    }\n}\n\n@mixin radialBackground($opacity: 1, $gradientIntensity: 1) {\n    @include Colours.paletteColour(\n        background-color,\n        hsla(\n            var(--theme-bg-hue),\n            var(--palette-100-s),\n            var(--palette-100-l),\n            $opacity\n        ),\n        hsla(var(--theme-bg-hue), 15%, 8%, $opacity)\n    );\n\n    &::before {\n        content: '';\n        z-index: 0;\n        inset: 0;\n        position: absolute;\n        opacity: calc(0.5 * $gradientIntensity);\n        background: $radialBackgroundThemedLight;\n        background-size: 100% 100%;\n        background-repeat: no-repeat;\n    }\n\n    &::after {\n        z-index: 0;\n        content: '';\n        inset: 0;\n        position: absolute;\n        background: var(--theme-bg-svg);\n        @include Colours.customProp(mix-blend-mode, color-burn, color-dodge);\n        @include Colours.customProp(opacity, 0.6, 0.1);\n    }\n\n    @at-root body.theme-dark #{&} {\n        &::before {\n            opacity: calc(0.2 * $gradientIntensity);\n            background: $radialBackgroundThemedDark;\n        }\n    }\n}\n\n$radialBackgroundLogin: radial-gradient(\n        circle at calc(1% * var(--theme-bg-pos)) top,\n        hsla(99, 30%, 74%, 0.25),\n        transparent\n    ),\n    radial-gradient(\n        circle at calc(100% - 1% * var(--theme-bg-pos)) bottom,\n        hsla(99, 22%, 57%, 0.4),\n        transparent\n    );\n\n@mixin radialBackgroundLogin() {\n    z-index: 0;\n    background: $radialBackgroundLogin;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    &::before {\n        z-index: -1;\n        content: '';\n        inset: 0;\n        position: absolute;\n        background-color: rgb(252, 252, 252);\n    }\n    &::after {\n        z-index: 0;\n        content: '';\n        inset: 0;\n        position: absolute;\n        background: var(--theme-bg-svg);\n        mix-blend-mode: color-dodge;\n        opacity: var(--theme-bg-grain);\n    }\n}\n","@use '../../utils' as Utils;\n\n.loading-overlay {\n    $block: &;\n    position: fixed;\n    inset: 0;\n    z-index: 99999 !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    pointer-events: none;\n    flex-direction: column;\n    isolation: isolate;\n    transition: opacity 0.5s ease-in-out;\n\n    @include Utils.theme-paletteColour(\n        background-color,\n        hsla(99deg, 0%, 98%, 0.9),\n        hsla(99deg, 22%, 8%, 1)\n    );\n\n    &#{$block}--login-page {\n        #{$block}__loading-indicator {\n            $backgroundLight: linear-gradient(\n                hsla(99deg, 30%, 74%, 1),\n                hsla(99deg, 90%, 0%, 0),\n                hsla(99deg, 22%, 57%, 1)\n            );\n            $backgroundDark: linear-gradient(\n                hsla(99deg, 30%, 74%, 1),\n                hsla(99deg, 90%, 80%, 0),\n                hsla(99deg, 22%, 57%, 1)\n            );\n            @include Utils.theme-paletteColour(\n                background,\n                $backgroundLight,\n                $backgroundDark\n            );\n\n            &:before {\n                @include Utils.theme-paletteColour(\n                    background,\n                    $backgroundLight,\n                    $backgroundDark\n                );\n            }\n        }\n    }\n\n    &#{$block}--animated {\n        #{$block}__title {\n            animation: load-title 0.4s forwards;\n            animation-delay: 0.4s;\n            opacity: 0;\n        }\n\n        #{$block}__subtitle {\n            animation: load-subtitle 0.4s forwards;\n            animation-delay: 0.7s;\n            opacity: 0;\n        }\n    }\n\n    #{$block}__logo {\n        position: relative;\n        width: 30rem;\n        height: 30rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n    }\n\n    #{$block}__title {\n        position: relative;\n\n        img {\n            width: 20rem;\n        }\n    }\n\n    #{$block}__subtitle {\n        position: relative;\n        font-size: 1.6rem;\n        line-height: 2rem;\n        font-weight: 400;\n        margin-top: 0.8rem;\n        letter-spacing: 0.05rem;\n        color: var(--colour-light);\n        pointer-events: none;\n        user-select: none;\n    }\n\n    #{$block}__loading-indicator {\n        $background: linear-gradient(\n            var(--colour-light),\n            hsla(99deg, 90%, 80%, 0),\n            var(--colour-dark)\n        );\n\n        position: absolute;\n        inset: 0;\n        width: 30rem;\n        height: 30rem;\n        border-radius: 50%;\n        animation: animate-loader 1.2s linear infinite;\n        transition: opacity 0.3s ease-in-out;\n        background: $background;\n        opacity: 0.6;\n\n        &:before {\n            content: '';\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n            filter: blur(0.8rem);\n            background: $background;\n        }\n\n        &:after {\n            content: '';\n            position: absolute;\n            inset: 0.3rem;\n            border-radius: 50%;\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsla(99deg, 0%, 98%, 1),\n                hsla(99deg, 22%, 8%, 1)\n            );\n        }\n    }\n\n    &#{$block}--auth {\n        #{$block}__subtitle {\n            opacity: 1;\n            animation: none;\n        }\n    }\n}\n\n@keyframes globalLoadingIn {\n    0% {\n        z-index: 99999;\n        opacity: 0;\n        // backdrop-filter: blur(0px);\n    }\n    100% {\n        z-index: 99999;\n        opacity: 1;\n        transform: scale(1);\n        // backdrop-filter: blur(10px);\n    }\n}\n\n@keyframes globalLoadingOut {\n    0% {\n        transform: scale(1);\n        // backdrop-filter: blur(10px);\n    }\n    100% {\n        opacity: 0;\n        // backdrop-filter: blur(0px);\n    }\n}\n\n@keyframes animate-loader {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes load-text-in {\n    0% {\n        transform: scale3d(0, 0, 0);\n        opacity: 0;\n    }\n\n    50% {\n        transform: scale3d(1, 1.2, 1);\n        opacity: 0.7;\n    }\n\n    100% {\n        transform: scale3d(1, 1, 1);\n        opacity: 1;\n    }\n}\n\n@keyframes load-title {\n    0% {\n        bottom: -3rem;\n    }\n\n    50% {\n        bottom: 1.2rem;\n        opacity: 1;\n    }\n\n    100% {\n        bottom: 0;\n        opacity: 1;\n    }\n}\n@keyframes load-subtitle {\n    0% {\n        bottom: 1.6rem;\n    }\n\n    50% {\n        bottom: -0.4rem;\n        opacity: 1;\n    }\n\n    100% {\n        bottom: 0;\n        opacity: 1;\n    }\n}\n","@use '../../utils' as Utils;\n\n.element-loading-indicator {\n    $block: &;\n    position: absolute;\n    inset: 0;\n    display: none;\n    align-items: center;\n    justify-content: center;\n\n    &#{$block}--loading {\n        display: flex;\n    }\n\n    #{$block}__loading-indicator {\n        $backgroundLight: linear-gradient(\n            Utils.theme-get(400),\n            hsla(99deg, 90%, 80%, 0),\n            Utils.theme-get(300)\n        );\n        $backgroundDark: linear-gradient(\n            white,\n            hsla(99deg, 90%, 80%, 0),\n            white\n        );\n        position: relative;\n        width: 3rem;\n        height: 3rem;\n        border-radius: 50%;\n        opacity: 0.6;\n        animation: element-loading-indicator 1.2s linear infinite;\n        @include Utils.theme-customProp(\n            background,\n            $backgroundLight,\n            $backgroundDark\n        );\n\n        &:before {\n            content: '';\n            inset: 0;\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            border-radius: 50%;\n            filter: blur(0.4rem);\n            @include Utils.theme-customProp(\n                background,\n                $backgroundLight,\n                $backgroundDark\n            );\n        }\n\n        &:after {\n            content: '';\n            position: absolute;\n            inset: 0.2rem;\n            border-radius: 50%;\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsla(99deg, 0%, 98%, 1),\n                0.8\n            );\n        }\n    }\n}\n\n@keyframes element-loading-indicator {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.toolbar';\n\n#{$block}__wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.4rem;\n\n    #{$block} {\n        display: flex;\n        gap: 0.6rem;\n        border-radius: 2.2rem;\n        padding: 0 0.8rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            200,\n            $alphaDark: 0.4\n        );\n\n        #{$block}__item {\n            cursor: pointer;\n            user-select: none;\n            display: flex;\n            gap: 1.4rem;\n            padding: 1.4rem 2rem;\n            border-radius: 0.8rem;\n            color: rgba(0, 0, 0, 0.6);\n            transition:\n                transform 0.1s ease-in-out,\n                box-shadow 0.1s ease-in-out,\n                background-color 0.1s ease-in-out,\n                border-radius 0.2s ease-in-out;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 0.8\n            );\n\n            &#{$block}__item--active {\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    white,\n                    100\n                );\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    black,\n                    $alphaLight: 0.8\n                );\n                @include Utils.shadow-get(2, 0);\n\n                #{$block}__item-icon {\n                    @include Utils.theme-paletteColour(\n                        color,\n                        900,\n                        black,\n                        $alphaLight: 0.5\n                    );\n                }\n            }\n\n            #{$block}__item-icon {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                width: 1.6rem;\n                height: 1.6rem;\n                font-size: 1.4rem;\n                line-height: 1.4rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    white,\n                    $alphaLight: 0.5\n                );\n            }\n            #{$block}__item-text {\n                font-size: 1.3rem;\n                font-weight: 500;\n                letter-spacing: 0.05rem;\n                line-height: 1.6rem;\n            }\n\n            &:not(#{$block}__item--active):not(:disabled):hover {\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    rgba(255, 255, 255, 0.6),\n                    200,\n                    $alphaDark: 0.4\n                );\n                @include Utils.shadow-get(2, 0);\n            }\n\n            &:not(#{$block}__item--active):not(:disabled):active {\n                background-color: rgba(255, 255, 255, 0.8);\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    rgba(255, 255, 255, 0.8),\n                    200,\n                    $alphaDark: 0.6\n                );\n                @include Utils.shadow-get(5, 0);\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.demmi-toast {\n    $block: &;\n\n    #{$block}__action {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        font-weight: 600;\n        letter-spacing: 0.15rem;\n        font-size: 1.2rem;\n        line-height: 1.6rem;\n        border-radius: 2rem;\n        padding: 0.8rem 1.2rem;\n        box-sizing: border-box;\n        transition:\n            background-color 0.1s ease-in-out,\n            color 0.1s ease-in-out;\n        @include Utils.theme-customProp(\n            background-color,\n            rgba(0, 0, 0, 0.04),\n            rgba(255, 255, 255, 0.08)\n        );\n        @include Utils.theme-customProp(\n            color,\n            hsla(0, 0%, 0%, 0.8),\n            hsla(0, 0%, 100%, 0.8)\n        );\n\n        &:not(:disabled):hover {\n            @include Utils.theme-customProp(\n                background-color,\n                rgba(0, 0, 0, 0.12),\n                rgba(255, 255, 255, 0.16)\n            );\n        }\n\n        &:not(:disabled):active,\n        &:not(:disabled):focus-visible {\n            @include Utils.theme-customProp(\n                background-color,\n                rgba(0, 0, 0, 0.08),\n                rgba(255, 255, 255, 0.12)\n            );\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.demmi-toast {\n    $block: &;\n\n    #{$block}__button-close {\n        cursor: pointer;\n        flex: 0 0 auto;\n        width: 3.2rem;\n        height: 3.2rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        line-height: 1.6rem;\n        border-radius: 50%;\n        box-sizing: border-box;\n        transition:\n            background-color 0.1s ease-in-out,\n            color 0.1s ease-in-out;\n        @include Utils.theme-customProp(\n            background-color,\n            rgba(0, 0, 0, 0),\n            rgba(255, 255, 255, 0)\n        );\n\n        &:not(:disabled):hover {\n            @include Utils.theme-customProp(\n                background-color,\n                rgba(0, 0, 0, 0.12),\n                rgba(255, 255, 255, 0.12)\n            );\n            svg {\n                @include Utils.theme-customProp(\n                    color,\n                    rgba(0, 0, 0, 0.8),\n                    rgba(255, 255, 255, 0.7)\n                );\n            }\n        }\n\n        &:not(:disabled):active,\n        &:not(:disabled):focus-visible {\n            @include Utils.theme-customProp(\n                background-color,\n                rgba(0, 0, 0, 0.08),\n                rgba(255, 255, 255, 0.08)\n            );\n            svg {\n                @include Utils.theme-customProp(\n                    color,\n                    rgba(0, 0, 0, 0.4),\n                    rgba(255, 255, 255, 0.8)\n                );\n            }\n        }\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.8rem;\n            width: 1.8rem;\n            @include Utils.theme-customProp(\n                color,\n                rgba(0, 0, 0, 0.32),\n                rgba(255, 255, 255, 0.5)\n            );\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './button-action';\n@use './button-close';\n\n.demmi-toasts-viewport {\n    --viewport-padding: 25px;\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    flex-direction: column;\n    padding: 1.6rem;\n    gap: 10px;\n    width: 42rem;\n    box-sizing: border-box;\n    max-width: 100vw;\n    margin: 0;\n    list-style: none;\n    z-index: 2147483647;\n    outline: none;\n}\n\n// Success\n\n$hueSuccess: 143;\n$hueError: 352;\n$hueWarning: 40;\n$hueInfo: 55;\n\n//#90DBB2\n$successLight: hsl(143, 43%, 85%);\n$successDark: hsl(143, 22%, 45%);\n$successIconLight: hsl(148, 33%, 70%);\n$successIconDark: hsl(148, 33%, 70%);\n\n// Error\n$errorLight: hsl(352, 59%, 85%);\n$errorDark: hsl(352, 20%, 50%);\n$errorIconLight: hsl(352, 43%, 70%);\n$errorIconDark: hsl(352, 43%, 70%);\n\n// Warning\n$warningLight: hsl(40, 72%, 79%);\n$warningDark: hsl(40, 38%, 55%);\n$warningIconLight: hsl(40, 60%, 60%);\n$warningIconDark: hsl(40, 60%, 60%);\n\n// Info\n$infoLight: hsl(55, 50%, 92%);\n$infoDark: hsl(55, 10%, 32%);\n$infoIconLight: hsl(55, 70%, 75%);\n$infoIconDark: hsl(55, 70%, 75%);\n\n.demmi-toast {\n    $block: &;\n    border-radius: 2.4rem;\n    box-shadow:\n        hsl(206 22% 7% / 35%) 0px 10px 38px -10px,\n        hsl(206 22% 7% / 20%) 0px 10px 20px -15px;\n    padding: 0.8rem;\n    display: grid;\n    grid-template-areas:\n        'icon title buttons'\n        'icon description buttons';\n    grid-template-columns: auto auto max-content;\n    column-gap: 1.6rem;\n    row-gap: 0.8rem;\n    align-items: center;\n    @include Utils.theme-customProp(\n        background-color,\n        $successLight,\n        $successDark\n    );\n\n    &#{$block}--type-success {\n        @include Utils.theme-customProp(\n            background-color,\n            $successLight,\n            $successDark\n        );\n\n        #{$block}__icon {\n            svg {\n                @include Utils.theme-customProp(\n                    color,\n                    $successIconLight,\n                    $successIconDark\n                );\n            }\n        }\n    }\n\n    &#{$block}--type-error {\n        @include Utils.theme-customProp(\n            background-color,\n            $errorLight,\n            $errorDark\n        );\n\n        #{$block}__icon {\n            svg {\n                @include Utils.theme-customProp(\n                    color,\n                    $errorIconLight,\n                    $errorIconDark\n                );\n            }\n        }\n    }\n\n    &#{$block}--type-warning {\n        @include Utils.theme-customProp(\n            background-color,\n            $warningLight,\n            $warningDark\n        );\n\n        #{$block}__icon {\n            svg {\n                @include Utils.theme-customProp(\n                    color,\n                    $warningIconLight,\n                    $warningIconDark\n                );\n            }\n        }\n    }\n\n    &#{$block}--type-info {\n        @include Utils.theme-customProp(\n            background-color,\n            $infoLight,\n            $infoDark\n        );\n\n        #{$block}__icon {\n            svg {\n                @include Utils.theme-customProp(\n                    color,\n                    $infoIconLight,\n                    $infoIconDark\n                );\n            }\n        }\n    }\n\n    #{$block}[data-state='open'] {\n        animation: slideIn 150ms cubic-bezier(0.16, 1, 0.3, 1);\n    }\n    #{$block}[data-state='closed'] {\n        animation: hide 100ms ease-in;\n    }\n    #{$block}[data-swipe='move'] {\n        transform: translateX(var(--radix-toast-swipe-move-x));\n    }\n    #{$block}[data-swipe='cancel'] {\n        transform: translateX(0);\n        transition: transform 200ms ease-out;\n    }\n    #{$block}[data-swipe='end'] {\n        animation: swipeOut 100ms ease-out;\n    }\n\n    #{$block}__buttons-area {\n        grid-area: buttons;\n        display: flex;\n        height: 100%;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: flex-end;\n        gap: 0.8rem;\n    }\n\n    #{$block}__title {\n        grid-area: title;\n        margin-top: 0.8rem;\n        font-weight: 600;\n        letter-spacing: 0.08rem;\n        font-size: 1.3rem;\n        line-height: 1.8rem;\n        @include Utils.theme-customProp(\n            color,\n            hsla(0, 0%, 0%, 0.6),\n            hsla(0, 0%, 100%, 0.9)\n        );\n    }\n\n    #{$block}__description {\n        grid-area: description;\n        margin-bottom: 1rem;\n        letter-spacing: 0.08rem;\n        font-size: 1.2rem;\n        line-height: 1.4rem;\n        @include Utils.theme-customProp(\n            color,\n            hsla(0, 0%, 0%, 0.9),\n            hsla(0, 0%, 100%, 0.9)\n        );\n    }\n\n    #{$block}__icon {\n        grid-area: icon;\n        margin-left: 0.8rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 50%;\n        height: 4rem;\n        width: 4rem;\n        @include Utils.theme-customProp(background-color, white, black);\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 2.4rem;\n            width: 2.4rem;\n            @include Utils.theme-customProp(color, $successLight, $successDark);\n        }\n    }\n}\n\n@keyframes hide {\n    from {\n        opacity: 1;\n    }\n    to {\n        opacity: 0;\n    }\n}\n\n@keyframes slideIn {\n    from {\n        transform: translateX(calc(100% + var(--viewport-padding)));\n    }\n    to {\n        transform: translateX(0);\n    }\n}\n\n@keyframes swipeOut {\n    from {\n        transform: translateX(var(--radix-toast-swipe-end-x));\n    }\n    to {\n        transform: translateX(calc(100% + var(--viewport-padding)));\n    }\n}\n\n// .Button {\n//     display: inline-flex;\n//     align-items: center;\n//     justify-content: center;\n//     border-radius: 4px;\n//     font-weight: 500;\n//     user-select: none;\n// }\n// .Button.small {\n//     font-size: 12px;\n//     padding: 0 10px;\n//     line-height: 25px;\n//     height: 25px;\n// }\n// .Button.large {\n//     font-size: 15px;\n//     padding: 0 15px;\n//     line-height: 35px;\n//     height: 35px;\n// }\n// .Button.violet {\n//     background-color: white;\n//     color: var(--violet-11);\n//     box-shadow: 0 2px 10px var(--black-a7);\n// }\n// .Button.violet:hover {\n//     background-color: var(--mauve-3);\n// }\n// .Button.violet:focus {\n//     box-shadow: 0 0 0 2px black;\n// }\n// .Button.green {\n//     background-color: var(--green-2);\n//     color: var(--green-11);\n//     box-shadow: inset 0 0 0 1px var(--green-7);\n// }\n// .Button.green:hover {\n//     box-shadow: inset 0 0 0 1px var(--green-8);\n// }\n// .Button.green:focus {\n//     box-shadow: 0 0 0 2px var(--green-8);\n// }\n","@use '../../utils' as Utils;\n\n.sidebar__section-title {\n    $block: &;\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    font-size: 1.5rem;\n    line-height: 2rem;\n    padding: 0 2.4rem;\n    font-weight: 400;\n    letter-spacing: 0.15rem;\n    text-align: start;\n    margin: 3.2rem 0 1.6rem;\n    @include Utils.theme-paletteColour(color, 900, 100, $alphaLight: 0.8);\n\n    &:first-child {\n        margin-top: 0;\n    }\n\n    svg {\n        display: block;\n        pointer-events: none;\n        height: 2rem;\n        width: 2rem;\n        line-height: 2rem;\n        @include Utils.theme-paletteColour(color, 800, 200, $alphaLight: 0.7);\n    }\n}\n\n$block: '.sidebar-button';\n.sidebar-button {\n    cursor: pointer;\n    width: 100%;\n    align-items: center;\n    gap: 2rem;\n    font-size: 1.3rem;\n    box-sizing: border-box;\n    line-height: 1.6rem;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    text-align: start;\n    background-color: transparent;\n    transition: background-color 0.1s ease-in-out;\n    @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.7);\n\n    &:disabled {\n        opacity: 0.4;\n    }\n\n    &:not(:disabled):not(#{$block}--active):hover {\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.3),\n            200,\n            $alphaDark: 0.2\n        );\n    }\n\n    &:not(:disabled):not(#{$block}--active):active {\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.5),\n            200,\n            $alphaDark: 0.3\n        );\n    }\n\n    &#{$block}--active {\n        // pointer-events: none;\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.6),\n            200,\n            $alphaDark: 0.3\n        );\n    }\n}\n\n#{$block}.sidebar-button-managed {\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    font-size: 1.3rem;\n    line-height: 1.6rem;\n    padding: 1.6rem 2.4rem;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    text-align: start;\n\n    #{$block}__icon {\n        height: 1.6rem;\n        width: 1.6rem;\n        line-height: 1.6rem;\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.6rem;\n            width: 1.6rem;\n        }\n    }\n\n    #{$block}__text {\n        #{$block}__badge {\n            letter-spacing: 0.1rem;\n            font-weight: 700;\n            font-size: 1rem;\n            padding: 0.4rem 0.8rem;\n            border-radius: 0.8rem;\n            text-align: center;\n            text-transform: uppercase;\n            margin-right: 0.8rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                100,\n                200,\n                $alphaDark: 0.2\n            );\n        }\n    }\n}\n\n.sidebar-button-custom {\n    $block: &;\n    display: block;\n    padding: 0;\n}\n\n.sidebar-button-divider {\n    flex: 0 0 0.1rem;\n    height: 0.1rem;\n    width: 100%;\n    @include Utils.theme-paletteColour(\n        background-color,\n        100,\n        200,\n        $alphaDark: 0.4\n    );\n}\n","@use '../../utils' as Utils;\n\n@use './_managed-button';\n\n$block: '.sidebar';\n\n#{$block} {\n    position: relative;\n    height: 100%;\n    display: flex;\n    width: var(--sidebar-width);\n    flex-direction: column;\n    max-height: 100%;\n    box-sizing: border-box;\n    overflow: hidden auto;\n    transition: transform var(--sidebar-transition-time) ease-in-out;\n\n    #{$block}__header {\n        width: var(--sidebar-width);\n        flex: 0 0 auto;\n        transition: opacity var(--sidebar-transition-time) ease-in-out;\n        padding: 1.6rem;\n        box-sizing: border-box;\n\n        #{$block}__title {\n            font-size: 1.8rem;\n            letter-spacing: 0.15rem;\n            font-weight: 400;\n            line-height: 4rem;\n            text-align: center;\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            gap: 2rem;\n            margin-left: 0.8rem;\n            @include Utils.theme-paletteColour(\n                color,\n                700,\n                white,\n                $alphaLight: 0.6\n            );\n\n            &#{$block}__title--only-buttons {\n                display: block;\n                width: 100%;\n                margin-left: 0;\n            }\n\n            #{$block}__title-buttons {\n                display: flex;\n                align-items: center;\n                gap: 0.5rem;\n            }\n        }\n\n        #{$block}__search {\n            margin: 2rem 0 0;\n        }\n    }\n\n    #{$block}__buttons {\n        width: var(--sidebar-width);\n        position: relative;\n        min-height: 10rem;\n        flex: 1 1 auto;\n        padding: 1rem 0;\n        display: flex;\n        flex-direction: column;\n        overflow: auto;\n        box-sizing: border-box;\n        transition: opacity var(--sidebar-transition-time) ease-in-out;\n    }\n\n    &:hover {\n        transform: translate3d(0, 0, 0);\n        #{$block}__header {\n            opacity: 1;\n        }\n        #{$block}__buttons {\n            opacity: 1;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.notifications-panel {\n    $block: &;\n    position: absolute;\n    inset: 0;\n    z-index: 9999;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n\n    &#{$block}--visible {\n        #{$block}__content {\n            opacity: 1;\n        }\n        #{$block}__backdrop {\n            opacity: 1;\n        }\n\n        .notifications-panel-content {\n            transition: transform 0.4s ease-out;\n            transform: translate3d(0, 1.2rem, 0);\n        }\n\n        @media (max-width: Utils.$mobileUIWidth) {\n            .notifications-panel-content {\n                transform: translate3d(0, 0, 0);\n            }\n        }\n    }\n\n    #{$block}__backdrop {\n        opacity: 0;\n        position: absolute;\n        inset: 0;\n        transition: opacity 0.3s ease-in-out;\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(0, 0, 0, 0.4),\n            rgba(0, 0, 0, 0.7)\n        );\n    }\n}\n\n$width: 46rem;\n.notifications-panel-content {\n    $block: &;\n    width: calc(100% - 4rem);\n    max-width: $width;\n    max-height: calc(100% - 2rem);\n    box-sizing: border-box;\n    border-radius: 2.4rem;\n    overflow: auto;\n    margin: 0;\n    transform-origin: top;\n    transform: translate3d(0, -100%, 0);\n    transition: transform 0.3s ease-in;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    @include Utils.shadow-get(4);\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.5), white);\n    @include Utils.theme-paletteColour(\n        background-color,\n        white,\n        hsla(var(--theme-bg-hue), 15%, 8%, 0.6)\n    );\n    @include Utils.theme-customProp(\n        box-shadow,\n        1.2rem 0rem 4rem Utils.theme-get(900, 0.1),\n        1.2rem 0rem 4rem rgba(0, 0, 0, 0.3)\n    );\n\n    &::before {\n        content: '';\n        z-index: 0;\n        inset: 0;\n        position: absolute;\n        pointer-events: none;\n        background-repeat: no-repeat;\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.2),\n            200,\n            $alphaDark: 0.2\n        );\n    }\n\n    #{$block}__title {\n        text-align: center;\n        font-size: 1.6rem;\n        letter-spacing: 0.05rem;\n        font-weight: 500;\n        line-height: 6rem;\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n    }\n\n    #{$block}__close-button {\n        display: none;\n        position: absolute;\n        top: 1rem;\n        right: 1rem;\n    }\n\n    @media (max-width: Utils.$mobileUIWidth) {\n        border-radius: 0;\n        height: 100%;\n        max-height: unset;\n        width: 100%;\n\n        #{$block}__close-button {\n            display: block;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.notification-item {\n    $block: &;\n    position: relative;\n    display: grid;\n    grid-template:\n        'badge action' 3.8rem\n        'message message' auto\n        'timestamp title' 2rem / auto auto;\n    padding: 1.2rem 1rem;\n    border-top: 0.1rem solid transparent;\n    transition: background-color 0.1s ease-in-out;\n\n    &:not(:last-child) {\n        border-bottom: none;\n    }\n\n    @include Utils.theme-paletteColour(\n        border-color,\n        100,\n        400,\n        $alphaLight: 0.6,\n        $alphaDark: 0.4\n    );\n\n    &:hover {\n        @include Utils.theme-paletteColour(\n            background-color,\n            400,\n            400,\n            $alphaLight: 0.08,\n            $alphaDark: 0.2\n        );\n    }\n\n    &#{$block}--new {\n        &::before {\n            content: '';\n            position: absolute;\n            width: 1rem;\n            height: 1rem;\n            right: 1.6rem;\n            bottom: 1.6rem;\n            border-radius: 0.5rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsl(101, 71%, 68%),\n                hsl(101, 71%, 68%) // hsl(101, 50%, 60%),\n                // hsl(101, 37%, 55%)\n            );\n        }\n    }\n\n    #{$block}__badge {\n        grid-area: badge;\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        justify-self: flex-start;\n        text-align: center;\n        border-radius: 0.8rem;\n        font-size: 1.2rem;\n        letter-spacing: 0.1rem;\n        font-weight: 500;\n        padding: 0 1.5rem;\n        line-height: 1.6rem;\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            200,\n            $alphaDark: 0.2\n        );\n\n        svg {\n            margin-right: 1rem;\n            height: 1.4rem;\n        }\n    }\n\n    #{$block}__timestamp {\n        grid-area: timestamp;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        font-size: 1.2rem;\n        font-weight: 400;\n        letter-spacing: 0.1rem;\n        margin-left: 0.6rem;\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.9);\n    }\n\n    #{$block}__buttons {\n        justify-self: flex-end;\n        grid-area: action;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        gap: 0.5rem;\n\n        .demmi-ui-button {\n            @include Utils.shadow-get(0, 0);\n        }\n    }\n\n    #{$block}__message {\n        grid-area: message;\n        display: flex;\n        flex-direction: column;\n        margin-top: 1.6rem;\n        margin-bottom: 0.4rem;\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.7);\n\n        #{$block}__text {\n            font-size: 1.3rem;\n            font-weight: 400;\n            letter-spacing: 0.05rem;\n            line-height: 2rem;\n            padding: 0 0.6rem 0.4rem;\n\n            strong {\n                font-weight: 600;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './notifications-panel';\n@use './notifications-item';\n\n$block: '.notifications';\n\n#{$block}__icon {\n    position: relative;\n\n    #{$block}__icon-indicator {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        top: -0.3rem;\n        right: -0.3rem;\n        width: 2rem;\n        height: 2rem;\n        border-radius: 1rem;\n        font-weight: 700;\n        font-size: 1.1rem;\n        color: white;\n        @include Utils.theme-paletteColour(\n            background-color,\n            hsl(101, 50%, 60%),\n            hsl(101, 37%, 55%)\n        );\n    }\n}\n","@use '../../../utils' as Utils;\n\n.order-item-header {\n    $block: &;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n\n    #{$block}__id {\n        line-height: 3rem;\n        font-size: 1.8rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        padding-left: 1rem;\n        @include Utils.theme-paletteColour(color, 900, 100, $alphaLight: 0.6);\n    }\n\n    #{$block}__status {\n        display: flex;\n        gap: 1rem;\n\n        #{$block}__status-badge {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            box-sizing: border-box;\n            padding: 0 1.6rem;\n            font-size: 1.2rem;\n            font-weight: 500;\n            letter-spacing: 0.1rem;\n            line-height: 2.8rem;\n            border-radius: 2rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                600,\n                200,\n                $alphaDark: 0.4,\n                $alphaLight: 0.6\n            );\n            @include Utils.theme-paletteColour(color, white, white);\n        }\n    }\n\n    @media (max-width: 480px) {\n        flex-direction: column-reverse;\n\n        #{$block}__status {\n            margin-left: auto;\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n.order-item-collection {\n    $block: &;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    // gap: 1.4rem;\n    border-radius: 1rem;\n    text-align: center;\n    padding: 1rem;\n    @include Utils.theme-paletteColour(\n        background-color,\n        800,\n        200,\n        $alphaLight: 0.6,\n        $alphaDark: 0.2\n    );\n    @include Utils.theme-paletteColour(color, white, white);\n\n    #{$block}__title {\n        font-size: 1.4rem;\n        font-weight: 600;\n        letter-spacing: 0.18rem;\n        line-height: 1.2rem;\n        margin: 1rem 0;\n        @include Utils.theme-paletteColour(color, 50, 100);\n    }\n\n    #{$block}__code {\n        gap: 1rem;\n        display: flex;\n        font-size: 3.6rem;\n        font-weight: 200;\n        line-height: 4rem;\n        text-transform: uppercase;\n    }\n\n    #{$block}__details {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n\n        #{$block}__key-val {\n            display: flex;\n            flex-direction: column;\n            justify-content: start;\n            padding: 0rem 1rem;\n            text-align: start;\n\n            #{$block}__key {\n                font-size: 1.3rem;\n                font-weight: 600;\n                line-height: 2rem;\n                letter-spacing: 0.1rem;\n                @include Utils.theme-paletteColour(color, 50, 100);\n            }\n            #{$block}__value {\n                font-size: 1.6rem;\n                font-weight: 400;\n                letter-spacing: 0.1rem;\n                line-height: 2.4rem;\n            }\n\n            &:last-child {\n                text-align: end;\n            }\n        }\n    }\n\n    @media (max-width: 540px) {\n        #{$block}__code {\n            margin-bottom: 1rem;\n        }\n    }\n    @media (max-width: 480px) {\n        #{$block}__code {\n            margin-bottom: 2rem;\n        }\n\n        #{$block}__details {\n            flex-direction: column;\n            gap: 1.2rem;\n\n            #{$block}__key-val {\n                text-align: center;\n                &:last-child {\n                    text-align: center;\n                }\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n$width: 100%;\n$maxWidth: 38rem;\n$height: 18rem;\n\n.order-item-coupon {\n    $block: &;\n    width: $width;\n    max-width: $maxWidth;\n    margin: 0 auto 2rem auto;\n    position: relative;\n    @include Utils.theme-customProp(\n        filter,\n        drop-shadow(0 0.4rem 0.6rem Utils.theme-get(900, 0)),\n        drop-shadow(0 0.4rem 0.6rem Utils.theme-get(900, 0))\n    );\n\n    #{$block}__wrapper-background {\n        position: relative;\n        height: $height;\n        width: $width;\n        max-width: $maxWidth;\n        border-radius: 1.2rem;\n        -webkit-mask-image: radial-gradient(\n                circle at 1rem 5rem,\n                transparent 1rem,\n                red 1rem\n            ),\n            radial-gradient(\n                closest-side circle at 50%,\n                red 99%,\n                transparent 100%\n            );\n        -webkit-mask-size:\n            100%,\n            1.2rem 0.4rem;\n        -webkit-mask-repeat: repeat, repeat-x;\n        -webkit-mask-position:\n            -1rem,\n            50% 4.8rem;\n        -webkit-mask-composite: source-out;\n        mask-composite: subtract;\n\n        @include Utils.theme-customProp(\n            background,\n            // radial-gradient(\n            //     circle at 30% 40%,\n            //     rgba(255, 255, 255, 1),\n            //     rgba(255, 255, 255, 0.7)\n            // ),\n            radial-gradient(\n                    circle at 30% 40%,\n                    Utils.theme-get(200, 0.35),\n                    Utils.theme-get(200, 0.15)\n                ),\n            radial-gradient(\n                circle at 30% 40%,\n                Utils.theme-get(200, 0.5),\n                Utils.theme-get(200, 0.2)\n            )\n        );\n        &::after {\n            content: '';\n            position: absolute;\n            top: 0;\n            left: 0;\n            right: 0;\n            height: 5rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                50,\n                200,\n                0.6,\n                0.3\n            );\n        }\n    }\n\n    #{$block}__contents {\n        position: absolute;\n        inset: 0;\n\n        #{$block}__code {\n            line-height: 5rem;\n            text-align: center;\n            font-weight: 700;\n            font-size: 1.3rem;\n            letter-spacing: 0.4rem;\n            @include Utils.theme-paletteColour(\n                color,\n                Utils.theme-get(800, 0.6),\n                Utils.theme-get(50, 0.9) // white\n            );\n        }\n\n        #{$block}__content-details {\n            position: relative;\n            box-sizing: border-box;\n            padding: 0.8rem 2rem;\n            padding-bottom: 2rem;\n            height: calc(100% - 5rem);\n            display: flex;\n            justify-content: space-between;\n            flex-direction: column;\n            gap: 1rem;\n\n            #{$block}__type {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                border-radius: 1rem;\n                font-weight: 600;\n                font-size: 1.4rem;\n                letter-spacing: 0.1rem;\n                line-height: 5rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    Utils.theme-get(900, 0.6),\n                    Utils.theme-get(50, 0.8) // white\n                );\n            }\n\n            #{$block}__detail-split {\n                display: flex;\n                justify-content: space-between;\n\n                #{$block}__detail:first-child {\n                    text-align: start !important;\n                }\n                #{$block}__detail:last-child {\n                    text-align: end;\n                }\n            }\n\n            #{$block}__detail {\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    white,\n                    $alphaLight: 0.8\n                );\n\n                #{$block}__key {\n                    text-transform: uppercase;\n                    font-weight: 700;\n                    font-size: 1.1rem;\n                    letter-spacing: 0.15rem;\n                    opacity: 0.7;\n                    line-height: 2rem;\n                }\n\n                #{$block}__value {\n                    font-weight: 400;\n                    font-size: 1.5rem;\n                    letter-spacing: 0.1rem;\n                    line-height: 2.4rem;\n                }\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n.order-item {\n    $block: &;\n    #{$block}__timeline {\n        display: flex;\n        position: relative;\n        gap: 2rem;\n        flex-direction: column;\n        padding: 1rem;\n\n        #{$block}__title {\n            font-size: 1.6rem;\n            font-weight: 400;\n            letter-spacing: 0.1rem;\n            line-height: 2rem;\n            text-align: center;\n            margin: 1rem auto;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 0.8\n            );\n\n            svg {\n                margin-right: 2rem;\n            }\n\n            span {\n                font-weight: 600;\n            }\n        }\n\n        #{$block}__update {\n            margin-top: 2rem;\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 1rem;\n            box-sizing: border-box;\n            @include Utils.loadingOpacity();\n\n            #{$block}__update-title {\n                font-size: 1.6rem;\n                font-weight: 400;\n                letter-spacing: 0.1rem;\n                line-height: 2rem;\n                text-align: start;\n                margin: 1rem 0;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    white,\n                    $alphaLight: 0.8\n                );\n            }\n\n            textarea.demmi-ui-input {\n                height: 10rem;\n            }\n\n            #{$block}__buttons {\n                display: flex;\n                flex-wrap: wrap;\n                gap: 1rem;\n\n                .demmi-ui-button {\n                    flex: 1 1 auto;\n                }\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n.order-item {\n    $block: &;\n\n    #{$block}__products-list {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n    }\n}\n","@use '../../../utils' as Utils;\n\n.order-item {\n    $block: &;\n\n    #{$block}__review-none {\n        font-size: 1.4rem;\n        line-height: 2rem;\n        font-weight: 400;\n        text-align: center;\n        padding: 4rem 2rem;\n        letter-spacing: 0.1rem;\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 0.8);\n    }\n\n    #{$block}__review {\n        position: relative;\n        padding: 1rem;\n\n        #{$block}__review-rating {\n            position: absolute;\n            top: 1rem;\n            right: 1rem;\n            display: flex;\n            gap: 0.4rem;\n            svg {\n                @include Utils.theme-paletteColour(color, 300, white);\n            }\n        }\n        #{$block}__review-timestamp {\n            font-size: 1.3rem;\n            font-weight: 500;\n            margin-bottom: 2rem;\n            // margin-top: -1rem;\n\n            span {\n                text-transform: uppercase;\n                font-size: 1.2rem;\n                font-weight: 700;\n                margin-left: 1rem;\n            }\n        }\n\n        #{$block}__review-title {\n            font-size: 1.5rem;\n            line-height: 2rem;\n            font-weight: 500;\n        }\n        #{$block}__review-description {\n            font-size: 1.3rem;\n            font-weight: 400;\n            line-height: 1.8rem;\n\n            #{$block}__review-description-paragraph {\n                margin: 1rem 0;\n            }\n        }\n\n        #{$block}__review-response {\n            margin-top: 2rem;\n            padding: 0.8rem 1.6rem 0.2rem;\n            font-size: 1.3rem;\n            font-weight: 400;\n            line-height: 1.8rem;\n            @include Utils.theme-customProp(border-radius, 1rem, 1.2rem);\n            @include Utils.theme-paletteColour(background-color, 50, 0.4);\n\n            #{$block}__review-response-title {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                font-size: 1.5rem;\n                font-weight: 500;\n                margin-bottom: 1rem;\n                margin-right: -0.8rem;\n\n                #{$block}__review-response-title-buttons {\n                    display: flex;\n                    align-items: center;\n                    gap: 0.8rem;\n                }\n            }\n\n            #{$block}__review-description-paragraph {\n                margin: 1.2rem 0;\n            }\n\n            #{$block}__review-no-response {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                justify-content: center;\n                gap: 1.6rem;\n                font-size: 1.4rem;\n                font-weight: 400;\n                padding: 1.6rem 0;\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n$block: '.order-refund-request';\n\n#{$block}__wrapper {\n    padding: 2rem 1rem;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n}\n\n#{$block}__none {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2.8rem;\n    font-size: 1.4rem;\n    line-height: 2rem;\n    font-weight: 400;\n    text-align: center;\n    padding: 2.8rem 2rem;\n    letter-spacing: 0.1rem;\n    @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 0.8);\n}\n\n#{$block} {\n    width: 100%;\n    display: flex;\n    gap: 3rem;\n    flex-direction: column;\n    padding: 1rem;\n    box-sizing: border-box;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n    @include Utils.loadingOpacity();\n\n    #{$block}__title {\n        font-size: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.1rem;\n        line-height: 2rem;\n        text-align: center;\n        margin: 1rem auto 0;\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 0.8);\n\n        svg {\n            margin-right: 2rem;\n        }\n\n        span {\n            font-weight: 600;\n        }\n    }\n\n    .demmi-ui-timeline {\n        margin: 2rem 1rem;\n    }\n\n    #{$block}__update {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        box-sizing: border-box;\n        @include Utils.loadingOpacity();\n\n        #{$block}__update-title {\n            font-size: 1.6rem;\n            font-weight: 400;\n            letter-spacing: 0.1rem;\n            line-height: 2rem;\n            text-align: start;\n            margin: 0 0 1rem 0;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 0.8\n            );\n        }\n\n        textarea.demmi-ui-input {\n            height: 10rem;\n        }\n\n        #{$block}__buttons {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 1rem;\n\n            .demmi-ui-button {\n                flex: 1 1 calc(50% - 1rem);\n            }\n        }\n    }\n\n    #{$block}__details {\n        padding: 2rem 2rem;\n        border-radius: 1.6rem;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 1rem;\n        @include Utils.theme-paletteColour(background-color, 50, 0.4);\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 0.8);\n\n        #{$block}__details-title {\n            font-size: 1.6rem;\n            font-weight: 400;\n            letter-spacing: 0.1rem;\n            line-height: 2rem;\n            text-align: center;\n            margin-bottom: 1rem;\n        }\n\n        #{$block}__products-list {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            padding: 0.5rem 1rem;\n            box-sizing: border-box;\n            border-radius: 1.2rem;\n            max-width: 40rem;\n            width: 100%;\n            @include Utils.theme-paletteColour(\n                background-color,\n                white,\n                100,\n                $alphaDark: 0.2\n            );\n        }\n\n        #{$block}__costing {\n            display: flex;\n            flex-direction: column;\n            padding: 1rem 1rem;\n            box-sizing: border-box;\n            border-radius: 1.2rem;\n            max-width: 40rem;\n            width: 100%;\n            @include Utils.theme-paletteColour(\n                background-color,\n                white,\n                100,\n                $alphaDark: 0.2\n            );\n\n            #{$block}__key-val {\n                display: flex;\n                justify-content: space-between;\n                line-height: 2rem;\n                padding: 0rem 1rem;\n                margin: 0.4rem 0;\n\n                #{$block}__key {\n                    font-size: 1.3rem;\n                    font-weight: 600;\n                }\n                #{$block}__value {\n                    font-size: 1.4rem;\n                    font-weight: 400;\n                }\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n$block: '.order-product-item';\n.order-item {\n    #{$block} {\n        display: flex;\n        gap: 2rem;\n        box-sizing: border-box;\n        border-radius: 1rem;\n        padding: 0.5rem;\n        line-height: 1.8rem;\n        width: 100%;\n        @include Utils.theme-paletteColour(background-color, white, 0.4);\n        @include Utils.theme-paletteColour(color, 900, white, $alphaLight: 0.6);\n\n        #{$block}__image {\n            width: 12rem;\n            box-sizing: border-box;\n            height: 10rem;\n            overflow: hidden;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            border-radius: 1rem;\n\n            img {\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n        #{$block}__info {\n            flex: 1 1 auto;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            padding: 1rem 0;\n\n            #{$block}__name {\n                font-size: 1.5rem;\n                font-weight: 600;\n            }\n\n            #{$block}__variant {\n                margin-top: 0.4rem;\n                font-size: 1.3rem;\n                font-weight: 400;\n            }\n\n            #{$block}__quantity {\n                margin-top: auto;\n                font-size: 1.6rem;\n                font-weight: 400;\n\n                span {\n                    font-weight: 600;\n                    font-size: 1.4rem;\n                }\n            }\n        }\n\n        #{$block}__cost {\n            display: flex;\n            align-items: center;\n            margin-left: auto;\n            margin-right: 1rem;\n            font-size: 1.6rem;\n            font-weight: 600;\n        }\n\n        &--list-view {\n            padding: 1rem 0.5rem;\n            border-radius: 0;\n            @include Utils.theme-paletteColour(\n                background-color,\n                transparent,\n                transparent\n            );\n            &:not(:last-child) {\n                border-bottom: 0.1rem solid transparent;\n                @include Utils.theme-paletteColour(\n                    border-color,\n                    100,\n                    200,\n                    $alphaDark: 0.2\n                );\n            }\n        }\n\n        &--S {\n            gap: 1.5rem;\n\n            #{$block}__image {\n                width: 9rem;\n                height: 7rem;\n                border-radius: 0.8rem;\n            }\n\n            #{$block}__info {\n                padding: 0.2rem 0;\n\n                #{$block}__name {\n                    font-size: 1.4rem;\n                }\n\n                #{$block}__variant {\n                    margin-top: 0.2rem;\n                    font-size: 1.3rem;\n                }\n\n                #{$block}__quantity {\n                    font-size: 1.5rem;\n                }\n            }\n\n            #{$block}__cost {\n                font-size: 1.5rem;\n            }\n        }\n\n        @media (max-width: 480px) {\n            display: grid;\n            grid-template:\n                'image image'\n                'info cost' / 1fr auto;\n            gap: 1.2rem 1rem;\n            padding: 1.2rem;\n\n            #{$block}__image {\n                grid-area: image;\n                width: 18rem;\n                height: 12rem;\n                margin: 0 auto;\n            }\n\n            #{$block}__info {\n                grid-area: info;\n                padding: 0;\n                gap: 0.4rem;\n\n                #{$block}__variant {\n                    margin-top: 0;\n                }\n                #{$block}__variant {\n                    margin-top: 0;\n                }\n            }\n\n            #{$block}__cost {\n                grid-area: cost;\n            }\n        }\n    }\n}\n","@use '../../../utils' as Utils;\n\n@use './order-item-header';\n@use './order-item-collection';\n@use './order-item-coupon';\n@use './tab-timeline';\n@use './tab-products';\n@use './tab-review';\n@use './tab-refund';\n@use './order-product-item';\n\n.order-item__wrapper {\n    grid-area: order;\n    overflow: hidden;\n    width: 100%;\n    max-width: 80rem;\n    justify-self: center;\n    box-sizing: border-box;\n}\n\n.order-item {\n    $block: &;\n    padding: 2rem 1rem;\n    width: 100%;\n    margin: 0 auto;\n    box-sizing: border-box;\n    line-height: 1.8rem;\n    display: flex;\n    gap: 2rem;\n    flex-direction: column;\n    overflow: auto;\n    height: 100%;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n    #{$block}__key-val {\n        display: flex;\n        justify-content: space-between;\n        line-height: 2rem;\n        padding: 0rem 1rem;\n        margin: 1rem 0;\n\n        #{$block}__key {\n            font-size: 1.3rem;\n            font-weight: 600;\n        }\n        #{$block}__value {\n            font-size: 1.4rem;\n            font-weight: 400;\n        }\n    }\n\n    #{$block}__divider {\n        margin: 2rem 1rem;\n        height: 0.1rem;\n        width: calc(100% - 2rem);\n        @include Utils.theme-paletteColour(\n            background-color,\n            200,\n            50,\n            $alphaDark: 0.2,\n            $alphaLight: 0.4\n        );\n    }\n\n    @media (max-width: 480px) {\n        padding-left: 0;\n        padding-right: 0;\n        padding-bottom: 0;\n\n        #{$block}__key-val {\n            flex-direction: column;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.orders-sidebar-button {\n    $block: &;\n    position: relative;\n    cursor: pointer;\n    line-height: 1.8rem;\n    transition:\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out;\n    padding: 1.6rem 1.2rem;\n    box-sizing: border-box;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n    #{$block}__status {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 1.2rem;\n        font-weight: 600;\n        letter-spacing: 0.2rem;\n        line-height: 2rem;\n        border-radius: 2rem;\n        text-align: center;\n        margin-bottom: 1rem;\n        padding: 0.5rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            200,\n            $alphaDark: 0.5\n        );\n    }\n\n    #{$block}__key-val-row {\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        margin-top: 1.6rem;\n        margin-bottom: 0.4rem;\n        box-sizing: border-box;\n        padding: 0 0.6rem;\n    }\n\n    #{$block}__key-val {\n        display: flex;\n        flex-direction: column;\n        justify-content: start;\n        text-align: start;\n\n        #{$block}__key {\n            font-size: 1.2rem;\n            font-weight: 600;\n            line-height: 1.4rem;\n            letter-spacing: 0.1rem;\n            @include Utils.theme-paletteColour(\n                color,\n                800,\n                100,\n                $alphaLight: 0.6\n            );\n        }\n\n        #{$block}__value {\n            font-size: 1.3rem;\n            font-weight: 400;\n            letter-spacing: 0.08rem;\n            line-height: 1.8rem;\n        }\n\n        &:last-child {\n            text-align: end;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './orderItem/order-item';\n@use './_sidebar-button';\n\n$block: '.orders';\n\n#{$block} {\n    position: relative;\n    z-index: 100;\n    margin: 0 auto;\n    display: grid;\n    grid-template: 'orders order' 1fr / 36rem 1fr;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: auto hidden;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n}\n","@use '../../utils' as Utils;\n\n.vendor-wrapper {\n    $block: &;\n\n    #{$block}__error {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        align-self: center;\n        justify-self: center;\n        border-radius: 2rem;\n        padding: 2.5rem 3.5rem;\n        box-sizing: border-box;\n        text-align: center;\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            200,\n            $alphaLight: 0.5,\n            $alphaDark: 0.2\n        );\n        @include Utils.theme-paletteColour(color, 900, 100, $alphaLight: 0.5);\n        @include Utils.shadow-get(2, 0);\n\n        #{$block}__error-title {\n            text-align: center;\n            line-height: 2.4rem;\n            font-weight: 6500;\n            font-size: 1.8rem;\n            letter-spacing: 0.1rem;\n        }\n\n        #{$block}__error-subtitle {\n            text-align: center;\n            line-height: 2.4rem;\n            font-weight: 400;\n            font-size: 1.3rem;\n            letter-spacing: 0.05rem;\n            margin-top: 1rem;\n        }\n\n        .demmi-ui-button {\n            margin-top: 2rem;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './error';\n\n.vendor-wrapper {\n    $block: &;\n\n    #{$block}__content {\n        border-radius: 2rem;\n        margin: 1rem auto;\n        overflow: auto hidden;\n        max-width: 180rem;\n        width: 100%;\n        box-sizing: border-box;\n        transition: opacity 0.3s ease-in-out;\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.3),\n            200,\n            $alphaDark: 0.2\n        );\n\n        &#{$block}--home {\n            @include Utils.theme-customProp(border, none, none);\n            @include Utils.theme-paletteColour(\n                background-color,\n                transparent,\n                transparent\n            );\n            @include Utils.shadow-get(0, 0);\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n.vendor-wrapper__mobile-menu {\n    display: none;\n    position: absolute;\n    inset: 0;\n\n    &.vendor-wrapper__mobile-menu--active {\n        .mobile-menu__content {\n            opacity: 1;\n        }\n    }\n\n    @include Utils.theme-paletteColour(\n        background-color,\n        50,\n        hsla(var(--theme-bg-hue), 15%, 23%, 1)\n    );\n\n    @media (max-width: Utils.$tabletUIWidth) {\n        display: block;\n    }\n\n    .mobile-menu__content {\n        height: 100%;\n        position: absolute;\n        left: 0;\n        top: 0;\n        right: 0;\n        width: 30rem;\n        box-sizing: border-box;\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        align-items: center;\n        justify-content: center;\n        opacity: 0;\n        transition: opacity 0.3s ease-in-out;\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './error';\n@use './content';\n@use './mobile-menu';\n\n$mobileUITransitionTime: 0.24s;\n\n.vendor-wrapper {\n    $block: &;\n    position: relative;\n    z-index: 100;\n    display: grid;\n    grid-template:\n        'header' 4rem\n        'content' 1fr\n        'toolbar' 5rem / 1fr;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: auto;\n    padding: 1rem;\n    transform-origin: left;\n    @include Utils.theme-paletteColour(\n        background-color,\n        var(--palette-100),\n        rgba(0, 0, 0, 1)\n    );\n\n    #{$block}__background {\n        position: absolute;\n        inset: 0;\n        z-index: -100;\n        @include Utils.bg-radialBackground();\n    }\n\n    #{$block}__foreground {\n        position: absolute;\n        inset: 0;\n        opacity: 0;\n        z-index: 100;\n        pointer-events: none;\n        transition: opacity $mobileUITransitionTime ease-in-out;\n        @include Utils.bg-radialBackground($gradientIntensity: 0.5);\n\n        #{$block}__foreground-icon {\n            $size: 2.4rem;\n            position: absolute;\n            left: 2rem;\n            top: 0;\n            bottom: 0;\n            width: $size;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            pointer-events: none;\n\n            svg {\n                height: $size;\n                width: $size;\n                @include Utils.theme-paletteColour(color, 600, 100);\n            }\n        }\n    }\n\n    #{$block}__header {\n        grid-area: header;\n        z-index: 1;\n        position: relative;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        box-sizing: border-box;\n\n        #{$block}__action-buttons {\n            display: flex;\n            gap: 0.8rem;\n            z-index: 1;\n\n            #{$block}__action-button-menu {\n                display: none;\n            }\n        }\n    }\n\n    #{$block}__content {\n        grid-area: content;\n        z-index: 1;\n    }\n\n    #{$block}__toolbar {\n        grid-area: toolbar;\n        z-index: 1;\n    }\n\n    @media (max-width: Utils.$tabletUIWidth) {\n        display: grid;\n        grid-template:\n            'header' 6rem\n            'content' 1fr/ 1fr;\n        padding: 0;\n        transition:\n            transform $mobileUITransitionTime ease-in-out,\n            border-radius $mobileUITransitionTime ease-in-out,\n            box-shadow $mobileUITransitionTime ease-in-out;\n\n        &#{$block}--mobile-menu-active {\n            transform: translate3d(30rem, 0px, 0px) scale3d(0.95, 0.95, 0.95);\n            border-radius: 2rem;\n\n            #{$block}__content {\n                pointer-events: none;\n                opacity: 0.8;\n            }\n\n            #{$block}__foreground {\n                cursor: pointer;\n                pointer-events: unset;\n                z-index: 1;\n                opacity: 1;\n            }\n        }\n\n        #{$block}__header {\n            display: flex;\n            justify-content: flex-start;\n            padding: 0.8rem;\n\n            #{$block}__theme-switcher {\n                display: none;\n            }\n\n            #{$block}__action-buttons {\n                width: 100%;\n\n                #{$block}__action-button-menu {\n                    display: block;\n                    margin-right: auto;\n                }\n            }\n        }\n\n        #{$block}__content {\n            margin: 0;\n        }\n\n        #{$block}__toolbar {\n            display: none;\n        }\n    }\n}\n\n.vendor-title {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    margin: 0 auto;\n    font-size: 1.6rem;\n    letter-spacing: 0.1rem;\n    font-weight: 600;\n    line-height: 4rem;\n    text-align: center;\n    color: white;\n    @include Utils.theme-paletteColour(color, 800, 50, 0.7, 1);\n}\n","@use '../../utils' as Utils;\n\n$_hsl: (\n    50: 'var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l)',\n    100:\n        'var(--phone-preview-palette-100-s), var(--phone-preview-palette-100-l)',\n    200:\n        'var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l)',\n    300:\n        'var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l)',\n    400:\n        'var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l)',\n    500:\n        'var(--phone-preview-palette-500-s), var(--phone-preview-palette-500-l)',\n    600:\n        'var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l)',\n    700:\n        'var(--phone-preview-palette-700-s), var(--phone-preview-palette-700-l)',\n    800:\n        'var(--phone-preview-palette-800-s), var(--phone-preview-palette-800-l)',\n    900:\n        'var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l)',\n);\n\n:root {\n    --phone-preview-hue: 200;\n}\n\n$transitionTiming: 0s;\n\n$block: '.display-shop';\n\nbody.theme-dark {\n    #{$block}__app {\n        background: radial-gradient(\n                ellipse at top left,\n                hsl(var(--phone-preview-hue), #{map-get($_hsl, 400)}, 0.3),\n                transparent\n            ),\n            radial-gradient(\n                ellipse at bottom right,\n                hsl(var(--phone-preview-hue), #{map-get($_hsl, 400)}, 0.2),\n                transparent\n            ),\n            hsla(var(--phone-preview-hue), #{map-get($_hsl, 200)}, 0.2);\n\n        #{$block}__header {\n            background-color: hsla(\n                var(--phone-preview-hue),\n                #{map-get($_hsl, 200)},\n                0.6\n            );\n\n            #{$block}__title {\n                color: white;\n                span {\n                    color: rgba(255, 255, 255, 0.8);\n                }\n            }\n\n            #{$block}__buttons-row {\n                #{$block}__buttons-row-button {\n                    span {\n                        color: rgba(255, 255, 255, 0.8);\n                    }\n                }\n            }\n\n            #{$block}__location {\n                color: rgba(255, 255, 255, 0.9);\n                background-color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 900)},\n                    0.2\n                );\n                border-color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 900)},\n                    0.2\n                );\n\n                #{$block}__location-top {\n                    span {\n                        color: rgba(255, 255, 255, 0.6);\n                    }\n                }\n            }\n\n            #{$block}__search {\n                color: white;\n                span {\n                    color: rgba(255, 255, 255, 0.6);\n                }\n            }\n        }\n\n        #{$block}__section-title {\n            color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 100)});\n        }\n\n        #{$block}__categories {\n            #{$block}__category {\n                color: rgba(255, 255, 255, 0.8);\n                background-color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 200)},\n                    0.3\n                );\n                span {\n                    color: rgba(255, 255, 255, 0.6);\n                }\n            }\n        }\n\n        #{$block}__product-list {\n            #{$block}__product {\n                box-shadow: none;\n                background-color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 200)},\n                    0.4\n                );\n                #{$block}__product-image {\n                    background-color: hsla(\n                        var(--phone-preview-hue),\n                        #{map-get($_hsl, 80)},\n                        0.2\n                    );\n                }\n                #{$block}__product-name {\n                    color: rgba(255, 255, 255, 1);\n                }\n                #{$block}__product-price {\n                    color: rgba(255, 255, 255, 1);\n                }\n                #{$block}__product-variant {\n                    color: rgba(255, 255, 255, 0.8);\n                }\n            }\n        }\n\n        #{$block}__reviews-list {\n            #{$block}__review {\n                box-shadow: none;\n                background-color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 200)},\n                    0.4\n                );\n                #{$block}__review-title {\n                    color: rgba(255, 255, 255, 1);\n                }\n                #{$block}__review-date {\n                    color: rgba(255, 255, 255, 0.8);\n                }\n\n                #{$block}__review-rating {\n                    #{$block}__review-rating-icon {\n                        color: #a5d6a7;\n                    }\n                }\n                #{$block}__review-description {\n                    color: rgba(255, 255, 255, 1);\n                }\n            }\n        }\n    }\n}\n\n#{$block}__app {\n    display: block;\n    box-sizing: border-box;\n    background: radial-gradient(\n            ellipse at center,\n            hsl(var(--phone-preview-hue), #{map-get($_hsl, 50)}),\n            transparent\n        ),\n        radial-gradient(\n            hsl(var(--phone-preview-hue), #{map-get($_hsl, 50)}),\n            hsl(var(--phone-preview-hue), #{map-get($_hsl, 100)})\n        );\n    width: 100%;\n    height: 100%;\n    border-radius: 1.5rem;\n    padding: 0 0 1rem 0;\n    overflow: hidden;\n    transition: background-color $transitionTiming ease-in-out;\n\n    #{$block}__header {\n        position: relative;\n        padding: 0.2rem;\n        box-shadow: 0 0rem 3rem\n            hsla(var(--phone-preview-hue), #{map-get($_hsl, 900)}, 0.2);\n        transition: box-shadow $transitionTiming ease-in-out;\n        background-color: rgba(255, 255, 255, 0.9);\n\n        #{$block}__title {\n            display: flex;\n            padding: 0 2rem;\n            justify-content: space-between;\n            position: relative;\n            color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 600)});\n            font-weight: 400;\n            font-size: 1.5rem;\n            text-align: center;\n            line-height: 5rem;\n            transition:\n                color $transitionTiming ease-in-out,\n                background-color $transitionTiming ease-in-out;\n\n            span {\n                color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 300)});\n                $size: 1.4rem;\n                height: $size;\n                width: $size;\n                font-size: $size;\n            }\n        }\n\n        #{$block}__buttons-row {\n            position: relative;\n            display: flex;\n            justify-content: space-evenly;\n            // padding-bottom: 0.8rem;\n            // border-bottom: 0.1rem solid\n            //     hsla(var(--phone-preview-hue), #{map-get($_hsl, 900)}, 0.1);\n\n            #{$block}__buttons-row-button {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n                width: 6rem;\n                height: 4.5rem;\n                font-size: 1.2rem;\n                font-weight: 500;\n                line-height: 1.4rem;\n                color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 600)},\n                    0.7\n                );\n\n                span {\n                    color: hsl(\n                        var(--phone-preview-hue),\n                        #{map-get($_hsl, 300)}\n                    );\n\n                    $size: 1.6rem;\n                    height: $size;\n                    width: $size;\n                    font-size: $size;\n                    margin-bottom: 0.8rem;\n                }\n            }\n        }\n\n        #{$block}__location {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            height: 5rem;\n            box-sizing: border-box;\n            padding: 0.6rem 1.2rem;\n            color: hsla(var(--phone-preview-hue), #{map-get($_hsl, 600)}, 0.7);\n            background-color: hsla(\n                var(--phone-preview-hue),\n                #{map-get($_hsl, 50)},\n                0.4\n            );\n            border-top: 0.1rem solid;\n            border-bottom: 0.1rem solid;\n            border-color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 100)});\n\n            #{$block}__location-top {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 1.1rem;\n                font-weight: 600;\n                letter-spacing: 0.1rem;\n\n                span {\n                    color: hsl(\n                        var(--phone-preview-hue),\n                        #{map-get($_hsl, 300)}\n                    );\n                    $size: 1.4rem;\n                    height: $size;\n                    width: $size;\n                    font-size: $size;\n                    line-height: $size;\n                    margin-right: 0.4rem;\n                }\n            }\n\n            #{$block}__location-address {\n                font-size: 1.2rem;\n                font-weight: 500;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                overflow: hidden;\n                width: 100%;\n                text-align: center;\n            }\n        }\n\n        #{$block}__search {\n            position: relative;\n            color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 300)});\n            font-weight: 500;\n            font-size: 1.3rem;\n            line-height: 5rem;\n            padding: 0 2rem;\n            transition: color $transitionTiming ease-in-out;\n\n            span {\n                margin-right: 2rem;\n                color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 500)},\n                    0.6\n                );\n                $size: 1.4rem;\n                height: $size;\n                width: $size;\n                font-size: $size;\n            }\n        }\n    }\n\n    #{$block}__section-title {\n        color: hsla(var(--phone-preview-hue), #{map-get($_hsl, 700)}, 0.8);\n        font-weight: 600;\n        font-size: 1.6rem;\n        margin-left: 1.6rem;\n        margin-top: 2.2rem;\n        margin-bottom: 1.2rem;\n        transition: color $transitionTiming ease-in-out;\n    }\n\n    #{$block}__categories {\n        margin-top: 1.2rem;\n        display: block;\n        white-space: nowrap;\n        margin-left: 1rem;\n\n        #{$block}__category {\n            margin: 0 0.8rem 0 0;\n            display: inline-flex;\n            flex-direction: column;\n            justify-content: center;\n            align-items: center;\n            border-radius: 1.5rem;\n            background-color: rgba(255, 255, 255, 0.5);\n            width: 15rem;\n            height: 9rem;\n            font-size: 1rem;\n            font-weight: 700;\n            line-height: 1.4rem;\n            text-transform: uppercase;\n            color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 300)});\n\n            span {\n                color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 300)});\n                $size: 2.8rem;\n                height: $size;\n                width: $size;\n                font-size: $size;\n                margin-bottom: 1.2rem;\n                margin-top: 0.6rem;\n            }\n        }\n    }\n\n    #{$block}__product-list {\n        white-space: nowrap;\n        margin: 1rem 0;\n        padding: 0 1rem;\n\n        #{$block}__product {\n            height: 20rem;\n            display: inline-block;\n            background-color: rgba(255, 255, 255, 0.8);\n            border-radius: 1.2rem;\n            width: 16rem;\n            margin-right: 1.6rem;\n            padding: 0.5rem;\n            box-sizing: border-box;\n            box-shadow: 0 0.5rem 1rem\n                hsla(var(--phone-preview-hue), #{map-get($_hsl, 400)}, 0.16);\n            transition: box-shadow $transitionTiming ease-in-out;\n\n            #{$block}__product-image {\n                background-color: hsl(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 50)}\n                );\n                width: 100%;\n                height: 12rem;\n                border-radius: 0.8rem;\n                margin-bottom: 0.6rem;\n                transition: background-color $transitionTiming ease-in-out;\n                overflow: hidden;\n\n                img {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                }\n            }\n            #{$block}__product-name {\n                color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 800)},\n                    0.6\n                );\n                font-weight: 700;\n                font-size: 1.3rem;\n                margin-left: 0.5rem;\n                line-height: 2rem;\n                margin-bottom: 0.6rem;\n            }\n            #{$block}__product-price {\n                display: flex;\n                align-items: flex-end;\n                color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 900)},\n                    0.6\n                );\n                font-weight: 600;\n                font-size: 1.8rem;\n                line-height: 2rem;\n                margin-left: 0.2rem;\n                margin-bottom: 0.2rem;\n                transition: color $transitionTiming ease-in-out;\n                span {\n                    font-size: 1.2rem;\n                    line-height: 1.6rem;\n                    margin: 0 0.3rem;\n                }\n            }\n            #{$block}__product-variant {\n                color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 900)},\n                    0.5\n                );\n                font-weight: 700;\n                font-size: 1rem;\n                margin-left: 0.5rem;\n                line-height: 1.4rem;\n                margin-bottom: 0.4rem;\n                transition: color $transitionTiming ease-in-out;\n            }\n        }\n    }\n\n    #{$block}__reviews-list {\n        white-space: nowrap;\n        margin: 1rem;\n        margin-bottom: 1.6rem;\n\n        #{$block}__review {\n            position: relative;\n            display: inline-block;\n            background-color: rgba(255, 255, 255, 0.8);\n            border-radius: 1.6rem;\n            width: 100%;\n            margin-right: 1rem;\n            padding: 1.6rem;\n            box-sizing: border-box;\n            box-shadow: 0 0.5rem 1rem\n                hsla(var(--phone-preview-hue), #{map-get($_hsl, 400)}, 0.16);\n            transition: box-shadow $transitionTiming ease-in-out;\n\n            #{$block}__review-title {\n                color: rgba(0, 0, 0, 0.6);\n                font-weight: 700;\n                font-size: 1.3rem;\n                line-height: 1.6rem;\n                margin-bottom: 0.4rem;\n            }\n            #{$block}__review-date {\n                color: rgba(0, 0, 0, 0.4);\n                font-weight: 600;\n                font-size: 1.1rem;\n                line-height: 1.2rem;\n                margin-bottom: 0.4rem;\n            }\n\n            #{$block}__review-rating {\n                position: absolute;\n                top: 1.4rem;\n                right: 1.4rem;\n                gap: 0.8rem;\n                // margin-bottom: 1.2rem;\n                // margin-left: 0.2rem;\n\n                #{$block}__review-rating-icon {\n                    color: #4caf50;\n                    $size: 2.4rem;\n                    height: $size;\n                    width: $size;\n                    font-size: $size;\n                }\n            }\n\n            #{$block}__review-description {\n                margin-top: 1rem;\n                color: rgba(0, 0, 0, 0.7);\n                font-weight: 400;\n                font-size: 1.2rem;\n                line-height: 1.8rem;\n                white-space: normal;\n                text-align: start;\n                letter-spacing: 0.05rem;\n            }\n        }\n    }\n\n    #{$block}__button {\n        background-color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 300)});\n        color: rgba(255, 255, 255, 1);\n        font-weight: 700;\n        font-size: 1.2rem;\n        line-height: 3.2rem;\n        text-align: center;\n        margin: 0 1rem;\n        border-radius: 1.2rem;\n        text-transform: uppercase;\n        transition: background-color $transitionTiming ease-in-out;\n    }\n}\n","@use '../../utils' as Utils;\n\n$_hsl: (\n    50: 'var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l)',\n    100:\n        'var(--phone-preview-palette-100-s), var(--phone-preview-palette-100-l)',\n    200:\n        'var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l)',\n    300:\n        'var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l)',\n    400:\n        'var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l)',\n    500:\n        'var(--phone-preview-palette-500-s), var(--phone-preview-palette-500-l)',\n    600:\n        'var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l)',\n    700:\n        'var(--phone-preview-palette-700-s), var(--phone-preview-palette-700-l)',\n    800:\n        'var(--phone-preview-palette-800-s), var(--phone-preview-palette-800-l)',\n    900:\n        'var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l)',\n);\n\n:root {\n    --phone-preview-hue: 200;\n}\n\n$transitionTiming: 0s;\n\n$block: '.display-product';\n\nbody.theme-dark {\n    #{$block}__app {\n        background: radial-gradient(\n                ellipse at top left,\n                hsl(var(--phone-preview-hue), #{map-get($_hsl, 400)}, 0.3),\n                transparent\n            ),\n            radial-gradient(\n                ellipse at bottom right,\n                hsl(var(--phone-preview-hue), #{map-get($_hsl, 400)}, 0.2),\n                transparent\n            ),\n            hsla(var(--phone-preview-hue), #{map-get($_hsl, 200)}, 0.1);\n\n        #{$block}__header {\n            #{$block}__title {\n                color: hsla(var(--phone-preview-hue), #{map-get($_hsl, 50)});\n\n                span {\n                    color: hsla(\n                        var(--phone-preview-hue),\n                        #{map-get($_hsl, 200)},\n                        1\n                    );\n                }\n            }\n        }\n\n        #{$block}__content {\n            overflow: auto;\n            height: 100%;\n            background: hsla(\n                var(--phone-preview-hue),\n                #{map-get($_hsl, 200)},\n                0.2\n            );\n        }\n\n        #{$block}__gallery {\n            #{$block}__gallery-images {\n                #{$block}__gallery-image {\n                    // background-color: hsl(\n                    //     var(--phone-preview-hue),\n                    //     #{map-get($_hsl, 50)}\n                    // );\n                    box-shadow: 0 0.8rem 1rem rgba(0, 0, 0, 0);\n                }\n            }\n            #{$block}__gallery-toolbar {\n                // background-color: rgba(0, 0, 0, 0.32);\n                #{$block}__gallery-toolbar-indicator {\n                    // background-color: white;\n                }\n            }\n        }\n\n        #{$block}__category {\n            color: rgba(255, 255, 255, 0.8);\n            #{$block}__icon {\n                color: rgba(255, 255, 255, 0.5);\n            }\n        }\n\n        #{$block}__card {\n            background: hsla(\n                var(--phone-preview-hue),\n                #{map-get($_hsl, 200)},\n                0.4\n            );\n            #{$block}__card-title {\n                color: white;\n            }\n            #{$block}__card-description {\n                color: white;\n            }\n        }\n\n        #{$block}__card-location {\n            color: rgba(255, 255, 255, 0.8);\n            span {\n                color: rgba(255, 255, 255, 0.6);\n            }\n        }\n\n        #{$block}__button-wrapper {\n            pointer-events: none;\n            background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));\n\n            #{$block}__button {\n                background-color: rgba(255, 255, 255, 0.16);\n                border-color: rgba(255, 255, 255, 0.4);\n                #{$block}__button-left {\n                    color: white;\n                }\n                #{$block}__button-right {\n                    color: hsl(\n                        var(--phone-preview-hue),\n                        #{map-get($_hsl, 600)}\n                    );\n                    background-color: hsl(\n                        var(--phone-preview-hue),\n                        #{map-get($_hsl, 50)}\n                    );\n                }\n            }\n        }\n    }\n}\n\n#{$block}__app {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    background: radial-gradient(\n        ellipse at top,\n        hsl(var(--phone-preview-hue), #{map-get($_hsl, 100)}),\n        hsl(var(--phone-preview-hue), #{map-get($_hsl, 200)})\n    );\n    width: 100%;\n    height: 100%;\n    border-radius: 1.5rem;\n    padding: 0 0 1rem;\n    overflow: hidden;\n    transition: background-color $transitionTiming ease-in-out;\n\n    #{$block}__header {\n        height: 5rem;\n\n        #{$block}__title {\n            display: flex;\n            padding: 0 2rem;\n            justify-content: space-between;\n            position: relative;\n            color: hsla(var(--phone-preview-hue), #{map-get($_hsl, 900)}, 0.8);\n            font-weight: 500;\n            font-size: 1.4rem;\n            text-align: center;\n            line-height: 5rem;\n            transition: color $transitionTiming ease-in-out;\n\n            span {\n                color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 600)});\n                $size: 1.6rem;\n                height: $size;\n                width: $size;\n                font-size: $size;\n            }\n        }\n    }\n\n    #{$block}__content {\n        background: linear-gradient(\n            rgba(255, 255, 255, 0.4),\n            rgba(255, 255, 255, 0.2)\n        );\n        border-radius: 1.2rem;\n        padding-top: 1.6rem;\n    }\n\n    #{$block}__gallery {\n        #{$block}__gallery-images {\n            #{$block}__gallery-image {\n                margin: 0 auto;\n                width: 30rem;\n                height: 22.8rem;\n                border-radius: 1.2rem;\n                background-color: hsl(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 50)}\n                );\n                box-shadow: 0 0.8rem 1rem rgba(0, 0, 0, 0.1);\n                overflow: hidden;\n\n                img {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                }\n            }\n        }\n        #{$block}__gallery-toolbar {\n            margin: 0 auto;\n            margin-top: 1.5rem;\n            margin-bottom: 1.5rem;\n            height: 0.8rem;\n            width: 20rem;\n            box-sizing: border-box;\n            padding: 0.2rem;\n            border-radius: 0.4rem;\n            background-color: rgba(0, 0, 0, 0.32);\n\n            #{$block}__gallery-toolbar-indicator {\n                background-color: white;\n                height: 0.4rem;\n                width: 0%;\n                border-radius: 0.2rem;\n            }\n        }\n    }\n\n    #{$block}__category {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 1rem;\n        margin-bottom: 1.5rem;\n        font-size: 1.2rem;\n        font-weight: 700;\n        color: rgba(0, 0, 0, 0.3);\n        text-transform: uppercase;\n        letter-spacing: 0.1rem;\n\n        #{$block}__icon {\n            color: rgba(0, 0, 0, 0.4);\n            $size: 1.6rem;\n            height: $size;\n            width: $size;\n            font-size: $size;\n        }\n    }\n\n    #{$block}__card {\n        background-color: rgba(255, 255, 255, 0.6);\n        border-radius: 0.8rem;\n        margin: 1rem 0.8rem;\n        padding: 1.6rem;\n        box-sizing: border-box;\n\n        #{$block}__card-title {\n            font-size: 1.6rem;\n            font-weight: 700;\n            color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 300)});\n            letter-spacing: 0.05rem;\n            line-height: 1.8rem;\n            margin-bottom: 1rem;\n        }\n        #{$block}__card-description {\n            font-size: 1.2rem;\n            font-weight: 400;\n            color: rgba(0, 0, 0, 0.8);\n\n            span {\n                display: block;\n                margin-bottom: 2rem;\n            }\n        }\n    }\n\n    #{$block}__card-location {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 5.2rem;\n        font-size: 1.2rem;\n        line-height: 1.6rem;\n        font-weight: 600;\n        color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 400)});\n        gap: 2rem;\n\n        span {\n            color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 300)});\n            $size: 1.8rem;\n            height: $size;\n            width: $size;\n            font-size: $size;\n        }\n    }\n\n    #{$block}__button-wrapper {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 14rem;\n        background: linear-gradient(\n            hsla(var(--phone-preview-hue), #{map-get($_hsl, 50)}, 0),\n            hsla(var(--phone-preview-hue), #{map-get($_hsl, 50)}, 1)\n        );\n        display: flex;\n        align-items: flex-end;\n\n        #{$block}__button {\n            display: flex;\n            width: 100%;\n            box-sizing: border-box;\n            border: 0.1rem solid;\n            border-color: hsl(var(--phone-preview-hue), #{map-get($_hsl, 200)});\n            font-weight: 700;\n            font-size: 1.2rem;\n            line-height: 5.2rem;\n            text-align: center;\n            margin: 1.6rem;\n            border-radius: 1.2rem;\n            backdrop-filter: blur(4px);\n            transition: background-color $transitionTiming ease-in-out;\n            background-color: hsla(\n                var(--phone-preview-hue),\n                #{map-get($_hsl, 50)},\n                0.6\n            );\n\n            #{$block}__button-left {\n                flex: 1 1 45%;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                color: hsla(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 600)},\n                    0.6\n                );\n                font-weight: 700;\n                font-size: 2rem;\n                line-height: 2rem;\n                letter-spacing: 0.05rem;\n\n                span {\n                    font-size: 1.2rem;\n                    line-height: 1.6rem;\n                    margin: 0 0.4rem;\n                    margin-top: 0.6rem;\n                }\n            }\n\n            #{$block}__button-right {\n                margin: -0.1rem;\n                flex: 1 1 55%;\n                color: white;\n                border-radius: 1.2rem;\n                text-transform: uppercase;\n                background-color: hsl(\n                    var(--phone-preview-hue),\n                    #{map-get($_hsl, 300)}\n                );\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './display-shop.scss';\n@use './display-product.scss';\n\n:root {\n    --phone-preview-palette-50-s: 35%;\n    --phone-preview-palette-50-l: 93%;\n    --phone-preview-palette-100-s: 40%;\n    --phone-preview-palette-100-l: 84%;\n    --phone-preview-palette-200-s: 45%;\n    --phone-preview-palette-200-l: 73%;\n    --phone-preview-palette-300-s: 50%;\n    --phone-preview-palette-300-l: 63%;\n    --phone-preview-palette-400-s: 55%;\n    --phone-preview-palette-400-l: 55%;\n    --phone-preview-palette-500-s: 60%;\n    --phone-preview-palette-500-l: 47%;\n    --phone-preview-palette-600-s: 65%;\n    --phone-preview-palette-600-l: 42%;\n    --phone-preview-palette-700-s: 70%;\n    --phone-preview-palette-700-l: 36%;\n    --phone-preview-palette-800-s: 75%;\n    --phone-preview-palette-800-l: 30%;\n    --phone-preview-palette-900-s: 80%;\n    --phone-preview-palette-900-l: 23%;\n}\n\n$_hsl: (\n    50: 'var(--phone-preview-palette-50-s), var(--phone-preview-palette-50-l)',\n    100:\n        'var(--phone-preview-palette-100-s), var(--phone-preview-palette-100-l)',\n    200:\n        'var(--phone-preview-palette-200-s), var(--phone-preview-palette-200-l)',\n    300:\n        'var(--phone-preview-palette-300-s), var(--phone-preview-palette-300-l)',\n    400:\n        'var(--phone-preview-palette-400-s), var(--phone-preview-palette-400-l)',\n    500:\n        'var(--phone-preview-palette-500-s), var(--phone-preview-palette-500-l)',\n    600:\n        'var(--phone-preview-palette-600-s), var(--phone-preview-palette-600-l)',\n    700:\n        'var(--phone-preview-palette-700-s), var(--phone-preview-palette-700-l)',\n    800:\n        'var(--phone-preview-palette-800-s), var(--phone-preview-palette-800-l)',\n    900:\n        'var(--phone-preview-palette-900-s), var(--phone-preview-palette-900-l)',\n);\n\n:root {\n    --phone-preview-hue: 200;\n}\n\n.app-switcher {\n    $block: &;\n    grid-area: appswitcher;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.6);\n    border-radius: 1.2rem;\n    display: flex;\n    padding: 0.4rem;\n    box-sizing: border-box;\n    gap: 0.5rem;\n    @include Utils.theme-paletteColour(\n        background-color,\n        800,\n        200,\n        $alphaLight: 0.5,\n        $alphaDark: 0.4\n    );\n\n    .app-switcher__button {\n        flex: 1 1 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 1.3rem;\n        font-weight: 500;\n        line-height: 1.8rem;\n        gap: 1rem;\n        border-radius: 1.2rem;\n        padding: 1rem;\n        cursor: pointer;\n        transition: background-color 0.1s ease-in-out;\n        @include Utils.theme-paletteColour(color, white, white);\n\n        .app-switcher__icon {\n            span {\n                color: white;\n                $size: 1.8rem;\n                height: $size;\n                width: $size;\n                font-size: $size;\n            }\n        }\n\n        &:not(.app-switcher__button--active):hover {\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0.2),\n                rgba(0, 0, 0, 0.2)\n            );\n        }\n\n        &.app-switcher__button--active {\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0.9),\n                black\n            );\n            @include Utils.theme-paletteColour(color, 500, white);\n            span {\n                @include Utils.theme-paletteColour(color, 300, white);\n            }\n        }\n    }\n}\n\n$transitionTiming: 0.4s;\n.fake-phone {\n    $block: &;\n    font-family: 'Montserrat';\n    user-select: none;\n    display: block;\n    width: 100%;\n    max-width: 40rem;\n    height: 100%;\n    max-height: 82rem;\n    margin: 0 auto;\n    border-radius: 2.5rem;\n    box-sizing: border-box;\n    padding: 1.2rem 0.6rem;\n    border: 0.2rem solid hsla(var(--phone-preview-hue), 30%, 75%, 1);\n    letter-spacing: 0.05rem;\n    // pointer-events: none;\n    box-shadow:\n        0 0.1rem 0.4rem hsla(var(--theme-bg-hue), 100%, 20%, 0.28),\n        0 0.8rem 2rem hsla(var(--theme-bg-hue), 100%, 20%, 0.12);\n    @include Utils.theme-paletteColour(\n        background-color,\n        rgba(70, 71, 73, 1),\n        rgba(40, 41, 43, 1)\n    );\n\n    #{$block}__display {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        height: 100%;\n        background-color: rgba(0, 0, 0, 0.6);\n        border-radius: 1.5rem;\n        overflow: hidden;\n\n        #{$block}__status-bar {\n            display: flex;\n            justify-content: space-between;\n            line-height: 3rem;\n            color: white;\n            font-size: 1.2rem;\n            font-weight: 500;\n            letter-spacing: 0.05rem;\n            padding: 0 1.5rem;\n\n            #{$block}__status-bar-left {\n                #{$block}__icon {\n                    $size: 1.2rem;\n                    height: $size;\n                    width: $size;\n                    font-size: $size;\n                    margin: 0 0 0 0.8rem;\n                }\n            }\n            #{$block}__status-bar-right {\n                #{$block}__icon {\n                    $size: 1.1rem;\n                    height: $size;\n                    width: $size;\n                    font-size: $size;\n                    margin: 0 0 0 0.2rem;\n\n                    .fa-battery-half {\n                        transform: rotate3d(0, 0, 1, -90deg) scale3d(0.9, 1, 1)\n                            translate3d(0.05rem, 0, 0);\n                    }\n                }\n            }\n        }\n    }\n\n    #{$block}__app {\n        flex: 1 1 auto;\n        overflow: hidden;\n    }\n\n    &#{$block}--animate {\n        animation: fake-phone-change 0.4s linear;\n    }\n}\n\n@keyframes fake-phone-change {\n    0% {\n        transform: scale3d(1, 1, 1);\n    }\n    20% {\n        transform: scale3d(0.95, 0.95, 0.95);\n    }\n    50% {\n        transform: scale3d(0.95, 0.95, 0.95);\n    }\n    80% {\n        transform: scale3d(1.05, 1.05, 1.05);\n    }\n    100% {\n        transform: scale3d(1, 1, 1);\n    }\n}\n","@use 'sass:math';\n@use '../../utils' as Utils;\n\n$block: '.page';\n\n/**\n    If Page with Sidebar is a child of another Page with Sidebar,\n    the sidebar will be styled differently.\n*/\n#{$block} {\n    #{$block}#{$block}--with-sidebar {\n        #{$block}__sidebar {\n            @include Utils.theme-paletteColour(\n                background-color,\n                100,\n                rgba(0, 0, 0, 0.1),\n                $alphaLight: 0\n            );\n        }\n\n        #{$block}__view {\n            border-top: none;\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0),\n                200,\n                $alphaDark: 0\n            );\n        }\n    }\n}\n\n#{$block}#{$block}--with-sidebar {\n    display: grid;\n    transition: grid var(--sidebar-transition-time) ease-in-out;\n    grid-template: 'sidebar details' 1fr / var(--sidebar-width) 1fr;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n    #{$block}__sidebar {\n        z-index: 1;\n        overflow: hidden;\n    }\n\n    #{$block}__view {\n        z-index: 0;\n        height: 100%;\n        border-left: 0.1rem solid transparent;\n        @include Utils.theme-paletteColour(\n            border-color,\n            100,\n            200,\n            $alphaDark: 0.4\n        );\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.2),\n            200,\n            $alphaDark: 0.2\n        );\n\n        #{$block}__view-header {\n            display: none;\n            justify-content: space-between;\n            align-items: center;\n            padding: 1.6rem 1.6rem 0;\n            margin-bottom: -0.8rem;\n            box-sizing: border-box;\n\n            @media (max-width: 480px) {\n                padding: 0.8rem 0.8rem 0;\n            }\n\n            #{$block}__view-title {\n                width: 100%;\n                text-align: center;\n                font-size: 1.5rem;\n                letter-spacing: 0.08rem;\n                font-weight: 500;\n                padding-right: 4.2rem;\n                box-sizing: border-box;\n                @include Utils.theme-paletteColour(\n                    color,\n                    700,\n                    50,\n                    $alphaLight: 0.8\n                );\n            }\n        }\n        #{$block}__view-content {\n            display: block;\n            height: 100%;\n            width: 100%;\n            position: relative;\n            overflow: auto;\n        }\n    }\n\n    @media (max-width: Utils.$tabletUIWidth) {\n        display: block;\n        overflow: hidden;\n        $widthOffset: var(--sidebar-width-offset, 7rem);\n\n        &#{$block}--visible {\n            #{$block}__sidebar {\n                opacity: 1;\n                transform: translate3d(0, 0, 0);\n                transition:\n                    opacity calc(var(--sidebar-transition-time) * 2) ease-in-out,\n                    transform var(--sidebar-transition-time) ease-in-out;\n            }\n            #{$block}__view {\n                transform: translate3d(\n                    calc(var(--sidebar-width) - $widthOffset),\n                    0,\n                    0\n                );\n            }\n        }\n\n        &#{$block}--no-children {\n            --sidebar-width-offset: 0rem;\n            #{$block}__view {\n                opacity: 0;\n            }\n        }\n\n        #{$block}__sidebar {\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            width: calc(var(--sidebar-width) - var(--sidebar-width-offset));\n            z-index: 0;\n            opacity: 0;\n            transform: translate3d(-var(--sidebar-width), 0, 0);\n            transition:\n                opacity calc(var(--sidebar-transition-time) / 2) ease-in-out,\n                transform var(--sidebar-transition-time) ease-in-out,\n                width var(--sidebar-transition-time) ease-in-out;\n\n            @media (max-width: Utils.$mobileUIWidth) {\n                width: calc(var(--sidebar-width) - $widthOffset);\n            }\n        }\n\n        #{$block}__view {\n            display: flex;\n            flex-direction: column;\n            width: 100%;\n            height: 100%;\n            min-width: unset;\n            z-index: 1;\n            transition: transform var(--sidebar-transition-time) ease-in-out;\n\n            #{$block}__view-header {\n                display: flex;\n                padding: 1.6rem;\n                margin-bottom: 0rem;\n                box-sizing: border-box;\n                border-bottom: 0.1rem solid transparent;\n                @include Utils.theme-paletteColour(\n                    border-color,\n                    100,\n                    200,\n                    $alphaDark: 0.4\n                );\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.page';\n\n#{$block}#{$block}--with-tabs {\n    display: grid;\n    grid-template:\n        'tabs' auto\n        'details' 1fr / 1fr;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n    #{$block}__tabs {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 1.2rem;\n        z-index: 1;\n        overflow: auto hidden;\n        margin: 0 auto;\n        max-width: 100%;\n    }\n\n    #{$block}__view {\n        z-index: 0;\n        padding: 0;\n        height: 100%;\n        border-radius: 0;\n        border-top: 0.1rem solid transparent;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(\n            border-color,\n            100,\n            200,\n            $alphaDark: 0.4\n        );\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.2),\n            200,\n            $alphaDark: 0.2\n        );\n    }\n}\n","@use '../../utils' as Utils;\n\n$height: 6rem;\n\n.page-tab {\n    $block: &;\n    cursor: pointer;\n    position: relative;\n    height: $height;\n    width: fit-content;\n    width: -webkit-fit-content;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    white-space: nowrap;\n    font-size: 1.3rem;\n    line-height: 2rem;\n    padding: 0.4rem 2rem;\n    box-sizing: border-box;\n    border: 0.2rem solid transparent;\n    transition:\n        color 0.1s ease-in-out,\n        background-color 0.1s ease-in-out;\n    @include Utils.theme-paletteColour(color, 900, 100, $alphaLight: 0.8);\n    @include Utils.theme-paletteColour(border-color, transparent);\n\n    &::after {\n        content: '';\n        position: absolute;\n        bottom: -0.4rem;\n        left: 1.6rem;\n        right: 1.6rem;\n        border-radius: 0.2rem;\n        height: 0.4rem;\n        transition: background-color 0.1s ease-in-out;\n        @include Utils.theme-paletteColour(background-color, transparent);\n    }\n\n    &:disabled {\n        cursor: default;\n        opacity: 0.4;\n\n        #{$block}__icon {\n            @include Utils.theme-paletteColour(background-color, 50, 400);\n        }\n    }\n\n    &:not(:disabled):hover {\n        @include Utils.theme-paletteColour(color, 900, 100, $alphaLight: 0.8);\n        &::after {\n            @include Utils.theme-paletteColour(background-color, 200, 600);\n        }\n        #{$block}__icon {\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                100,\n                $alphaLight: 0.8\n            );\n        }\n    }\n\n    &:not(:disabled):active,\n    &:not(:disabled):focus-visible {\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n        &::after {\n            @include Utils.theme-paletteColour(\n                background-color,\n                400,\n                300,\n                $alphaDark: 0.8\n            );\n        }\n        #{$block}__icon {\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                50,\n                $alphaLight: 0.8\n            );\n        }\n    }\n\n    &#{$block}--active {\n        pointer-events: none;\n        @include Utils.theme-paletteColour(color, 700, 50);\n        &::after {\n            @include Utils.theme-paletteColour(\n                background-color,\n                400,\n                300,\n                $alphaDark: 0.8\n            );\n        }\n        #{$block}__icon {\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                50,\n                $alphaLight: 0.8\n            );\n        }\n    }\n\n    #{$block}__icon {\n        margin-right: 1.6rem;\n        line-height: 1.6rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        @include Utils.theme-paletteColour(color, 900, 100, $alphaLight: 0.8);\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.6rem;\n            width: 1.6rem;\n        }\n    }\n\n    &#{$block}--loading {\n        #{$block}__icon {\n            opacity: 0.4;\n        }\n        #{$block}__text {\n            opacity: 0.4;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.page';\n\n#{$block}#{$block}--with-toolbar {\n    display: grid;\n    grid-template:\n        'toolbar' auto\n        'details' 1fr / 1fr;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n    #{$block}__toolbar {\n        z-index: 1;\n        width: 100%;\n    }\n\n    #{$block}__view {\n        z-index: 0;\n        padding: 0;\n        height: 100%;\n        border-radius: 0;\n        border-top: 0.1rem solid transparent;\n        box-sizing: border-box;\n        @include Utils.theme-paletteColour(border-color, 100, 200);\n        @include Utils.theme-paletteColour(\n            background-color,\n            0,\n            200,\n            $alphaDark: 0.4\n        );\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './withSidebar';\n@use './withTabs';\n@use './tab';\n@use './withToolbar';\n\n$block: '.page';\n\n#{$block} {\n    position: relative;\n    z-index: 100;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: hidden;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n    #{$block}__view {\n        position: relative;\n        width: 100%;\n        margin: 0 auto;\n        box-sizing: border-box;\n        overflow: auto;\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.user-menu-dropdown';\n\n#{$block} {\n    position: absolute;\n    z-index: 9999;\n    right: 0;\n    top: 5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 32rem;\n    padding: 0.2rem 0;\n    box-sizing: border-box;\n    border-radius: 1.6rem;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border: 0.1rem solid transparent;\n    overflow: hidden;\n    @include Utils.theme-paletteColour(\n        background-color,\n        50,\n        hsla(var(--theme-bg-hue), 15%, 24%, 0.8)\n    );\n    @include Utils.theme-paletteColour(border-color, 50, 300, $alphaDark: 0.2);\n    @include Utils.shadow-get(6, 0);\n\n    #{$block}__divider {\n        height: 0.1rem;\n        border-radius: 0.1rem;\n        width: calc(100% - 3.2rem);\n        @include Utils.theme-paletteColour(\n            background-color,\n            100,\n            200,\n            $alphaDark: 0.4\n        );\n    }\n\n    #{$block}__section {\n        z-index: 1;\n        width: 100%;\n        padding: 1.2rem 0.6rem;\n        box-sizing: border-box;\n    }\n\n    #{$block}__user {\n        z-index: 1;\n        width: 100%;\n        display: flex;\n        gap: 1.6rem;\n        align-items: center;\n        padding: 2rem;\n        box-sizing: border-box;\n\n        #{$block}__user-image {\n            flex: 0 0 4rem;\n            grid-area: image;\n            width: 4rem;\n            height: 4rem;\n            border-radius: 50%;\n            overflow: hidden;\n            @include Utils.theme-paletteColour(\n                background-color,\n                100,\n                200,\n                $alphaDark: 0.4\n            );\n\n            img {\n                max-height: 100%;\n                max-width: 100%;\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n        #{$block}__user-info-stack {\n            display: flex;\n            flex-direction: column;\n            gap: 0.4rem;\n            overflow: hidden;\n\n            #{$block}__user-name {\n                grid-area: name;\n                font-weight: 500;\n                font-size: 1.6rem;\n                letter-spacing: 0.08rem;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                @include Utils.theme-paletteColour(color, 500, 50);\n            }\n\n            #{$block}__user-email {\n                grid-area: status;\n                font-weight: 400;\n                font-size: 1.3rem;\n                letter-spacing: 0.04rem;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                @include Utils.theme-paletteColour(color, 500, 100);\n            }\n        }\n    }\n\n    #{$block}__version {\n        z-index: 1;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 0.6rem;\n        padding: 0.8rem 2rem 1.6rem;\n        box-sizing: border-box;\n        line-height: 1.4rem;\n        pointer-events: none;\n        user-select: none;\n        text-transform: uppercase;\n\n        #{$block}__version-build,\n        #{$block}__version-date {\n            display: flex;\n            justify-content: space-between;\n        }\n\n        #{$block}__version-key {\n            display: inline-block;\n            font-size: 1rem;\n            font-weight: 600;\n            text-align: start;\n            letter-spacing: 0.1rem;\n            @include Utils.theme-paletteColour(\n                color,\n                700,\n                100,\n                $alphaLight: 0.4,\n                $alphaDark: 0.7\n            );\n        }\n\n        #{$block}__version-val {\n            display: inline-block;\n            font-size: 1.2rem;\n            font-weight: 700;\n            text-align: end;\n            letter-spacing: 0.2rem;\n            @include Utils.theme-paletteColour(\n                color,\n                800,\n                100,\n                $alphaLight: 0.5,\n                $alphaDark: 0.8\n            );\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.user-menu-dropdown-button';\n\n$height: 4.8rem;\n\n#{$block} {\n    $block: &;\n    cursor: pointer;\n    flex: 0 0 100%;\n    width: 100%;\n    height: $height;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    gap: 2rem;\n    font-size: 1.3rem;\n    line-height: 2rem;\n    font-weight: 500;\n    letter-spacing: 0.08rem;\n    box-sizing: border-box;\n    padding: 0 2rem;\n    border-radius: 0.8rem;\n    background-color: transparent;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.6);\n\n    &:disabled {\n        cursor: default;\n        opacity: 0.4;\n\n        #{$block}__icon {\n            @include Utils.theme-paletteColour(background-color, 50, 400);\n        }\n    }\n\n    &:not(:disabled):hover {\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.6),\n            200,\n            $alphaDark: 0.2\n        );\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n\n        #{$block}__icon {\n            @include Utils.theme-paletteColour(\n                color,\n                700,\n                50,\n                $alphaLight: 0.8\n            );\n        }\n    }\n\n    &:not(:disabled):active,\n    &:not(:disabled):focus-visible {\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 1),\n            200,\n            $alphaDark: 0.3\n        );\n        @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n\n        #{$block}__icon {\n            @include Utils.theme-paletteColour(\n                color,\n                700,\n                50,\n                $alphaLight: 0.8\n            );\n        }\n    }\n\n    #{$block}__icon {\n        line-height: 1.6rem;\n        @include Utils.theme-paletteColour(color, 800, 50, $alphaLight: 0.6);\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.6rem;\n            width: 1.6rem;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.user-menu-trigger-button';\n\n#{$block} {\n    $block: &;\n    cursor: pointer;\n    flex: 0 0 auto;\n    width: 4.4rem;\n    height: 4.4rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1.6rem;\n    border-radius: 50%;\n    box-sizing: border-box;\n    padding: 1.2rem;\n    border: 0.1rem solid transparent;\n    backdrop-filter: blur(0.4rem);\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    @include Utils.theme-paletteColour(\n        background-color,\n        rgba(255, 255, 255, 0.5),\n        400,\n        $alphaDark: 0.2\n    );\n    @include Utils.theme-paletteColour(\n        border-color,\n        transparent,\n        200,\n        $alphaDark: 0.4\n    );\n    @include Utils.theme-paletteColour(color, 300, 100);\n\n    &:not(:disabled):hover {\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.8),\n            300,\n            $alphaDark: 0.3\n        );\n        @include Utils.theme-paletteColour(\n            border-color,\n            transparent,\n            200,\n            $alphaDark: 0.4\n        );\n        @include Utils.theme-paletteColour(color, 300, 50);\n    }\n\n    &:not(:disabled):active,\n    &:not(:disabled):focus-visible {\n        @include Utils.theme-paletteColour(\n            background-color,\n            white,\n            300,\n            $alphaDark: 0.3\n        );\n        @include Utils.theme-paletteColour(\n            border-color,\n            transparent,\n            200,\n            $alphaDark: 0.4\n        );\n        @include Utils.theme-paletteColour(color, 300, 50);\n    }\n\n    #{$block}__divider {\n        height: 0.1rem;\n        width: 100%;\n        @include Utils.theme-paletteColour(background-color, 100);\n    }\n\n    #{$block}__user {\n        display: flex;\n        gap: 1.6rem;\n        align-items: center;\n\n        #{$block}__user-image {\n            grid-area: image;\n            width: 6rem;\n            height: 6rem;\n            border-radius: 50%;\n            overflow: hidden;\n            @include Utils.theme-paletteColour(background-color, 200);\n\n            img {\n                max-height: 100%;\n                max-width: 100%;\n                width: 100%;\n                height: 100%;\n                object-fit: cover;\n            }\n        }\n\n        #{$block}__user-info-stack {\n            display: flex;\n            flex-direction: column;\n            gap: 0.4rem;\n\n            #{$block}__user-name {\n                grid-area: name;\n                font-weight: 600;\n                font-size: 1.5rem;\n                letter-spacing: 0.08rem;\n            }\n\n            #{$block}__user-email {\n                grid-area: status;\n                font-weight: 400;\n                font-size: 1.3rem;\n                letter-spacing: 0.04rem;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './dropdown';\n@use './dropdown-button';\n@use './trigger-button';\n\n$block: '.user-menu';\n\n#{$block} {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    z-index: 1;\n\n    @media (max-width: Utils.$tabletUIWidth) {\n        display: none;\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.demmi-ui-card';\n\n#{$block} {\n    &#{$block}--no-padding {\n        #{$block}__title {\n            padding: 1rem 1rem 0;\n        }\n    }\n\n    &#{$block}--collapsed {\n        #{$block}__title {\n            margin-bottom: 0;\n\n            #{$block}__button-collapse {\n                svg {\n                    transform: rotate3d(0, 0, 1, 180deg);\n                }\n            }\n        }\n    }\n\n    #{$block}__title {\n        height: 5.4rem;\n        max-height: 5.4rem;\n        display: flex;\n        justify-content: space-between;\n        line-height: 4.4rem;\n        font-size: 1.6rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        padding: 1rem 2rem 0;\n        box-sizing: border-box;\n        align-items: flex-end;\n        @include Utils.theme-paletteColour(color, 900, 100, $alphaLight: 0.6);\n\n        #{$block}__button-collapse {\n            margin-left: -1rem;\n            margin-right: 1rem;\n            svg {\n                transition: transform 0.2s ease-in-out;\n            }\n        }\n\n        #{$block}__title-text {\n            display: flex;\n            align-items: center;\n\n            #{$block}__title-with-subtitle {\n                line-height: 2rem;\n                display: flex;\n                align-items: start;\n                flex-direction: column;\n\n                #{$block}__subtitle {\n                    display: flex;\n                    justify-content: space-between;\n                    line-height: 1.6rem;\n                    padding-bottom: 0.4rem;\n                    font-size: 1.1rem;\n                    letter-spacing: 0.15rem;\n                    font-weight: 600;\n                    text-transform: uppercase;\n                }\n            }\n\n            #{$block}__subtitle {\n                display: flex;\n                justify-content: space-between;\n                line-height: 1.6rem;\n                padding-bottom: 0.4rem;\n                font-size: 1.1rem;\n                letter-spacing: 0.15rem;\n                font-weight: 600;\n                text-transform: uppercase;\n            }\n        }\n\n        #{$block}__extras {\n            display: flex;\n            gap: 1rem;\n            align-items: center;\n            justify-content: flex-start;\n            height: 100%;\n\n            #{$block}__control-buttons {\n                display: flex;\n                gap: 1rem;\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$parentBlock: '.demmi-ui-card';\n$block: '.demmi-ui-card-tabs';\n\n#{$parentBlock} {\n    #{$block} {\n        display: flex;\n        flex-wrap: nowrap;\n        gap: 1rem;\n        overflow: auto;\n        padding: 0.8rem 1.2rem;\n        margin: 0 auto;\n        justify-content: safe center; // BUG: \"safe\" not in Safari https://caniuse.com/?search=flex%20safe\n\n        #{$block}__tab {\n            cursor: pointer;\n            font-size: 1.3rem;\n            font-weight: 500;\n            line-height: 1.4rem;\n            letter-spacing: 0.05rem;\n            background-color: red;\n            padding: 1rem 1.6rem;\n            text-wrap: nowrap;\n            border-radius: 0.8rem;\n            border: 0.1rem solid transparent;\n            transition:\n                background-color 0.1s ease-in-out,\n                border-color 0.1s ease-in-out;\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0),\n                rgba(0, 0, 0, 0)\n            );\n\n            &:hover {\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    rgba(255, 255, 255, 0.6),\n                    200,\n                    $alphaDark: 0.15\n                );\n                @include Utils.theme-paletteColour(\n                    border-color,\n                    rgba(255, 255, 255, 0),\n                    100,\n                    $alphaDark: 0.1\n                );\n            }\n\n            &#{$block}__tab--active {\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    rgba(255, 255, 255, 0.8),\n                    200,\n                    $alphaDark: 0.2\n                );\n                @include Utils.theme-paletteColour(\n                    border-color,\n                    rgba(255, 255, 255, 0),\n                    100,\n                    $alphaDark: 0.3\n                );\n            }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n@use './title';\n@use './tabs';\n\n$block: '.demmi-ui-card';\n\n#{$block} {\n    width: 100%;\n    position: relative;\n    box-sizing: border-box;\n    border-radius: 1.6rem;\n    @include Utils.theme-paletteColour(\n        background,\n        radial-gradient(\n            circle at 30% 40%,\n            rgba(255, 255, 255, 0.3),\n            rgba(255, 255, 255, 0.2)\n        ),\n        200,\n        $alphaDark: 0.1\n    );\n\n    &#{$block}--no-padding {\n        padding: 0;\n\n        #{$block}__title {\n            padding: 1rem 1rem 0;\n        }\n\n        #{$block}__main-content {\n            padding: 0;\n        }\n    }\n\n    &#{$block}--dark-only {\n        @at-root body:not(.theme-dark) #{&} {\n            width: unset;\n            padding: 0;\n            border-radius: unset;\n            @include Utils.theme-paletteColour(background-color, unset, unset);\n            @include Utils.theme-paletteColour(background, unset, unset);\n            #{$block}__content {\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    unset,\n                    unset\n                );\n                @include Utils.theme-paletteColour(background, unset, unset);\n            }\n        }\n    }\n\n    &#{$block}--collapsed {\n        #{$block}__title {\n            margin-bottom: 0;\n\n            #{$block}__button-collapse {\n                svg {\n                    transform: rotate3d(0, 0, 1, 180deg);\n                }\n            }\n        }\n        #{$block}__main-content {\n            display: none;\n        }\n    }\n\n    #{$block}__content {\n        display: block;\n        border-radius: 1.6rem;\n        @include Utils.theme-paletteColour(\n            background,\n            radial-gradient(\n                circle at 30% 40%,\n                rgba(255, 255, 255, 0.5),\n                rgba(255, 255, 255, 0.3)\n            ),\n            200,\n            $alphaDark: 0.3\n        );\n    }\n\n    #{$block}__main-content {\n        padding: 1rem;\n    }\n\n    #{$block}__divider {\n        margin: 1rem 0;\n        height: 0.2rem;\n        width: 100%;\n        @include Utils.theme-paletteColour(background-color, 50, 0.2);\n    }\n\n    &#{$block}--loading {\n        #{$block}__main-content {\n            opacity: 0.4;\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.demmi-ui-toast';\n\n$typeIndicatorWidth: 0.6rem;\n\n$colorRed: rgb(214, 108, 108);\n$colorGreen: rgb(105, 184, 86);\n$colorBlue: rgb(85, 176, 190);\n$color: $colorBlue;\n\n$borderRadius: 1.2rem;\n#{$block} {\n    width: 44rem;\n    box-sizing: border-box;\n    overflow: hidden;\n    border-radius: $borderRadius;\n    backdrop-filter: blur(4px);\n    transition:\n        transform 0.05s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        max-height 0.3s ease-in-out,\n        opacity 0.2s ease-in-out,\n        background-color 0.1s ease-in-out;\n    align-items: stretch;\n    @include Utils.theme-paletteColour(color, 800, 900);\n    @include Utils.theme-paletteColour(\n        background-color,\n        rgba(255, 255, 255, 1),\n        hsla(var(--theme-bg-hue), 6%, 18%, 0.9),\n        $alphaDark: 1\n    );\n    @include Utils.shadow-get(3, 2);\n\n    &::after {\n        $margin: 0rem;\n        content: '';\n        position: absolute;\n        left: $margin;\n        top: $margin;\n        bottom: $margin;\n        width: calc($typeIndicatorWidth * 4);\n        border-left: $color $typeIndicatorWidth solid;\n        border-radius: $borderRadius;\n        box-sizing: border-box;\n    }\n\n    #{$block}__timer {\n        $margin: 0rem;\n        position: absolute;\n        right: 0;\n        bottom: 0;\n        top: 0;\n        background-color: $color;\n        opacity: 0.1;\n        width: 100%;\n        border-radius: $borderRadius;\n        transition: max-width 0.1s linear;\n    }\n\n    &#{$block}--dismissing-1,\n    &#{$block}--dismissing-2,\n    &#{$block}--dismissing-3 {\n        transition:\n            transform 0.5s ease-in-out,\n            box-shadow 0.1s ease-in-out,\n            max-height 0.1s ease-in-out,\n            background-color 0.1s ease-in-out,\n            opacity 0.4s ease-in-out;\n    }\n\n    &#{$block}--dismissing-1 {\n        transform: translate3d(100%, 0, 0);\n        opacity: 0;\n    }\n    &#{$block}--dismissed {\n        opacity: 0;\n        max-height: 0;\n    }\n\n    &:hover {\n        $scaleFactor: 1.02;\n        z-index: 1;\n        transform: translate3d(-1rem, -0rem, 0)\n            scale3d($scaleFactor, $scaleFactor, $scaleFactor);\n        @include Utils.shadow-get(5, 6);\n        @include Utils.theme-paletteColour(\n            background-color,\n            white,\n            hsla(var(--theme-bg-hue), 6%, 18%, 1)\n        );\n    }\n\n    #{$block}__content {\n        padding: 1rem 1rem 1rem calc(1rem + $typeIndicatorWidth);\n        display: flex;\n\n        #{$block}__icon {\n            padding: 0.5rem 1rem 0.5rem 0.5rem;\n            svg {\n                width: 2.2rem;\n                height: 2.2rem;\n                color: $color;\n            }\n        }\n\n        #{$block}__text-content {\n            flex: 1 1 auto;\n            display: flex;\n            flex-direction: column;\n            gap: 0.6rem;\n            padding: 0.2rem 0.6rem;\n\n            #{$block}__title {\n                pointer-events: none;\n                font-size: 1.4rem;\n                font-weight: 600;\n                letter-spacing: 0.08rem;\n                line-height: 2.4rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    50,\n                    $alphaDark: 0.8,\n                    $alphaLight: 0.6\n                );\n            }\n\n            #{$block}__body {\n                pointer-events: none;\n                font-size: 1.2rem;\n                font-weight: 400;\n                letter-spacing: 0.05rem;\n                line-height: 2rem;\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    50,\n                    $alphaLight: 0.8\n                );\n\n                strong {\n                    font-weight: 500;\n                }\n            }\n        }\n\n        #{$block}__dismiss-area {\n            margin-left: 1rem;\n            flex: 0 0 auto;\n            // padding: 0 1rem;\n            position: relative;\n            display: flex;\n            align-items: flex-start;\n            justify-content: end;\n\n            // &::after {\n            //     content: '';\n            //     position: absolute;\n            //     left: 0;\n            //     top: 0.4rem;\n            //     bottom: 0.4rem;\n            //     width: 0.2rem;\n            //     background-color: red;\n            //     opacity: 0.2;\n            // }\n        }\n    }\n}\n","@use '../../utils' as Utils;\n\n$block: '.demmi-ui-toasts-area';\n\n#{$block} {\n    z-index: 9999;\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    width: 0;\n\n    #{$block}__list {\n        position: absolute;\n        bottom: 0;\n        right: 1rem;\n        display: flex;\n        flex-direction: column-reverse;\n        overflow: visible;\n        gap: 1rem;\n        padding: 1rem 0;\n    }\n}\n","@use '../utils' as Utils;\n\n$block: '.demmi-ui-modal';\n\n#{$block} {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n\n    &#{$block}--visible {\n        #{$block}__content {\n            opacity: 1;\n        }\n        #{$block}__backdrop {\n            opacity: 1;\n        }\n    }\n\n    #{$block}__backdrop {\n        opacity: 0;\n        position: absolute;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        inset: 0;\n        transition: opacity 0.3s ease-in-out;\n        backdrop-filter: blur(15px);\n        -webkit-backdrop-filter: blur(15px);\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            rgba(0, 0, 0, 0.6),\n            $alphaLight: 0.3\n        );\n    }\n\n    #{$block}__content {\n        position: relative;\n        opacity: 0;\n        z-index: 1;\n        max-height: 100%;\n        width: 100%;\n        overflow: visible auto;\n        transition: opacity 0.2s ease-in-out;\n        justify-content: center;\n\n        #{$block}__content-wrapper {\n            overflow: hidden;\n            border-radius: 2rem;\n            @include Utils.shadow-get(4, 0);\n\n            #{$block}__divider {\n                margin: 2rem 0;\n                height: 0.1rem;\n                width: 100%;\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    hsla(0, 0%, 0%, 0.06),\n                    black\n                );\n            }\n\n            #{$block}__area {\n                width: 100%;\n                box-sizing: border-box;\n                @include Utils.theme-customProp(margin, unset, 1rem 0);\n\n                &#{$block}__area--dark {\n                    @include Utils.theme-customProp(\n                        border-radius,\n                        unset,\n                        1.6rem\n                    );\n                    @include Utils.theme-paletteColour(\n                        background-color,\n                        50,\n                        200,\n                        $alphaDark: 0.4\n                    );\n                }\n\n                &#{$block}__area--light {\n                    @include Utils.theme-customProp(\n                        border-radius,\n                        unset,\n                        1.6rem\n                    );\n                    @include Utils.theme-paletteColour(\n                        background-color,\n                        white,\n                        100,\n                        $alphaDark: 0.8\n                    );\n                }\n            }\n\n            #{$block}__area-title {\n                padding: 2rem;\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n            }\n\n            #{$block}__area-buttons {\n                padding: 2rem;\n                position: relative;\n\n                &#{$block}__area-buttons--doing-request {\n                    #{$block}__action-buttons {\n                        opacity: 0.2;\n                        pointer-events: none;\n                    }\n                }\n\n                #{$block}__action-buttons {\n                    display: flex;\n                    justify-content: flex-end;\n                    gap: 2rem;\n                }\n            }\n        }\n    }\n}\n","@use '../utils' as Utils;\n\n.demmi-ui-button {\n    $block: &;\n    cursor: pointer;\n    width: fit-content;\n    width: -webkit-fit-content;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    font-size: 1.3rem;\n    line-height: 2rem;\n    padding: 1.2rem 2.4rem;\n    border: 0.2rem solid;\n    border-radius: 1rem;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    @include Utils.theme-paletteColour(\n        background-color,\n        50,\n        rgba(0, 0, 0, 0.8)\n    );\n    @include Utils.theme-paletteColour(border-color, 100, transparent);\n    @include Utils.theme-paletteColour(color, 700, white);\n    @include Utils.shadow-get(1, 0);\n\n    &:disabled {\n        cursor: default;\n        opacity: 0.4;\n    }\n\n    &:not(:disabled):hover {\n        border-radius: 3rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            rgba(0, 0, 0, 1)\n        );\n        @include Utils.shadow-get(2, 0);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(1.1, 1.1, 1.1);\n        border-radius: 3rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            rgba(0, 0, 0, 1)\n        );\n        @include Utils.shadow-get(4, 0);\n    }\n\n    &#{$block}--outlined {\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.1),\n            transparent\n        );\n        @include Utils.theme-paletteColour(border-color, 100, 0.5);\n        @include Utils.theme-paletteColour(color, 700, black);\n        @include Utils.shadow-get(0);\n\n        &:not(:disabled):hover {\n            @include Utils.theme-paletteColour(border-color, 200, 1);\n            @include Utils.theme-paletteColour(\n                background-color,\n                50,\n                rgba(0, 0, 0, 0)\n            );\n            @include Utils.shadow-get(2, 0);\n        }\n\n        &:not(:disabled):active {\n            @include Utils.theme-paletteColour(border-color, 200, 1);\n            @include Utils.theme-paletteColour(\n                background-color,\n                50,\n                rgba(0, 0, 0, 0)\n            );\n            @include Utils.shadow-get(4, 0);\n        }\n    }\n\n    &#{$block}--delete {\n        border-color: transparent;\n        color: white;\n        @include Utils.theme-paletteColour(\n            background-color,\n            hsl(0, 70%, 70%),\n            hsl(0, 40%, 50%)\n        );\n\n        &:not(:disabled):hover {\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsl(0, 70%, 70%),\n                hsl(0, 40%, 50%)\n            );\n        }\n\n        &:not(:disabled):active {\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsl(0, 70%, 70%),\n                hsl(0, 40%, 50%)\n            );\n        }\n    }\n\n    &#{$block}--save {\n        border-color: transparent;\n        color: white;\n        @include Utils.theme-paletteColour(\n            background-color,\n            hsl(90, 50%, 70%),\n            hsl(90, 25%, 50%)\n        );\n\n        &:not(:disabled):hover {\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsl(90, 50%, 70%),\n                hsl(90, 25%, 50%)\n            );\n        }\n\n        &:not(:disabled):active {\n            @include Utils.theme-paletteColour(\n                background-color,\n                hsl(90, 50%, 70%),\n                hsl(90, 25%, 50%)\n            );\n        }\n    }\n\n    &#{$block}--size-small {\n        letter-spacing: 0.15rem;\n        font-size: 1.1rem;\n        line-height: 1.4rem;\n        font-weight: 600;\n        padding: 1rem 2rem;\n        text-transform: uppercase;\n    }\n\n    #{$block}__icon {\n        margin-right: 1.2rem;\n        height: 1.4rem;\n        line-height: 1.4rem;\n\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.4rem;\n            width: 1.4rem;\n        }\n    }\n}\n","@use '../utils' as Utils;\n\n.demmi-ui-toggle {\n    $block: &;\n    cursor: pointer;\n    position: relative;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    font-size: 1.3rem;\n    line-height: 1.6rem;\n    padding: 0.8rem 0.8rem 0.8rem 1.6rem;\n    font-weight: 500;\n    letter-spacing: 0.1rem;\n    border-radius: 1.2rem;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out;\n\n    @include Utils.theme-paletteColour(\n        color,\n        rgba(0, 0, 0, 0.6),\n        rgba(255, 255, 255, 0.8)\n    );\n\n    input {\n        display: none;\n\n        &:checked {\n            ~ #{$block}__indicator:before {\n                transform: translate3d(2.8rem, 0, 0);\n                @include Utils.theme-paletteColour(background-color, 1, 100);\n            }\n        }\n    }\n\n    &:hover {\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            rgba(255, 255, 255, 0.12)\n        );\n    }\n\n    #{$block}__indicator {\n        cursor: pointer;\n        position: relative;\n        width: 6rem;\n        height: 3.2rem;\n        border-radius: 2rem;\n        @include Utils.theme-paletteColour(background-color, 100, 0.3);\n        @include Utils.theme-paletteColour(\n            box-shadow,\n            #{inset 0 0.1rem 0.1rem rgba(0, 0, 0, 0.08)},\n            #{0 0.1rem 0.1rem rgba(255, 255, 255, 0.16)}\n        );\n\n        &:before {\n            position: absolute;\n            content: '';\n            height: 2.4rem;\n            width: 2.4rem;\n            left: 0.4rem;\n            top: 0.4rem;\n            border-radius: 50%;\n            transition:\n                transform 0.2s ease-in-out,\n                background-color 0.2s ease-in-out;\n            @include Utils.theme-paletteColour(\n                background-color,\n                50,\n                100,\n                $alphaLight: 0.4,\n                $alphaDark: 0.2\n            );\n            $dropShadowLight: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.16);\n            $dropShadowDark: 0 0.2rem 0.4rem rgba(0, 0, 0, 0.32);\n            @include Utils.theme-paletteColour(\n                box-shadow,\n                #{inset 0 0.1rem 0.1rem rgba(255, 255, 255, 1),\n                $dropShadowLight},\n                #{inset 0 0.1rem 0.1rem rgba(255, 255, 255, 0.12),\n                $dropShadowDark}\n            );\n        }\n    }\n\n    &#{$block}--disabled {\n        pointer-events: none;\n        opacity: 0.6;\n    }\n}\n","@use '../utils' as Utils;\n\n.demmi-ui-icon-button {\n    $block: &;\n    cursor: pointer;\n    width: fit-content;\n    width: -webkit-fit-content;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    line-height: 1.6rem;\n    border-radius: 0.8rem;\n    box-sizing: border-box;\n    padding: 1.2rem;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    color: rgba(255, 255, 255, 0.8);\n    border: 0.2rem solid;\n    background-color: hsla(var(--theme-bg-hue), 20%, 10%, 0);\n    border-color: transparent;\n    @include Utils.shadow-get(0);\n    @include Utils.theme-paletteColour(\n        background-color,\n        50,\n        rgba(0, 0, 0, 0.8)\n    );\n    @include Utils.theme-paletteColour(border-color, 100, transparent);\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), white);\n\n    &:disabled {\n        cursor: default;\n        opacity: 0.4;\n    }\n\n    &:not(:disabled):hover {\n        border-radius: 50%;\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            rgba(0, 0, 0, 1)\n        );\n        @include Utils.shadow-get(1, 0);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(1.1, 1.1, 1.1);\n        border-radius: 50%;\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            rgba(0, 0, 0, 1)\n        );\n        @include Utils.shadow-get(3, 0);\n    }\n\n    &:not(:disabled):focus-visible {\n        transform: translate3d(0, -0.1rem, 0);\n        @include Utils.theme-paletteColour(\n            background-color,\n            50,\n            rgba(0, 0, 0, 1)\n        );\n        @include Utils.shadow-get(1, 0);\n    }\n\n    svg {\n        display: block;\n        pointer-events: none;\n        height: 1.6rem;\n        width: 1.6rem;\n        @include Utils.theme-paletteColour(color, 400, white);\n    }\n\n    &#{$block}--transparent {\n        border: none;\n        @include Utils.theme-paletteColour(\n            background-color,\n            transparent,\n            transparent\n        );\n    }\n\n    &#{$block}--overlay {\n        backdrop-filter: blur(10px);\n        border: none;\n        @include Utils.theme-paletteColour(\n            background-color,\n            400,\n            0.8,\n            $alphaLight: 0.4\n        );\n        @include Utils.shadow-get(0);\n\n        &:not(:disabled):hover {\n            @include Utils.shadow-get(2, 0);\n        }\n\n        &:not(:disabled):active {\n            @include Utils.shadow-get(4, 0);\n        }\n\n        svg {\n            @include Utils.theme-paletteColour(color, white);\n        }\n    }\n\n    &#{$block}--large {\n        line-height: 1.6rem;\n        padding: 1.4rem;\n\n        svg {\n            height: 1.6rem;\n            width: 1.6rem;\n        }\n    }\n\n    &#{$block}--small {\n        line-height: 1.2rem;\n        padding: 1.1rem;\n\n        svg {\n            height: 1.2rem;\n            width: 1.2rem;\n        }\n    }\n\n    &#{$block}--mini {\n        line-height: 1rem;\n        padding: 0.8rem;\n\n        svg {\n            height: 1.1rem;\n            width: 1.1rem;\n        }\n\n        &:not(:disabled):active {\n            border-radius: 50%;\n        }\n    }\n}\n","@use '../utils' as Utils;\n\n.demmi-ui-item-switch {\n    $block: &;\n    position: relative;\n    display: flex;\n    align-items: stretch;\n    justify-content: center;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out;\n    width: fit-content;\n    box-sizing: border-box;\n    padding: 0rem 0.4rem;\n    margin: 0 auto;\n    border-radius: 0.8rem;\n    gap: 0.4rem;\n    @include Utils.theme-paletteColour(\n        background-color,\n        rgba(255, 255, 255, 0.5),\n        200,\n        $alphaDark: 0.4\n    );\n\n    #{$block}__item {\n        z-index: 1;\n        cursor: pointer;\n        flex: 0 0 auto;\n        display: flex;\n        align-items: center;\n        padding: 1.2rem 2rem;\n        transition: opacity 0.1s ease-in-out;\n        background: rgba(255, 0, 0, 0.1);\n        background: transparent;\n        opacity: 0.8;\n\n        #{$block}__item-content {\n            pointer-events: none;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            background-color: transparent;\n            transition:\n                width 0.3s ease-in-out,\n                opacity 0.3s ease-in-out;\n            font-size: 1.2rem;\n            line-height: 1.2rem;\n            font-weight: 500;\n            letter-spacing: 0.12rem;\n            text-align: center;\n            overflow: hidden;\n        }\n\n        &:hover:not(#{$block}--active) {\n            opacity: 1;\n        }\n        &#{$block}__item--active {\n            opacity: 1;\n        }\n    }\n\n    #{$block}__indicator {\n        position: absolute;\n        top: 0.4rem;\n        bottom: 0.4rem;\n        left: 0;\n        pointer-events: none;\n        border-radius: 0.8rem;\n        transition: all 0.3s cubic-bezier(0.38, 0.1, 0.26, 1.41);\n        @include Utils.theme-paletteColour(background-color, white, 100);\n        @include Utils.shadow-get(2, 0);\n    }\n}\n","@use '../utils' as Utils;\n\n$coreblock: '.demmi-ui-item-switch';\n$block: '.demmi-ui-button-switch';\n\n#{$block} {\n    .demmi-ui-item-switch {\n        #{$coreblock}__item {\n            &:hover:not(#{$coreblock}--active) {\n                @include Utils.theme-paletteColour(\n                    color,\n                    900,\n                    white,\n                    $alphaLight: 0.8\n                );\n            }\n            &#{$coreblock}__item--active {\n                #{$block}__item-text {\n                    @include Utils.theme-paletteColour(\n                        color,\n                        900,\n                        900,\n                        $alphaLight: 0.8\n                    );\n                }\n            }\n        }\n\n        #{$block}__item {\n            z-index: 1;\n            cursor: pointer;\n            flex: 0 0 auto;\n            display: flex;\n            height: 1.4rem;\n            align-items: center;\n            padding: 0;\n            transition: color 0.1s ease;\n            background: rgba(255, 0, 0, 0.1);\n            background: transparent;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 0.8\n            );\n\n            #{$block}__item-text {\n                pointer-events: none;\n                background-color: transparent;\n                transition:\n                    width 0.3s ease-in-out,\n                    opacity 0.3s ease-in-out;\n                font-size: 1.2rem;\n                line-height: 1.2rem;\n                font-weight: 500;\n                letter-spacing: 0.12rem;\n                text-align: center;\n                overflow: hidden;\n            }\n        }\n\n        .demmi-ui-item-switch__indicator {\n            top: -0.2rem;\n            bottom: -0.2rem;\n            left: 0;\n        }\n    }\n}\n","@use '../utils' as Utils;\n\n.demmi-ui-input-file-button {\n    display: block;\n    margin: 0 auto;\n    cursor: pointer;\n    font-size: 1.3rem;\n    box-sizing: border-box;\n    line-height: 2rem;\n    padding: 1.2rem 2.4rem;\n    border-radius: 1rem;\n    font-weight: 500;\n    letter-spacing: 0.15rem;\n    border: 0.2rem solid;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out;\n    @include Utils.shadow-get(1, 0);\n    @include Utils.theme-paletteColour(\n        background-color,\n        50,\n        rgba(0, 0, 0, 0.8)\n    );\n    @include Utils.theme-paletteColour(border-color, 100, transparent);\n    @include Utils.theme-paletteColour(color, 700, white);\n\n    &:not(:disabled):hover {\n        border-radius: 3rem;\n        @include Utils.shadow-get(2, 0);\n        @include Utils.theme-paletteColour(border-color, 200, transparent);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(1.1, 1.1, 1.1);\n        border-radius: 3rem;\n        @include Utils.shadow-get(4, 0);\n        @include Utils.theme-paletteColour(border-color, 200, transparent);\n    }\n}\n","@use '../utils' as Utils;\n\n$block: '.demmi-ui-input-time';\n\n#{$block} {\n    width: 18rem;\n    box-sizing: border-box;\n    display: flex;\n    gap: 0.8rem;\n    align-items: center;\n    justify-content: center;\n    padding: 0.4rem;\n    border-radius: 1.6rem;\n    @include Utils.theme-paletteColour(\n        background-color,\n        100,\n        100,\n        $alphaDark: 0.6\n    );\n\n    span {\n        font-size: 1.8rem;\n        font-weight: 600;\n        @include Utils.theme-paletteColour(color, 700, black);\n    }\n\n    #{$block}__button {\n        flex: 1 1 50%;\n        cursor: pointer;\n        width: fit-content;\n        width: -webkit-fit-content;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 1.3rem;\n        font-weight: 500;\n        letter-spacing: 0.3rem;\n        box-sizing: border-box;\n        line-height: 1.4rem;\n        padding: 1.2rem;\n        border-radius: 1.4rem;\n        transition:\n            transform 0.1s ease-in-out,\n            box-shadow 0.1s ease-in-out,\n            background-color 0.1s ease-in-out,\n            border-color 0.1s ease-in-out,\n            border-radius 0.2s ease-in-out;\n        @include Utils.theme-paletteColour(background-color, white, 0.8);\n        @include Utils.theme-paletteColour(border-color, 100, transparent);\n        @include Utils.theme-paletteColour(color, 700, white);\n\n        &:not(:disabled):hover {\n            border-radius: 3rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                white,\n                rgba(0, 0, 0, 1)\n            );\n            @include Utils.shadow-get(2, 0);\n        }\n\n        &:not(:disabled):active {\n            transform: scale3d(1.1, 1.1, 1.1);\n            border-radius: 3rem;\n            @include Utils.theme-paletteColour(\n                background-color,\n                white,\n                rgba(0, 0, 0, 1)\n            );\n            @include Utils.shadow-get(4, 0);\n        }\n    }\n\n    &#{$block}--inline {\n        width: 13rem;\n        padding: 0.4rem;\n        gap: 0.6rem;\n        border-radius: 1.2rem;\n        box-sizing: border-box;\n\n        #{$block}__button {\n            border-radius: 1rem;\n            padding: 1rem 0;\n        }\n    }\n}\n\n#{$block}__overlay {\n    #{$block}__scroll {\n        max-height: 20rem;\n        padding: 0.5rem;\n        box-sizing: border-box;\n        border-radius: 1.6rem;\n        overflow: auto;\n        @include Utils.theme-paletteColour(background-color, 50, white);\n\n        #{$block}__scroll-item {\n            font-size: 1.3rem;\n            font-weight: 400;\n            letter-spacing: 0.3rem;\n            text-align: center;\n            border-radius: 1.6rem;\n            padding: 1.2rem 1.6rem;\n            cursor: pointer;\n            user-select: none;\n            @include Utils.theme-paletteColour(color, 900, black);\n\n            &:hover {\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    white,\n                    black\n                );\n                @include Utils.theme-paletteColour(color, black, white);\n            }\n        }\n    }\n}\n","@use '../utils' as Utils;\n\n.demmi-ui-input {\n    $block: &;\n    padding: 1rem 1.6rem;\n    font-size: 1.3rem;\n    letter-spacing: 0.08rem;\n    line-height: 2rem;\n    border-radius: 1rem;\n    width: 100%;\n    box-sizing: border-box;\n    outline: none;\n    border: 0.2rem solid transparent;\n    transition:\n        background-color 0.1s ease-in-out,\n        border-color 0.1s ease-in-out,\n        border-radius 0.2s ease-in-out,\n        box-shadow 0.2s ease-in-out;\n\n    @include Utils.theme-paletteColour(\n        background-color,\n        600,\n        0.4,\n        $alphaLight: 0.04\n    );\n    @include Utils.theme-paletteColour(color, 900, white);\n    @include Utils.theme-paletteColour(\n        border-color,\n        700,\n        transparent,\n        $alphaLight: 0.2\n    );\n\n    &#{$block}--invert {\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(255, 255, 255, 0.3),\n            0.3\n        );\n        @include Utils.theme-paletteColour(\n            border-color,\n            rgba(255, 255, 255, 1),\n            transparent\n        );\n    }\n\n    &:hover {\n        @include Utils.theme-paletteColour(\n            background-color,\n            600,\n            0.5,\n            $alphaLight: 0.08\n        );\n\n        &#{$block}--invert {\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0.8),\n                0.4\n            );\n        }\n    }\n\n    &:focus {\n        border-radius: 3rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            600,\n            0.5,\n            $alphaLight: 0.08\n        );\n        @include Utils.theme-paletteColour(\n            border-color,\n            700,\n            100,\n            $alphaLight: 0.2,\n            $alphaDark: 0.4\n        );\n        @include Utils.shadow-get(2, 0);\n\n        &#{$block}--invert {\n            @include Utils.theme-paletteColour(\n                background-color,\n                rgba(255, 255, 255, 0.8),\n                0.5\n            );\n        }\n    }\n\n    &::placeholder {\n        @include Utils.theme-paletteColour(\n            color,\n            rgba(0, 0, 0, 0.4),\n            rgba(255, 255, 255, 0.7)\n        );\n    }\n}\n\n.demmi-ui-input__wrapper {\n    position: relative;\n\n    textarea.demmi-ui-input {\n        height: 40rem;\n        max-width: 100%;\n        min-width: 100%;\n        resize: none;\n        box-sizing: border-box;\n        padding-bottom: 3rem;\n        &:focus {\n            border-radius: 1rem;\n        }\n    }\n\n    .demmi-ui-input__max-length {\n        position: absolute;\n        bottom: 1rem;\n        right: 0.6rem;\n        font-size: 1.1rem;\n        font-weight: 700;\n        line-height: 1.4rem;\n        border-radius: 0.5rem;\n        text-transform: uppercase;\n        margin: 0 auto;\n        padding: 0.5rem 1rem;\n        color: white;\n        backdrop-filter: blur(10px);\n        @include Utils.theme-paletteColour(\n            background-color,\n            700,\n            0.8,\n            $alphaLight: 0.4\n        );\n    }\n}\n","@use '../utils' as Utils;\n\n$block: '.demmi-ui-menu';\n\n#{$block} {\n    opacity: 0;\n    transform: translate3d(0, -1.2rem, 0);\n    transition:\n        opacity 0.2s ease-in-out,\n        transform 0.2s ease-in-out;\n    position: fixed;\n    top: 10rem;\n    left: 10rem;\n    z-index: 9999;\n\n    #{$block}__card {\n        box-sizing: border-box;\n        background: white;\n        backdrop-filter: blur(10px);\n        -webkit-backdrop-filter: blur(10px);\n        overflow: hidden auto;\n        max-height: 40rem;\n        border-radius: 2rem;\n        box-shadow:\n            0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12),\n            0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);\n    }\n\n    &#{$block}--static {\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n        position: relative;\n        top: unset;\n        left: unset;\n    }\n    &#{$block}--visible {\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n    }\n\n    #{$block}__section-heading {\n        padding: 2rem 0rem 0;\n        margin: 0 2rem 0.8rem;\n        font-size: 1.4rem;\n        font-weight: 400;\n        line-height: 1.8rem;\n        letter-spacing: 0.1rem;\n        @include Utils.theme-paletteColour(\n            color,\n            rgba(0, 0, 0, 0.4),\n            rgba(255, 255, 255, 0.6)\n        );\n    }\n\n    #{$block}__section-items {\n        padding: 1rem;\n    }\n    #{$block}__divider {\n        height: 0.1rem;\n        margin: 2rem -1rem;\n        @include Utils.theme-paletteColour(\n            background-color,\n            rgba(0, 0, 0, 0.08),\n            rgba(255, 255, 255, 0.08)\n        );\n    }\n\n    #{$block}-item {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        gap: 1.6rem;\n        border-radius: 0.8rem;\n        padding: 1rem 2rem 1rem 1.6rem;\n        box-sizing: border-box;\n        width: 100%;\n        line-height: 1.8rem;\n        font-size: 1.3rem;\n        letter-spacing: 0.08rem;\n        font-weight: 400;\n        background: transparent;\n        outline: none;\n        border: none;\n        @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), black);\n\n        svg {\n            width: 1.4rem;\n            height: 1.4rem;\n            opacity: 0.6;\n        }\n\n        &:disabled {\n            opacity: 0.4;\n        }\n\n        &:hover:not(:disabled) {\n            @include Utils.theme-paletteColour(background-color, 50, black);\n\n            @include Utils.theme-paletteColour(\n                color,\n                rgba(0, 0, 0, 0.8),\n                white\n            );\n\n            svg {\n                opacity: 0.8;\n            }\n        }\n    }\n\n    &#{$block}--visible {\n        #{$block}__content {\n            opacity: 1;\n        }\n        #{$block}__backdrop {\n            opacity: 1;\n        }\n    }\n}\n","@use '../utils' as Utils;\n\n.demmi-ui-chip {\n    $block: &;\n    cursor: pointer;\n    position: relative;\n    width: fit-content;\n    box-sizing: border-box;\n    padding: 0.8rem 1.6rem;\n    border-radius: 2rem;\n    border: 0.2rem solid;\n    transition:\n        transform 0.1s ease-in-out,\n        box-shadow 0.1s ease-in-out,\n        background-color 0.1s ease-in-out;\n    @include Utils.theme-paletteColour(\n        background-color,\n        50,\n        0.2,\n        $alphaLight: 0.6\n    );\n    @include Utils.theme-paletteColour(border-color, 100, 0.5);\n\n    input {\n        display: none;\n    }\n\n    &#{$block}--active {\n        @include Utils.theme-paletteColour(background-color, 200, 1);\n        @include Utils.theme-paletteColour(border-color, 200, transparent);\n\n        #{$block}__text {\n            font-weight: 500;\n            @include Utils.theme-paletteColour(color, white);\n        }\n    }\n\n    #{$block}__text {\n        font-size: 1.2rem;\n        line-height: 1.6rem;\n        font-weight: 400;\n        letter-spacing: 0.12rem;\n        @include Utils.theme-paletteColour(color, 700, white);\n    }\n\n    &:not(#{$block}--active):hover {\n        @include Utils.theme-paletteColour(background-color, 50, 0.6);\n        @include Utils.theme-paletteColour(border-color, 100, 0.6);\n    }\n\n    &#{$block}--disabled {\n        pointer-events: none;\n        opacity: 0.4;\n    }\n}\n","@use '../utils' as Utils;\n\n$timelineItemSize: 2.4rem;\n$block: '.demmi-ui-timeline';\n\n#{$block} {\n    position: relative;\n    margin: 0 1rem;\n    $margin: 3rem;\n\n    #{$block}__item {\n        position: relative;\n        padding-left: calc($timelineItemSize + 1rem);\n        padding-top: 0.2rem;\n\n        &:not(:last-child) {\n            margin-bottom: $margin;\n        }\n\n        &::after {\n            content: '';\n            position: absolute;\n            left: 0;\n            top: 0;\n            height: $timelineItemSize;\n            width: $timelineItemSize;\n            border-radius: 50%;\n            border: 0.3rem solid white;\n            box-sizing: border-box;\n            @include Utils.theme-paletteColour(border-color, 100, 100);\n        }\n\n        &::before {\n            $lineWidth: 0.4rem;\n            content: '';\n            position: absolute;\n            left: calc(($timelineItemSize / 2) - ($lineWidth / 2));\n            top: $timelineItemSize - 0.1rem;\n            bottom: 0;\n            width: $lineWidth;\n            border-radius: calc($lineWidth / 2);\n            @include Utils.theme-paletteColour(background-color, 100, 300);\n        }\n\n        &:not(:last-child)::before {\n            bottom: -(calc($margin + 0.1rem));\n        }\n\n        #{$block}__item-title {\n            font-size: 1.4rem;\n            font-weight: 500;\n            letter-spacing: 0.05rem;\n            line-height: 2rem;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 1\n            );\n        }\n\n        #{$block}__item-date {\n            font-size: 1.1rem;\n            font-weight: 600;\n            letter-spacing: 0.1rem;\n            line-height: 2rem;\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                100,\n                $alphaLight: 0.6\n            );\n        }\n\n        #{$block}__item-text {\n            position: relative;\n            margin-top: 1.2rem;\n            font-size: 1.3rem;\n            font-weight: 400;\n            letter-spacing: 0.05rem;\n            line-height: 2rem;\n            padding: 1rem 1.4rem 3.6rem;\n            border-radius: 0.8rem;\n            @include Utils.theme-paletteColour(background-color, 50, 0.4);\n            @include Utils.theme-paletteColour(\n                color,\n                900,\n                white,\n                $alphaLight: 1\n            );\n\n            #{$block}__item-text-badge {\n                position: absolute;\n                bottom: 0.8rem;\n                right: 0.8rem;\n                height: 2.2rem;\n                line-height: 2.2rem;\n                padding: 0rem 1.2rem;\n                box-sizing: border-box;\n                border-radius: 0.6rem;\n                font-size: 1rem;\n                font-weight: 700;\n                text-transform: uppercase;\n                letter-spacing: 0.05rem;\n                @include Utils.theme-paletteColour(\n                    background-color,\n                    rgba(255, 255, 255, 0.8),\n                    200,\n                    $alphaDark: 0.4\n                );\n                @include Utils.theme-paletteColour(\n                    color,\n                    Utils.theme-get(800, 0.6),\n                    Utils.theme-get(50, 0.9)\n                );\n            }\n        }\n    }\n}\n","@use '../utils' as Utils;\n\n$block: '.demmi-ui-select';\n\n#{$block}__trigger {\n    $block: &;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.6rem;\n    padding-right: 1.6rem;\n    @include Utils.theme-paletteColour(\n        background-color,\n        50,\n        rgba(255, 255, 255, 0.8)\n    );\n    @include Utils.theme-paletteColour(border-color, 100, transparent);\n    @include Utils.theme-paletteColour(color, 700, black);\n\n    &:not(:disabled):hover {\n        border-radius: 3rem;\n        @include Utils.theme-paletteColour(background-color, 50, white);\n        @include Utils.shadow-get(2, 0);\n    }\n\n    &:not(:disabled):active {\n        transform: scale3d(1.1, 1.1, 1.1);\n        border-radius: 3rem;\n        @include Utils.theme-paletteColour(background-color, 50, white);\n        @include Utils.shadow-get(4, 0);\n    }\n\n    &#{$block}--has-title {\n        padding-top: 0.7rem;\n        padding-bottom: 0.7rem;\n    }\n\n    #{$block}__content {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 1.2rem;\n\n        #{$block}__text {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            letter-spacing: 0.1rem;\n\n            #{$block}__text-title {\n                font-weight: 600;\n                font-size: 1rem;\n                line-height: 1.2rem;\n                text-transform: uppercase;\n                @include Utils.theme-customProp(opacity, 0.6, 0.4);\n            }\n            #{$block}__text-main {\n                line-height: 1.8rem;\n            }\n        }\n    }\n\n    #{$block}__dropdown-icon {\n        svg {\n            display: block;\n            pointer-events: none;\n            height: 1.6rem;\n            width: 1.6rem;\n            @include Utils.theme-paletteColour(color, 400, black);\n        }\n    }\n}\n\n.SelectContent {\n    box-sizing: border-box;\n    background: white;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    overflow: hidden auto;\n    max-height: 40rem;\n    border-radius: 1.2rem;\n    box-shadow:\n        0 0.8rem 2rem hsla(var(--theme-bg-hue), 40%, 10%, 0.12),\n        0 4rem 8rem hsla(var(--theme-bg-hue), 40%, 10%, 0.08);\n}\n\n.SelectViewport {\n    padding: 0.5rem;\n}\n\n.SelectItem {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 1.6rem;\n    border-radius: 0.8rem;\n    padding: 1rem 2rem 1rem 1.6rem;\n    box-sizing: border-box;\n    width: 100%;\n    line-height: 1.8rem;\n    font-size: 1.3rem;\n    letter-spacing: 0.08rem;\n    font-weight: 400;\n    background: transparent;\n    outline: none;\n    border: none;\n    @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.6), black);\n\n    svg {\n        width: 1.4rem;\n        height: 1.4rem;\n        opacity: 0.6;\n    }\n\n    &:disabled {\n        opacity: 0.4;\n    }\n\n    &:hover:not(:disabled) {\n        @include Utils.theme-paletteColour(background-color, 50, black);\n\n        @include Utils.theme-paletteColour(color, rgba(0, 0, 0, 0.8), white);\n\n        svg {\n            opacity: 0.8;\n        }\n    }\n}\n","@use '../utils' as Utils;\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow,\n.react-datepicker__navigation-icon::before {\n    border-style: solid;\n    border-width: 0.3rem 0.3rem 0 0;\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0.9rem;\n    height: 0.6rem;\n    width: 0.6rem;\n    opacity: 0.5;\n}\n.react-datepicker__year-read-view--down-arrow {\n    @include Utils.theme-paletteColour(border-color, 700, 50);\n}\n.react-datepicker__month-read-view--down-arrow {\n    @include Utils.theme-paletteColour(border-color, 700, 50);\n}\n.react-datepicker__month-year-read-view--down-arrow {\n    @include Utils.theme-paletteColour(border-color, 700, 50);\n}\n.react-datepicker__navigation-icon::before {\n    @include Utils.theme-paletteColour(border-color, 700, 50);\n}\n.react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n}\n\n.react-datepicker {\n    font-family: 'Helvetica Neue', helvetica, arial, sans-serif;\n    font-size: 1.2rem;\n    line-height: initial;\n    border-radius: 1.6rem;\n    display: flex;\n    overflow: auto;\n    @include Utils.theme-paletteColour(border-color, 50, 300, $alphaDark: 0.2);\n    @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n    @include Utils.theme-paletteColour(\n        background-color,\n        50,\n        hsla(var(--theme-bg-hue), 15%, 24%, 1)\n    );\n    @include Utils.shadow-get(6, 2);\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box {\n    border-bottom-left-radius: 1.6rem;\n    border-bottom-right-radius: 1.6rem;\n}\n\n.react-datepicker-popper {\n    z-index: 1;\n    line-height: 0;\n}\n.react-datepicker-popper .react-datepicker__triangle {\n    stroke: #aeaeae;\n}\n.react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {\n    fill: #f0f0f0;\n    color: #f0f0f0;\n}\n.react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle {\n    fill: #fff;\n    color: #fff;\n}\n\n.react-datepicker__header {\n    text-align: center;\n    padding: 0.8rem 0;\n    position: relative;\n    @include Utils.theme-paletteColour(\n        background-color,\n        100,\n        200,\n        $alphaDark: 0.2\n    );\n}\n.react-datepicker__header--time {\n    padding-bottom: 0.8rem;\n    padding-left: 0.1rem;\n    padding-right: 0.5rem;\n}\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n    border-top-left-radius: 0;\n}\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n    // border-top-right-radius: 1.6rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 1.5rem;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n    margin-top: 0;\n    font-weight: 500;\n    font-size: 1.2rem;\n    @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.8);\n}\n\nh2.react-datepicker__current-month {\n    padding: 0;\n    margin: 0;\n}\n\n.react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.react-datepicker__navigation {\n    align-items: center;\n    background: none;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    padding: 0;\n    border: none;\n    z-index: 1;\n    height: 4.2rem;\n    width: 4.2rem;\n    text-indent: -999em;\n    overflow: hidden;\n    border-radius: 50%;\n    @include Utils.theme-paletteColour(\n        background-color,\n        100,\n        hsl(358deg, 16.85%, 34.9%)\n    );\n}\n.react-datepicker__navigation--previous {\n    left: 0rem;\n}\n.react-datepicker__navigation--next {\n    right: 00rem;\n}\n.react-datepicker__navigation--next--with-time:not(\n        .react-datepicker__navigation--next--with-today-button\n    ) {\n    right: 8.5rem;\n}\n.react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n    top: 0.4rem;\n}\n.react-datepicker__navigation--years-upcoming {\n    top: -0.4rem;\n}\n.react-datepicker__navigation:hover *::before {\n    // border-color: rgb(165.75, 165.75, 165.75);\n    opacity: 1;\n}\n\n.react-datepicker__navigation-icon {\n    position: relative;\n    top: -0.1rem;\n    font-size: 2rem;\n    width: 0;\n}\n.react-datepicker__navigation-icon--next {\n    left: 0.1rem;\n}\n.react-datepicker__navigation-icon--next::before {\n    transform: rotate(45deg);\n    left: -0.7rem;\n}\n.react-datepicker__navigation-icon--previous {\n    right: 0.1rem;\n}\n.react-datepicker__navigation-icon--previous::before {\n    transform: rotate(225deg);\n    right: -0.7rem;\n}\n\n.react-datepicker__month-container {\n    float: left;\n}\n// .react-datepicker__month-container ~ .react-datepicker__month-container {\n//     margin-left: 0.8rem;\n// }\n\n.react-datepicker__year {\n    margin: 0.4rem;\n    text-align: center;\n}\n.react-datepicker__year-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 18rem;\n}\n.react-datepicker__year .react-datepicker__year-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 0.2rem;\n}\n\n.react-datepicker__month {\n    margin: 0.4rem;\n    text-align: center;\n}\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 0.2rem;\n}\n\n.react-datepicker__input-time-container {\n    clear: both;\n    width: 100%;\n    float: left;\n    margin: 0.5rem 0 1rem 1.5rem;\n    text-align: left;\n}\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n    display: inline-block;\n}\n.react-datepicker__input-time-container\n    .react-datepicker-time__input-container {\n    display: inline-block;\n}\n.react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input {\n    display: inline-block;\n    margin-left: 1rem;\n}\n.react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input {\n    width: auto;\n}\n.react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-inner-spin-button,\n.react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n.react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__input\n    input[type='time'] {\n    -moz-appearance: textfield;\n}\n.react-datepicker__input-time-container\n    .react-datepicker-time__input-container\n    .react-datepicker-time__delimiter {\n    margin-left: 0.5rem;\n    display: inline-block;\n}\n\n.react-datepicker__time-container {\n    float: right;\n    border-left: 0.1rem solid #aeaeae;\n    width: 8.5rem;\n}\n.react-datepicker__time-container--with-today-button {\n    display: inline;\n    border: 0.1rem solid #aeaeae;\n    border-radius: 1.6rem;\n    position: absolute;\n    right: -8.7rem;\n    top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n    border-bottom-right-radius: 1.6rem;\n}\n.react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box {\n    width: 8.5rem;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n    border-bottom-right-radius: 1.6rem;\n}\n.react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(19.5rem + 3.2rem / 2);\n    overflow-y: scroll;\n    padding-right: 0;\n    padding-left: 0;\n    width: 100%;\n    box-sizing: content-box;\n}\n.react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item {\n    height: 3rem;\n    padding: 0.5rem 1rem;\n    white-space: nowrap;\n}\n.react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: #f0f0f0;\n}\n.react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected {\n    background-color: #216ba5;\n    color: white;\n    font-weight: bold;\n}\n.react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected:hover {\n    background-color: #216ba5;\n}\n.react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled {\n    color: #ccc;\n}\n.react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n}\n\n.react-datepicker__week-number {\n    color: #ccc;\n    display: inline-block;\n    width: 3.2rem;\n    line-height: 3.2rem;\n    text-align: center;\n    margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:not(\n        .react-datepicker__week-number--selected,\n        .react-datepicker__week-number--keyboard-selected\n    ):hover {\n    border-radius: 1.6rem;\n    background-color: #f0f0f0;\n}\n.react-datepicker__week-number--selected {\n    border-radius: 1.6rem;\n    background-color: #216ba5;\n    color: #fff;\n}\n.react-datepicker__week-number--selected:hover {\n    background-color: rgb(28.75, 93.2196969697, 143.75);\n}\n.react-datepicker__week-number--keyboard-selected {\n    border-radius: 1.6rem;\n    background-color: rgb(41.5, 134.5606060606, 207.5);\n    color: #fff;\n}\n.react-datepicker__week-number--keyboard-selected:hover {\n    background-color: rgb(28.75, 93.2196969697, 143.75);\n}\n\n.react-datepicker__day-names {\n    white-space: nowrap;\n    margin-top: 0.4rem;\n    margin-bottom: -0.4rem;\n}\n\n.react-datepicker__week {\n    white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n    // color: #000;\n    display: inline-block;\n    width: 3.2rem;\n    line-height: 3.2rem;\n    text-align: center;\n    margin: 0.166rem;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n    cursor: pointer;\n}\n.react-datepicker__day:not([aria-disabled='true']):hover,\n.react-datepicker__month-text:not([aria-disabled='true']):hover,\n.react-datepicker__quarter-text:not([aria-disabled='true']):hover,\n.react-datepicker__year-text:not([aria-disabled='true']):hover {\n    border-radius: 1.6rem;\n    @include Utils.theme-paletteColour(\n        background-color,\n        400,\n        100,\n        $alphaDark: 0.4,\n        $alphaLight: 0.2\n    );\n}\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n    font-weight: bold;\n}\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n    border-radius: 1.6rem;\n    background-color: #3dcc4a;\n    color: #fff;\n}\n.react-datepicker__day--highlighted:not([aria-disabled='true']):hover,\n.react-datepicker__month-text--highlighted:not([aria-disabled='true']):hover,\n.react-datepicker__quarter-text--highlighted:not([aria-disabled='true']):hover,\n.react-datepicker__year-text--highlighted:not([aria-disabled='true']):hover {\n    background-color: rgb(49.8551020408, 189.6448979592, 62.5632653061);\n}\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n    color: magenta;\n}\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n    color: green;\n}\n.react-datepicker__day--holidays,\n.react-datepicker__month-text--holidays,\n.react-datepicker__quarter-text--holidays,\n.react-datepicker__year-text--holidays {\n    position: relative;\n    border-radius: 1.6rem;\n    background-color: #ff6803;\n    color: #fff;\n}\n.react-datepicker__day--holidays .overlay,\n.react-datepicker__month-text--holidays .overlay,\n.react-datepicker__quarter-text--holidays .overlay,\n.react-datepicker__year-text--holidays .overlay {\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #333;\n    color: #fff;\n    padding: 0.4rem;\n    border-radius: 0.4rem;\n    white-space: nowrap;\n    visibility: hidden;\n    opacity: 0;\n    transition:\n        visibility 0s,\n        opacity 0.3s ease-in-out;\n}\n.react-datepicker__day--holidays:not([aria-disabled='true']):hover,\n.react-datepicker__month-text--holidays:not([aria-disabled='true']):hover,\n.react-datepicker__quarter-text--holidays:not([aria-disabled='true']):hover,\n.react-datepicker__year-text--holidays:not([aria-disabled='true']):hover {\n    background-color: rgb(207, 82.9642857143, 0);\n}\n.react-datepicker__day--holidays:hover .overlay,\n.react-datepicker__month-text--holidays:hover .overlay,\n.react-datepicker__quarter-text--holidays:hover .overlay,\n.react-datepicker__year-text--holidays:hover .overlay {\n    visibility: visible;\n    opacity: 1;\n}\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n    border-radius: 1.6rem;\n    background-color: #216ba5;\n    // color: #fff;\n    // @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.7);\n    @include Utils.theme-paletteColour(\n        background-color,\n        400,\n        200,\n        $alphaDark: 0.3,\n        $alphaLight: 0.3\n    );\n}\n// .react-datepicker__day--selected:not([aria-disabled='true']):hover,\n// .react-datepicker__day--in-selecting-range:not([aria-disabled='true']):hover,\n// .react-datepicker__day--in-range:not([aria-disabled='true']):hover,\n// .react-datepicker__month-text--selected:not([aria-disabled='true']):hover,\n// .react-datepicker__month-text--in-selecting-range:not(\n//         [aria-disabled='true']\n//     ):hover,\n// .react-datepicker__month-text--in-range:not([aria-disabled='true']):hover,\n// .react-datepicker__quarter-text--selected:not([aria-disabled='true']):hover,\n// .react-datepicker__quarter-text--in-selecting-range:not(\n//         [aria-disabled='true']\n//     ):hover,\n// .react-datepicker__quarter-text--in-range:not([aria-disabled='true']):hover,\n// .react-datepicker__year-text--selected:not([aria-disabled='true']):hover,\n// .react-datepicker__year-text--in-selecting-range:not(\n//         [aria-disabled='true']\n//     ):hover,\n// .react-datepicker__year-text--in-range:not([aria-disabled='true']):hover {\n//     background-color: rgb(28.75, 93.2196969697, 143.75);\n// }\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n    border-radius: 1.6rem;\n    // background-color: rgb(186.25, 217.0833333333, 241.25);\n    color: rgb(0, 0, 0);\n    @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.7);\n    @include Utils.theme-paletteColour(\n        background-color,\n        400,\n        300,\n        $alphaDark: 0.4,\n        $alphaLight: 0.3\n    );\n}\n// .react-datepicker__day--keyboard-selected:not([aria-disabled='true']):hover,\n// .react-datepicker__month-text--keyboard-selected:not(\n//         [aria-disabled='true']\n//     ):hover,\n// .react-datepicker__quarter-text--keyboard-selected:not(\n//         [aria-disabled='true']\n//     ):hover,\n// .react-datepicker__year-text--keyboard-selected:not(\n//         [aria-disabled='true']\n//     ):hover {\n//     background-color: rgb(28.75, 93.2196969697, 143.75);\n// }\n.react-datepicker__day--in-selecting-range:not(\n        .react-datepicker__day--in-range,\n        .react-datepicker__month-text--in-range,\n        .react-datepicker__quarter-text--in-range,\n        .react-datepicker__year-text--in-range\n    ),\n.react-datepicker__month-text--in-selecting-range:not(\n        .react-datepicker__day--in-range,\n        .react-datepicker__month-text--in-range,\n        .react-datepicker__quarter-text--in-range,\n        .react-datepicker__year-text--in-range\n    ),\n.react-datepicker__quarter-text--in-selecting-range:not(\n        .react-datepicker__day--in-range,\n        .react-datepicker__month-text--in-range,\n        .react-datepicker__quarter-text--in-range,\n        .react-datepicker__year-text--in-range\n    ),\n.react-datepicker__year-text--in-selecting-range:not(\n        .react-datepicker__day--in-range,\n        .react-datepicker__month-text--in-range,\n        .react-datepicker__quarter-text--in-range,\n        .react-datepicker__year-text--in-range\n    ) {\n    // background-color: rgba(33, 107, 165, 0.5);\n    // @include Utils.theme-paletteColour(color, 900, 50, $alphaLight: 0.7);\n    @include Utils.theme-paletteColour(\n        background-color,\n        400,\n        200,\n        $alphaDark: 0.3,\n        $alphaLight: 0.1\n    );\n}\n.react-datepicker__month--selecting-range\n    .react-datepicker__day--in-range:not(\n        .react-datepicker__day--in-selecting-range,\n        .react-datepicker__month-text--in-selecting-range,\n        .react-datepicker__quarter-text--in-selecting-range,\n        .react-datepicker__year-text--in-selecting-range\n    ),\n.react-datepicker__year--selecting-range\n    .react-datepicker__day--in-range:not(\n        .react-datepicker__day--in-selecting-range,\n        .react-datepicker__month-text--in-selecting-range,\n        .react-datepicker__quarter-text--in-selecting-range,\n        .react-datepicker__year-text--in-selecting-range\n    ),\n.react-datepicker__month--selecting-range\n    .react-datepicker__month-text--in-range:not(\n        .react-datepicker__day--in-selecting-range,\n        .react-datepicker__month-text--in-selecting-range,\n        .react-datepicker__quarter-text--in-selecting-range,\n        .react-datepicker__year-text--in-selecting-range\n    ),\n.react-datepicker__year--selecting-range\n    .react-datepicker__month-text--in-range:not(\n        .react-datepicker__day--in-selecting-range,\n        .react-datepicker__month-text--in-selecting-range,\n        .react-datepicker__quarter-text--in-selecting-range,\n        .react-datepicker__year-text--in-selecting-range\n    ),\n.react-datepicker__month--selecting-range\n    .react-datepicker__quarter-text--in-range:not(\n        .react-datepicker__day--in-selecting-range,\n        .react-datepicker__month-text--in-selecting-range,\n        .react-datepicker__quarter-text--in-selecting-range,\n        .react-datepicker__year-text--in-selecting-range\n    ),\n.react-datepicker__year--selecting-range\n    .react-datepicker__quarter-text--in-range:not(\n        .react-datepicker__day--in-selecting-range,\n        .react-datepicker__month-text--in-selecting-range,\n        .react-datepicker__quarter-text--in-selecting-range,\n        .react-datepicker__year-text--in-selecting-range\n    ),\n.react-datepicker__month--selecting-range\n    .react-datepicker__year-text--in-range:not(\n        .react-datepicker__day--in-selecting-range,\n        .react-datepicker__month-text--in-selecting-range,\n        .react-datepicker__quarter-text--in-selecting-range,\n        .react-datepicker__year-text--in-selecting-range\n    ),\n.react-datepicker__year--selecting-range\n    .react-datepicker__year-text--in-range:not(\n        .react-datepicker__day--in-selecting-range,\n        .react-datepicker__month-text--in-selecting-range,\n        .react-datepicker__quarter-text--in-selecting-range,\n        .react-datepicker__year-text--in-selecting-range\n    ) {\n    background-color: #f0f0f0;\n    color: #000;\n}\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n    cursor: default;\n    // color: #ccc;\n    opacity: 0.4;\n}\n.react-datepicker__day--disabled .overlay,\n.react-datepicker__month-text--disabled .overlay,\n.react-datepicker__quarter-text--disabled .overlay,\n.react-datepicker__year-text--disabled .overlay {\n    position: absolute;\n    bottom: 70%;\n    left: 50%;\n    transform: translateX(-50%);\n    background-color: #333;\n    color: #fff;\n    padding: 0.4rem;\n    border-radius: 0.4rem;\n    white-space: nowrap;\n    visibility: hidden;\n    opacity: 0;\n    transition:\n        visibility 0s,\n        opacity 0.3s ease-in-out;\n}\n\n.react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n}\n.react-datepicker__input-container .react-datepicker__calendar-icon {\n    position: absolute;\n    padding: 0.5rem;\n    box-sizing: content-box;\n}\n\n.react-datepicker__view-calendar-icon input {\n    padding: 0.6rem 1rem 0.5rem 2.5rem;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n    border: 0.1rem solid transparent;\n    border-radius: 1.6rem;\n    position: relative;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n}\n.react-datepicker__year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover\n    .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover\n    .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover\n    .react-datepicker__month-read-view--down-arrow {\n    border-top-color: rgb(178.5, 178.5, 178.5);\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n    transform: rotate(135deg);\n    right: -1.6rem;\n    top: 0;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n    background-color: #f0f0f0;\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 3rem;\n    z-index: 1;\n    text-align: center;\n    border-radius: 1.6rem;\n    border: 0.1rem solid #aeaeae;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n    height: 15rem;\n    overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n    line-height: 2rem;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 1.6rem;\n    border-top-right-radius: 1.6rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 1.6rem;\n    border-bottom-right-radius: 1.6rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n    background-color: #ccc;\n}\n.react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: rgb(178.5, 178.5, 178.5);\n}\n.react-datepicker__year-option:hover\n    .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover\n    .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover\n    .react-datepicker__navigation--years-previous {\n    border-top-color: rgb(178.5, 178.5, 178.5);\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 1.5rem;\n}\n\n.react-datepicker__close-icon {\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    padding: 0 0.6rem 0 0;\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    display: table-cell;\n    vertical-align: middle;\n}\n.react-datepicker__close-icon::after {\n    cursor: pointer;\n    background-color: #216ba5;\n    color: #fff;\n    border-radius: 50%;\n    height: 1.6rem;\n    width: 1.6rem;\n    padding: 0.2rem;\n    font-size: 1.2rem;\n    line-height: 1;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n    content: '×';\n}\n.react-datepicker__close-icon--disabled {\n    cursor: default;\n}\n.react-datepicker__close-icon--disabled::after {\n    cursor: default;\n    background-color: #ccc;\n}\n\n.react-datepicker__today-button {\n    background: #f0f0f0;\n    border-top: 0.1rem solid #aeaeae;\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 0.5rem 0;\n    clear: left;\n}\n\n.react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n}\n@media (max-width: 40rem), (max-height: 55rem) {\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n        width: 2rem;\n        line-height: 2rem;\n    }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n}\n\n.react-datepicker__children-container {\n    width: 13.8rem;\n    margin: 0.4rem;\n    padding-right: 0.2rem;\n    padding-left: 0.2rem;\n    height: auto;\n}\n\n.react-datepicker__aria-live {\n    position: absolute;\n    clip-path: circle(0);\n    border: 0;\n    height: 0.1rem;\n    margin: -0.1rem;\n    overflow: hidden;\n    padding: 0;\n    width: 0.1rem;\n    white-space: nowrap;\n}\n\n.react-datepicker__calendar-icon {\n    width: 1em;\n    height: 1em;\n    vertical-align: -0.125em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
